export function enums(): string {
    return 'enums';
}

export enum ModoEdicion {
    Ninguno,
    Adicion,
    Edicion,
    Visualizacion,
    Eliminacion
}

// Las enumeraciones de Ang. y Js no coinciden, Ejemplo, en Ang. el modo Edicion es 2, pero en el api ese 2 es eliminación.
export enum ModoEdicionApi {
    Adicion,
    Edicion,
    Eliminacion,
    Visualizacion
}

export enum EstadoRegistro {
    Nuevo,
    Editado,
    Eliminado,
    Ninguno
}

// Ruta back: D:\GEMINUS\WORKSPACE-GIT\CF-V3\SolGeminus\Geminus.Api\Types

export enum AtributosPersonalizadosWeb {
    Productos = 0,
    Diseños = 1,
    NoConformidades = 2,
    Terceros = 3,
    Clientes = 4,

    Proveedores = 5,

    ActivosFijos = 6,

    PedidosProduccion = 7,

    ClasificacionProductos = 8, // es igual que variantes

    CabeceraDocumento = 9,

    DetalleDocumento = 10,

    PropiedadesFabricacion = 11,

    PropiedadesOperacion = 12,

    AtributosComunes = 13,

    Oportunidades = 14,

    TareasProyectos = 15,

    Proyectos = 16,

    MesaAyuda = 17,

    Empleado = 18,
    // CampanasContactos = 19, //Se remueve para la unificación de contactos campañas y de clientes, JGIRALDO 02/07/2019
    HistoriaClinica = 20,
    Prospectos = 21,
    Carpetas = 22,
    Contenidos = 23,
    VersionContenidos = 24,
    HojasDeVida = 25,
    ContactosClientes = 26,
    RelacionDeGastos = 27,
    Pacientes = 28,
    CitaMedica = 29,
    // Pertenece al Ingreso de pacientes en salud
    Ingreso = 30,
    Actividades = 31,
    Furips = 32,
    ///Modificado->Lsalazar->16/02/2024:La enumeracion no continue en ordn ya que se eliminaron 2 de las categorias
    NotasHistoriaClinica = 33,

    // publicaciones
    publicacionesClientes = 36,
    publicacionesProveedor = 37,
    Glosas = 38,
    //equipos
    EquiposMantenimiento = 39,
    NovedadesPeriodicasNomina = 40,
    InformesEvaluacionesMedicas = 41,
    /****PARA LOS TIPOS DE SITIOS*********/
    SitioPublico = 100,
    SitioPrivado = 101,
    SitioPorPermisos = 102,
    /*****PARA LOS CONTENIDOS DE LAS TABLAS ********/
    /*****SISTEMA, PROCESO, TIPOS CONTENIDO ********/
    Sistema = 10003,
    Proceso = 10004,
    TipoContenido = 10005
}

export enum Meses {
    MONTH_1,
    MONTH_2,
    MONTH_3,
    MONTH_4,
    MONTH_5,
    MONTH_6,
    MONTH_7,
    MONTH_8,
    MONTH_9,
    MONTH_10,
    MONTH_11,
    MONTH_12,
    MONTH_13
}

export enum MesesDesc {
    Enero = 0,
    DescripcionEnero = 'MONTH_1',
    Febrero = 1,
    DescripcionFebrero = 'MONTH_2',
    Marzo = 2,
    DescripcionMarzo = 'MONTH_3',
    Abril = 3,
    DescripcionAbril = 'MONTH_4',
    Mayo = 4,
    DescripcionMayo = 'MONTH_5',
    Junio = 5,
    DescripcionJunio = 'MONTH_6',
    Julio = 6,
    DescripcionJulio = 'MONTH_7',
    Agosto = 7,
    DescripcionAgosto = 'MONTH_8',
    Septiembre = 8,
    DescripcionSeptiembre = 'MONTH_9',
    Octubre = 9,
    DescripcionOctubre = 'MONTH_10',
    Noviembre = 10,
    DescripcionNoviembre = 'MONTH_11',
    Diciembre = 11,
    DescripcionDiciembre = 'MONTH_12',
    MesCierre = 12,
    DescripcionMesCierre = 'LBL_CLOSURE'
}

export enum Categorias {
    DescripcionOportunidades = 'OPORTUNITIES',
    Oportunidades = 0,
    DescripcionProyectos = 'PROJECTS',
    Proyectos = 1,
    DescripcionTareas = 'TASKS',
    Tareas = 2,
    DescripcionSolicitudes = 'REQUESTS',
    Solicitudes = 3,
    DescripcionDocumentos = 'DOCUMENTS',
    Documentos = 4,
    DescripcionAgenda = 'SCHEDULER',
    Agenda = 5,
    DescripcionActivosFijos = 'MN_FIXED_ASSETS',
    ActivosFijos = 6,
    DescripcionCampaña = 'CAMPAIGNS',
    Campaña = 7,
    DescripcionEvaluacionCompetencias = 'EVALUACION_COMPETENCIAS',
    EvaluacionCompetencias = 8
}

// OJO se duplica ya que la anterior no coincide con el backend
export enum CategoriasEstados {
    DescripcionOportunidades = 'OPORTUNITIES',
    Oportunidades = 0,

    DescripcionProyectos = 'PROJECTS',
    Proyectos = 1,

    DescripcionTareas = 'PROYECTS_TASKS',
    Tareas = 2,

    DescripcionSolicitudes = 'REQUESTS',
    Solicitudes = 3,

    DescripcionDocumentos = 'DOCUMENTS',
    Documentos = 4,

    DescripcionAgenda = 'SCHEDULER',
    Agenda = 5,

    DescripcionCampaña = 'CAMPAIGNS',
    Campaña = 6,

    DescripcionActivosFijos = 'MN_FIXED_ASSETS',
    ActivosFijos = 7,

    DescripcionVacantes = 'APPLICANTS_VACANCIES',
    Vacantes = 8,

    DescripcionControlAsistencia = 'MN_ASSIST_CONTROL',
    ControlAsistencia = 9,

    DescripcionTiposCarpetas = 'TYPES_OF_FOLDERS',
    TiposCarpetas = 10,

    DescripcionContenidos = 'CONTENT',
    Contenidos = 11,

    DescripcionHistoriaClinica = 'MN_CLINIC_HISTORY',
    HistoriaClinica = 12,

    DescripcionEvaluacionCompetencias = 'LBL_COMPETENCY_EVALUATION',
    EvaluacionCompetencias = 13,

    DescripcionHistoriaClinicaUrgencias = 'CLINIC_HISTORY_EMERGENCY',
    HistoriaClinicaUrgencias = 14,

    Productos = 15,
    DescripcionProductos = 'PRODUCTS',

    Actividades = 16,
    DescripcionActividades = 'LBL_ACTIVITIES',

    Clientes = 17,
    DescripcionClientes = 'LBL_CUSTOMERS',

    Proveedores = 18,
    DescripcionProveedores = 'MN_SUPPLIERS',

    Variantes = 19,
    DescripcionVariantes = 'LOT_SERIAL_SIZE',

    MesaAyuda = 20,
    DescripcionMesaAyuda = 'LBL_CONFIG_DESK_HELP',

    Empleado = 21,
    DescripcionEmpleado = 'LBL_EMPLOYEE',

    Prospectos = 22,
    DescripcionProspectos = 'MN_PROSPECTS',

    ContactosClientes = 23,
    DescripcionContactosClientes = 'CONTACTS_EXTERNAL_CUSTOMERS',

    CitaMedica = 24,
    DescripcionCitaMedica = 'MEDICAL_APPOINTMENT',

    /// ingreso paciente
    Ingreso = 25,
    DescripcionIngreso = 'ADMISSION_PATIENT',

    Nomina = 26,
    DescripcionNomina = 'PAYROLL_NEWS_CONCEPTS',

    Cartera = 27,
    DescripcionCartera = 'PURSE',

    Terceros = 28,
    DescripcionTerceros = 'EXTERNAL_CUSTOMERS',

    Pacientes = 29,
    DescripcionPacientes = 'MN_PATIENTS',

    Furips = 30,
    DescripcionFurips = 'FURIPS.COMPONENT_FURIPS',

    ResultadosHistoriaClinica = 31,
    DescripcionResultadosHistoriaClinica = 'RESULTS_CLINIC_HISTORY',

    Glosas = 32,
    DescripcionGlosas = 'GLOSSES',

    NominaElectronica = 33,
    DescripcionNominaElectronica = "ELECTRONIC_PAYROLL.ELECTRONIC_PAYROLL",

    EncuestasClientes = 34,
    DescripcionEncuestasClientes = 'LBL_CUSTOMER_SURVEYS',

    Retenciones = 35,
    DescripCionRetenciones = 'WITHHOLDING',

    Equipos = 36,
    DescripcionEquipos = 'LBL_EQUIPMENT',

    MatrizDeRiesgo = 37,
    DescripcionMatrizDeRiesgo = 'LBL_RISK_MATRIX',

    Riesgos = 38,
    DescripcionRiesgos = 'LBL_RISKS',

    OrdenMantenimiento = 39,
    DescripcionOrdenMantenimienro = 'LBL_MAINTENANCE_ORDER',

    //EGRESOS CUENTAS POR PAGAR
    Egresos = 40,
    DescripcionEgresos = 'D_PROCESS_EGRESS',

    //INGRESOS DE CUENTAS POR COBRAR
    Ingresos = 41,
    DescripcionIngresos = 'D_PROCESS_INGRESS',

    ProcesoSeleccion = 42,
    DescripcionProcesoSeleccion = 'VACANCIES',
    CertificadoIngresos = 43,
    DescripcionCertificadoIngresos = 'CERTIFICATE_OF_INCOME_AND_WITHHOLDINGS',
    HojasDeVida = 44,
    DescripcionHojasDeVida = 'CV_TITLE'
}

export enum TiposEstados {
    Inicial,
    EnProgreso,
    Finalizado
}

export enum SiyNo {
    No,
    Si,
    NoAplica
}

export enum EstadoTareasPedido {
    Ninguno,
    PorIniciar,
    EnProgreso,
    Finalizada,
    EnPausa
}

export enum TipoArchivo {
    Pdf = 0,
    Documento = 1,
    HojaDeCalculo = 2,
    Presentacion = 3,
    Html = 4,
    video = 5,
    Audio = 6,
    Comprimido = 7,
    Imagen = 8
}

export enum EstadoPedidosConDescripcion {
    EnDigitacion = 0,
    DescripcionEnDigitacion = 'LBL_IN_DIGITALIZATION',

    Aprobado = 1,
    DescripcionAprobado = 'LBL_APPROVED',

    NoProgramado = 2,
    DescripcionNoProgramado = 'LBL_NON_SCHEDULED',

    Programado = 3,
    DescripcionProgramado = 'LBL_SCHEDULED',

    OrdenLanzada = 4,
    DescripcionOrdenLanzada = 'LBL_ORDER_THROWN',

    ListoProceso = 5,
    DescripcionListoProceso = 'LBL_PROCES_READY',

    ListoParcial = 6,
    DescripcionListoParcial = 'LBL_PARTIALLY_READY',

    Listo = 7,
    DescripcionListo = 'LBL_READY',

    DespachadoParcialmente = 8,
    DescripcionDespachadoParcialmente = 'LBL_PARTIALLY_DISPATCHED',

    DespachadoTotalmente = 9,
    DescripcionDespachadoTotalmente = 'LBL_TOTALLY_DISPATCHED',

    PendientesPorDespachar = 10,
    DescripcionPendientesPorDespachar = 'LBL_PENDING_FOR_DISPATCH',

    NoListo = 11,
    DescripcionNoListo = 'LBL_NOT_READY',

    Terminados = 12,
    DescripcionTerminados = 'LBL_FINISHED',

    NoTerminado = 13,
    DescripcionNoTerminado = 'LBL_NOT_FINISHED',

    OpReportada = 14,
    DescripcionOpReportada = 'REPORTED_OP',

    Anulada = 15,
    DescripcionAnulada = 'VOIDED',

    OPReportadoParcial = 16,
    DescripcionOPReportadoParcial = 'PARTIAL_REPORTED_OP'
}

export enum EstadoPedidos {
    EnDigitacion = 0,
    Aprobado = 1,
    NoProgramado = 2,
    Programado = 3,
    OrdenLanzada = 4,
    ListoProceso = 5,
    ListoParcial = 6,
    Listo = 7,
    DespachadoParcialmente = 8,
    DespachadoTotalmente = 9,
    PendientesPorDespachar = 10,
    NoListo = 11,
    Terminados = 12,
    NoTerminado = 13,
    OpReportada = 14,
    Anulada = 15
}

export enum ModuloReportes {
    RecursosHumanos = 1,
    Frigo = 2,
    Ventas = 3,
    FormatosDocumentos = 4,
    MantenimientoEquipos = 5,
    InformesVistas = 6,
    Comunicados = 7,
    ActivosFijos = 8,
    Financiero = 9,
    Inventarios = 10,
    CRM = 11,
    TablasDelSistema = 12,
    Produccion = 13,
    Despachos = 14,
    GestionDeContenidos = 15,
    ObrasCiviles = 16,
    InformesPorMenus = 17,
    Salud = 18,
    Nomina = 19,
    Solicitudes = 20,
    Visitantes = 21,
    Tareas = 22
}

export enum ProcesosDocumentos {
    Compras = 1,
    DescripcionCompras = 'D_PROCESS_PURCHASE',
    Ventas = 2,
    DescripcionVentas = 'D_PROCESS_SALE',
    Egresos = 3,
    DescripcionEgresos = 'D_PROCESS_EGRESS',
    Ingresos = 4,
    DescripcionIngresos = 'D_PROCESS_INGRESS',
    Inventarios = 5,
    DescripcionInventarios = 'D_PROCESS_INVENTORIES',
    Contables = 6,
    DescripcionContables = 'D_PROCESS_COUNTABLE',
    OrdenDeTrabajo = 7,
    DescripcionOrdenDeTrabajo = 'WORK_ORDER',
    OrdenesProgramadas = 8,
    DescripcionOrdenesProgramadas = 'D_PROCESS_SCHEDULED_ORDERS',
    OrdenesProduccion = 9,
    DescripcionOrdenesProduccion = 'D_PROCESS_SCHEDULED_PRODUCTION',
    InventarioProduccion = 10,
    DescripcionInventarioProduccion = 'D_PROCESS_INVENTORIES_PRODUCTION',
    GestionOrdenesProduccion = 18,
    DescripcionGestionOrdenesProduccion = 'D_PROCESS_SCHEDULED_PRODUCTION_ADMIN',
    GestionDocumental = 20,
    DescripcionGestionDocumental = 'D_PROCESS_DOCUMENTARY_MANAGEMENT',
    NominaElectronica = 21,
    DescripcionNominaElectronica = 'ELECTRONIC_PAYROLL.ELECTRONIC_PAYROLL'
}

export enum ProveedorServicioAlmacenamiento {
    'Local' = 1,
    'GoogleDrive'
}

export enum DimensionesVenta {
    DescripcionProducto = 'LABEL_PRODUCT',
    Producto = 1,

    DescripcionGrupo = 'INV_GROUP',
    Grupo = 2,

    DescripcionSubGrupo = 'INV_SUBGROUP',
    SubGrupo = 3,

    DescripcionUnidadNegocioProducto = 'LBL_UNITS_OF_BUSINESS_PRODUCT',
    UnidadNegocioProducto = 4,

    DescripcionTarifaIva = 'LBL_RATE_IVA',
    TarifaIva = 5,

    DescripcionDiseño = 'INV_DESIGN',
    Diseño = 6,

    DescripcionCliente = 'LBL_CUSTOMER',
    Cliente = 7,

    DescripcionUnidadNegocioCliente = 'LBL_UNITS_OF_BUSINESS_CUSTOMER',
    UnidadNegocioCliente = 8,

    DescripcionSector = 'CU_LBL_SECTOR',
    Sector = 9,

    DescripcionCiudadCliente = 'LBL_CITY_CUSTOMER',
    CiudadCliente = 10,

    DescripcionCiudadDespacho = 'LBL_CITY_OFFICE',
    CiudadDespacho = 11,

    DescripcionZona = 'LBL_ZONE',
    Zona = 12,

    DescripcionTipoCliente = 'LBL_TYPE_CUSTOMER',
    TipoCliente = 13,

    DescripcionAlmacen = 'WAREHOUSE',
    Almacen = 14,

    DescripcionUnidadNegocioDocumento = 'LBL_UNITS_OF_BUSINESS_DOCUMENT',
    UnidadNegocioDocumento = 15,

    DescripcionVendedor = 'SELLER',
    Vendedor = 16,

    DescripcionRegionVendedor = 'SELLING_REGION',
    RegionVendedor = 17,

    DescripcionLoteMes = 'LBL_MONTH',
    Mes = 18,

    DescripcionClasificacionCliente = 'LBL_CLIENT_CLASSIFICATION',
    ClasificacionCliente = 19,

    DescripcionSemana = 'LBL_WEEK',
    Semana = 20,

    DescripcionProductosCostoProduccion = 'PRODUCTS_PRODUCTION_COST',
    ProductosCostoProduccion = 21,

    DescripcionTipoServicio = 'LBL_SERVICE_TYPE',
    TipoServicio = 22,

    DescripcionComparativoMes = 'LBL_MONTH_COMPARATIVE',
    ComparativoMes = 23,

    DescripcionTipoDocumento = 'LBL_DOCUMENT_TYPE',
    TipoDocumento = 24,

    DescripcionFormasDePago = 'PAYMENT_METHOD',
    FormasDePago = 25,

    DescripcionDocumento = 'LBL_DOCUMENT',
    Documento = 26,

    DescripcionDocumentoVinculado = 'LBL_DOCUMENT_LINKED',
    DocumentoVinculado = 27,

    DescripcionDetalladoDocumentosConVariante = 'DETAILED_DOCUMENTS_WITH_VARIANT',
    DetalladoDocumentosConVariante = 28
}

export enum TipoInformeTiemposActividades {
    InformeAgrupado = 1,
    InformeDatallado,
    InformeIndicador,
    InformeOtSubtipotaera
}

export enum RH {
    DescripcionPositivo = '+',
    Positivo = 'P',
    DescripcionNegativo = '-',
    Negativo = 'N'
}

/**
 * @author LHeredia
 * Este enum es usado para llenar los lookups
 */
export enum enumRH {
    DescripcionPositivo = '+',
    Positivo = 1,
    DescripcionNegativo = '-',
    Negativo = 2
}

export enum Genero {
    DescripcionFemenino = 'Femenino',
    Femenino = 'F',
    DescripcionMasculino = 'Masculino',
    Masculino = 'M'
}

/**
 * @author LHeredia
 * Este enum es usado para llenar los lookups
 */
export enum Generos {
    Femenino = 1,
    DescripcionFemenino = 'Masculino',
    Masculino = 2,
    DescripcionMasculino = 'Femenino'
}

export enum NivelEstudios {
    BasicaPrimaria = 1,
    DescripcionBasicaPrimaria = 'Básica Primaria',
    BasicaSecundaria = 2,
    DescripcionBasicaSecundaria = 'Básica Secundaria',
    Bachillerato = 3,
    DescripcionBachillerato = 'Bachillerato',
    CarreraTecnica = 4,
    DescripcionCarreraTecnica = 'Carrera Técnica',
    CarreraProfesional = 5,
    DescripcionCarreraProfesional = 'Carrera Profesional',
    Especializacion = 6,
    DescripcionEspecializacion = 'Especialización',
    Maestria = 7,
    DescripcionMaestria = 'Maestría',
    Doctorado = 8,
    DescripcionDoctorado = 'Doctorado',
    Tecnologo = 9,
    DescripcionTecnologo = 'Tecnólogo'
}

export enum TipoCuentaBancaria {
    DescripcionAhorros = 'A - Ahorros',
    Ahorros = 'A',
    DescripcionCorriente = 'C - Corriente',
    Corriente = 'C',
    DescripcionRotativo = 'R - Rotativo',
    Rotativo = 'R'
}

export enum EstadosPedidosVTEX {
    DescripcionReadyForHandling = 'Pendientes recepción - ready-for-handling',
    ReadyForHandling = 1,
    DescripcionHandling = 'Recibidos - handling',
    Handling = 2,
    DescripcionTodos = 'Todos los anteriores',
    Todos = 3
}

export enum TipoEncuesta {
    Encuesta = 0,
    Invitacion = 1
}

export enum TiposGraficos {
    None = -1,
    Bar = 0,
    Area = 1,
    Doughnut = 2,
    Line = 3,
    Pie = 4
}

export enum TipoPreguntaEncuesta {
    'respuesta_corta' = 1,
    'parrafo' = 2,
    'opcion_multiple' = 3,
    'seleccion_multiple' = 4,
    'desplegable' = 5,
    'fecha' = 6,
    'numero' = 7,
}

export enum EnviarCorreoCRM {
    Nunca = 0,
    DescripcionNunca = 'NEVER',

    EnvioPorDefectoNo = 1,
    DescripcionEnvioPorDefectoNo = 'SEND_DEFAULT_NO',

    EnvioPorDefectoSi = 2,
    DescripcionEnvioPorDefectoSi = 'SEND_DEFAULT_YES',

    Siempre = 3,
    DescripcionSiempre = 'ALWAYS'
}

export enum PlataformaYeminus {
    Web,
    Movil,
    Ecommerce,
    PortalEmpleado
}
export enum distribucionPantalla {
    layout1 = 1,
    layout2,
    layout3,
    layout4
}

export enum CategoriaEncuestas {
    DescripcionNinguno = 'NONE',
    Ninguno = 0,
    DescripcionDocumentos = 'Documentos',
    Documentos = 1,
    DescripcionCampanas = 'Campañas',
    Campanas = 2,
    DescripcionSolicitudes = 'Solicitudes',
    Solicitudes = 3,
    DescripcionTareas = 'Tareas',
    Tareas = 4,
    DescripcionEncuestasClientes = 'LBL_CUSTOMER_SURVEYS',
    EncuestasClientes = 5,
    DescripcionEmpleados = 'LBL_EMPLOYEES',
    Empleados = 6
}

export enum NotasInternas {
    Oportunidades,
    Proyectos,
    Tareas,
    Solicitudes,
    Documentos,
    Productos,
    Terceros,
    Campanas,
    Agenda,
    Contenidos,
    Contactos,
    HistoriaClinica,
    Pacientes
}

export enum TipoContacto {
    ContactosCampañas = 1,
    Suscriptores,
    ContactosClientes
}

export enum AperturaTiposDocumento {
    TiposDocumento = 1,
    TiposContenido
}

export enum EtapasDocumento {
    Productos = 1,
    NotaCreditoCxP = 2,
    Contabilidad = 3,
    NotaDebitoCxP = 4,
    FacturaCxP = 5,
    VentasFacturaCxC = 6,// Utilizado en ventas etapa 2
    RecibosCarteraFacturaCxC = 7,// Utilizado en ingresos etapa 1 y en proeso ventas etapa 1
    NotasDebitoCxC = 8,
    NotasCreditoCxC = 9,
    PagosCxP = 10,
    EgresosPOS = 11,
    IngresosPOS = 12,
    OrdenTrabajo = 13,
    OrdenesGralProduccion = 14,
    ReportesProduccion = 15,
    PedidosClasificacion = 16,
    ReporteProducPorClasif = 17,
    GestionOrdenProduccion = 18,
    Ninguno = 19
}
//#region TipoUsuarioSalud
export enum TipoUsuarioSaludContributivo {
    DescripcionCotizante = '01-Contributivo cotizante',
    Cotizante = 0,
    DescripcionBeneficiario = '02-Contributivo beneficiario',
    Beneficiario = 1,
    DescripcionContributivoAdicional = '03-Contributivo adicional',
    ContributivoAdicional = 2
}
export enum TipoUsuarioSaludSubsidiado {
    DescripcionSubsidiado = '04-Subsidiado',
    Subsidiado = 3
}
export enum TipoUsuarioSaludSinRegimen {
    DescripcionSinRegimen = '05-Sin régimen',
    SinRegimen = 4
}
export enum TipoUsuarioSaludEspeciales {
    DescripcionEspecialCotizante = '06-Especiales o de excepción cotizante',
    EspecialCotizante = 5,
    DescripcionEspecialBeneficiaro = '07-Especiales o de excepción beneficiario',
    EspecialBeneficiaro = 6
}
export enum TipoUsuarioSaludParticular {
    DescripcionParticular = '12-Particular',
    Particular = 7
}
export enum TipoUsuarioSaludARL {
    DescripcionARL = '09-Tomador/Amparado ARL',
    ARL = 8
}
export enum TipoUsuarioSaludSOAT {
    DescripcionSOAT = '10-Tomador/Amparado SOAT',
    SOAT = 9
}
export enum TipoUsuarioSaludPlanesVoluntarios {
    DescripcionPlanesVoluntarios = '11-Tomador/Amparado planes voluntarios de salud',
    PlanesVoluntarios = 10
}
//#endregion
export enum GrupoSanguineo {
    DescripcionO_Positivo = 'O+',
    O_Positivo = 0,
    DescripcionO_Negativo = 'O-',
    O_Negativo = 1,
    DescripcionA_Positivo = 'A+',
    A_Positivo = 2,
    DescripcionA_Negativo = 'A-',
    A_Negativo = 3,
    DescripcionB_Positivo = 'B+',
    B_Positivo = 4,
    DescripcionB_Negativo = 'B-',
    B_Negativo = 5,
    DescripcionAB_Positivo = 'AB+',
    AB_Positivo = 6,
    DescripcionAB_Negativo = 'AB-',
    AB_Negativo = 7
}

/**
 * @author LHeredia
 * Este enum es usado para llenar los lookups
 */
export enum GrupoSanguineo2 {
    DescripcionA = 'A',
    A = 0,
    DescripcionB = 'B',
    B = 1,
    DescripcionO = 'O',
    O = 2,
    DescripcionAB = 'AB',
    AB = 3,
}
export enum ZonaSalud {
    DescripcionUrbano = 'SLD_URBANO',
    Urbano = 0,
    DescripcionRural = 'SLD_RURAL',
    Rural = 1
}

export enum TipoConsultaEnTratamientos {
    ConsultaLaboratorio = '1',
    ConsultaGeneralOControl = '2',
    InterConsulta = '3',
    MedicamentosYDispositivos = '4',
    RayosX = '5',
    Cirugia = '6',
    Terapia = '7',
    OtrosServicios = '8',
    FormulasMedicas = '9',
}

export enum AperturaTerceros {
    Terceros,
    Prospectos,
    PreciosPorCliente,
    CostosPorProveedor,
    Clientes,
    Proveedores,
    ActivosFijos
}

export enum EntidadesNotasInternas {
    Oportunidades,
    Project,
    Tasks,
    Request,
    Documents,
    Products,
    ExternalCustomers,
    Campaings,
    Schedule
}

// Enumeración para identificar las opciones del tercero
export enum OrdenOpcionesTercero {
    Oportunidades,
    Proyectos,
    Tareas,
    Campanas,
    Agenda,
    Incidencias,
    HistorialVentas,
    HistorialCompras,
    CuentasXCobrar,
    CuentasXPagar,
    CorreosEnviados,
    Anticipos,
    ExtractoCartera,
    MatricesRiesgo,
    HistoriasClinicas,
    Citas,
    Ingresos,
    PlanesTratamiento,
    RecibosYNotasCreditos
}
// Tener en cuenta que al agregar un item en la enumeracion debe sser validado
// en la captura de pacientes para obtener las categorias de acuerdo al tipo de entidad
export enum TiposEntidades {

    Contributivo = 0,
    DescripcionContributivo = '01-Contributivo',

    Subsidiado = 1,
    DescripcionSubsidiado = '04-Subsidiado',

    Particular = 2,
    DescripcionParticular = '08-Particular',

    Especial = 3,
    DescripcionEspecial = '06-Especiales o de excepción',

    ARL = 4,
    DescripcionARL = '09-Tomador/Amparado ARL',

    SOAT = 5,
    DescripcionSOAT = '10-Tomador/Amparado SOAT',

    SinRegimen = 6,
    DescripcionSinRegimen = '05-Sin régimen',

    PlanesVoluntarios = 7,
    DescripcionPlanesVoluntarios = '11-Tomador/Amparado planes voluntarios de salud',

    PacienteParticular = 8,
    DescripcionPacienteParticular = '08-Paciente particular',
}

export enum TiposDeContrato {
    Indefinido = 0,
    DescripcionIndefinido = 'CONTRACT_TYPE.UNDEFINED_TERM',

    Fijo = 1,
    DescripcionFijo = 'CONTRACT_TYPE.FIXED_TERM',

    ObraOLabor = 2,
    DescripcionObraOLabor = 'CONTRACT_TYPE.WORK_OR_LABOR',

    Aprendizaje = 3,
    DescripcionAprendizaje = 'CONTRACT_TYPE.LEARNING',

    PracticasOPasantias = 4,
    DescripcionPracticasOPasantias = 'CONTRACT_TYPE.INTERNSHIPS',
}

export enum GeneracionDocumentos {

    DescripcionDocumento = 'LBL_DOCUMENT_MODE',
    Documento = 0,
    // "SUMMARY_PRODUCT")] Viene comentado desde el Back-end
    // ProductoResumido,
    // "DISPATCH_ADDRESS")] Viene comentado desde el Back-end
    // DireccionDespacho,
    DescripcionProductoUnoAUno = 'DOCUMENT_BY_NIT',
    ProductoUnoAUno = 3,

    DescripcionDireccionDespachoUnoAUno = 'DISPATCH_ADDRESS_ONE_TO_ONE',
    DireccionDespachoUnoAUno = 4,

    DescripcionDocOrigenWorkflow = 'DOCUMENT_ORIGIN_WF',
    DocOrigenWorkflow = 5,

    DescripcionResponsable = 'OA_RESPONSABLE_MODE',
    Responsable = 6
}

export enum SituacionClienteDataCredito {

    DescripcionNormal = 'NORMAL',
    Normal = 0,

    DescripcionConcordato = 'CONCORDAT',
    Concordato = 1,

    DescripcionLiquidacionForzosa = 'FORCED_LIQUIDATION',
    LiquidacionForzosa = 2,

    DescripcionLiquidacionVoluntaria = 'VOLUNTARY_LIQUIDATION',
    LiquidacionVoluntaria = 3,

    DescripcionProcesoDeReorganizacion = 'REORGANIZATION_PROCESS',
    ProcesoDeReorganizacion = 4,

    DescripcionLey550 = 'LAW550',
    Ley550 = 5,

    DescripcionLey1116 = 'LAW1116',
    Ley1116 = 6,

    DescripcionOtro = 'LBL_OTHER',
    Otro = 7
}

export enum Parientes {
    Hijo = 0,
    DescripcionHijo = 'SON',

    Hija = 1,
    DescripcionHija = 'DAUGHTER',

    Padre = 2,
    DescripcionPadre = 'FATHER',

    Madre = 3,
    DescripcionMadre = 'MOTHER',

    Hermano = 4,
    DescripcionHermano = 'BROTHER',

    Hermana = 5,
    DescripcionHermana = 'SISTER',

    Padrastro = 6,
    DescripcionPadrastro = 'STEPFATHER',

    Madrastra = 7,
    DescripcionMadrastra = 'STEPMOTHER',

    Abuelo = 8,
    DescripcionAbuelo = 'GRANDFATHER',

    Abuela = 9,
    DescripcionAbuela = 'GRANDMOTHER',

    Conyuge = 10,
    DescripcionConyuge = 'SPOUSE',

    Otro = 11,
    DescripcionOtro = 'Otro'
}

export enum ParientesMasculinos {
    Hijo = 0,
    DescripcionHijo = 'SON',

    Padre = 2,
    DescripcionPadre = 'FATHER',

    Hermano = 4,
    DescripcionHermano = 'BROTHER',

    Padrastro = 6,
    DescripcionPadrastro = 'STEPFATHER',

    Conyuge = 10,
    DescripcionConyuge = 'SPOUSE',

    Otro = 11,
    DescripcionOtro = 'Otro'

}

export enum ParientesFemeninos {
    Hija = 1,
    DescripcionHija = 'DAUGHTER',

    Madre = 3,
    DescripcionMadre = 'MOTHER',

    Hermana = 5,
    DescripcionHermana = 'SISTER',

    Madrastra = 7,
    DescripcionMadrastra = 'STEPMOTHER',

    Abuela = 9,
    DescripcionAbuela = 'GRANDMOTHER',

    Conyuge = 10,
    DescripcionConyuge = 'SPOUSE',

    Otro = 11,
    DescripcionOtro = 'Otro'

}
/**
 * Esta enumeracion actualmente solo se usa para filtros
 */
export enum TiposMedicamentos {
    DescripcionMedicamentos = 'MEDICINES',
    Medicamentos = 0,

    DescripcionDispositivos = 'TITLE_DEVICES',
    Dispositivos = 1,

    DescripcionMedicamentosVitales = 'VITAL_MEDICINES',
    MedicamentosVitales = 2,

    DescripcionPreparacionesMagistrales = 'SPEECHES_PREPARATIONS',
    PreparacionesMagistrales = 3,

    DescripcionDrogaBlanca = 'WHITE_DRUG',
    DrogaBlanca = 4,

    DescripcionLaboratorio = 'LABORATORY',
    Laboratorio = 5,

    DescripcionRayosX = 'X_RAY',
    RayosX = 6,

    DescripcionQuirurgico = 'LBL_SURGICAL',
    Quirurgico = 7,

    DescripcionTerapias = 'THERAPIES',
    Terapias = 8,

    DescripcionEspecialista = 'SPECIALIZES',
    Especialista = 9,

    DescripcionInterConsulta = 'INTERCONSULTATION',
    InterConsulta = 10,

    DescripcionConsultaGeneralOControl = 'GENERAL_CONSULTATION_OR_CONTROL',
    ConsultaGeneralOControl = 11,

    // Inicio Componentes quirurgicos por factor SOAT
    DescripcionQuirurgicoComponenteCirujano = 'LBL_SURGICAL_COMPONENT_SURGEON_FACTOR_SOAT',
    QuirurgicoComponenteCirujano = 12,

    DescripcionQuirurgicoComponenteAnestesiologo = 'LBL_SURGICAL_COMPONENT_ANAESTHESIOLOGIST_FACTOR_SOAT',
    QuirurgicoComponenteAnestesiologo = 13,

    DescripcionQuirurgicoComponenteAyudante = 'LBL_SURGICAL_COMPONENT_ASSISTANT_FACTOR_SOAT',
    QuirurgicoComponenteAyudante = 14,

    DescripcionQuirurgicoComponenteSala = 'LBL_SURGICAL_COMPONENT_ROOM_FACTOR_SOAT',
    QuirurgicoComponenteSala = 15,

    DescripcionQuirurgicoComponenteMateriales = 'LBL_SURGICAL_COMPONENT_MATERIALS_SURGICAL_FACTOR_SOAT',
    QuirurgicoComponenteMateriales = 16,
    // Fin

    // este hace parte de procedimientos quirugicos por ISS
    DescripcionQuirurgicoISS = 'LBL_SURGICAL_ISS',
    QuirurgicoISS = 17,

    // este hace parte de procedimientos quirugicos por Precio base
    DescripcionQuirurgicoPrecioBase = 'LBL_SURGICAL_BASE_PRICE',
    QuirurgicoPrecioBase = 18,

    // Inicio componentes quirurgicos por ISS
    DescripcionQuirurgicoComponenteCirujanoISS = 'LBL_SURGICAL_COMPONENT_SURGEON_ISS',
    QuirurgicoComponenteCirujanoISS = 19,

    DescripcionQuirurgicoComponenteAnestesiologoISS = 'LBL_SURGICAL_COMPONENT_ANAESTHESIOLOGIST_ISS',
    QuirurgicoComponenteAnestesiologoISS = 20,

    DescripcionQuirurgicoComponenteAyudanteISS = 'LBL_SURGICAL_COMPONENT_ASSISTANT_ISS',
    QuirurgicoComponenteAyudanteISS = 21,

    DescripcionQuirurgicoComponenteSalaISS = 'LBL_SURGICAL_COMPONENT_ROOM_ISS',
    QuirurgicoComponenteSalaISS = 22,

    DescripcionQuirurgicoComponenteMaterialesISS = 'LBL_SURGICAL_COMPONENT_MATERIALS_SURGICAL_ISS',
    QuirurgicoComponenteMaterialesISS = 23,
    // Fin

    // Inicio componentes quirurhicos por precio base
    DescripcionQuirurgicoComponenteCirujanoPrecioBase = 'LBL_SURGICAL_COMPONENT_SURGEON_BASE_PRICE',
    QuirurgicoComponenteCirujanoPrecioBase = 24,

    DescripcionQuirurgicoComponenteAnestesiologoPrecioBase = 'LBL_SURGICAL_COMPONENT_ANAESTHESIOLOGIST_BASE_PRICE',
    QuirurgicoComponenteAnestesiologoPrecioBase = 25,

    DescripcionQuirurgicoComponenteAyudantePrecioBase = 'LBL_SURGICAL_COMPONENT_ASSISTANT_BASE_PRICE',
    QuirurgicoComponenteAyudantePrecioBase = 26,

    DescripcionQuirurgicoComponenteSalaPrecioBase = 'LBL_SURGICAL_COMPONENT_ROOM_BASE_PRICE',
    QuirurgicoComponenteSalaPrecioBase = 27,

    DescripcionQuirurgicoComponenteMaterialesPrecioBase = 'LBL_SURGICAL_COMPONENT_MATERIALS_SURGICAL_BASE_PRICE',
    QuirurgicoComponenteMaterialesPrecioBase = 28,
    // Fin

    DescripcionOtrosServicios = 'LBL_OTHER_SERVICES',
    OtrosServicios = 29,
    
    //Modificado->Lsalazar->18/11/2024:Se eliminan opciones de la enumeracion que no estan siendo utilizadas(Se informo a Ing Edison)
    //DescripcionTransportePrimario = 'LBL_TRANSPORT_PRIMARY',
    //TransportePrimario = 30,

    //DescripcionTransporteSecundario = 'LBL_TRANSPORT_SECUNDARY',
    //TransporteSecundario = 31,
}

export enum TiposMedicamentosSalud {

    DescripcionMedicamentos = 'MEDICINES',
    Medicamentos = 0,

    DescripcionDispositivos = 'TITLE_DEVICES',
    Dispositivos = 1,

    DescripcionMedicamentosVitales = 'VITAL_MEDICINES',
    MedicamentosVitales = 2,

    DescripcionPreparacionesMagistrales = 'SPEECHES_PREPARATIONS',
    PreparacionesMagistrales = 3,

    DescripcionDrogaBlanca = 'WHITE_DRUG',
    DrogaBlanca = 4,

}

export enum TipoSalud {

    DescripcionLaboratorio = 'LABORATORY',
    Laboratorio = 5,

    DescripcionRayosX = 'X_RAY',
    RayosX = 6,

    // este hace parte de procedimientos quirugicos por factor SOAT
    DescripcionQuirurgico = 'LBL_SURGICAL_FACTOR_SOAT',
    Quirurgico = 7,

    DescripcionTerapias = 'THERAPIES',
    Terapias = 8,

    DescripcionEspecialista = 'SPECIALIZES',
    Especialista = 9,

    DescripcionInterConsulta = 'INTERCONSULTATION',
    InterConsulta = 10,

    DescripcionConsultaGeneralOControl = 'GENERAL_CONSULTATION_OR_CONTROL',
    ConsultaGeneralOControl = 11,

    // Inicio Componentes quirurgicos por factor SOAT
    DescripcionQuirurgicoComponenteCirujano = 'LBL_SURGICAL_COMPONENT_SURGEON_FACTOR_SOAT',
    QuirurgicoComponenteCirujano = 12,

    DescripcionQuirurgicoComponenteAnestesiologo = 'LBL_SURGICAL_COMPONENT_ANAESTHESIOLOGIST_FACTOR_SOAT',
    QuirurgicoComponenteAnestesiologo = 13,

    DescripcionQuirurgicoComponenteAyudante = 'LBL_SURGICAL_COMPONENT_ASSISTANT_FACTOR_SOAT',
    QuirurgicoComponenteAyudante = 14,

    DescripcionQuirurgicoComponenteSala = 'LBL_SURGICAL_COMPONENT_ROOM_FACTOR_SOAT',
    QuirurgicoComponenteSala = 15,

    DescripcionQuirurgicoComponenteMateriales = 'LBL_SURGICAL_COMPONENT_MATERIALS_SURGICAL_FACTOR_SOAT',
    QuirurgicoComponenteMateriales = 16,
    // Fin

    // este hace parte de procedimientos quirugicos por ISS
    DescripcionQuirurgicoISS = 'LBL_SURGICAL_ISS',
    QuirurgicoISS = 17,

    // este hace parte de procedimientos quirugicos por Precio base
    DescripcionQuirurgicoPrecioBase = 'LBL_SURGICAL_BASE_PRICE',
    QuirurgicoPrecioBase = 18,

    // Inicio componentes quirurgicos por ISS
    DescripcionQuirurgicoComponenteCirujanoISS = 'LBL_SURGICAL_COMPONENT_SURGEON_ISS',
    QuirurgicoComponenteCirujanoISS = 19,

    DescripcionQuirurgicoComponenteAnestesiologoISS = 'LBL_SURGICAL_COMPONENT_ANAESTHESIOLOGIST_ISS',
    QuirurgicoComponenteAnestesiologoISS = 20,

    DescripcionQuirurgicoComponenteAyudanteISS = 'LBL_SURGICAL_COMPONENT_ASSISTANT_ISS',
    QuirurgicoComponenteAyudanteISS = 21,

    DescripcionQuirurgicoComponenteSalaISS = 'LBL_SURGICAL_COMPONENT_ROOM_ISS',
    QuirurgicoComponenteSalaISS = 22,

    DescripcionQuirurgicoComponenteMaterialesISS = 'LBL_SURGICAL_COMPONENT_MATERIALS_SURGICAL_ISS',
    QuirurgicoComponenteMaterialesISS = 23,
    // Fin

    // Inicio componentes quirurhicos por precio base
    DescripcionQuirurgicoComponenteCirujanoPrecioBase = 'LBL_SURGICAL_COMPONENT_SURGEON_BASE_PRICE',
    QuirurgicoComponenteCirujanoPrecioBase = 24,

    DescripcionQuirurgicoComponenteAnestesiologoPrecioBase = 'LBL_SURGICAL_COMPONENT_ANAESTHESIOLOGIST_BASE_PRICE',
    QuirurgicoComponenteAnestesiologoPrecioBase = 25,

    DescripcionQuirurgicoComponenteAyudantePrecioBase = 'LBL_SURGICAL_COMPONENT_ASSISTANT_BASE_PRICE',
    QuirurgicoComponenteAyudantePrecioBase = 26,

    DescripcionQuirurgicoComponenteSalaPrecioBase = 'LBL_SURGICAL_COMPONENT_ROOM_BASE_PRICE',
    QuirurgicoComponenteSalaPrecioBase = 27,

    DescripcionQuirurgicoComponenteMaterialesPrecioBase = 'LBL_SURGICAL_COMPONENT_MATERIALS_SURGICAL_BASE_PRICE',
    QuirurgicoComponenteMaterialesPrecioBase = 28,
    // Fin

    DescripcionOtrosServicios = 'LBL_OTHER_SERVICES',
    OtrosServicios = 29,

    DescripcionConsultaPreanestesicaISS = 'PREANESTHETIC_CONSULTATION_ISS',
    ConsultaPreanestesicaISS = 30,

    DescripcionConsultaPrequirurgicaISS = 'PRE_SURGERY_CONSULTATION_ISS',
    ConsultaPrequirurgicaISS = 31,

    DescripcionConsultaPreanestesicaSOAT = 'PREANESTHETIC_CONSULTATION_SOAT',
    ConsultaPreanestesicaSOAT = 32,

    DescripcionConsultaPrequirurgicaSOAT = 'PRE_SURGERY_CONSULTATION_SOAT',
    ConsultaPrequirurgicaSOAT = 33,
    //nuevos derechos de sala ISS
    DescripcionQuirurgicoComponenteSalaPartoISS = 'SURGICAL_COMPONENT_BIRTHS',
    QuirurgicoComponenteSalaPartoISS = 34,

    DescripcionQuirurgicoComponenteSalaEspecialISS = 'SURGICAL_COMPONENT_SPECIAL_PROCEDURE',
    QuirurgicoComponenteSalaEspecialISS = 35,

    DescripcionQuirurgicoComponenteSalaEndoscopiaISS = 'SURGICAL_COMPONENT_ENDOSCOPY',
    QuirurgicoComponenteSalaEndoscopiaISS = 36,

    DescripcionQuirurgicoComponenteSalaCuracionesISS = 'SURGICAL_COMPONENT_CURES',
    QuirurgicoComponenteSalaCuracionesISS = 37,

    DescripcionQuirurgicoComponenteSalaObservacionBajoNivelISS = 'SURGICAL_COMPONENT_OBSERVATION_LOW_LEVEL',
    QuirurgicoComponenteSalaObservacionBajoNivelISS = 38,

    DescripcionQuirurgicoComponenteSalaObservacionMedioNivelISS = 'SURGICAL_COMPONENT_OBSERVATION_MEDIUM_LEVEL',
    QuirurgicoComponenteSalaObservacionMedioNivelISS = 39,

    DescripcionQuirurgicoComponenteSalaObservacionAltoNivelISS = 'SURGICAL_COMPONENT_OBSERVATION_HIGH_LEVEL',
    QuirurgicoComponenteSalaObservacionAltoNivelISS = 40,

    DescripcionQuirurgicoComponenteSalaRecuperacionBajoNivelISS = 'SURGICAL_COMPONENT_RECOVERY_LOW_LEVEL',
    QuirurgicoComponenteSalaRecuperacionBajoNivelISS = 41,

    DescripcionQuirurgicoComponenteSalaRecuperacionMedioNivelISS = 'SURGICAL_COMPONENT_RECOVERY_MEDIUM_LEVEL',
    QuirurgicoComponenteSalaRecuperacionMedioNivelISS = 42,

    DescripcionQuirurgicoComponenteSalaRecuperacionAltoNivelISS = 'SURGICAL_COMPONENT_RECOVERY_HIGH_LEVEL',
    QuirurgicoComponenteSalaRecuperacionAltoNivelISS = 43,

    DescripcionDerechosDeSalaObservacionUrgenciasPrimerNivel = 'EMERGENCY_ROOM_RIGHTS_FIRST_LEVEL_SOAT_FACTOR',
    DerechosDeSalaObservacionUrgenciasPrimerNivel = 44,

    DescripcionDerechosDeSalaObservacionUrgenciasSegundoNivel = 'EMERGENCY_ROOM_RIGHTS_SECOND_LEVEL_SOAT_FACTOR',
    DerechosDeSalaObservacionUrgenciasSegundoNivel = 45,

    DescripcionDerechosDeSalaObservacionUrgenciasTerceroNivel = 'EMERGENCY_ROOM_RIGHTS_THIRD_LEVEL_SOAT_FACTOR',
    DerechosDeSalaObservacionUrgenciasTerceroNivel = 46,

    DescripcionSalaCuraciones = 'HEALING_ROOM_SOAT_FACTOR',
    SalaCuraciones = 47
}


export enum EstadoInvima {

    DescripcionVigente = 'LBL_VALID',
    Vigente = 1,

    DescripcionEnTramite = 'LBL_IN_PROCESS',
    EnTramite = 2,

    DescripcionCancelado = 'LBL_CANCELLED',
    Cancelado = 3,

    DescripcionPerdidaFuerza = 'LBL_LOSS_OF_STRENGTH',
    PerdidaFuerza = 4,

    DescripcionTemporalmenteNoComercializableVigente = 'TEMPORARILY_NOT_TRADED_CURRENT',
    TemporalmenteNoComercializableVigente = 5,

    DescripcionTemporalmenteNoComercializableEnTramite = 'TEMPORARILY_NOT_TRADED_CURRENT_IN_PROCESS_OF_RENEWAL',
    TemporalmenteNoComercializableEnTramite = 6,

    DescripcionVencido = 'LBL_DEFEATED',
    Vencido = 7,

    DescripcionNegado = 'LBL_DENIED',
    Negado = 8,

    DescripcionAbandono = 'LBL_ABANDONMENT',
    Abandono = 9,

    DescripcionDesistido = 'LBL_DESISTED',
    Desistido = 10,

    DescripcionNinguno = 'NINGUNO',
    Ninguno = 11
}

export enum ConceptosRips {

    DescripcionConsultas = 'LBL_CONSULTATIONS',
    Consultas = 1,

    DescripcionProcedimientoDiagnostico = 'LBL_DIAGNOSTIC_PROCEDURE',
    ProcedimientoDiagnostico = 2,

    DescripcionProcedimientoTerapNoQuirurgicos = 'LBL_NON_SURGICAL_THERAPEUTIC_PROCEDURE',
    ProcedimientoTerapNoQuirurgicos = 3,

    DescripcionProcedimientoTeraQuirurgicos = 'LBL_THERAPEUTIC_SURGICAL_PROCEDURE',
    ProcedimientoTeraQuirurgicos = 4,

    DescripcionProcedimientoPromocionPrevencion = 'LBL_PREVENTION_PROMOTION_PROCEDURE',
    ProcedimientoPromocionPrevencion = 5,

    DescripcionEstancias = 'LBL_STAYS',
    Estancias = 6,

    DescripcionHonorarios = 'LBL_HONORARIUM',
    Honorarios = 7,

    DescripcionDerechosSala = 'LBL_ROOM_RIGHTS',
    DerechosSala = 8,

    DescripcionMaterialesInsumos = 'LBL_INPUT_MATERIALS',
    MaterialesInsumos = 9,

    DescripcionBancoSangre = 'LBL_BLOOD_BANK',
    BancoSangre = 10,

    DescripcionProtesisOrtesis = 'LBL_PROSTHESIS',
    ProtesisOrtesis = 11,

    DescripcionMedicamentosPos = 'LBL_POS_MEDICATIONS',
    MedicamentosPos = 12,

    DescripcionMedicamentosNoPos = 'LBL_NOT_POS_MEDICATIONS',
    MedicamentosNoPos = 13,

    DescripcionTrasladoPacientes = 'LBL_TRANSFER_PATIENTS',
    TrasladoPacientes = 14,
    
    //Consulta odontológica
    DescripcionConsultaOdontologica = 'LBL_ODONTOLOGIC_CONSULTATION',
    ConsultaOdontologica = 15,
    
    //Consulta de medicina interna
    DescripcionConsultaMedicinaInterna = 'LBL_INTERNAL_MEDICINE_CONSULTATION',
    ConsultaMedicinaInterna = 16,
    
    //Consulta de pediatría
    DescripcionConsultaPediatria = 'LBL_PEDIATRIC_CONSULTATION',
    ConsultaPediatria = 17,
    
    //Consulta de ginecología
    DescripcionConsultaGinecologia = 'LBL_GYNECOLOGIC_CONSULTATION',
    ConsultaGinecologia = 18,
    
    //Consulta de obstetricia
    DescripcionConsultaObstetricia = 'LBL_OBSTETRIC_CONSULTATION',
    ConsultaObstetricia = 19,
    
    //Consulta de cirugía general
    DescripcionConsultaCirugiaGeneral = 'LBL_GENERAL_SURGERY_CONSULTATION',
    ConsultaCirugiaGeneral = 20

}

export enum AlcanceTipoAdicionesPrecio {

    DescripcionNivelGeneral = 'LBL_GENERAL_LEVEL',
    NivelGeneral = 0,

    DescripcionNivelItem = 'LBL_ITEM_LEVEL',
    NivelItem = 1,
}

export enum TomarCostoTipoAdicionesPrecio {

    DescripcionTomarCostoProducto = 'LBL_PROJECTED_COST_PRODUCT',
    TomarCostoProducto = 0,

    DescripcionTomarCostoDocumento = 'LBL_PROJECTED_COST_PRODUCT_DOCUMENT',
    TomarCostoDocumento = 1,
}

export enum TipoPromedioProducto {

    DescripcionPorProducto = 'PR_FOR_PRODUCT',
    PorProducto = 0,

    DescripcionPorVariante = 'PR_FOR_SERIAL_LOT',
    PorVariante = 1
}

export enum DiasSemana {
    DescripcionDomingo = 'Domingo',
    Domingo = 0,

    DescripcionLunes = 'Lunes',
    Lunes = 1,

    DescripcionMartes = 'Martes',
    Martes = 2,

    DescripcionMiercoles = 'Miercoles',
    Miercoles = 3,

    DescripcionJueves = 'Jueves',
    Jueves = 4,

    DescripcionViernes = 'Viernes',
    Viernes = 5,

    DescripcionSabado = 'Sabado',
    Sabado = 6
}

export enum RedondearA {
    'Descripcion0.00001' = 0.00001,
    'Descripcion0.0001' = 0.0001,
    'Descripcion0.001' = 0.001,
    'Descripcion0.01' = 0.01,
    'Descripcion0.1' = 0.1,
    'Descripcion1' = 1,
    'Descripcion10' = 10,
    'Descripcion100' = 100,
    'Descripcion1000' = 1000,
    'Descripcion10000' = 10000,
    'Descripcion100000' = 100000
}

export enum AperturaFiltroCitas {
    FiltroCitas,
    AsignacionCitas
}

export enum TransaccionSISMED {
    DescripcionPrimariaInstitucional = 'Primaria institucional',
    PrimariaInstitucional = '01',

    DescripcionPrimariaComercial = 'Primaria comercial',
    PrimariaComercial = '02',

    DescripcionSecundariaInstitucional = 'Secundaria institucional',
    SecundariaInstitucional = '03',

    DescripcionSecundariaComercial = 'Secundaria comercial',
    SecundariaComercial = '04',

    DescripcionFinalInstitucional = 'Final institucional',
    FinalInstitucional = '05'
}

export enum keyCode {
    Enter = 13,
}

// Propiedades del producto
export enum AperturaProducto {
    MateriaPrima = 1,
    Insumo = 2,
    EnProceso = 3,
    Terminado = 4,
    ParaLaVenta = 5,
    GastoServicio = 6,
    Empaque = 7,
    Dotacion = 8,
    ActivoFijo = 9,
    ServicioSalud = 10,
    MedicamentoDispositivo = 11,
    RubroPresupuestalIngresos = 12,
    RubroPresupuestalEgresos = 13
}

export enum TiposProducto {
    DescripcionProductoParaVenta = 'MN_PRODUCTS_FOR_SALES',
    ProductoParaVenta = 'productoParaVenta',

    DescripcionMateriaPrima = 'MN_PRODUCTS_RAW_MATERIAL',
    MateriaPrima = 'materiaPrima',

    DescripcionInsumo = 'MN_PRODUCTS_SUPPLIES',
    Insumo = 'insumo',

    DescripcionProductoEnProceso = 'MN_PRODUCTS_IN_PROCESS',
    ProductoEnProceso = 'productoEnProceso',

    DescripcionProductoTerminado = 'MN_PRODUCTS_FINISHED',
    ProductoTerminado = 'productoTerminado',

    DescripcionServicio = 'MN_PRODUCTS_EXPENSE_SERVICE',
    Servicio = 'servicio',

    DescripcionEmpaque = 'MN_PRODUCTS_PACKING',
    Empaque = 'empaque',

    DescripcionDotacion = 'MN_PRODUCTS_ENDOWMENT',
    Dotacion = 'dotacion',

    DescripcionProductoActivoFijo = 'LBL_FIXED_ASSETS',
    ProductoActivoFijo = 'productoActivoFijo',

    DescripcionServicioSalud = 'MN_PRODUCTS_HEALTH_SERVICES',
    ServicioSalud = 'servicioSalud',

    DescripcionMedicamentoDispositivo = 'MN_PRODUCTS_MEDICINES_DEVICES',
    MedicamentoDispositivo = 'medicamentoDispositivo',

    DescripcionRubroPresupuestalIngreso = 'MN_BUDGET_ITEM',
    RubroPresupuestalIngreso = 'rubroPresupuestalIngreso',
    DescripcionRubroPresupuestalEgreso = 'MN_BUDGET_ITEM_OUTGOINGS',
    RubroPresupuestalEgreso = 'rubroPresupuestalEgreso'


}

// Grupos quirúrgicos
export enum GruposQuirurgicos {
    DescripcionGrupo01 = 'Grupo 01',
    Grupo01 = '01',

    DescripcionGrupo02 = 'Grupo 02',
    Grupo02 = '02',

    DescripcionGrupo03 = 'Grupo 03',
    Grupo03 = '03',

    DescripcionGrupo04 = 'Grupo 04',
    Grupo04 = '04',

    DescripcionGrupo05 = 'Grupo 05',
    Grupo05 = '05',

    DescripcionGrupo06 = 'Grupo 06',
    Grupo06 = '06',

    DescripcionGrupo07 = 'Grupo 07',
    Grupo07 = '07',

    DescripcionGrupo08 = 'Grupo 08',
    Grupo08 = '08',

    DescripcionGrupo09 = 'Grupo 09',
    Grupo09 = '09',

    DescripcionGrupo10 = 'Grupo 10',
    Grupo10 = '10',

    DescripcionGrupo11 = 'Grupo 11',
    Grupo11 = '11',

    DescripcionGrupo12 = 'Grupo 12',
    Grupo12 = '12',


    DescripcionGrupo13 = 'Grupo 13',
    Grupo13 = '13',

    DescripcionGrupoEspecial20 = 'Grupo especial 20',
    GrupoEspecial20 = '20',

    DescripcionGrupoEspecial21 = 'Grupo especial 21',
    GrupoEspecial21 = '21',

    DescripcionGrupoEspecial22 = 'Grupo especial 22',
    GrupoEspecial22 = '22',

    DescripcionGrupoEspecial23 = 'Grupo especial 23',
    GrupoEspecial23 = '23',

    DescripcionGrupoInterno1 = 'Grupo Interno 1',
    GrupoInterno1 = '24',

    DescripcionGrupoInterno2 = 'Grupo Interno 2',
    GrupoInterno2 = '25',

    DescripcionGrupoInterno3 = 'Grupo Interno 3',
    GrupoInterno3 = '26'
}

export enum TipoInsumoApu {
    DescripcionNinguno = 'NINGUNO',
    Ninguno = 0,

    DescripcionMaterial = 'MATERIAL',
    Material = 1,

    DescripcionManoObra = 'MANO_DE_OBRA',
    ManoObra = 2,

    DescripcionTransporte = 'TRANSPORTE',
    Transporte = 3,

    DescripcionEquipo = 'EQUIPO',
    Equipo = 4,

    DescripcionCIF = 'C.I.F',
    CIF = 5,
}

export enum AmbitoSalud {
    DescripcionAmbulatorio = 'Ambulatorio',
    Ambulatorio = 0,

    DescripcionHospitalario = 'Hospitalario',
    Hospitalario = 1,

    DescripcionUrgencia = 'Urgencia',
    Urgencia = 2
}

export enum FElectronicaAcuseRespuesta {
    DescripcionCorreoNoVistoCliente = 'LBL_MAIL_NOT_SEEN_BY_CLIENT',
    CorreoNoVistoCliente = 0,

    DescripcionCorreoVistoCliente = 'LBL_MAIL_SEEN_BY_CLIENT',
    CorreoVistoCliente = 1,

    DescripcionAceptadoCliente = 'LBL_ACCEPTED_BY_CLIENT',
    AceptadoCliente = 2,

    DescripcionRechazdoCliente = 'LBL_REJECTED_CLIENT',
    RechazdoCliente = 3
}

export enum FElectronicaAcuseRespuestaProveedor {
    DescripcionCorreoNoVistoProveedor = 'LBL_MAIL_NOT_SEEN_BY_SUPPLIER',
    CorreoNoVistoProveedor = 0,

    DescripcionCorreoVistoProveedor = 'LBL_MAIL_SEEN_BY_SUPPLIER',
    CorreoVistoProveedor = 1,

    DescripcionAceptadoProveedor = 'LBL_ACCEPTED_BY_SUPPLIER',
    AceptadoProveedor = 2,

    DescripcionRechazdoProveedor = 'LBL_REJECTED_SUPPLIER',
    RechazdoProveedor = 3
}

export enum FEestadoRepresntacionGrafica {
    DescripcionSinRepresentacionGrafica = 'LBL_WITHOUT_GRAPHIC_REPRESENTATION',
    SinRepresentacionGrafica = 0,

    DescripcionConRepresentacionGrafica = 'LBL_WITH_GENERATED_REPRESENTATION',
    ConRepresentacionGrafica = 1,

    DescripcionRepresentacionEnviaCliente = 'LBL_GRAPHIC_REPRESENTATION_SENT_CLIENT',
    RepresentacionEnviaCliente = 2,
}

export enum TiposProbabilidadCierre {
    DescripcionBaja = 'Baja',
    Baja = 0,

    DescripcionMedia = 'Media',
    Media = 1,

    DescripcionAlta = 'Alta',
    Alta = 2,

    DescripcionMuyAlta = 'Muy Alta',
    MuyAlta = 3
}

export enum ModuloCostos {
    DescripcionGeneral = 'General',
    General = 'CT',

    DescripcionNomina = 'Nómina',
    Nomina = 'NO',
}


export enum Monedas {
    DescripcionDolar = 'Dolar',
    Dolar = 'USD',

    DescripcionEuro = 'Euro',
    Euro = 'EUR',

    DescripcionYuan = 'Yuan',
    Yuan = 'CNY',

    DescripcionLibraEsterlina = 'Libra Esterlina',
    LibraEsterlina = 'GBP',

    DescripcionReal = 'Real',
    Real = 'BRL',

    DescripcionYen = 'Yen',
    Yen = 'JPY',

    DescripcionPesoMexicano = 'Peso Mexicano',
    PesoMexicano = 'MEX',

    DescripcionPesoColombiano = 'Peso Colombiano',
    PesoColombiano = 'COP'
}

export enum TipoConsultaEnOrdenesDeServicio {
    ConsultaOrdenesDeServicio = '1'
}
export enum MonedaExtranjera {
    DescripcionDolar = 'Dólar (USA)',
    Dolar = 'USD',

    DescripcionEuro = 'Euro (Unión Europea)',
    Euro = 'EUR',

    DescripcionLibraEsterlina = 'Libra Esterlina (Reino Unido)',
    LibraEsterlina = 'GBP',

    DescripcionReal = 'Real (Brasil)',
    Real = 'BRL',

    DescripcionYuan = 'Yuan (China)',
    Yuan = 'CNY',

    DescripcionYen = 'Yen (Japon)',
    Yen = 'JPY',

    DescripcionDTF = 'Tasa Interes (DTF)',
    DTF = 'DTF',

    DescripcionMex = 'Peso (Mexico)',
    Mex = 'MEX',

    DescripcionPesoColombiano = 'Peso Colombiano',
    PesoColombiano = 'COP'
}
export enum TabsCapturaDocumentos {
    Ninguno,
    TabSalud,
    TabFinanciera,
    TabContratosProveedor,
    TabVentas,
    TabGeneral,
    TabLogistica,
    TabObservaciones,
    TabDocSoporte,
    TabInformacionPersonalizada
}
export enum TiposConsulta {
    DescripcionConsultaExterna = 'SLD_EXTERNAL_CONSULTATION',
    ConsultaExterna = 1,

    DescripcionHospitalizacion = 'SLD_HOSPITALITATION',
    Hospitalizacion = 2,

    DescripcionPromocionYPrevencion = 'SLD_PROMOTION_AND_PREVENTION',
    PromocionYPrevencion = 3,

    DescripcionSoat = 'SLD_SOAT',
    Soat = 4,

    DescripcionUrgencias = 'SLD_EMERGENCY',
    Urgencias = 5,

    DescripcionCapcom = 'LBL_CAPCOM',
    Capcom = 6,

    DescripcionCirugia = 'SURGERY',
    Cirugia = 7,

    DescripcionEntregaServicios = 'LBL_SERVICES_DELIVERY',
    EntregaServicios = 8,

    DescripcionPartos = 'LBL_NATURAL_BIRTH',
    Partos = 9,

    DescripcionColposcopia = 'LBL_COLPOSCOPY',
    Colposcopia = 10,

    DescripcionPlanificacion = 'LBL_PLANNING',
    Planificacion = 11,

    DescripcionCambioSondaVesical = 'LBL_BLADDER_CATHETER_CHANGE',
    CambioSondaVesical = 12,

    DescripcionCuraciones = 'LBL_CURES',
    Curaciones = 13
}
export enum TipoEntregaDocumento {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',
    Total = 1,
    DescripcionTotal = 'LBL_TOTAL_DELIVERY',
    Parcial = 2,
    DescripcionParcial = 'LBL_PARTIAL_DELIVERY'
}

export enum MetodoDepreciacion {

    Lineal = 0,
    DescripcionLineal = 'LINEAL',

    SumaDeDigitos = 1,
    DescripcionSumaDeDigitos = 'DIGIT_SUM',

    PorUso = 2,
    DescripcionPorUso = 'BY_USE',
}

export enum TiposFormasPagoDian {
    DescripcionEfectivo = 'FORM_OF_PAYMENT_DIAN.EFFECTIVE',
    Efectivo = 10,

    DescripcionTarjetaDebito = 'FORM_OF_PAYMENT_DIAN.DEBIT_VIEW',
    TarjetaDebito = 49,

    DescripcionConsigancionBancaria = 'FORM_OF_PAYMENT_DIAN.BANK_CONSIGNMENT',
    ConsigancionBancaria = 42,

    DescripcionTransferenciaDebitoBancaria = 'FORM_OF_PAYMENT_DIAN.BANK_DEBIT_TRANSFER',
    TransferenciaDebitoBancaria = 47,

    DescripcionTarjetaCredito = 'FORM_OF_PAYMENT_DIAN.CREDIT_VIEW',
    TarjetaCredito = 48,

    DescripcionCheque = 'FORM_OF_PAYMENT_DIAN.CHECK',
    Cheque = 20,

    DescripcionBonos = 'FORM_OF_PAYMENT_DIAN.BONUS',
    Bonos = 71,

    DescripcionVales = 'FORM_OF_PAYMENT_DIAN.VOUCHERS',
    Vales = 72,

    DescripcionInstrumentoNoDefinido = 'FORM_OF_PAYMENT_DIAN.INSTRUMENT_NOT_DEFINED',
    InstrumentoNoDefinido = 1,

    DescripcionOtro = 'LBL_NEITHER',
    Otro = 0,

}

export enum VisualizarTarjeta {
    DescripcionNinguno = 'NONE',
    Ninguno = 0,

    PorEntregar = 1,
    DescripcionPorEntregar = 'MENU_CONTENTS_DOCUMENT.PENDING_DELIVERY',

    AtrasadosEntrega = 3,
    DescripcionAtrasadosEntrega = 'MENU_CONTENTS_DOCUMENT.OVERDUE_DELIVERY',

    PorContabilizar = 2,
    DescripcionPorContabilizar = 'MENU_CONTENTS_DOCUMENT.PENDING_TO_BE_ACCOUNTED_FOR',


    NumeroDocumento = 4,
    DescripcionNumeroDocumento = 'NUMBER_DOCUMENT',

    PendientesPorCufe = 5,
    DescripcionPendientesPorCufe = 'MENU_CONTENTS_DOCUMENT.REQUEST_CUFE_CUDE',

    PendientesVincular = 6,
    DescripcionPendientesVincular = 'LBL_DOCUMENT_UNLINKED'
}

export enum MenuMasAcciones {
    HistorialDeEventos = 0,
    CambioEstado,
    HistorialDeEstado,
    EviarCorreo,
    HistorialDeCorreo,
    CrearActividad,
    HistorialDeActividades,
    ListarFormato,
    ArchivosDigitales,
    LanzarEncueta,
    Auditoria,
    CambiarColor,
    EnviarNotificacion,
    AgregarRecibosMasivo,
    ImportarRecibos,
    AgregarNotasCreditoMasivo,
    ImportarNotasCredito,
    EnviarNotificacionPorCorreo,
    TrasladarCuentasPorCobrar,
    CambioFechasVencimientoFacturas,
    GenerarCobrosIntereses
}

export enum PresentacionMasAcciones {
    Boton = 0,
    Li,
    Ul
}

export enum TiposDiagnostico {
    DescripcionImpresiónDiagnostica = 'Impresión diagnostica',
    ImpresiónDiagnostica = 1,

    DescripcionConfirmadoNuevo = 'Confirmado nuevo',
    ConfirmadoNuevo = 2,

    DescripcionConfirmadoRepetido = 'Confirmado repetido',
    ConfirmadoRepetido = 3
}

export enum EliminarAnular {
    Eliminar = 1,
    Anular = 2,
}

export enum ModoAperturaDevolucionDocumentosComponent {
    DevolucionVentas = 0,
    DuplicarDocumento = 1,
    DevolucionCompras = 2
}

export enum OpcionAperturaGestionCorreos {
    DevolucionVentas = 0,
    DuplicarDocumento = 1
}

export enum Cultura {
    EspanolColombia = 'es-CO',
    EspanolEstadosUnidos = 'es-US',
    InglesEstadosUnidos = 'us-US'
}

export enum PresentacionMovimientoContable {
    Detallado = 0,
    Totalportercero = 1,
    Totalportercero2 = 2,
    Totalpordocumento = 3
}

export enum tipoInterfaces {
    DescripcionFacturasDeVentas = 'MENU_ACCOUNTING_STANDAR.LBL_SALES_INVOICES',
    FacturasDeVentas = 1,

    DescripcionNotasDebitoCxC = 'MENU_ACCOUNTING_STANDAR.LBL_DEBIT_NOTES_CxC',
    NotasDebitoCxC = 2,

    DescripcionNotasCreditoCxC = 'MENU_ACCOUNTING_STANDAR.LBL_CREDIT_NOTES_CxC',
    NotasCreditoCxC = 3,

    DescripcionFacturasCompra = 'MENU_ACCOUNTING_STANDAR.LBL_PURCHASE_INVOICES',
    FacturasCompra = 4,

    DescripcionNotasDebitoCxP = 'MENU_ACCOUNTING_STANDAR.LBL_DEBIT_NOTES_CxP',
    NotasDebitoCxP = 5,

    DescripcionNotasCreditoCxP = 'MENU_ACCOUNTING_STANDAR.LBL_CREDIT_NOTES_CxP',
    NotasCreditoCxP = 6,

    DescripcionCostosDeProduccion = 'MENU_ACCOUNTING_STANDAR.LBL_PRODUCTION_COSTS',
    CostosDeProduccion = 7,

    DescripcionRecibosDeCaja = 'MENU_ACCOUNTING_STANDAR.LBL_CASH_REGISTER_RECEIPTS',
    RecibosDeCaja = 10,

    DescripcionComprobantesEgreso = 'MENU_ACCOUNTING_STANDAR.LBL_PROOFS_OF_DEPARTURE',
    ComprobantesEgreso = 11,

    DescripcionActivosFijos = 'MN_FIXED_ASSETS',
    ActivosFijos = 12,

    DescripcionDevolucionesVentas = 'MENU_ACCOUNTING_STANDAR.LBL_SALES_RETURNS',
    DevolucionesVentas = 13,

    DescripcionDevolucionesCompras = 'MENU_ACCOUNTING_STANDAR.LBL_RETURNS_ON_PURCHASES',
    DevolucionesCompras = 14,

    DescripcionContablesInternos = 'MENU_ACCOUNTING_STANDAR.LBL_INTERNAL_ACCOUNTANTS',
    ContablesInternos = 15,

    DescripcionCostosInventarios = 'MENU_ACCOUNTING_STANDAR.LBL_INVENTORY_COSTS',
    CostosInventarios = 16
}

export enum NaturalezaCD {
    DescripcionCredito = 'LBL_CREDIT',
    Credito = 'C',

    DescripcionDebito = 'LBL_DEBIT',
    Debito = 'D'
}
export enum TipoReferencias {
    DescripcionRemision = 'Remision',
    Remision = 'R',

    DescripcionOrdenDeServicio = 'Orden De Servicio',
    OrdenDeServicio = 'O'

}

export enum TipoTransporte {

    DescripcionAmbulanciaBasica = 'BASIC_AMBULANCE',
    AmbulanciaBasica = 'B',

    DescripcionAmbulanciaMedicalizada = 'MEDICALIZED_AMBULANCE',
    AmbulanciaMedicalizada = 'M'

}

export enum TiposAccidente {

    DescripcionAtaqueMunicipio = 'Ataque Municipio',
    AtaqueMunicipio = 0,

    DescripcionTransito = 'Accidente de transito',
    Transito = 1,

    DescripcionSismo = 'Sismo',
    Sismo = 2,

    DescripcionMaremoto = 'Maremoto',
    Maremoto = 3,

    DescripcionErupcionVolcanica = 'Erupcion Volcanica',
    ErupcionVolcanica = 4,

    DescripcionUracan = 'Uracan',
    Uracan = 5,

    DescripconInundaciones = 'Inundaciones',
    Inundaciones = 6,

    DescripcionAvalancha = 'Avalancha',
    Avalancha = 7,

    DescripcionDeslizamiento = 'Deslizamiento',
    Deslizamiento = 8,

    DescripcionIncendioNatural = 'Incendio Natural',
    IncendioNatural = 9,

    DescripcionExplosion = 'Explosion',
    Explosion = 10,

    DescripcionMasacre = 'Masacre',
    Masacre = 11,

    DescripcionMinaAntiPersonal = 'Mina Anti Personal',
    MinaAntiPersonal = 12,

    DescripcionCombate = 'Combate',
    Combate = 13,

    DescripcionIncendioTerrorista = 'Incendio Terrorista',
    IncendioTerrorista = 14,

    DescripcionDesplazados = 'Desplazados',
    Desplazados = 15,

    DescripcionOtro = 'Otro',
    Otro = 16,

    DescripcionRayo = 'Rayo',
    Rayo = 17,

    DescripcionVendaval = 'Vendaval',
    Vendaval = 18,

    DescripcionTornado = 'Tornado',
    Tornado = 19

}


export enum TiposProceso {
    DescripcionEnsamble = 'Ensamble',
    Ensamble = 'E',

    DescripcionDesensamble = 'Desensamble',
    Desensamble = 'D'
}

export enum MetodoDistribucionCosto {
    DescripcionPorCantidad = 'Por Cantidad',
    PorCantidad = 0,

    DescripcionPorTiempo = 'Por Tiempo',
    PorTiempo = 1,

    DescripcionPorCantidadAlterna = 'Por Cantidad Alterna',
    PorCantidadAlterna = 2,

    DescripcionPorPrecio = 'Por Precio',
    PorPrecio = 3
}

export enum PresentacionAuxiliarSaldos {
    Cuenta = 0,
    CuentaTercero = 1,
    CuentaCentroDeCosto = 2,
    CuentaCentroDeCostoTercero = 3,
    CuentaTerceroCentroDeCosto = 4,
    CuentaNit = 5
}

export enum ModoAperturaHistoriasClinicas {
    HistoriaClinica = 1,
    CitasProgramadas,
    IngresoUrgencias,
    HistoriaClinicaUrgencias
}

export enum MetodosDescuentoDocumento {
    DescripcionValorTotal = 'COMPONENT_APPLY_DISCOUNTS_MASSIVE.APPLY_VALUE_TOTAL', // Aplicar sobre el valor total
    ValorTotal = 0,
    DescripcionValorConDescuento = 'COMPONENT_APPLY_DISCOUNTS_MASSIVE.APPLY_VALUE_WITH_DESC', // Aplicar sobre el valor con descuento
    ValorConDescuento = 1,
}

export enum PresentacionCargarArchivo {
    Icono,
    Boton,
    BononConIcono,
    Enlace,
    Foto,
    TextoConIcono
}

export enum TiposResolucion {
    DescripcionAutorizacion = 'Autorización',
    Autorizacion = 'A',

    DescripcionHabilitacion = 'Habilitación',
    Habilitacion = 'H'
}

export enum TiposFacturacionElectronica {
    SinFacturacionElec = 0,
    DescripcionSinFacturacionElec = 'LBL_DOES_NOT_APPLY',

    FacturacionElecHabi = 1,
    DescripcionFacturacionElecHabi = 'ELECTRONIC_BILLING_ENABLING',

    FacturacionElecProd = 2,
    DescripcionFacturacionElecProd = 'ELECTRONIC_BILLING_PRODUCTION'
}

export enum TiposValidacionCantidadBienSinIva {
    CodigoDeBien = 0,
    DescripcionCodigoDeBien = 'CODE_OF_PROPERTY',

    CodigoDeProduto = 1,
    DescripcionCodigoDeProduto = 'PRODUCT_CODE',
}

export enum DestinoPlantillasCorreo {
    Normal = 1,
    DescripcionNormal = 'SEND_MAIL_NORMAL',

    FacturacionElectronica = 2,
    DescripcionFacturacionElectronica = 'SEND_MAIL_AS_ELECTRONIC_BILL',

    SMS = 3,
    DescripcionSMS = 'SEND_BY_SMS'
}


export enum TiposVehiculosSalud {
    DescripcionAutomovil = "Automóvil",
    Automovil = 1,
    DescripcionBus = "Bus",
    Bus = 2,
    DescripcionBuseta = "Buseta",
    Buseta = 3,
    DescripcionCamion = "Camión",
    Camion = 4,
    DescripcionCamioneta = "Camioneta",
    Camioneta = 5,
    DescripcionCampero = "Campero",
    Campero = 6,
    DescripcionMicrobus = "Microbus",
    Microbus = 7,
    DescripcionTractocamion = "Tractocamión",
    Tractocamion = 8,
    DescripcionMotocicleta = "Motocicleta",
    Motocicleta = 10,
    DescripcionMotocarro = "Motocarro",
    Motocarro = 14,
    DescripcionMototriciclo = "Mototriciclo",
    Mototriciclo = 17,
    DescripcionCuatrimoto = "Cuatrimoto",
    Cuatrimoto = 19,
    DescripcionMotoExtrajera = "Moto Extrajera",
    MotoExtrajera = 20,
    DescripcionVehiculoExtranjero = "Vehículo Extranjero",
    VehiculoExtranjero = 21,
    DescripcionVolqueta = "Volqueta",
    Volqueta = 22,
}

export enum TiposEstadoAseguramiento {
    DescripcionAsegurado = 'COMPONENT_SOAT.INSURED',
    Asegurado = 1,

    DescripcionNoAsegurado = 'COMPONENT_SOAT.NOT_INSURED',
    NoAsegurado = 2,

    DescripcionVehiculoFantasma = 'COMPONENT_SOAT.PHANTOM_VEHICLE',
    VehiculoFantasma = 3,

    DescripcionPolizaFalsa = 'COMPONENT_SOAT.FALSE_POLICY',
    PolizaFalsa = 4,

    DescripcionVehiculoEnFuga = 'COMPONENT_SOAT.FLEEING_VEHICLE',
    VehiculoEnFuga = 5,

    DescripcionAseguradoDecreto2497 = 'Asegurado D.2497',
    AseguradoDecreto2497 = 6,

    DescripcionNoAseguradoPropietarioIndeterminado = 'No asegurado – Propietario Indeterminado',
    NoAseguradoPropietarioIndeterminado = 7

}

export enum TiposEtnia {
    DescripcionNinguna = 'LBL_NEITHER',
    Ninguna = 0,

    DescripcionIndigena = 'COMPONENT_PATIENT.INDIGENOUS',
    Indigena = 1,

    DescripcionRomGitano = 'COMPONENT_PATIENT.GYPSY',
    RomGitano = 2,

    DescripcionRaizal = 'COMPONENT_PATIENT.RAIZAL',
    Raizal = 3,

    DescripcionPalanqueroSanBrasilio = 'COMPONENT_PATIENT.PALANQUERO_OF_SAINT_BRASILIO',
    PalanqueroSanBrasilio = 4,

    DescripcionNegro = 'COMPONENT_PATIENT.NIGGER',
    Negro = 5,

    DescripcionMulato = 'COMPONENT_PATIENT.MULATTO',
    Mulato = 6,

    DescripcionAfrocolombianoOAfro = 'COMPONENT_PATIENT.AFRO_COLOMBIAN_O_AFRO',
    AfrocolombianoOAfro = 7,

    DescripcionOtro = 'COMPONENT_PATIENT.OTHER',
    Otro = 8
}

export enum TiposRecibosCaja {
    PagoFacturas = 'F',
    DescripcionPagoFacturas = 'PAYMENT_INVOICES',

    PagoProvisional = 'X',
    DescripcionPagoProvisional = 'PROVISIONAL_PAYMENT',

    OtrosIngresos = 'O',
    DescripcionOtrosIngresos = 'OTHER_INCOME',

    // Se pone para otras Monedas con valor M para no confundirse con pagos facturas, igual se debe cambiar al
    // momento de enviar a guardar la clase del recibo si es otras monedas
    OtrasMonedas = 'M',
    DescripcionOtrasMonedas = 'OTHER_CURRENCIES',

    NotaCredito = 'C',
    DescripcionNotaCredito = 'LBL_PORTFOLIO_NOTE'
}

export enum BalanceCuentasVisualizar {
    Cuenta = 0,
    CuentaTercero = 1,
    TerceroCuenta = 2,
    CuentaCC = 3,
    CCCuenta = 4,
    CuentaTerceroCC = 5,
    CuentaCCTercero = 6,
    PorMes = 7,
    PorTrimestre = 8,
    CuentaNit = 9,
    NitCuenta = 10,
    CuentaTerceroSinSaldo = 11,
    TerceroCuentaSinSaldo = 12
}

export enum TipoLiquidacion {
    FactorSoat = 0,
    DescripcionFactorSoat = 'LBL_SOAT_FACTOR',

    PrecioBaseISS = 1,
    DescripcionPrecioBaseISS = 'LBL_ISS_BASE_PRICE',

    PrecioEspecifico = 2,
    DescripcionPrecioEspecifico = 'LBL_LAST_PRICE',

    FactorUVT = 3,
    DescripcionFactorUVT = 'LBL_SOAT_UVT_FACTOR'
}

// Enumeración para las opciones de Activo y Inactivo
export enum ActivoInactivo {
    Activo = 'A',
    DescripcionActivo = 'Activo',
    Inactivo = 'I',
    DescripcionInactivo = 'Inactivo'
}
export enum CamposRequeridos {

    // no se debe mostrar el campo
    No = 0,
    DescripcionNo = 'ENUM_REQUIRED_FIELDS.NOT_VISIBLE_IN_DOCUMENT',

    // No es obligatorio y permite ser modificado.
    VisibleModificable = 1,
    DescripcionVisibleModificable = 'ENUM_REQUIRED_FIELDS.NOT_REQUIRED_AND_MODIFY',

    // Es obligatorio y permite ser modificado.
    ObligatorioModificable = 2,
    DescripcionObligatorioModificable = 'ENUM_REQUIRED_FIELDS.REQUIRED_AND_MODIFY',

    // No es obligatorio y no se permite modificar.
    VisibleNoModificable = 3,
    DescripcionVisibleNoModificable = 'ENUM_REQUIRED_FIELDS.NOT_REQUIRED_AND_NOT_MODIFY',

    // Es obligatorio y no se permite modificar.
    ObligatorioNoModificable = 4,
    DescripcionObligatorioNoModificable = 'ENUM_REQUIRED_FIELDS.REQUIRED_AND_NOT_MODIFY',

    // No es obligatorio y permite ser modificado con el documento bloquedado.
    VisibleModificableBloquedado = 5,
    DescripcionVisibleModificableBloquedado = 'ENUM_REQUIRED_FIELDS.NOT_REQUIRED_AND_MODIFY_WITH_DOCUMENT_BLOCKED',

    // Es obligatorio y permite ser modificado con el documento bloquedado.
    ObligatorioModificableBloqueado = 6,
    DescripcionObligatorioModificableBloqueado = 'ENUM_REQUIRED_FIELDS.REQUIRED_AND_MODIFY_WITH_DOCUMENT_BLOCKED',

    // Nunca modificable.
    NuncaModificable = 7,
    DescripcionNuncaModificable = 'ENUM_REQUIRED_FIELDS.NEVER_MODIFY'
}

export enum CamposRequeridosString {

    // no se debe mostrar el campo
    No = 'N',
    DescripcionNo = 'ENUM_REQUIRED_FIELDS.NOT_VISIBLE_IN_DOCUMENT',

    // se debe mostrar pero no es obligatorio y es modificable
    VisibleModificable = 'S',
    DescripcionVisibleModificable = 'ENUM_REQUIRED_FIELDS.NOT_REQUIRED_AND_MODIFY',

    // se debe mostrar, es obligatorio y es modificable
    ObligatorioModificable = 'O',
    DescripcionObligatorioModificable = 'ENUM_REQUIRED_FIELDS.REQUIRED_AND_MODIFY',

    // se debe mostrar y no es modificable
    VisibleNoModificable = 'P',
    DescripcionVisibleNoModificable = 'ENUM_REQUIRED_FIELDS.NOT_REQUIRED_AND_NOT_MODIFY',

    // se debe mostrar y es obligatorio pero no es modificable
    ObligatorioNoModificable = 'R',
    DescripcionObligatorioNoModificable = 'ENUM_REQUIRED_FIELDS.REQUIRED_AND_NOT_MODIFY',

    // No es obligatorio y permite ser modificado con el documento bloquedado.
    VisibleModificableBloquedado = 'B',
    DescripcionVisibleModificableBloquedado = 'ENUM_REQUIRED_FIELDS.NOT_REQUIRED_AND_MODIFY_WITH_DOCUMENT_BLOCKED',

    // Es obligatorio y permite ser modificado con el documento bloquedado.
    ObligatorioModificableBloqueado = 'K',
    DescripcionObligatorioModificableBloqueado = 'ENUM_REQUIRED_FIELDS.REQUIRED_AND_MODIFY_WITH_DOCUMENT_BLOCKED',

    // Nunca modificable
    NuncaModificable = 'X',
    DescripcionNuncaModificable = 'ENUM_REQUIRED_FIELDS.NEVER_MODIFY'
}

export enum MenuListaPrecios {
    Ventas = 1,
    Salud = 2,
}

export enum ProcesosSistema {
    LiquidacionNomina = 0,
    descripcionLiquidacionNomina = 'LIQUIDATION_OF_PAYROLL',

    ImportarTercero = 1,
    descripcionImportarTercero = 'SYSTEM_NOTIFICATIONS.MN_IMPORTING_CUSTOMER',

    ImportarDocumento = 2,
    descripcionImportarDocumento = 'SYSTEM_NOTIFICATIONS.IMPORTING_DOCUMENT',

    FacturacionPeriodica = 3,
    descripcionFacturacionPeriodica = 'PERIODIC_BILLING',

    ActualizarInventarioWoocomerce = 4,
    descripcionActualizarInventarioWoocomerce = 'LBL_UPDATE_WOOCOMMERCE_INVENTORY'
}
export enum EnumTipoCaja {
    CajaMenor = 0,
    DescripcionCajaMenor = 'MN_PETTY_CASH',

    CajaGeneral = 1,
    DescripcionCajaGeneral = 'GENERAL_CASH',

    RelacionGastos = 2,
    DescripcionRelacionGastos = 'EXPENSES'
}

export enum TipoOperacionMipres {
    Direccionamiento = 1,
    DescripcionDireccionamiento = 'ADDRESSING',

    Programacion = 2,
    DescripcionProgramacion = 'PROGRAMMING',

    Entrega = 3,
    DescripcionEntrega = 'LBL_DELIVERY',

    ReporteDeEntrega = 4,
    DescripcionReporteDeEntrega = 'DELIVERY_REPORTS',

    Facturacion = 5,
    DescripcionFacturacion = 'MN_RULES_BILLING_LOGISTICS.FACT',
}
export enum TipoMovimiento {
    DescripcionTodos = 'Todos',
    Todos = 0,

    DescripcionSoloDebitos = 'Solo Débitos',
    SoloDebitos = 1,

    DescripcionSoloCreditos = 'Solo Créditos',
    SoloCreditos = 2
}

export enum FomraGeneracionRips {
    DescripcionIndividual = 'LBL_INDIVIDUAL',
    Individual = 0,
    DescripcionRemision = 'LBL_REMISSION',
    Remision = 1
}

export enum RipsAGenerar {
    DescripcionAgrupado = 'GROUPED',
    Agrupado = 'AD',
    DescripcionTransacciones = 'TRANSACTION',
    Transacciones = 'AF',
    DescripcionProcedimientos = 'PROCEDURES',
    Procedimientos = 'AP',
    DescripcionConsultas = 'MN_QUERIES',
    Consultas = 'AC',
    DescripcionUsuarios = 'OF_LABEL_USERS',
    Usuarios = 'US',
    DescripcionMedicamentos = 'MEDICINES',
    Medicamentos = 'AM',
    DescripcionOtrosServicios = 'LBL_OTHER_SERVICES',
    OtrosServicios = 'AT',
    DescripcionEventos = 'FAC_CONCEPT_EVENT_TITLE',
    Eventos = 'ST',
    //Rips adicionales tecnomedica
    DescripcionDispositivosMedicosNoPos = 'NON_DEVICE_MEDICAL_POS',
    DispositivosMedicosNoPos = 'DMNP',
    DescripcionMedicamentosConIva = 'MEDICINES_VAT',
    MedicamentosConIva = 'MCI',
    DescripcionMedicamentosSinIva = 'MEDICINES_FREE_VAT',
    MedicamentosSinIva = 'MSI',
    DescripcionMedicamentosConYSinIva = 'MEDICINES_VAT_FREE_VAT',
    MedicamentosConYSinIva = 'MCYS'
}

export enum TagBoxRips {
    NumeroRadicado = 1,
    Prefijos = 2,
    NumeroDocumento = 3
}

export enum TagBoxNotificacionesDocumentos {
    CorreoPrefijo = 1,
    AlertaPrefijo = 2
}

export enum OpcionesGeneracionDocumentosMultiples {
    DocumentoADocumento = 0,
    DocumentoUnicoNuevo = 1,
    DocumentoUnicoExistente = 2,
    DocumentoPorCliente = 3
}

export enum NaturalezaJuridica {
    PersonaJuridica = 'J',
    DescripcionPersonaJuridica = 'LEGAL_PERSON_AND_ASSIMILATED',
    PersonaNatural = 'N',
    DescripcionPersonaNatural = 'NATURAL_AND_ASSIMILATED_PERSON'
}

export enum ModoFacturacion {
    Citas,
    HistoriaCLinica
}

export enum TomarCosto {

    PromedioAlmacen = '1',
    DescripcionPromedioAlmacen = 'MENU_CONTENTS_PARAMETERS.AVERAGE_WAREHOUSE',

    Producto = '2',
    DescripcionProducto = 'LABEL_PRODUCT',

    ProductoActualizar = '3',
    DescripcionProductoActualizar = 'MENU_CONTENTS_PARAMETERS.PRODUCT_AND_UPDATE_IT',

    Proveedor = '4',
    DescripcionProveedor = 'PROVIDER',

    ProveedorActualizar = '5',
    DescripcionProveedorActualizar = 'MENU_CONTENTS_PARAMETERS.PROVIDER_AND_UPDATE_IT',

    ListaDeCosto = '6',
    DescripcionListaDeCosto = 'MENU_CONTENTS_PARAMETERS.COSTS_LIST_PROVIDER',

    Kit = '7',
    DescripcionKit = 'LBL_CURRENT_PRODUCTION_COST',

    KitActualizar = '8',
    DescripcionKitActualizar = 'MENU_CONTENTS_PARAMETERS.KIT_AND_UPDATE_IT',

    PromedioAlmacenActualizarloRecostear = '9',
    DescripcionPromedioAlmacenActualizarloRecostear = 'MENU_CONTENTS_PARAMETERS.AVERAGE_WAREHOUSE_AND_UPDATE_TO_RECOSTING',

    CostoEmpaque = '10',
    DescripcionCostoEmpaque = 'MENU_CONTENTS_PARAMETERS.PACKAGE_COST',

    CostoDocumentoConsumo = '11',
    DescripcionCostoDocumentoConsumo = 'MENU_CONTENTS_PARAMETERS.LBL_COST_CONSUME_DOCUMENTO'
}
export enum TomarPrecio {

    Producto = 1,
    DescripcionProducto = 'LABEL_PRODUCT',

    Cliente = 2,
    DescripcionCliente = 'LBL_CUSTOMER',

    ClienteActualizar = 3,
    DescripcionClienteActualizar = 'MENU_CONTENTS_PARAMETERS.CUSTOMER_AND_UPDATE_IT',

    ListaCliente = 4,
    DescripcionListaCliente = 'LBL_LIST_PRICES_CUSTOMER_AGREEMENT',

    NumeroPrecio = 5,
    DescripcionNumeroPrecio = 'MENU_CONTENTS_PARAMETERS.NUMBER_OF_PRICE_CLIENT_PREFIX',

    PrecioEmpaque = 6,
    DescripcionPrecioEmpaque = 'MENU_CONTENTS_PARAMETERS.PACKAGE_PRICE',

    PrecioPorCantidad = 7,
    DescripcionPrecioPorCantidad = 'MENU_CONTENTS_PARAMETERS.PRICE_PER_QUANTITY_RANGES'
}
export enum TomarCostoManejo {
    DocumentoOrigen = 'S',
    DescripcionDocumentoOrigen = 'DOCUMENT_ORIGIN',

    ProveedorActualAlmacen = 'N',
    DescripcionProveedorActualAlmacen = 'MENU_CONTENTS_PARAMETERS.CURRENT_WAREHOUSE_AVARAGE',

    Proveedor = '3',
    DescripcionProveedor = 'PROVIDER',

    ListaCostoProveedor = 'L',
    DescripcionListaCostoProveedor = 'MENU_CONTENTS_PARAMETERS.COSTS_LIST_PROVIDER',

    Producto = '5',
    DescripcionProducto = 'LABEL_PRODUCT',

    Kit = '6',
    DescripcionKit = 'LBL_KIT'
}
export enum TomarPrecioManejo {
    DocumentoOrigen = 'S',
    DescripcionDocumentoOrigen = 'DOCUMENT_ORIGIN',

    Cliente = '2',
    DescripcionCliente = 'LBL_CUSTOMER',

    ListaPrecio = '3',
    DescripcionListaPrecio = 'LBL_LIST_PRICES_CUSTOMER_AGREEMENT',

    NumeroPrecio = '4',
    DescripcionNumeroPrecio = 'MENU_CONTENTS_PARAMETERS.NUMBER_OF_PRICE_CLIENT_PREFIX',

    PrecioBaseActual = 'N',
    DescripcionPrecioBaseActual = 'MENU_CONTENTS_PARAMETERS.CURRENT_BASE_PRICE',

    PrecioEmpaque = '6',
    DescripcionPrecioEmpaque = 'MENU_CONTENTS_PARAMETERS.PACKAGE_PRICE',

    PrecioPorCantidad = '7',
    DescripcionPrecioPorCantidad = 'MENU_CONTENTS_PARAMETERS.PRICE_PER_QUANTITY_RANGES'
}
export enum PresentacionPantalla {
    Institucional = 'N',
    DescripcionInstitucional = 'MENU_CONTENTS_PARAMETERS.LBL_INTITUTIONAL',

    PuntoVentaGeneral = 'G',
    DescripcionPuntoVentaGeneral = 'MENU_CONTENTS_PARAMETERS.GENERAL_POINT_OF_SALE',

    PuntoVentaMenuProducto = 'C',
    DescripcionPuntoVentaMenuProducto = 'MENU_CONTENTS_PARAMETERS.POINT_OF_SALE_WIDTH_MENU_PRODUCT',

    PuntoVentaMenuProductoMesa = 'M',
    DescripcionPuntoVentaMenuProductoMesa = 'MENU_CONTENTS_PARAMETERS.POINT_OF_SALE_WITH_MENU_PRODUCT_AND_TABLE',

    EcommerceCarrito = 'E',
    DescripcionEcommerceCarrito = 'MENU_CONTENTS_PARAMETERS.ECOMMERCE_SHOPPING_CART'

}
export enum ManejoBodegaAlmacen {
    DejarIgualDocumentoOrigen = 'S',
    DescripcionDejarIgualDocumentoOrigen = 'MENU_CONTENTS_PARAMETERS.LEAVE_SAME_SOURCE_DOCUMENT',

    InvertirAlmacenes = 'N',
    DescripcionInvertirAlmacenes = 'MENU_CONTENTS_PARAMETERS.REVERSE_WAREHOUSES'
}
export enum TomarCentroCosto {
    Prefijo = 1,
    DescripcionPrefijo = 'DOC_PREFIX',

    OficinaPuntoPago = 2,
    DescripcionOficinaPuntoPago = 'MENU_CONTENTS_PARAMETERS.OFFICE_POINT_OF_PAY',

    Tercero = 3,
    DescripcionTercero = 'LBL_CLIENT',

    Almacen = 4,
    DescripcionAlmacen = 'WAREHOUSE',

    GrupoProducto = 5,
    DescripcionGrupoProducto = 'MENU_CONTENTS_PARAMETERS.GROUP_PRODUCT'
}
export enum ControlDisponibilidad {
    NoControla = 0,
    DescripcionNoControla = 'MENU_CONTENTS_INFORMATION_REQUESTED.LBL_DOESNT_CONTROL',

    ControlaIncluyendoOrdenarCompra = 1,
    DescripcionControlaIncluyendoOrdenarCompra = 'MENU_CONTENTS_INFORMATION_REQUESTED.LBL_CONTROL_INCLUDING_PURCHASE_ORDER',

    ControlarSinIncluirOrdenarCompra = 2,
    DescripcionControlarSinIncluirOrdenarCompra = 'MENU_CONTENTS_INFORMATION_REQUESTED.LBL_CONTROL_WITHOUT_PURCHASE_ORDER'
}

export enum AplicarDescuentos {
    ValorSinIva = 'N',
    DescripcionValorSinIva = 'MENU_CONTENTS_PARAMETERS.LBL_VALUE_WITHOUT_IVA',

    ValorConIva = 'S',
    DescripcionValorConIva = 'MENU_CONTENTS_PARAMETERS.LBL_VALUE_WITH_IVA'
}
export enum Naturaleza {
    EntradaInventario = 'E',
    DescripcionEntradaInventario = 'MENU_CONTENTS_DOCUMENT.ENTRY_TO_STOCK',

    SalidaInventario = 'S',
    DescripcionSalidaInventario = 'MENU_CONTENTS_DOCUMENT.INVENTORY_OUTPUT'
}
export enum SolicitarEnDocumento {
    PrecioVenta = 'S',
    DescripcionPrecioVenta = 'MENU_CONTENTS_DOCUMENT.SALES_PRICE',

    CostoCompra = 'N',
    DescripcionCostoCompra = 'MENU_CONTENTS_DOCUMENT.PURCHASE_COST'
}
export enum SolicitarCostoAutomatico {
    CostoPromedio = 'S',
    DescripcionCostoPromedio = 'AUTO_COST',

    CostoCompraProduccion = 'N',
    DescripcionCostoCompraProduccion = 'MENU_CONTENTS_DOCUMENT.BUY_PRODUCTON_COST'
}
export enum PedidosPendientes {
    DescripcionOrdenesDeCompra = 'LBL_PURCHASE_ORDERS',
    OrdenesDeCompra = 1,
    DescripcionPedidoClientes = 'CUSTOMER_ORDERS',
    PedidoClientes = 2
}
export enum OrigenDestino {
    Origen = 1,
    DescripcionOrigen = 'ORIGIN_ANIMAL',

    Destino = 2,
    DescripcionDestino = 'LBL_DESTINATION'
}
export enum tiposPromedio {
    DescripcionMesesUltimoAño = 'EMPLOYEE_GROUPS_COMPONENT.MONTHS_OF_THE_CURRENT_YEAR',
    MesesUltimoAño = 0,
    DescripcionUltimosDoceMeses = 'EMPLOYEE_GROUPS_COMPONENT.LAST_TWELVE_MONTHS',
    UltimosDoceMeses = 1
}

export enum EstadosWocommerce {
    DescripcionPending = 'WOOCOMMERCE_TRADS.PENDING',
    Pending = 1,
    DescripcionShipped = 'WOOCOMMERCE_TRADS.SHIPPED',
    Shipped = 2,
    DescripcionProcessing = 'WOOCOMMERCE_TRADS.PROCESSING',
    Processing = 3,
    DescripcionOnHold = 'WOOCOMMERCE_TRADS.ONHOLD',
    Onhold = 4,
    DescripcionCompleted = 'WOOCOMMERCE_TRADS.COMPLETED',
    Completed = 5,
    DescripcionCancelled = 'WOOCOMMERCE_TRADS.CANCELLED',
    Cancelled = 6,
    DescripcionRefunded = 'WOOCOMMERCE_TRADS.REFUNDED',
    Refunded = 7,
    DescripcionFailed = 'WOOCOMMERCE_TRADS.FAILED',
    Failed = 8,
    DescripcionAll = 'LABEL_ALL_PLURAL',
    All = 9
}

export enum PeriodoNomina {
    Mensual = 1,
    DescripcionMensual = 'LBL_MONTHLY',

    Quincenal = 2,
    DescripiconQuincenal = 'LBL_EVERY_TWO_WEEKS'
}

export enum GenerarDocumentoContabilidad {
    DocumentoPorTipoNomina = 'N',
    DescripcionDocumentoPorTipoNomina = 'MENUS_PAY_SHEET_TYPE.DOCUMENT_PAYROLL_DOCUMENT_TYPE',

    DocumentoPorTipoNominaCentroCosto = 'C',
    DescripcionDocumentoPorTipoNominaCentroCosto = 'MENUS_PAY_SHEET_TYPE.DOCUMENT_EACH_TYPE_PAYROLL_COST_CENTER',

    DocumentoPorEmpleado = 'E',
    DescripcionDocumentoPorEmpleado = 'MENUS_PAY_SHEET_TYPE.DOCUMENT_PER_EMPLOYEE'
}
export enum OrigenLiquidacionNomina {
    DescripcionLiquidacionNomina = 'N',
    LiquidacionNomina = 1,
    DescripcionLiquidacionVacaciones = 'V',
    LiquidacionVacaciones = 2,
    DescripcionLiquidacionContrato = 'C',
    LiquidacionContrato = 3,
    DescripcionLiquidacionNovedadesEnVacaciones = 'W',
    LiquidacionNovedadesEnVacaciones = 4
}


export enum TiposDeCargo {
    Jefactura = 0,
    DescripcionJefactura = 'LBL_HEADSHIP',

    Profesional = 1,
    DescripcionProfesional = 'LBL_PROFESSIONAL',

    Auxiliar = 2,
    DescripcionAuxiliar = 'LBL_AUXILIARY',

    Operario = 3,
    DescripcionOperario = 'LBL_OPERATOR'
}

export enum SiyNoString {
    No = 'N',
    Si = 'S'
}
export enum GruposPlanDeCuentas {
    Activo = '1',
    DescripcionActivo = 'ACTIVE',

    Pasivo = '2',
    DescripcionPasivo = 'MENU_ACCOUNTING_PLAN.LBL_PASSIVE',

    Patrimonio = '3',
    DescripcionPatrimonio = 'MENU_ACCOUNTING_PLAN.LBL_HERITAGE',

    Ingresos = '4',
    DescripcionIngresos = 'D_PROCESS_INGRESS',

    Gastos = '5',
    DescripcionGastos = 'SPENDS',

    CostosDeVentas = '6',
    DescripcionCostosDeVentas = 'MENU_ACCOUNTING_PLAN.LBL_SELLING_COST',

    CostosDeProduccionOperacion = '7',
    DescripcionCostosDeProduccionOperacion = 'MENU_ACCOUNTING_PLAN.LBL_PRODUCTION_OPERATION_COST',

    CuentasDeOrdenDeudoras = '8',
    DescripcionCuentasDeOrdenDeudoras = 'MENU_ACCOUNTING_PLAN.LBL_DEPTOR_MEMORANDUM_ACCOUNTS',

    CuentasDeOrdenAcreedoras = '9',
    DescripcionCuentasDeOrdenAcreedoras = 'MENU_ACCOUNTING_PLAN.LBL_CREDITOR_MEMORANDUM_ACCOUNTS'
}
export enum TiposPlanDeCuentas {
    Mayor = 'S',
    DescripcionMayor = 'LBL_GREATERTHAN',

    Movimiento = 'D',
    DescripcionMovimiento = 'LBL_TRANSFER'
}
export enum ClaseDeCuenta {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',

    RetefuentePracticada = 1,
    DescripcionRetefuentePracticada = 'MENU_ACCOUNTING_PLAN.REFUEL_PRACTICED',

    ReteivaRegimenCompunPracticada = 3,
    DescripcionReteivaRegimenCompunPracticada = 'MENU_ACCOUNTING_PLAN.RESISTANCE_COMMON_REGIMEN_PRACTICADE',

    ReteIvaNoDomiciliados = 4,
    DescripcionReteIvaNoDomiciliados = 'MENU_ACCOUNTING_PLAN.RESISTANCE_NO_DOMICILED_PRACTICED',

    ReteivaAsumidoRegimenSimplificado = 5,
    DescripcionReteivaAsumidoRegimenSimplificado = 'MENU_ACCOUNTING_PLAN.RESISTANCE_ASSUMED_SIMPLIFIELD_REGIME',

    RetefuenteTituloTimbreProcesad = 6,
    DescripcionRetefuenteTituloTimbreProcesad = 'MENU_ACCOUNTING_PLAN.RETEFUEL_PRACTICAL_BELL_TITLE',

    IngresosBrutosRecibidosPorOperacionesPropias = 7,
    DescripcionIngresosBrutosRecibidosPorOperacionesPropias = 'MENU_ACCOUNTING_PLAN.GROSS_INCOME_RECEIVED_FROM_OWN_OPERATIONS',

    IngresosConsorciosOUnionesTemporales = 8,
    DescripcionIngresosConsorciosOUnionesTemporales = 'MENU_ACCOUNTING_PLAN.INCOME_THROUGHT_CONSORTIUMS_OR_JOIN_TEMPORARY',

    IngresosContratosMandatosAdministraciónDelegada = 9,
    DescripcionIngresosContratosMandatosAdministraciónDelegada = 'MENU_ACCOUNTING_PLAN.INCOME_THROUGHT_MANDATE_CONTRACTS_DELGATED_ADMINISTRATION',

    IngresosExploracionExplotacionMinerales = 10,
    DescripcionIngresosExploracionExplotacionMinerales = 'MENU_ACCOUNTING_PLAN.INCOME_FROM_MINERAL_EXPLORATION_AND_EXPLOITATION',

    IngresosFiducia = 11,
    DescripcionIngresosFiducia = 'MENU_ACCOUNTING_PLAN.INCOME_THROUGH_TRUST',

    IngresosRecibidosTercero = 12,
    DescripcionIngresosRecibidosTercero = 'MENU_ACCOUNTING_PLAN.INCOME_RECEIVED_THROUGH_CLIENT',

    RetencionICAPracticada = 13,
    DescripcionRetencionICAPracticada = 'MENU_ACCOUNTING_PLAN.ICA_RETENTION_PRACTICED',

    RetencionCREEPracticada = 14,
    DescripcionRetencionCREEPracticada = 'MENU_ACCOUNTING_PLAN.CREE_RETENTION_PRACTICED',

    RetencionIvaVentas = 15,
    DescripcionRetencionIvaVentas = 'IVA_RETENCION_SALES',

    RetencionFuenteVentas = 16,
    DescripcionRetencionFuenteVentas = 'SOURCE_RETENCION_SALES',

    RetencionIcaVentas = 17,
    DescripcionRetencionIcaVentas = 'ICA_RETENCION_SALES',

    RetencionCreeVentas = 18,
    DescripcionRetencionCreeVentas = 'CREE_RETENCION_SALES',

    ImpuestoConsumo = 19,
    DescripcionImpuestoConsumo = 'INV_TAX_FEE_2',

    IngresosEmpresasConjuntas = 20,
    DescripcionIngresosEmpresasConjuntas = 'MENU_ACCOUNTING_PLAN.INCOME_THROUGH_JOIN_VENTURE',

    IngresosCuentasParticipación = 21,
    DescripcionIngresosCuentasParticipación = 'MENU_ACCOUNTING_PLAN.INCOME_THROUGH_PARTICIPATION_ACCOUNTS',

    IngresosConvenionCooperacionEntidadesPublicas = 22,
    DescripcionIngresosConvenionCooperacionEntidadesPublicas = 'MENU_ACCOUNTING_PLAN.INCOME_THROUGH_COOPERATION_AGREEMENTS_PUBLIC_ENTITIES'
}
export enum ManejoDeSaldos {
    PorTercero = 'N',
    DescripcionPorTercero = 'MENU_ACCOUNTING_PLAN.BY_THIRD_PARTY',

    PorTerceroDocumentoReferencia = 'D',
    DescripcionPorTerceroDocumentoReferencia = 'MENU_ACCOUNTING_PLAN.BY_THIRD_PARTY_AND_REFERENCE_DOCUMENT'
}

export enum MenuHistoriaClinica {
    AsignarCita,
    EliminarCita,
    CambiarEstadoCita,
    HistorialEstadoCita,
    FacturarCita,
    AnularDocumento,
    ArchivosDigitalesCita,
    VerHistoria,
    CambioEstadoHistoria,
    HistorialEstadoHistoria,
    ListarHistoria,
    FacturarHistoria,
    ArchivosDigitalesHistoria
}
export enum TipoSalario {
    TipoFijo = 'N',
    DescripcionTipoFijo = 'FIXED',

    TipoIntegral = 'S',
    DescripcionTipoIntegral = 'LBL_INTEGRAL',

    TipoVariable = 'V',
    DescripcionTipoVariable = 'VARIABLE'
}

export enum OperacionesBD {
    CrearUsuario,
    VincularBD
}

export enum DevolverCantidadesPendientes {
    DejarCantidadPendiente = 0,
    DescripcionDejarCantidadPendiente = 'LEAVE_PENDING_AMOUNT',

    ReEntregarDevolver = 1,
    DescripcionReEntregarDevolver = 'RESEND_RETURN_PRODUCTS',

    CancelarCantidadPendiente = 2,
    DescripcionCancelarCantidadPendiente = 'CANCEL_PENDING_AMOUNTS'
}
export enum PresentacionGridBasesLiquidacion {
    ResumenPorConcepto = 1,
    DescripcionResumenPorConcepto = 'BASES_LIQUIDATION_COMPONENT.SUMMARY_BY_CONCEPT',

    Detallado = 2,
    DescripcionDetallado = 'DETAILED'
}

export enum VisualizarEcommerce {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',

    EnEcommerce = 1,
    DescripcionEnEcommerce = 'MENU_PRODUCT.STATE_IN_ECOMMERCE',

    EnPuntoDeVenta = 2,
    DescripcionEnPuntoDeVenta = 'MENU_PRODUCT.STATE_IN_POINT_OF_SALE',

    Ambos = 3,
    DescripcionAmbos = 'LBL_CONFIG_PROJ_PED'

}
export enum ClasesDocumentoCompra {
    RequisitoCompra = 'RC',
    DescripcionRequisitoCompra = 'PURCHASE_REQUISITION',

    ComprasRemision = 'CR',
    DescripcionComprasRemision = 'REFERRAL_PURCHASE',

    NotaCreditoCXP = 'NCP',
    DescripcionNotaCreditoCXP = 'CREDIT_NOTE_CXP',

    CotizacionCompra = 'CC',
    DescripcionCotizacionCompra = 'PURCHASE_QUOTE',

    FacturaCompra = 'CO',
    DescripcionFacturaCompra = 'INVOICE_BUY',

    NotaDebitoCXP = 'NDP',
    DescripcionNotaDebitoCXP = 'DEBIT_NOTE_CXP',

    OrdenCompra = 'OC',
    DescripcionOrdenCompra = 'LBL_PURCHASE_ORDER',

    NotaCreditoFacturaCompra = 'DC',
    DescripcionNotaCreditoFacturaCompra = 'MENU_CONTENTS_DOCUMENT.CREDIT_NOTE_INVOICE_PURCHASES',

    PropositoEspecifico = 'PEC',
    DescripcionPropositoEspecifico = 'SPECIFIC_PURPOSE',

    RecepcionMercancia = 'RM',
    DescripcionRecepcionMercancia = 'RECEPTION_OF_GOODS',

    AjustesCosto = 'AC',
    DescripcionAjustesCosto = 'MN_COST_ADJUSTMENTS',

    NotaDebitoFacturaCompra = '9C',
    DescripcionNotaDebitoFacturaCompra = 'MENU_CONTENTS_DOCUMENT.DEBIT_NOTE_INVOICE_PURCHASES'
}
export enum ClasesDocumentoVenta {
    Cotizacion = 'CT',
    DescripcionCotizacion = 'LBL_CONTRIBUTE',

    NotaCreditoCXC = 'IG',
    DescripcionNotaCreditoCXC = 'CREDIT_NOTE_CXC',

    PedidosClientes = 'PE',
    DescripcionPedidosClientes = 'CUSTOMER_ORDERS',

    NotaDebitoCXC = 'NDC',
    DescripcionNotaDebitoCXC = 'MENU_CONTENTS_DOCUMENT.DEBIT_NOTE_CXC',

    Reservas = 'RS',
    DescripcionReservas = 'LBL_RESERVS',

    Remisiones = 'RE',
    DescripcionRemisiones = 'LBL_REMISSIONS',

    PropositoEspecifico = 'PEV',
    DescripcionPropositoEspecifico = 'SPECIFIC_PURPOSE',

    FacturaVenta = 'FV',
    DescripcionFacturaVenta = 'INVOICE_SALES',

    Traslados = 'TR',
    DescripcionTraslados = 'MN_FRIGO_TRANSFERS',

    NotaCreditoFacturaVenta = 'DV',
    DescripcionNotaCreditoFacturaVenta = 'MENU_CONTENTS_DOCUMENT.CREDIT_NOTE_INVOICE_SALES',

    ContratosClientesFacturacionPeriodica = 'CRC',
    DescripcionContratosClientesFacturacionPeriodica = 'LBL_CONTRACT_CUSTOMER',

    PronosticoVentasCliente = 'FO',
    DescripcionPronosticoVentasCliente = 'PROGNOSTIC_SALES_CUSTOMER',

    NotaDebitoFacturaVenta = '9V',
    DescripcionNotaDebitoFacturaVenta = 'DEBIT_NOTE_PAYMENT'
}
export enum ClasesDocumentoEgreso {
    Egresos = 'EG',
    DescripcionEgresos = 'MENU_ACCOUNTING_STANDAR.LBL_PROOFS_OF_DEPARTURE'
}
export enum ClasesDocumentoIngreso {
    Ingresos = 'IG',
    DescripcionIngresos = 'MENU_ACCOUNTING_STANDAR.LBL_CASH_REGISTER_RECEIPTS'
}
export enum ClasesDocumentoInventario {
    AjusteConteoSalida = 'CFS',
    DescripcionAjusteConteoSalida = 'COUNTING_OUTPUT_ADJUSTMENT',

    AjustesCosto = 'AC',
    DescripcionAjustesCosto = 'MN_COST_ADJUSTMENTS',

    AjusteConteoEntrada = 'CFE',
    DescripcionAjusteConteoEntrada = 'COUNTING_INPUT_ADJUSTMENT',

    ConteoFisico = 'FI',
    DescripcionConteoFisico = 'PHYSICAL_COUNT',

    Traslados = 'TR',
    DescripcionTraslados = 'MN_FRIGO_TRANSFERS',

    PropositoEspecifico = 'US',
    DescripcionPropositoEspecifico = 'SPECIFIC_PURPOSE'
}
export enum ClasesDocumentoContable {
    Contable = 'CTB',
    DescripcionContable = 'LBL_COUNTABLE',

    ContableWeb = 'CW',
    DescripcionContableWeb = 'LBL_WEB_COUNTABLE'
}
export enum ClasesDocumentoOrdenTrabajo {
    OrdenTrabajo = 'PPR',
    DescripcionOrdenTrabajo = 'WORK_ORDER',

    OrdenTrabajoVariante = 'PPC',
    DescripcionOrdenTrabajoVariante = 'WORK_ORDER_BY_VARIANT'
}
export enum ClasesDocumentoInvProduccYPresptPublic {
    OrdenProduccion = 'OP',
    DescripcionOrdenProduccion = 'ENUM_INV_PRODUCTION_AND_BUDGET.PRODUCTION_ORDER',

    EntradaProduccion = 'EP',
    DescripcionEntradaProduccion = 'ENUM_INV_PRODUCTION_AND_BUDGET.PRODUCTION_ENTRANCE',

    ConsumoProduccion = 'CP',
    DescripcionConsumoProduccion = 'ENUM_INV_PRODUCTION_AND_BUDGET.CONSUMPTION_OF_PRODUCTION',

    PropositoEspecifico = 'PG',
    DescripcionPropositoEspecifico = 'ENUM_INV_PRODUCTION_AND_BUDGET.SPECIFIC_PURPOSE',

    IngresosCredito = 'I4',
    DescripcionIngresosCredito = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_CREDIT',

    IngresosContracredito = 'I5',
    DescripcionIngresosContracredito = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_COUNTERCLAIMS',

    IngresosAdiciones = 'I1',
    DescripcionIngresosAdiciones = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_ADDITIONS',

    IngresosReducciones = 'I2',
    DescripcionIngresosReducciones = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_REDUCTIONS',

    IngresosRecaudos = 'I3',
    DescripcionIngresosRecaudos = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_COLLECTION',

    IngresosCreditoE1 = 'E1',
    DescripcionIngresosCreditoE1 = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_CREDIT',

    IngresosContracreditoE2 = 'E2',
    DescripcionIngresosContracreditoE2 = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_COUNTERCLAIMS',

    IngresosAplazamientos = 'E3',
    DescripcionIngresosAplazamientos = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_DEFERMENT',

    IngresosDesplazamientos = 'E4',
    DescripcionIngresosDesplazamientos = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_DISPLACEMENT',

    IngresosAdicionesE5 = 'E5',
    DescripcionIngresosAdicionesE5 = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_ADDITIONS',

    IngresosReduccionesE6 = 'E6',
    DescripcionIngresosReduccionesE6 = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_REDUCTIONS',

    IngresosCertificadoDisponibilidadPresupuestal = 'E7',
    DescripcionIngresosCertificadoDisponibilidadPresupuestal = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_BUDGET_AVALILABILITY_CERTIFICATE',

    IngresosRegistroPresupuetal = 'E8',
    DescripcionIngresosRegistroPresupuetal = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_BUDGETARY_REGISTRATION',

    IngresosObligaciones = 'E9',
    DescripcionIngresosObligaciones = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_OBLIGATIONS',

    IngresosPagos = 'EA',
    DescripcionIngresosPagos = 'ENUM_INV_PRODUCTION_AND_BUDGET.INCOME_PAYMENTS'
}

export enum ModosComponenteVariantes {
    NORMAL = 0, // Se usa cuando la directiva se llama desde la creación de items uno a uno
    GENERAR = 1, // Se usa cuando se está generando un documento a partir de otro
    CELDANORMAL = 2,
    CELDAGENERAR = 3
    // Se usa cuando se da click en el botón auxiliar de la selección de lotes y se valida si es para generar o para el mismo documento
}

export enum TipoBaseDatos {
    DescripcionEnterprise = 'ORACLE ENTERPRISE',
    Enterprise = 'Oracle Enterprise',
    DescripcionExpress = 'ORACLE EXPRESS (XE)',
    Express = 'Oracle Express'
}

export enum CodigosOpcionesTerceros {
    Oportunidades = 'C_OP',
    DescricionOportunidades = 'MN_OPPORTUNITIES',

    Proyectos = 'C_PR',
    DescripcionProyectos = 'PROJECTS',

    Tareas = 'C_TR',
    DescripcionTareas = 'TASKS',

    Agenda = 'C_AG',
    DescripcionAgenda = 'SCHEDULER',

    Incidencias = 'C_IN',
    DescripcionIncidencias = 'INCIDENCES',

    HistorialVentas = 'C_HV',
    DescripcionHistorialVentas = 'LBL_SALES_HISTORY',

    HistorialCompras = 'C_HC',
    DescripcionHistorialCompras = 'LBL_SHOPPING_HISTORY',

    CuentasXCobrar = 'C_CC',
    DescripcinonCuentasXCobrar = 'LBL_ACCOUNTS_RECEIVABLE',

    CuentasXPagar = 'C_CP',
    DescripcionCuentasXPagar = 'LBL_DEBTS_TO_PAY',

    CorreosEnviados = 'C_CE',
    DescripcionCorreosEnviados = 'MA_LBL_SENT_EMAILS',

    Campanas = 'C_CA',
    DescripcionCampanas = 'CAMPAIGNS',

    Anticipos = 'C_AN',
    Descripcion = 'LBL_ADVANCES_PAYMENTS',

    ExtractoCartera = 'C_EC',
    DescripcionExtractoCartera = 'MN_PORTFOLIO_STATEMENT',

    MatricesDeRiesgo = 'C_MR',
    DescripcionMatricesDeRiesgo = 'LBL_RISK_MATRIX',

    HistoriasClinicas = 'C_HCI',
    DescripcionHistoriasClinicas = 'MN_MEDICAL_RECORDS',

    Citas = 'C_CI',
    DescripcionCitas = 'APPOINTMENTS_SCHEDULING',

    Ingresos = 'C_IN',
    DescripcionIngresos = 'PATIENTS_ENTRANCE',

    PlanesTratamiento = 'C_DT',
    DescripcionPlanesTratamiento = 'TREATMENT_PLAN',

    Pacientes = 'C_PC',
    DescripcionPacientes = 'MN_PATIENTS',

    RecibosYNotasCreditos = "C_RNC",
    dESCRIPCIONRecibosYNotasCreditos = ""
}

export enum TiposCodigosBarra {
    Codabar = 0,
    Code11 = 1,
    Code16k = 2,
    Code39 = 3,
    Code93 = 4,
    Code128 = 5,
    DataMatrix = 6,
    Ean8 = 7,
    Ean13 = 8,
    Industrial2of5 = 9,
    Interleaved2of5 = 10,
    Isbn = 11,
    Msi = 12,
    Pdf417 = 13,
    Planet = 14,
    Postnet = 15,
    UccEan128 = 16,
    UpcA = 17,
    UpcE = 18,
    UspsOneCode4CB = 19,
    RoyalMail = 20,
    AustraliaPost = 21,
    RoyalTpgPostKix = 22,
    Sscc18 = 23,
    Pzn = 24,
    DeutschePostLeitcode = 25,
    DeutschePostIdentcode = 26,
    UspsTrayLabel = 27,
    UspsSackLabel = 28,
    EanVelocity = 29,
    SingaporePost = 30,
    Jan8 = 31,
    Jan13 = 32,
    SwissPostParcel = 33,
    Opc = 34,
    Ean99 = 35,
    Itf14 = 36,
    Scc14 = 37,
    Issn = 38,
    Ismn = 39,
    NumlyNumber = 40,
    QRCode = 41,
    UspsFim = 42,
    UspsHorizontalBars = 43,
    Telepen = 44,
    Pharmacode = 45,
    Semacode = 46,
    Code32 = 47,
    UspsPicUccEan128 = 48,
    FedExGround96 = 49,
    AztecCode = 50,
    CompactPdf417 = 51,
    MacroPdf417 = 52,
    MicroPdf417 = 53,
    VicsBol = 54,
    VicsScacPro = 55,
    ItalianPost25 = 56,
    Isbt128 = 57,
    HibcLic39 = 58,
    HibcLic128 = 59,
    HibcPas39 = 60,
    HibcPas128 = 61,
    UspsIntelligentMail = 62,
    EanUpcAddOn2 = 63,
    EanUpcAddOn5 = 64,
    UspsPicCode128 = 65,
    GS1DataBarOmnidirectional = 66,
    GS1DataBar14 = 67,
    Rss14 = 68,
    GS1DataBarTruncated = 69,
    GS1DataBar14Truncated = 70,
    Rss14Truncated = 71,
    GS1DataBarStacked = 72,
    GS1DataBar14Stacked = 73,
    Rss14Stacked = 74,
    GS1DataBarStackedOmnidirectional = 75,
    GS1DataBar14StackedOmnidirectional = 76,
    Rss14StackedOmnidirectional = 77,
    GS1DataBarLimited = 78,
    RssLimited = 80,
    GS1DataBarExpanded = 81,
    RssExpanded = 82,
    GS1DataBarExpandedStacked = 83,
    RssExpandedStacked = 84,
    GS1128 = 85,
    MaxiCode = 86,
    MicroQRCode = 87,
    Matrix2of5 = 88,
    DanishPostal39 = 89,
    FrenchPostal39AR = 90,
    IATA2of5 = 91,
    AustraliaPostDomesticEParcelBarcode = 92,
    UspsIntelligentMailContainerBarcode = 93,
    KodakPatchCode = 94,
    GS1DataMatrix = 95,
    Ean13CCA = 96,
    Ean13CCB = 97,
    Ean8CCA = 98,
    Ean8CCB = 99,
    UpcACCA = 100,
    UpcACCB = 101,
    UpcECCA = 102,
    UpcECCB = 103,
    UccEan128CCA = 104,
    UccEan128CCB = 105,
    UccEan128CCC = 106,
    GS1128CCA = 107,
    GS1128CCB = 108,
    GS1128CCC = 109,
    GS1DataBarOmnidirectionalCCA = 110,
    GS1DataBar14CCA = 111,
    Rss14CCA = 112,
    GS1DataBarOmnidirectionalCCB = 113,
    GS1DataBar14CCB = 114,
    Rss14CCB = 115,
    GS1DataBarTruncatedCCA = 116,
    GS1DataBar14TruncatedCCA = 117,
    Rss14TruncatedCCA = 118,
    GS1DataBarTruncatedCCB = 119,
    GS1DataBar14TruncatedCCB = 120,
    Rss14TruncatedCCB = 121,
    GS1DataBarLimitedCCA = 122,
    RssLimitedCCA = 123,
    GS1DataBarLimitedCCB = 124,
    RssLimitedCCB = 125,
    GS1DataBarStackedCCA = 126,
    GS1DataBar14StackedCCA = 127,
    Rss14StackedCCA = 128,
    GS1DataBarStackedCCB = 129,
    GS1DataBar14StackedCCB = 130,
    Rss14StackedCCB = 131,
    GS1DataBarStackedOmnidirectionalCCA = 132,
    GS1DataBar14StackedOmnidirectionalCCA = 133,
    Rss14StackedOmnidirectionalCCA = 134,
    GS1DataBarStackedOmnidirectionalCCB = 135,
    GS1DataBar14StackedOmnidirectionalCCB = 136,
    Rss14StackedOmnidirectionalCCB = 137,
    GS1DataBarExpandedCCA = 138,
    RssExpandedCCA = 139,
    GS1DataBarExpandedCCB = 140,
    RssExpandedCCB = 141,
    GS1DataBarExpandedStackedCCA = 142,
    RssExpandedStackedCCA = 143,
    GS1DataBarExpandedStackedCCB = 144,
    RssExpandedStackedCCB = 145,
    MICRE13B = 146,
    Ean14 = 147,
    Dun14Itf = 148,
    Dun14Ean = 149,
    GS1QRCode = 150,
    Ppn = 151,
    IFAsecurPharm = 152,
    DhlAwb = 153,
    HibcLicDataMatrix = 154,
    HibcLicQRCode = 155,
    HibcLicAztecCode = 156,
    HibcPasDataMatrix = 157,
    HibcPasQRCode = 158,
    HibcPasAztecCode = 159,
    Isbt128DataMatrix = 160,
    DeutschePostResponsePlusPostMatrix = 161,
    DeutschePostBzl = 162,
    UspsIntelligentMailPackageBarcode = 163,
    HanXinCode = 164,
    JapanPost = 165,
    KoreaPost = 166,
    DataLogic2of5 = 167,
    MailmarkCMDM = 168,
    Mailmark4StateC = 169,
    Mailmark4StateL = 170,
    DotCode = 171,
    GS1AztecCode = 172,
    SwissQRCode = 173,
    Pharmacode2D = 174,
    ChannelCode = 175,
    JABCode = 176
}

export enum TipoProcesoPagoCesantias {

    FinanciacionVivienda = 1,
    DescripcionFinanciacionVivienda = 'LOSSES_LIQUIDATION.HOUSING_FINANCING',

    CancelacionHipotecaria = 2,
    DescripcionCancelacionHipotecaria = 'LOSSES_LIQUIDATION.MORTGAGE_CANCELLATION',

    ReparacionesLocativas = 3,
    DescripcionReparacionesLocativas = 'LOSSES_LIQUIDATION.LOCATIVE_REPAIR',

    Educacion = 4,
    DescripcionEducacion = 'LOSSES_LIQUIDATION.EDUCATION',

    EducacionAhorroOSeguro = 5,
    DescripcionEducacionAhorroOSeguro = 'LOSSES_LIQUIDATION.EDUCATION_SAVINGS/INSURANCE',

    GastosEscrituracion = 6,
    DescripcionGastosEscrituracion = 'LOSSES_LIQUIDATION.DEED_EXPENSES',

    GastosImpuestos = 7,
    DescripcionGastosImpuestos = 'LOSSES_LIQUIDATION.TAX_EXPENSES',

    DotacionVivienda = 8,
    DescripcionDotacionVivienda = 'LOSSES_LIQUIDATION.HOUSING_EQUIPMENT',

    TrasladoCesantias = 9,
    DescripcionTrasladoCesantias = 'LOSSES_LIQUIDATION.TRANSFER_OF_SEASONINGS',

    ConsignacionAfondo = 10,
    DescripcionConsignacionAfondo = 'LOSSES_LIQUIDATION.CONSIGNMENT_IN_FUND',

}
export enum TipoListar {
    Individual = 0,
    Unificado = 1
}
export enum ConversionTiempo {
    Anios = 0,
    Meses = 1,
    Dias = 2,
    Horas = 3,
    Minutos = 4,
    Segundos = 5,
    Milisegundos = 6
}
/**
 * Enumeracion para reportar informacion de SIRAS Y FURIPS
 */
export enum CondicionDelAccidentado {
    DescripcionConductor = 'ANIMAL_ENTRANCE.DRIVER',
    Conductor = 0,

    DescripcionPeaton = 'LBL_PEDESTRIAN',
    Peaton = 1,

    DescripcionOcupante = 'LBL_OCCUPANT',
    Ocupante = 2,

    DescripcionCiclista = 'LBL_CYCLIST',
    Ciclista = 3,

    DescripcionMotociclista = 'MOTORCYCLE_USER',
    Motociclista = 4,

    DescripcionOtros = 'LABEL_OTHERS',
    Otros = 5
}

export enum TipoConductor {
    Conductor,
    ConductorAmparo,
    Otro
}
export enum TipoCalculo {
    Suma = 0,
    Resta = 1
}

export enum DestinoEscenarios {
    PresupuestoContable = 0,
    DescripcionPresupuestoContable = 'MENU_BUDGET_SCENARIOS.LBL_ACCOUNTING_BUDGET_BY_ACCOUNT',

    PresupuestoContablePorCuentaCentroCosto = 1,
    DescripcionPresupuestoContablePorCuentaCentroCosto = 'MENU_BUDGET_SCENARIOS.LBL_ACCOUNTING_BUDGET_BY_ACCOUNT_COST_CENTER',

    PresupuestoVentasPeriodoCliente = 2,
    DescripcionPresupuestoVentasPeriodoCliente = 'MENU_BUDGET_SCENARIOS.LBL_SALES_BUDGET_BY_PERIOD_CUSTOMER',

    PresupuestoVentasPeriodoVendedor = 3,
    DescripcionPresupuestoVentasPeriodoVendedor = 'MENU_BUDGET_SCENARIOS.LBL_SALES_BUDGET_BY_PERIOD_SELLER',

    PresupuestoVentasPorPeriodo = 4,
    DescripcionPresupuestoVentasPorPeriodo = 'MENU_BUDGET_SCENARIOS.LBL_SALES_BUDGET_BY_PERIOD',

    PresupuestoVentasPorProductoPeriodo = 5,
    DescripcionPresupuestoVentasPorProductoPeriodo = 'MENU_BUDGET_SCENARIOS.SALES_BUDGET_BY_PERIOD_PRODUCT',

    PresupuestoVentasPorClienteProducto = 6,
    DescripcionPresupuestoVentasPorClienteProducto = 'MENU_BUDGET_SCENARIOS.SALES_BUDGET_BY_PERIOD_PRODUCT_AND_CUSTOMER'
}

export enum TipoIncapacidades {
    DescripcionNueva = 'NEW_2',
    Nueva = 0,

    DescripcionProrroga = 'LBL_EXTENDED',
    Prorroga = 1
}

export enum OpcionesMenuConcuta {
    NotasEvolucion,
    Eliminar,
    ActualizarConducta
}

export enum TipoTarjetapago {
    BonoDescuento = 0,
    DescripcionBonoDescuento = 'PAYMENT_CARD_MENU.LBL_DISCOUNT_BONUS',

    TarjetaRegalo = 1,
    DescripcionTarjetaRegalo = 'LBL_PAYMENT_CARD',

    Separadoproductos = 2,
    DescripcionSeparadoproductos = 'PAYMENT_CARD_MENU.LBL_PRODUCT_PREORDER'
}

export enum CuposTarjeta {
    Todos = 0,
    DescripcionTodos = 'LABEL_ALL_PLURAL',

    ConCupoDisponible = 1,
    DescripcionConCupoDisponible = 'PAYMENT_CARD_MENU.LBL_WITH_AVAILABLE_BALANCE',

    SinCupoDisponible = 2,
    DescripcionSinCupoDisponible = 'PAYMENT_CARD_MENU.LBL_WITHOUT_AVAILABLE_BALANCE'
}

export enum MovimientoTarjeta {
    Recarga = 0,
    DescripcionRecarga = 'PAYMENT_CARD_MENU.LBL_REHARGE',

    VaciarCupo = 1,
    DescripcionVaciarCupo = 'PAYMENT_CARD_MENU.LBL_CLEAR_DEPOSITS',

    Pago = 2,
    DescripcionPago = 'LBL_PAYMENT'
}

export enum DenominacionesMonedas {
    Monedas = 0,
    DescripcionMonedas = 'CURRENCY_DENOMINATIONS_COMPONENT.LBL_CURRENCIES',

    Billetes = 1,
    DescripcionBilletes = 'CURRENCY_DENOMINATIONS_COMPONENT.LBL_TICKETS'
}

export enum OpcionesDescuentoMasivo {
    DescripcionPreciosEIvaDocumentos = 'COMPONENT_APPLY_DISCOUNTS_MASSIVE.PRICES_AND_IVA_DOCUMENTS', // Aplicar descuento en todos los precios y iva del documento
    PreciosEIvaDocumentos = 0,
    DescripcionValorAdicional1 = 'COMPONENT_APPLY_DISCOUNTS_MASSIVE.ADDITIONAL_VALUE_1', // Aplicar valor con descuento en el campo MD_PRECIOTOTAL_CREDITO
    ValorAdicional1 = 1,
    DescripcionValorAdicional2 = 'COMPONENT_APPLY_DISCOUNTS_MASSIVE.ADDITIONAL_VALUE_2', // Aplicar valor con descuento en el campo MD_PRECIOTOTAL_CREDITO2
    ValorAdicional2 = 2,
}

export enum MetodoIngreso {
    DescripcionCitasMedicas = 'MEDICAL_APPOINTMENT',
    CitasMedicas = 0,
    DescripcionIngresoPacientes = 'ADMISSION_PATIENT',
    IngresoPacientes = 1,
    DescripcionAmbos = 'PATIENT_ADMISSION_AND_MEDICAL_APPOINTMENT',
    Ambos = 2,
    DescripcionOtrasEvolucionesInformesMedicos = 'MEDICAL_REPORTS_AND_DEVELOPMENTS',
    OtrasEvolucionesInformesMedicos = 3,
    DescripcionInformeQuirurgico = 'SURGICAL_REPORT',
    InformeQuirurgico = 4,
    DescripcionTriage = 'TRIAGE',
    Triage = 5
}

export enum FEOperador {
    TheFactory = 0,
    DescripcionTheFactory = 'LBL_THE_FACTORY_OPERTATOR_FOR_ELECTRONIC_BILL',

    Carvajal = 1,
    DescripcionCarvajal = 'LBL_CARVAJAL_OPERTATOR_FOR_ELECTRONIC_BILL',

    Directa = 2,
    DescripcionDirecta = 'ALERT_GEM',

    TheFactoryValPrevia = 3,
    DescripcionTheFactoryValPrevia = 'LBL_PRIOR_VALIDATION_THE_FACTORY_OPERTATOR_FOR_ELECTRONIC_BILL'
}

export enum InformacionAListar {
    PlanDePagosCartera = 0,
    DescripcionPlanDePagosCartera = 'MENU_CONTENTS_PARAMETERS.LBL_PAYMENTS_PLAN_PORTFOLIO',

    MovimientoClasificaciones = 1,
    DescripcionMovimientoClasificaciones = 'MENU_CONTENTS_PARAMETERS.LBL_CLASSIFICATIONS_MOVEMENT',

    FormasPagoFaptura = 2,
    DescripcionFormasPagoFaptura = 'MENU_CONTENTS_PARAMETERS.LBL_PAYMENT_METHODS_INVOICE',

    MovimientoContable = 3,
    DescripcionMovimientoContable = 'ACCOUNTING_MOVEMENT',

    ActivosFijo = 4,
    DescripcionActivosFijo = 'MN_FIXED_ASSETS',

    CodigoQr = 5,
    DescripcionCodigoQr = 'MENU_CONTENTS_PARAMETERS.LBL_QR_CODE',

    CodigoBarra = 6,
    DescripcionCodigoBarra = 'BAR_CODE',

    SaldosCartera = 7,
    DescripcionSaldosCartera = 'SACRIFICE_BILL_BALANCE',

    ComposicionPrecio = 8,
    DescripcionComposicionPrecio = 'MENU_CONTENTS_PARAMETERS.LBL_PRICE_ADDITIONS',

    FirmaEstados = 9,
    DescripcionFirmaEstados = 'MENU_CONTENTS_PARAMETERS.LBL_STATES_FIRMS',

    LecturaDeAcueducto = 10,
    DescripcionLecturaDeAcueducto = 'MENU_CONTENTS_PARAMETERS.LBL_READING_AQUEDUCT',

    Resoluciones = 11,
    DescripcionResoluciones = 'COMPONENT_PREFIXES.RESOLUTIONS',

    ValoresRetenciones = 12,
    DescripcionValoresRetenciones = 'MENU_CONTENTS_PARAMETERS.LBL_TETENTIONS_VALUES',

    FotosProducto = 13,
    DescripcionFotosProducto = 'MENU_CONTENTS_PARAMETERS.LBL_PRODUCTS_PICTURE',

    VariantesDocumentoOrigen = 14,
    DescripcionVariantesDocumentoOrigen = 'DOCUMENT_ORIGIN_VARIANTS',

    ValidacionCodigoProducto = 15,
    DescripcionValidacionCodigoProducto = 'PRODUCT_CODE_VALIDATION',

    ValorFechaUltimoPago = 16,
    DescripcionValorFechaUltimoPago = 'VALUE_DATE_LAST_PAY'
}

export enum TiposVariantes {
    DescripcionNo = 'LABEL_NO',
    No = 'N',
    DescripcionSinEmpaque = 'WITHOUT_PACK',
    SinEmpaque = 'S',
    DescripcionConEmpaque = 'WITH_PACK',
    ConEmpaque = 'E'
}

export enum SiNoTodos {
    No = 1,
    DescripcionNo = 'LABEL_NO',
    Si = 2,
    DescripcionSi = 'LABEL_YES',
    Todos = 3,
    DescripcionTodos = 'LABEL_ALL_PLURAL'
}

export enum ModoVisualizacionAsignarDatosDocumentos {
    Responsable = 1,
    Vendedor = 2,
    Recorrido = 3,
    Vehiculo = 4,
    Conductor = 5,
    Fecha3 = 6,
    Fecha4 = 7,
    PatronContable = 8,
    VincularDocumento = 9,
    Todos = 10,
    Fecha2 = 11
}

export enum PeriodosTiempo {
    Semanal = 0,
    DescripcionSemanal = 'LBL_WEEKLY',

    Mensual = 1,
    DescripcionMensual = 'LBL_MONTHLY'
}
export enum TipoCodigoBarras {
    No = 'N',
    DescripcionNo = 'LABEL_NO',
    PorCodigoAlterno = 'S',
    DescripcionPorCodigoAlterno = 'TYPING_ALTERNATE_CODE',
    PorVariante = 'V',
    DescripcionPorVariante = 'TYPING_VARIANTS',
    PorAlternoVariante = 'W',
    DescripcionPorAlternoVariante = 'TYPING_ALTERNATE_VARIANT_CODE',
    PorMascaraOCodigo = 'M',
    DescripcionPorMascaraOCodigo = 'TYPING_BY_MASK_OR_CODE',
    PorMascaraOCodigoAlterno = 'A',
    DescripcionPorMascaraOCodigoAlterno = 'TYPING_BY_MASK_OR_ALTERNATE_CODE'
}


export enum TipoActividadPlanCalidad {
    Numeracion = 0,
    DescripcionNumeracion = 'LBL_NUMERATION',

    Chequeo = 1,
    DescripcionChequeo = 'LBL_CHECK'
}

export enum TiposPlantilla {
    DescripcionEmail = 'ENUM_EMAIL',
    Email = 0,
    DescripcionSMS = 'LBL_SMS',
    SMS = 1,
    DescripcionImpresion = 'LBL_PRINT',
    Impresion = 2
}

export enum TipoProgramacionOT {
    DescripcionPendientes = 'EARRINGS_FINISHED_TODAY',
    Pendientes = 0,

    DescripcionPorFecha = 'BY_DATE',
    PorFecha = 1,
}
export enum TipoAnexoInformacionExogena {
    HidrocarburosGasesYMinerales = 0,
    DescripcionHidrocarburosGasesYMinerales = 'EXOGENOUS_MENU.LBL_HIDROCARBON_GASES_MINERALS',

    ContratosDeMandoOAdministracionDelegada = 1,
    DescripcionContratosDeMandoOAdministracionDelegada = 'EXOGENOUS_MENU.LBL_COMMAND_DELEGATED_ADMINISTRATION_CONTRACTS',

    ConsorciosYUnionesTemporales = 2,
    DescripcionConsorciosYUnionesTemporales = 'EXOGENOUS_MENU.LBL_CONSORTIA_TEMPORALY_UNIONS',

    IngresosParaTerceros = 3,
    DescripcionIngresosParaTerceros = 'EXOGENOUS_MENU.LBL_INCOME_RECEIVED_FOR_OTHERS',

    AnexosGenerales = 4,
    DescripcionAnexosGenerales = 'EXOGENOUS_MENU.LBL_GENERAL_ANNEXES',
}

export enum OpcionesProgramacionPago {
    ProgramarPago = 0,
    DesprogramarPago = 1,
    BloquearPago = 2,
    DesbloquearPago = 3
}

export enum EstadosPagosCxP {
    SinProgramar = 1,
    DescripcionSinProgramar = 'LBL_NON_SCHEDULED',
    Programado = 2,
    DescripcionProgramado = 'LBL_SCHEDULED',
    Bloqueado = 3,
    DescripcionBloqueado = 'LBL_LOCKED'
}

export enum TiposDeCuentasEspecificacion {
    OtrasRetDescuentos = 1,
    Excedentes = 2,
    Otros = 3
}

export enum modoAperturaDevolucionDocumentosMasivo {
    seleccionarListaDocumentos = 0,
    CargarArchivo = 1,
}

export enum AccionesMenuRecibos {
    VisualizarFactura = 1
}

export enum AccionAdministrarArchivos {
    crearCarpeta = 0,
    subirArchivo = 1,
    EliminarArchivos = 2,
    Renombrar = 3,
    Refrescar = 4,
    Mover = 5
}

export enum presentacionesProgramacionOt {
    DescripcionDetallado = 'DETAILED',
    Detallado = 0,

    DescripcionResumenXProceso = 'SUMMARY_BY_PROCESS_OT',
    ResumenXProceso = 1,
}
// identificadores usados en la tabla Formulas (identificador 1 e identificador 2)
export enum Identificadores {
    Constante = 0,
    DescripcionConstante = 'IDENTIFIERS.CONSTANT',

    CantidadLiquida = 1,
    DescripcionCantidadLiquida = 'IDENTIFIERS.LIQUID_AMOUNT',

    ValorLiquida = 2,
    DescripcionValorLiquida = 'IDENTIFIERS.LIQUID_VALUE',

    SumatoriaValor = 3,
    DescripcionSumatoriaValor = 'IDENTIFIERS.SUM_VALUE',

    SumatoriaValorTope = 4,
    DescripcionSumatoriaValorTope = 'IDENTIFIERS.SUMMATION_CAP_VALUE',

    SumatoriaCantidad = 5,
    DescripcionSumatoriaCantidad = 'IDENTIFIERS.SUMMATION_AMOUNT',

    PromedioDiario = 6,
    DescripcionPromedioDiario = 'IDENTIFIERS.DAILY_AVERAGE',

    PromedioMensual = 7,
    DescripcionPromedioMensual = 'IDENTIFIERS.MONTHLY_AVERAGE',

    UltimoPago = 8,
    DescripcionUltimoPago = 'IDENTIFIERS.LAST_PAYMENT',

    Numero = 9,
    DescripcionNumero = 'IDENTIFIERS.NUMBER',

    Resultado = 10,
    DescripcionResultado = 'IDENTIFIERS.RESULT',

    VrLiquidadoFondoS = 11,
    DescripcionVrLiquidadoFondoS = 'IDENTIFIERS.VR_SETTLED_FUND_S',

    SumatoriaVrFondoS = 12,
    DescripcionSumatoriaVrFondoS = 'IDENTIFIERS.SUM_VR_FUND_S',

    ValorDeLista = 13,
    DescripcionValorDeLista = 'IDENTIFIERS.LIST_VALUE',

    SumValorcedula = 14,
    DescripcionSumValorcedula = 'IDENTIFIERS.SUM_CEDULA_VALUE',

    SumCantcedula = 15,
    DescripcionSumCantcedula = 'IDENTIFIERS.AMOUNT_CEDULA',

    UltimoPagocedula = 16,
    DescripcionUltimoPagocedula = 'IDENTIFIERS.LAST_CEDULA_PAYMENT',

}

export enum Condicion {
    Si = 1,
    DescripcionSi = 'LABEL_YES',
    SiNo = 2,
    DescripcionSiNo = 'CONDITIONS.ELSE',
    FinSi = 3,
    DescripcionFinSi = 'CONDITIONS.END_IF',
}

export enum CargarConstantes {
    AuxAlimentacionDia = 1,
    DescripcionAuxAlimentacionDia = 'LOAD_CONSTANTS.SUP_FOOD_DAY',

    AuxAlimentacionMes = 2,
    DescripcionAuxAlimentacionMes = 'LOAD_CONSTANTS.SUP_FOOD_MONTH',

    AuxMovilizacionDia = 3,
    DescripcionAuxMovilizacionDia = 'LOAD_CONSTANTS.SUP_MOBILIZATION_DAY',

    AuxMovilizacionMes = 4,
    DescripcionAuxMovilizacionMes = 'LOAD_CONSTANTS.SUP_MOBILIZATION_MONTH',

    AuxTransporteDia = 5,
    DescripcionAuxTransporteDia = 'LOAD_CONSTANTS.SUP_DAY_TRANSPORT',

    AuxTransEmpleado = 6,
    DescripcionAuxTransEmpleado = 'LOAD_CONSTANTS.SUP_TRANSPORTATION_MONTHLY',

    AuxVehiculoDia = 7,
    DescripcionAuxVehiculoDia = 'LOAD_CONSTANTS.SUP_VEHICLE_DAY',

    AuxVehiculoMes = 8,
    DescripcionAuxVehiculoMes = 'LOAD_CONSTANTS.SUP_VEHICLE_MONTH',

    AuxViviendaDia = 9,
    DescripcionAuxViviendaDia = 'LOAD_CONSTANTS.SUP_DIA_HOUSING',

    AuxViviendaMes = 10,
    DescripcionAuxViviendaMes = 'LOAD_CONSTANTS.SUP_HOUSING_MONTH',

    BaseIncapacidad = 11,
    DescripcionBaseIncapacidad = 'LOAD_CONSTANTS.INCAPACITY_BASE',

    ComisionesDia = 12,
    DescripcionComisionesDia = 'LOAD_CONSTANTS.DAY_COMMITTIONS',

    ComisionesMes = 13,
    DescripcionComisionesMes = 'LOAD_CONSTANTS.MONTHLY_COMMISSIONS',

    CantDiasLaborados = 14,
    DescripcionCantDiasLaborados = 'LOAD_CONSTANTS.QUANTITY_WORKING_DAYS',

    CantAñosLaborados = 15,
    DescripcionCantAñosLaborados = 'LOAD_CONSTANTS.QUANTITY_YEARS_WORKED',

    CantDiasUltCorte = 16,
    DescripcionCantDiasUltCorte = 'LOAD_CONSTANTS.NUMBER_OF_DAYS_LAST_CUT',

    CantDiasMes = 17,
    DescripcionCantDiasMes = 'LOAD_CONSTANTS.QUANTITY_DAYS_MONTH',

    CantDiasLSemestre = 18,
    DescripcionCantDiasLSemestre = 'LOAD_CONSTANTS.NUMBER_OF_SEMESTER_DAYS',

    diasRealesLiquidac = 19,
    DescripciondiasRealesLiquidac = 'LOAD_CONSTANTS.ACTUAL_SETTLEMENT_DAYS',

    Promsalariobasico = 20,
    DescripcionPromsalariobasico = 'LOAD_CONSTANTS.AVERAGE_BASE_SALARY',

    PromsalbasCesanti = 21,
    DescripcionPromsalbasCesanti = 'LOAD_CONSTANTS.AVERAGE_BASE_SALARY_C',

    Prombasicodiaper = 22,
    DescripcionPrombasicodiaper = 'LOAD_CONSTANTS.AVERAGE_BASE_DAY',

    PorcentajeSalud = 23,
    DescripcionPorcentajeSalud = 'LOAD_CONSTANTS.HEALTH_PERCENT',

    PorcentajePension = 24,
    DescripcionPorcentajePension = 'LOAD_CONSTANTS.PENSION_PERCENTAGE',

    SalarioHora = 25,
    DescripcionSalarioHora = 'LOAD_CONSTANTS.HOUR_SALARY',

    SalarioPromHora = 26,
    DescripcionSalarioPromHora = 'LOAD_CONSTANTS.AVERAGE_WAGE_HOUR',

    SalarioDia = 27,
    DescripcionSalarioDia = 'LOAD_CONSTANTS.DAILY_SALARY',

    SalarioPromedioDia = 28,
    DescripcionSalarioPromedioDia = 'LOAD_CONSTANTS.AVERAGE_WAGE_DAY',

    SalarioMes = 29,
    DescripcionSalarioMes = 'LOAD_CONSTANTS.MONTHLY_SALARY',

    SalarioPromedioMes = 30,
    DescripcionSalarioPromedioMes = 'LOAD_CONSTANTS.AVERAGE_MONTHLY_WAGE',

    SalarioMinimo = 31,
    DescripcionSalarioMinimo = 'LOAD_CONSTANTS.MINIMUM_WAGE',

    SalProductividadDia = 32,
    DescripcionSalProductividadDia = 'LOAD_CONSTANTS.DAILY_PRODUCTIVITY',

    SalProductividadMes = 33,
    DescripcionSalProductividadMes = 'LOAD_CONSTANTS.MONTHLY_PRODUCTIVITY',

    ValorBaseConcepto = 34,
    DescripcionValorBaseConcepto = 'LOAD_CONSTANTS.CONCEPT_BASE_VALUE',

    ValorUVT = 35,
    DescripcionValorUVT = 'LOAD_CONSTANTS.UVT_VALUE',

    EsSalarioIntegral = 36,
    DescripcionEsSalarioIntegral = "LOAD_CONSTANTS.COMPREHENSIVE_SALARY",

    ValorBaseNovedad = 37,
    DescripcionValorBaseNovedad = "LOAD_CONSTANTS.NOVELTY_BASE_VALUE"
}

export enum DesdePeriodo {
    Primero = 1,
    DescripcionPrimero = '1',

    Segundo = 2,
    DescripcionSegundo = '2',

    ultimo = 253,
    DescripcionUltimo = 'LIQUIDATION_FORMULATIONS.LAST'
}

export enum SolicitarLlevarSaldos {
    CentroDeOperaciones = 1,
    Concepto = 2,
    Tercero = 3,
    SegundoTercero = 4,
    TercerTercero = 5,
    SaldosCentroDeCosto = 6,
    SaldosTercero = 7,
    SaldosTerceroYDocumento = 8,
    SaldosTerceroYCC = 9
}

export enum Unidades {
    Dias = 'DI',
    DescripcionDias = 'DAYS',

    Horas = 'HR',
    DescripcionHoras = 'LBL_HOURS',

    Cantidad = 'CT',
    DescripcionCantidad = 'ORDER_PRO_QUANTITY',

    Valor = 'VR',
    DescripcionValor = 'SACRIFICE_BILL_VALUE'
}

export enum DeducidoDevengado {
    Deducido = 'C',
    DescripcionDeducido = 'PAYROLL_ITEMS.DEDUCTED',

    Devengado = 'D',
    DescripcionDevengado = 'PAYROLL_ITEMS.ACCRUED',

    Todos = 'T',
    DescripcionTodos = 'LABEL_ALL_PLURAL'
}

export enum TipoNovedadPlantillaLiquidacion {
    SuspensionTemporalContrato = 1,
    DescripcionSuspensionTemporalContrato = 'TYPE_NEW_DETTLEMENT_TEMPLATE.TEMPORARY_SUSPENSION_OF_CONTRACT',

    LicenciaNoRemunerada = 2,
    DescripcionLicenciaNoRemunerada = 'TYPE_NEW_DETTLEMENT_TEMPLATE.UNPAID_LEAVE',

    VariacionTransitoriaSalario = 3,
    DescripcionVariacionTransitoriaSalario = 'TYPE_NEW_DETTLEMENT_TEMPLATE.TRANSITORY_WAGE_VARIATION',

    LicenciaMaternidadPaternidad = 4,
    DescripcionLicenciaMaternidadPaternidad = 'TYPE_NEW_DETTLEMENT_TEMPLATE.PARENTAL_LEAVE',

    IncapacidadEnfermedadGeneral = 5,
    DescripcionIncapacidadEnfermedadGeneral = 'TYPE_NEW_DETTLEMENT_TEMPLATE.INCAPACITY_GENERAL_SICKNESS',

    LicenciaRemunerada = 6,
    DescripcionLicenciaRemunerada = 'TYPE_NEW_DETTLEMENT_TEMPLATE.PAID_LEAVE',

    EnfermedadProfesional = 7,
    DescripcionEnfermedadProfesional = 'TYPE_NEW_DETTLEMENT_TEMPLATE.OCCUPATIONAL_DISEASE',

    VariacionPermanenteSalario = 8,
    DescripcionVariacionPermanenteSalario = 'TYPE_NEW_DETTLEMENT_TEMPLATE.PERMANENT_WAGE_VARIATION',

    ComisionPorServicio = 9,
    DescripcionComisionPorServicio = 'TYPE_NEW_DETTLEMENT_TEMPLATE.SERVICE_COMMISSION',

    PrestamoEmpleado = 10,
    DescripcionPrestamoEmpleado = 'PAYROLL_ITEMS.EMPLOYE_LOAN'

}

export enum AsumeIncapacidad {
    Empresa = 1,
    DescripcionEmpresa = 'LBL_COMPANY',
    Eps = 2,
    DescripcionEps = 'LC_EPS'
}

export enum TipoInterfaceContable {
    CentroDeCosto = 'C',
    DescripcionCentroDeCosto = 'PAYROLL_ITEMS.DETAILED_BY_COST_CENTER',

    DetalladoEmpleado = 'D',
    DescripcionDetalladoEmpleado = 'PAYROLL_ITEMS.EMPLOYEE_DETAIL',

    NitAsociado = 'N',
    DescripcionNitAsociado = 'PAYROLL_ITEMS.ASSOCIATE_NIT'
}

export enum MetodsCalculo {
    BaseXPm = 1,
    DescripcionBaseXPm = 'PAYROLL_ITEMS.CALCULATION_METHOD_1',
    BaseXPmXDias = 2,
    DescripcionBaseXPmXDias = 'PAYROLL_ITEMS.CALCULATION_METHOD_2'
}

export enum PresentacionMetricasVenta {
    PorAño = 1,
    DescripcionPorAño = 'METRIC_SALES.PER_YEAR',

    PorMes = 2,
    DescripcionPorMes = 'METRIC_SALES.PER_MONTH',

    PorProducto = 3,
    DescripcionPorProducto = 'PR_FOR_PRODUCT',

    PorGrupoProducto = 4,
    DescripcionPorGrupoProducto = 'METRIC_SALES.BY_PRODUCT_GROUP',

    PorFabricante = 5,
    DescripcionPorFabricante = 'METRIC_SALES.BY_MANUFACTURER',

    PorUnidadDeNegocio = 6,
    DescripcionPorUnidadDeNegocio = 'METRIC_SALES.BY_BUSINESS_UNIT',

    PorDiseño = 7,
    DescripcionPorDiseño = 'METRIC_SALES.BY_DESING',

    PorTipoProducto = 8,
    DescripcionPorTipoProducto = 'METRIC_SALES.BY_PRODUCT_TYPE',

    PorMarca = 9,
    DescripcionPorMarca = 'METRIC_SALES.BY_BRAND',

    PorTipoDeServicio = 10,
    DescripcionPorTipoDeServicio = 'METRIC_SALES.BY_SERVICE_TYPE',

    PorCategoriaVenta = 11,
    DescripcionPorCategoriaVenta = 'METRIC_SALES.BY_SALES_CATEGORY',
}
/**
 * tipos de graficas usables de devextreme
 */
export enum TipoGrafica {
    GraficaBarra = 'bar',
    DescripcionGraficaBarra = 'GRAPHICS_TYPES.BAR',
    GraficaLinea = 'line',
    DescripcionGraficaLinea = 'GRAPHICS_TYPES.LINE',
    GraficaArea = 'area',
    DescripcionGraficaArea = 'GRAPHICS_TYPES.AREA',
    GraficaPunto = 'scatter',
    DescripcionGraficaPunto = 'GRAPHICS_TYPES.SCATTER',
}


export enum modoAperturaImportarRecibos {
    RecibosDeCaja = 0,
    NotasCartera = 1
}


export enum OpcionesAgregarRecibosMasivos {
    Cliente = 0,
    DescripcionCliente = "LBL_BY_CUSTOMER",

    Unica = 1,
    DescripcionUnica = "PAYMENTS_RETURN_DOCUMENTOS.LBL_ONLY",

    Documento = 2,
    DescripcionDocumento = "BY_ORDER"
}

export enum TipoEscaner {
    Cedula = 0
}

export enum MediosDeTransporte {
    Maritimo = 0,
    DescripcionMaritimo = 'TRANSPORT_MEANS.SEA',
    Aereo = 1,
    DescripcionAereo = 'TRANSPORT_MEANS.AIR',
    Ferroviario = 2,
    DescripcionFerroviario = 'TRANSPORT_MEANS.RAILWAY',
    Carretera = 3,
    DescripcionCarretera = 'TRANSPORT_MEANS.ROAD',
    MultiModal = 4,
    DescripcionMultiModal = 'TRANSPORT_MEANS.MULTIPLE',
}

export enum Icoterms {
    EnFabrica = 0,
    DescripcionEnFabrica = 'ICOTERM.EXW',
    LibreAlCostadoDelBuque = 1,
    DescripcionLibreAlCostadoDelBuque = 'ICOTERM.FAS',
    LibreABordo = 2,
    DescripcionLibreABordo = 'ICOTERM.FOB',
    LibreTransportista = 3,
    DescripcionLibreTransportista = 'ICOTERM.FCA',
    CosteYFlete = 4,
    DescripcionCosteYFlete = 'ICOTERM.CFR',
    CosteSeguroYFlete = 5,
    DescripcionCosteSeguroYFlete = 'ICOTERM.CIF',
    TransportePagadoHasta = 6,
    DescripcionTransportePagadoHasta = 'ICOTERM.CPT',
    TransporteYSeguroPagadoHasta = 7,
    DescripcionTransporteYSeguroPagadoHasta = 'ICOTERM.CIP',
    EntregadoEnPunto = 9,
    DescripcionEntregadoEnPunto = 'ICOTERM.DAP',
    EntregadoConDerechosPagados = 10,
    DescripcionEntregadoConDerechosPagados = 'ICOTERM.DDP',
    EntregadoLugarDescargada = 11,
    DescripcionEntregadoLugarDescargada = 'ICOTERM.DPU',
}

export enum TipoNovedad {
    DescripcionLiquidacionNomina = "ADD_NEWS_COMPONENT.NEW_PAYROLL_SETTLEMENT",
    LiquidacionNomina = "N",
    DescripcionLiquidacionContrato = "ADD_NEWS_COMPONENT.NEW_CONTRACT_SETTLEMENT",
    LiquidacionContrato = "Q"
}

export enum ModoCreacion {
    Individual = 0,
    Masivo = 1
}

export enum PeriodoAplicacion {
    Primero = 1,
    Segundo = 2,
    Ultimo = 253,
    Todos = 254
}

export enum ConceptoDefinidoPara {
    TodosLosMeses = 1,
    DescripcionTodosLosMeses = 'NOMINA_FIXED_CONCEPTS.CONCEPT_FOR_EVERY_MONTH',
    MesEspecifico = 2,
    DescripcionMesEspecifico = 'NOMINA_FIXED_CONCEPTS.CONCEPT_FOR_SPECIFIC_MONTH',
    RangoDePeriodo = 3,
    DescripcionRangoDePeriodo = 'NOMINA_FIXED_CONCEPTS.PERIOD_RANGE'
}

export enum ProcedenciaNotaHistoriaclinica {
    NotaEnfermeria = 0,
    DescripcionNotaEnfermeria = "NURSING_NOTES",
    EvolucionMedico = 1,
    DescripcionEvolucionMedico = "CLINIC_HISTORY.EVOLUTION_DOCTOR",
    Destinos = 2,
    DescripcionDestinos = 'LBL_DESTINATION'
}
export enum ClaseNotaHistoriaclinica {
    Otro = 0,
    DescripcionOtro = "LBL_OTHER",
    IngresoSalaObservaciones = 1,
    DescripcionIngresoSalaObservaciones = "PATIENT_ADMISSION_OBSERVATION",
    EgresoPacienteDelRecinto = 2,
    DescripcionEgresoPacienteDelRecinto = "EGRESS_PATIENT_FROM_ROOM",
    IngresoPacienteProcedimientoQuirurgico = 3,
    DescripcionIngresoPacienteProcedimientoQuirurgico = "PATIENT_ADMISSION_TO_SURGICAL_PROCEDURE",
    DescripcionAdministracionMedicamentos = "MEDICATION_ADMINISTRATION",
    AdministracionMedicamentos = 4

}

export enum EstadosPeriodos {
    Cerrado = 'C',
    Abierto = 'A',
    Todos = 'T'
}

export enum TipoCierrePeriodo {
    Contrato = 'contrato',
    Periodo = 'periodo'
}

export enum MetodoCalculoDiasComisiones {
    DescripcionDiasAtraso = "CU_LBL_DAYS_BEHIND",
    DiasAtraso = 1,
    DescripcionDiasFactura = "LBL_INVOICE_DAYS",
    DiasFactura = 2
}

export enum SeccionReporte {
    Encabezado = 0,
    Detalle = 1,
    Pie = 2,
    FormasPago = 3,
    Impuestos = 4
}

export enum TipoConsultaEnPreciosTercero {
    Compras = 0, // Proveedores
    Ventas = 1 // Clientes
}

export enum AperturaConsultaPrecios {
    Clientes = 0,
    Proveedor = 1,
    Productos = 2
}

export enum TipoOrigenMovimiento {
    InteresesCesantia = 'C',
    DescripcionInteresesCesantia = 'TYPE_ORIGIN_MOVEMENT.SEVERANECES_AND_INTERESTS',
    PrimaYExtraLegales = 'E',
    DescripcionPrimaYExtraLegales = 'TYPE_ORIGIN_MOVEMENT.PREMIUM_AND_EXTRA_LEGAL',
    Nomina = 'N',
    DescripcionNomina = 'PAY_SHEET',
    Prestamo = 'P',
    DescripcionPrestamo = 'LOAN',
    Liquidacion = 'Q',
    DescripcionLiquidacion = 'MENU_PAYROLL_PERIODS.SETTLEMENT_CONTRACT',
    Vacaciones = 'V',
    DescripcionVacaciones = 'VACATIONS',
    NovedadesVacaciones = 'W',
    DescripcionNovedadesVacaciones = 'TYPE_ORIGIN_MOVEMENT.VACATION_NEWS',
    ProvisionesDeNomina = 'I',
    DescripcionProvisionesDeNomina = "PAYROLL_PROVISIONS.PAYROLL_PROVISIONS"
}

// enumeracion que contiene todos los grupos de los conceptos segun la DIAN para los devengados
export enum GrupoDianDevengados {
    SalarioBasico = 0,
    DescripcionSalarioBasico = "BASIC_SALARY",
    CompensacionOrdinaria = 1,
    DescripcionCompensacionOrdinaria = "DIAN_GROUP.ORDINARY_COMPENSATION",
    CompensacionExtraordinaria = 2,
    DescripcionCompensacionExtraordinaria = "DIAN_GROUP.EXTRAORDINARY_COMPENSATION",
    AnticipoNomina = 3,
    DescripcionAnticipoNomina = "DIAN_GROUP.ADVANCES_PAYMENTS",
    BonosSalarial = 4,
    DescripcionBonosSalarial = "DIAN_GROUP.WAGE_BONUS",
    BonosNoSalarial = 5,
    DescripcionBonosNoSalarial = "DIAN_GROUP.NON_WAGE_BONUS",
    BonoAlimentacionSalarial = 6,
    DescripcionBonoAlimentacionSalarial = "DIAN_GROUP.WAGE_FOOD_VOUCHER",
    BonoAlimentacionNoSalarial = 7,
    DescripcionBonoAlimentacionNoSalarial = "DIAN_GROUP.NON_WAGE_FOOD_VOUCHER",
    AuxilioSalarial = 8,
    DescripcionAuxilioSalarial = "DIAN_GROUP.WAGE_SUBSIDY",
    AuxilioNoSalarial = 9,
    DescripcionAuxilioNoSalarial = "DIAN_GROUP.NON_WAGE_SUBSIDY",
    BonificacionSalarial = 10,
    DescripcionBonificacionSalarial = "DIAN_GROUP.SALARY_BONUS",
    BonificacionNoSalarial = 11,
    DescripcionBonificacionNoSalarial = "DIAN_GROUP.NON_SALARY_BONUS",
    Dotacion = 12,
    DescripcionDotacion = "DIAN_GROUP.ENDOWMENT",
    NoSalarialAprendicesPracticantes = 13,
    DescripcionNoSalarialAprendicesPracticantes = "DIAN_GROUP.TRAINEES_OR_INTERNS",
    Teletrabajo = 14,
    DescripcionTeletrabajo = "DIAN_GROUP.TELEWORK",
    BonificacionRetiro = 15,
    DescripcionBonificacionRetiro = "DIAN_GROUP.RETIREMENT_BONUS",
    Indemnizacion = 16,
    DescripcionIndemnizacion = "DIAN_GROUP.INDEMNIFICATION",
    Comisiones = 17,
    DescripcionComisiones = "LBL_COMMISSIONS",
    AuxilioDeTransporte = 18,
    DescripcionAuxilioDeTransporte = "DIAN_GROUP.TRANSPORTATION_SUPPORT",
    ViaticosSalariales = 19,
    DescripcionViaticosSalariales = "DIAN_GROUP.SALARY_BENEFITS",
    ViaticosNoSalariales = 20,
    DescripcionViaticosNoSalariales = "DIAN_GROUP.NON_SALARY_BENEFITS",
    HoraExtraDiurnaOrdinaria = 21,
    DescripcionHoraExtraDiurnaOrdinaria = "DIAN_GROUP.ORDINARY_DAYTIME_OVERTIME",
    HoraExtraNocturnaOrdinaria = 22,
    DescripcionHoraExtraNocturnaOrdinaria = "DIAN_GROUP.ORDINARY_NIGHTTIME_OVERTIME",
    HoraExtraDominicalesFestivasDiurna = 23,
    DescripcionHoraExtraDominicalesFestivasDiurna = "DIAN_GROUP.SUNDAY_HOLIDAY_DAYTIME_OVERTIME",
    HoraExtraDominicalesFestivasNocturna = 24,
    DescripcionHoraExtraDominicalesFestivasNocturna = "DIAN_GROUP.SUNDAY_HOLIDAY_NIGHT_OVERTIME",
    RecargoNocturo = 25,
    DescripcionRecargoNocturo = "DIAN_GROUP.NIGHT_OVERTIME",
    RecargoDiurnoDominicalFestivo = 26,
    DescripcionRecargoDiurnoDominicalFestivo = "DIAN_GROUP.SUNDAY_HOLIDAY_DAYTIME_SURCHARGE",
    RecargoNocturnoDominicalFestivo = 27,
    DescripcionRecargoNocturnoDominicalFestivo = "DIAN_GROUP.SUNDAY_HOLIDAY_NIGHT_SURCHARGE",
    VacacionesComunes = 28,
    DescripcionVacacionesComunes = "DIAN_GROUP.VACATION_TAKEN",
    VacacionesCompensadas = 29,
    DescripcionVacacionesCompensadas = "DIAN_GROUP.VACATION_IN_CASH",
    PrimaLegal = 30,
    DescripcionPrimaLegal = "LBL_PREMIUM",
    PrimaNoSalarial = 31,
    DescripcionPrimaNoSalarial = "DIAN_GROUP.NON_WAGE_PREMIUM",
    Cesantias = 32,
    DescripcionCesantias = "LIQUIDATE_CONTRACT.CESANTIAS",
    InteresesALasCesantias = 33,
    DescripcionInteresesALasCesantias = "DIAN_GROUP.INTEREST_ON_SEVERANCE_PAY",
    OtroConceptoSalarial = 34,
    DescripcionOtroConceptoSalarial = "DIAN_GROUP.OTHER_WAGE_CONCEPT",
    OtroConceptoNoSalarial = 35,
    DescripcionOtroConceptoNoSalarial = "DIAN_GROUP.OTHER_NON_SALARY_ITEM",
    IncapacidadComun = 36,
    DescripcionIncapacidadComun = "DIAN_GROUP.COMMON_DISABILITY",
    IncapacidadProfesional = 37,
    DescripcionIncapacidadProfesional = "DIAN_GROUP.PROFESSIONAL_DISABILITY",
    IncapacidadLaboral = 38,
    DescripcionIncapacidadLaboral = "DIAN_GROUP.INCAPACITY_FOR_WORK",
    LicenciaDeMaternidadPaternidad = 39,
    DescripcionLicenciaDeMaternidadPaternidad = "DIAN_GROUP.MATERNITY_PATERNITY_LEAVE",
    LicenciaRemunerada = 40,
    DescripcionLicenciaRemunerada = "TYPE_NEW_DETTLEMENT_TEMPLATE.PAID_LEAVE",
    LicenciaNoRemunerada = 41,
    DescripcionLicenciaNoRemunerada = "TYPE_NEW_DETTLEMENT_TEMPLATE.UNPAID_LEAVE",
    HuelgaLegal = 42,
    DescripcionHuelgaLegal = "DIAN_GROUP.LEGAL_STRIKES",
    PagosATerceros = 43,
    DescripcionPagosATerceros = "DIAN_GROUP.PAYMENT_TO_THIRD_PARTIES",
    Reintegros = 44,
    DescripcionReintegros = "MN_REINTEGRATE"
}
// enumeracion que contiene todos los grupos de los conceptos segun la DIAN para los deducidos
export enum GrupoDianDeducidos {
    OtrasDeducciones = 5000,
    DescripcionOtrasDeducciones = "DIAN_GROUP.OTHER_DEDUCTIONS",
    Salud = 5001,
    DescripcionSalud = "LBL_HEALTH",
    Pension = 5002,
    DescripcionPension = "DIAN_GROUP.PENSION",
    FondoDeSoldaridad = 5003,
    DescripcionFondoDeSoldaridad = "SOLIDARITY_FUNDS.SOLIDARITY_FUNDS",
    FondoDeSubsistencia = 5004,
    DescripcionFondoDeSubsistencia = "SOLIDARITY_FUNDS.SUBSISTENCE_FUNDS",
    SancionPublica = 5005,
    DescripcionSancionPublica = "DIAN_GROUP.PUBLIC_PENALTY",
    SancionPrivada = 5006,
    DescripcionSancionPrivada = "DIAN_GROUP.PRIVATE_PENALTY",
    Libranza = 5007,
    DescripcionLibranza = "DIAN_GROUP.RELEASE",
    PagosATerceros = 5008,
    DescripcionPagosATerceros = "DIAN_GROUP.PAYMENT_TO_THIRD_PARTIES",
    PensionVoluntaria = 5009,
    DescripcionPensionVoluntaria = "DIAN_GROUP.VOLUNTARY_PENSION",
    RetencionEnLaFuente = 5010,
    DescripcionRetencionEnLaFuente = "DIAN_GROUP.RETENTION_AT_SOURCE",
    AhorroCooperativa = 5011,
    DescripcionAhorroCooperativa = "DIAN_GROUP.COOPERATIVE_SAVINGS",
    EmbargoFiscal = 5012,
    DescripcionEmbargoFiscal = "DIAN_GROUP.TAX_LIEN",
    Sindicato = 5013,
    DescripcionSindicato = "DIAN_GROUP.SINDICAT",
    Anticipo = 5014,
    DescripcionAnticipo = "DIAN_GROUP.DEDUCTED_FOR_ADVANCE",
    AhorroFomentoConstrucciónAFC = 5015,
    DescripcionAhorroFomentoConstrucciónAFC = "DIAN_GROUP.SAVINGS_AFC_CONSTRUCTION",
    PlanComplementarioSalud = 5016,
    DescripcionPlanComplementarioSalud = "DIAN_GROUP.COMPLEMENTARY_PLAN",
    ServiciosEducativos = 5017,
    DescripcionServiciosEducativos = "DIAN_GROUP.EDUCATION_SERVICES_PAYMENT",
    Reintegros = 5018,
    DescripcionReintegros = "DIAN_GROUP.REINTEGRATION",
    Deudas = 5019,
    DescripcionDeudas = "DIAN_GROUP.DEBTS",
    LicenciaNoRemunerada = 5020,
    DescripcionLicenciaNoRemunerada = "TYPE_NEW_DETTLEMENT_TEMPLATE.UNPAID_LEAVE"
}

export enum ProveedoresSMS {
    DescripcionBigBang = 'Big Bang',
    BigBang = 1,

    DescripcionClaro = 'Claro',
    Claro = 2,

    DescripcionItCloud = 'It cloud',
    ItCloud = 3
}

export enum TipoPagoEgreso {
    PagoFacturasProveedor = 'T',
    DescripcionPagoFacturasProveedor = 'LBL_PAYMENT_OF_SUPPLIER_INVOICES',
    NotaCuentaXP = 'N',
    DescripcionNotaCuentaXP = 'NOTE_ACCOUNT_PAYABLE',
    OtrosEgresos = 'A',
    DescripcionOtrosEgresos = 'MN_RULES_BILLING_LOGISTICS.OTHER_EXPENSES',
    Cheque = 'C',
    DescripcionCheque = 'CHECK',
    Efectivo = 'J',
    DescripcionEfectivo = 'EFECTIVE',
    OtrosEgresosEfectivo = 'Z',
    DescripcionOtrosEgresosEfectivo = 'MN_RULES_BILLING_LOGISTICS.OTHER_EXPENSES',
    OtrosEgresosTransferenciaBancaria = 'W',
    DescripcionOtrosEgresosTransferenciaBancaria = 'MN_RULES_BILLING_LOGISTICS.OTHER_BANK_TRANSFER_EXPENSES',
    PagoFacturasChequePosfechado = 'P',
    DescripcionPagoFacturasChequePosfechado = 'MN_RULES_BILLING_LOGISTICS.PAYMENT_OF_INVOICES_POSTDATED_CHECK',
    TransferenciasOtrasMonedas = 'M',
    DescripcionTransferenciasOtrasMonedas = 'MN_RULES_BILLING_LOGISTICS.TRANSFERS_OTHER_CURRENCIES'


}

export enum MetodoGeneracionEgreso {
    Proveedor = 0,
    DescripcionProveedor = 'LBL_BY_SUPPLIER',

    Unico = 1,
    DescripcionUnico = 'PAYMENTS_RETURN_DOCUMENTOS.LBL_ONLY',

    Factura = 2,
    DescripcionFactura = 'LBL_BY_INVOICE'
}

export enum EntidadTraslado {
    Eps = "S",
    FondoPension = "P",
}

export enum MetodoImpresion {
    MostrarPdf = 'N',
    DescripcionMostrarPdf = 'MENU_CONTENTS_PARAMETERS.SHOW_PDF',
    MostrarPdfConOpciones = 'S',
    DescripcionMostrarPdfConOpciones = 'MENU_CONTENTS_PARAMETERS.SHOW_PDF_WITH_PRINT_OPTIONS',
    PlantillasPredeterminadas = 'P',
    DescripcionPlantillasPredeterminadas = 'MENU_CONTENTS_PARAMETERS.USE_DEFAULT_TEMPLATES_FOR_DOCUMENT'
}

export enum TipoDePago {
    PagoAProveedores = 0,
    DescripcionPagoAProveedores = 'BANK_FORMATS.SUPPLIER_PAYMENT',
    PagoDeNomina = 1,
    DescripcionPagoDeNomina = 'BANK_FORMATS.PAYROLL_PAYMENT'
}

export enum modoAperturaCrearEgreso {
    ObligacionesSeleccionadas = 0,
    EgresoUnico = 1,
}

export enum VistasSql {
    VistaTerceros = 1, // V_TERCEROS
    VistaProductos = 2,// V_PRODUCTOS
    VistaActivosFijos = 3,//V_ACTIVOSFIJOS
    VistaEmpleados = 4,// V_EMPLEADOS
    VistaPlanDeCuentas = 5,// V_PLAN_CUENTAS
    VistaSolicitudes = 6,// V_SOLICITUDES
    VistaActividades = 7,// V_ACTIVIDADES
    VistaTareasProyectos = 8,// V_TAREAS_PROYECTOS
    VistaEquipos = 9,// V_EQUIPOS
    VistaOportunidades = 11,// V_OPORTUNIDADES
    VistaArrendamientosEquipo = 13,// V_ARRENDAMIENTO_EQUIPOS
    VistaDocsDestinoNivelDos = 14,// V_DOCS_DESTINO_NIVEL_DOS
    VistaDocsDestinoNivelUno = 15,// V_DOCS_DESTINO_NIVEL_UNO
    VistaDocsOrigenNivelDos = 16,// V_DOCS_ORIGEN_NIVEL_DOS
    VistaDocsOrigenNivelUno = 17,// V_DOCS_ORIGEN_NIVEL_UNO
    VistaEncabezadoDocumentos = 18,// V_ENCABEZADO_DOCUMENTOS
    VistaEstadosActividades = 19,// V_ESTADOS_ACTIVIDADES
    VistaEstadosOportunidades = 20,// V_ESTADOS_OPORTUNIDADES
    VistaEstadosSolicitudes = 21,// V_ESTADOS_SOLICITUDES
    VistaEstadosTareas = 22,// V_ESTADOS_TAREAS
    VistaGastosCaja = 23,// V_GASTOSCAJA
    VistaHistoricoCambiosEmpleados = 24,// V_HISTORICO_CAMBIOS_EMPLEADOS
    VistaIngresoAnimalesFrigorifico = 25,// V_INGRESO_ANIMALES_FRIGORIFICO -> No utilizado en el back
    VistaLiquidacionEquipos = 26,// V_LIQUIDACION_EQUIPOS
    VistaMejorasActivos = 27,// V_MEJORAS
    VistaMovimientoContable = 28,// V_DET_MOVIMIENTO_CONTABLE
    VistaMovimientoInventarioVariantes = 29,// V_MTO_INVENT_VARIANTES
    VistaProductosPendientesComprar = 30,// V_PRODUCTOS_PENDIENTES_COMPRAR
    VistaProductosPendientesPedidos = 31,// V_PRODUCTOS_PENDIENTES_PEDIDOS
    VistaSacrificioAnimalesFrigo = 32,// V_SACRIFICIO_ANIMALES_FRIGO -> No utilizado en el back
    VistaSaldosActivosFijos = 33,// V_SALDOSAF
    // La enumeracion # 34 queda disponible borrar el comentario despues de utilizarla
    VistaTiemposActividades = 35,// V_TIEMPOS_ACTIVIDADES
    VistaTraslados = 36,// V_TRASLADOS
    VistaMovimientoInventario = 37,// V_MOVIMIENTO_INVENTARIO
    VistaCantidadesCEDI = 38,// V_CANTIDADES_CEDI
    VistaConsumosPendientesOrdenesProduccion = 39,// V_CONS_PENDIENTES_ORD_PROD
    VistaProductosPendientesProducir = 40,// V_PROD_PENDIENTES_PRODUCIR
    VistaComposicionPrecio = 41,// V_COMPOSICION_PRECIO
    VistaTotalTiemposTareas = 42,// V_TOTAL_TIEMPOS_TAREAS
    VistaTotalTiemposSolicitudes = 43,// V_TOTAL_TIEMPOS_SOLICITUDES
    VistaCuentasxCobrarClientes = 44,// V_CXC_CLIENTES
    VistaAnticiposClientes = 45,// V_ANTICIPOS_CLIENTES
    VistaValorPedidoClientes = 46,// V_VALOR_PEDIDO_CLIENTES
    VistaHistoriasClinicas = 47,// V_HISTORIAS_CLINICAS
    SaldosActualesCXC = 48,// V_SALDOS_ACTUALES_CXC
    SaldosActualesCXP = 49,// V_SALDOS_ACTUALES_CXP
    TarjetasDePago = 50,// V_TARJETAS_DE_PAGO
    FacturacionContratos = 51,// V_FACTURACION_CONTRATOS
    ProductosContartos = 52,// V_PRODUCTOS_CONTRATOS
    Nomina = 53 // V_NOMINA
}

export enum MetodoCalculo {
    ValorFijoFlete = 0,
    DescripcionValorFijoFlete = 'MN_FREIGHT_RATE.FIXED_VALUE_FREIGHT',

    ValorFletePorUnidadBase = 1,
    DescripcionValorFletePorUnidadBase = 'MN_FREIGHT_RATE.FREIGHT_VALUE_BY_BASE_UNIT',

    ValorFletePorUnidadAlterna = 2,
    DescripcionValorFletePorUnidadAlterna = 'MN_FREIGHT_RATE.FIXED_VALUE_FREIGHT_BY_ALTERNATE_UNIT',

    ValorFleteFijoRecorrido = 3,
    DescripcionValorFleteFijoRecorrido = 'MN_FREIGHT_RATE.FIXED_VALUE_FREIGHT_JOURNEY',

    ValorFletePorUnidadBaseRecorrido = 4,
    DescripcionValorFletePorUnidadBaseRecorrido = 'MN_FREIGHT_RATE.FREIGHT_VALUE_BY_BASE_UNIT_JOURNEY',

    ValorFletePorUnidadAlternaRecorrido = 5,
    DescripcionValorFletePorUnidadAlternaRecorrido = 'MN_FREIGHT_RATE.FREIGHT_VALUE_BY_ALTERNATE_UNIT_JOURNEY'
}

export enum ClavesFormulaPatronContable {
    Precio = 'PRECIO',
    DescripcionPrecio = "COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_PRICE_WITHOUT_VAT",

    Costo = 'COSTO',
    DescripcionCosto = "COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_COST_WITHOUT_VAT",

    Base = 'BASE',
    DescripcionBase = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_PRICE_OR_COST_WITHOUT_VAT',

    Pago = 'PAGO',
    DescripcionPago = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_VALUE_PAYED_EACH_PAYMENT_METHOD',

    ValorAdicional = 'VALOR_ADICIONAL',
    DescripcionValorAdicional = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ADDITIONAL_VALUE_FROM_DOCUMENTS_HEADER',

    IvaDocumento = 'IVA_DOCUMENTO',
    DescripcionIvaDocumento = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_VAT_VALUE',

    ImpoConsumo = 'IMPOCONSUMO',
    DescripcionImpoConsumo = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_CONSUMPTION_TAX_VALUE',

    Descuento = 'DESCUENTO',
    DescripcionDescuento = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_DISCOUNT_VALUE',

    Fletes = 'FLETES',
    DescripcionFletes = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_FREIGHT_VALUE_WHEN_NO_DISTRIBUTED_IN_ITEMS',

    IvaFletes = 'IVA_FLETES',
    DescripcionIvaFletes = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_FREIGHT_VAT_VALUE_WHEN_NO_DISTRIBUTED_IN_ITEMS',

    PrecioAdicionalUno = 'PRECIO_ADICIONAL1',
    DescripcionPrecioAdicionalUno = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_ADITTIONAL_ONE_PRICE',

    PrecioAdicionalDos = 'PRECIO_ADICIONAL2',
    DescripcionPrecioAdicionalDos = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_ADITTIONAL_TWO_PRICE',

    Pedir = 'PEDIR',
    DescripcionPedir = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_ORDER_ACCOUNT'
}

export enum ClavesCuentasPorCobrarPatroContable {
    Grupos = 'GRUPO1,GRUPO2,GRUPO3,GRUPO4,GRUPO5,GRUPO6,GRUPO7,GRUPO8,GRUPO9,GRUPO10',
    DescripcionGrupos = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ACCOUNT_PRODUCT_GROUP',

    Impuestos = 'IMPUESTO1,IMPUESTO2,IMPUESTO3,IMPUESTO4,IMPUESTO5',
    DescripcionImpuestos = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ACCOUNT_VAT_RATE_PRODUCT',

    GruposCentroCosto = 'GRUPOCC1,GRUPOCC2,GRUPOCC3,GRUPOCC4,GRUPOCC5',
    DescripcionGruposCentroCosto = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ACCOUNT_FROM_PRODUCT_GROUP_AND_COST_CENTER',

    TiposNit = 'TIPONIT1,TIPONIT2',
    DescripcionTiposNit = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ACCOUNT_FROM_CLIENTS_TYPE_SPECIFIED_IN_HEADER',

    RegimenesNit = 'REGIMENIT1,REGIMENIT2',
    DescripcionRegimenesNit = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ACCOUNT_CLIENTS_REGIME_SPECIFIED_IN_HEADER',

    Almacen = 'ALMACEN',
    DescripcionAlmacen = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_WAREHOUSE_ACCOUNT',

    AlmacenDestino = 'ALMACENDES',
    DescripcionAlmacenDestino = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_WAREHOUSE_ACCOUNT_DESTINATION',


    FormaPago = 'FORMAPAGO',
    DescripcionFormaPago = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_ACCOUNT_PAYMENT_METHOD',

    CtaFactura = 'CTAFACTURA',
    DescripcionCtaFactura = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_INTO_ACCOUNT_THE_QUOTA',

    SinCuenta = 'SINCUENTA',
    DescripcionSinCuenta = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_NOT_ACCOUNTING_TRANSACTIONS_SETS_VARIABLES_TO_BE_USED',

    Pedir = 'PEDIR',
    DescripcionPedir = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_ORDER_VALUE'
}

export enum ClavesNitPatronContable {
    TerceroDos = 0.2,
    DescripcionTerceroDos = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_SECOND_CLIENT',

    TerceroTres = 0.3,
    DescripcionTerceroTres = 'COMPONENT_ACCOUNTING_STANDARDS.ENUM_DESCRIPTION_TAKE_DOCUMENTS_THIRD_CLIENT'
}

export enum ControlPresupuestoOrdenTrabajo {
    NoAplica = 0,
    DescripcionNoAplica = 'LBL_DOES_NOT_APPLY',

    SoyPresupuesto = 1,
    DescripcionSoyPresupuesto = 'MENU_CONTENTS_PARAMETERS.IM_BUDGET_WORK_ORDER',

    ControlarCompras = 2,
    DescripcionControlarCompras = 'MENU_CONTENTS_PARAMETERS.CONTROL_PURCHSES_WORK_ORDER',

    ControlarConsumos = 3,
    DescripcionControlarConsumos = 'MENU_CONTENTS_PARAMETERS.CONTROL_CONSUMPTIONS_WORK_ORDER'
}

export enum PresupuestoOrdenTrabajoProductos {

    NoAplica = 0,
    DescripcionNoAplica = 'LBL_DOES_NOT_APPLY',

    ControlOtCantidadProducto = 1,
    DescripcionControlOtCantidadProducto = 'PRODUCT_LABELS.CONTROL_WORK_ORDER_QUANTITYS_PRODUCT',

    ControlOtValorProducto = 2,
    DescripcionControlOtValorProducto = 'PRODUCT_LABELS.CONTROL_WORK_ORDER_VALUES_PRODUCT',

    ControlOtCantidadValorProducto = 3,
    DescripcionControlOtCantidadValorProducto = 'PRODUCT_LABELS.CONTROL_WORK_ORDER_QUANTITY_AND_VALUES_PRODUCT',

    ControlOtCantidadTipoServicio = 4,
    DescripcionControlOtCantidadTipoServicio = 'PRODUCT_LABELS.CONTROL_WORK_ORDER_QUANTITY_AND_SERVICE_TYPE',

    ControlOtValorTipoServicio = 5,
    DescripcionControlOtValorTipoServicio = 'PRODUCT_LABELS.CONTROL_WORK_ORDER_VALUE_AND_SERVICE_TYPE',

    ControlOtCantidadValorTipoServicio = 6,
    DescripcionControlOtCantidadValorTipoServicio = 'PRODUCT_LABELS.CONTROL_WORK_ORDER_QUANTITY_VALUE_AND_SERVICE_TYPE',
}
export enum AlineacionFormatoImpresion {
    Izquierda = 0,
    Centro = 1,
    Derecha = 2,
    Justificado = 3
}

export enum EstiloLetra {
    negrilla = 0
}

export enum ClasesDocumentoNominaElectronica {
    NominaIndividual = 'NIE',
    DescripcionNominaIndividual = 'ELECTRONIC_PAYROLL.NIE',
    AjusteNomina = 'NIA',
    DescripcionAjusteNomina = "ELECTRONIC_PAYROLL.NIA"
}

export enum GruposCuentas {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',

    CuentaUno = 1,
    DescripcionCuentaUno = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_ONE_OF_THE_PRODUCT_GROUP',

    CuentaDos = 2,
    DescripcionCuentaDos = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_TWO_OF_THE_PRODUCT_GROUP',

    CuentaTres = 3,
    DescripcionCuentaTres = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_THREE_OF_THE_PRODUCT_GROUP',

    CuentaCuatro = 4,
    DescripcionCuentaCuatro = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_FOUR_OF_THE_PRODUCT_GROUP',

    CuentaCinco = 5,
    DescripcionCuentaCinco = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_FIVE_OF_THE_PRODUCT_GROUP',

    CuentaSeis = 6,
    DescripcionCuentaSeis = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_SIX_OF_THE_PRODUCT_GROUP',

    CuentaSiete = 7,
    DescripcionCuentaSiete = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_SEVEN_OF_THE_PRODUCT_GROUP',

    CuentaOcho = 8,
    DescripcionCuentaOcho = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_EIGHT_OF_THE_PRODUCT_GROUP',

    CuentaNueve = 9,
    DescripcionCuentaNueve = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_NINE_OF_THE_PRODUCT_GROUP',

    CuentaDiez = 10,
    DescripcionCuentaDiez = 'MENU_CONTENTS_PARAMETERS.LBL_ACCOUNT_TEN_OF_THE_PRODUCT_GROUP'

}
export enum AccionesRecosteoInventarios {
    Ninguna = 0,
    VerificarSaldosFinales = 1,
    OrganizarSaldosFinales = 2,
    VerificarCostosMovimientos = 3,
    OrganizarCostosMovimientos = 4,
    DescripcionNinguna = 'LBL_NEITHER',
    DescripcionVerificarSaldosFinales = 'VERIFY_FINAL_BALANCES',
    DescripcionVerificarCostosMovimientos = 'VERIFY_COST_MOVEMENTS',
    DescripcionOrganizarSaldosFinales = 'ORGANIZE_FINAL_BALANCES',
    DescripcionOrganizarCostosMovimientos = 'ORGANIZE_COST_MOVEMENTS'
}

export enum TipoCobroServicio {
    Todos = 0,
    DescripcionTodos = 'LABEL_ALL_PLURAL',
    Facturados = 1,
    DescripcionFacturados = "LBL_BILLED",
    SinFacturar = 2,
    DescripcionSinFacturar = 'LBL_WITHOUT_BILLING'
}

export enum CantidadPendiente {
    ConEntregaPendiente = 1,
    DescripcionConEntregaPendiente = 'D_WITH_PENDING_AMOUNT',

    SinEntregaPendiente = 2,
    DescripcionSinEntregaPendiente = 'D_WITHOUT_PENDING_AMOUNT',

    ConEntregaParcial = 5,
    DescripcionConEntregaParcial = 'WITH_PARTIAL_DELIVERY',

    SinOrdenTrabajo = 3,
    DescripcionSinOrdenTrabajo = 'WITH_OT_PENDING',

    AtrasadosEntrega = 4,
    DescripcionAtrasadosEntrega = 'MENU_CONTENTS_DOCUMENT.OVERDUE_DELIVERY'
}

export enum NovedadesPlantillaIntegradaLiquidacionAportes {
    SuspensionTemporalContrato = 1,
    DescripcionSuspensionTemporalContrato = 'TYPE_NEW_DETTLEMENT_TEMPLATE.TEMPORARY_SUSPENSION_OF_CONTRACT',

    IncapacidadEnfermedadGeneral = 2,
    DescripcionIncapacidadEnfermedadGeneral = 'TYPE_NEW_DETTLEMENT_TEMPLATE.INCAPACITY_GENERAL_SICKNESS',

    LicenciaMaternidadPaternidad = 3,
    DescripcionLicenciaMaternidadPaternidad = 'TYPE_NEW_DETTLEMENT_TEMPLATE.PARENTAL_LEAVE',

    Vacaciones = 4,
    DescripcionVacaciones = 'VACATIONS',

    LicenciaRemunerada = 5,
    DescripcionLicenciaRemunerada = 'TYPE_NEW_DETTLEMENT_TEMPLATE.PAID_LEAVE',

    VariacionCentrosDeTrabajo = 6,
    DescripcionVariacionCentrosDeTrabajo = 'PILA.CHANGE_OF_WORK_CENTERS',

    IncapacidadPorAToEP = 7,
    DescripcionIncapacidadPorAToEP = 'PILA.DISABILITY_FOR_AT_OR_EP'
}

export enum TipoNovedadPila {
    IGE = 'I',
    DescripcionIGE = 'PILA.GENERAL_DISABILITY',

    IRP = 'A',
    DescripcionIRP = 'PILA.DISABILITY_FOR_AT_OR_EP',

    LMA = 'M',
    DescripcionLMA = 'MATERNITY_PATERNITY_LEAVE',

    SLN = 'L',
    DescripcionSLN = 'PILA.TEMPORARY_SUSPENSION_OF_CONTRACT',

    VACX = 'V',
    DescripcionVACX = 'VACATIONS',

    VACL = 'R',
    DescripcionVACL = 'TYPE_NEW_DETTLEMENT_TEMPLATE.PAID_LEAVE',

    Salario = 'G',
    DescripcionSalario = 'LBL_SALARY',

    VariacionCentroTrabajo = 'W',
    DescripcionVariacionCentroTrabajo = 'PILA.CHANGE_OF_WORK_CENTERS'
}

export enum OperadoresMatematicos {
    Suma = '+',
    DescripcionSuma = '+',
    Resta = '-',
    DescripcionResta = '-',
    Multiplicacion = '*',
    DescripcionMultiplicacion = '*',
    Division = '/',
    DescripcionDivision = '/'
}

export enum TiposRegimenes {
    DescripcionRegimencomun = 'DESCRIPTION_REGIMEN.COMMON_REGIMEN',
    Regimencomun = '01',

    DescripcionRegimensimplificado = 'DESCRIPTION_REGIMEN.SIMPLIFIELD_REGIMEN',
    Regimensimplificado = '02',

    DescripcionGrancontribuyente = 'DESCRIPTION_REGIMEN.LARGE_CONTRIBUTOR',
    Grancontribuyente = '03',

    DescripcionEmpresasDelGobierno = 'DESCRIPTION_REGIMEN.GOVERNMENT_COMPANIES',
    EmpresasDelGobierno = '04',

    DescripcionOrganizacionNoGubernamental = 'DESCRIPTION_REGIMEN.NON_GOVERNMENTAL_ORGANIZATION',
    OrganizacionNoGubernamental = '05',

    DescripcionExtranjeros = 'DESCRIPTION_REGIMEN.FOREIGNERS',
    Extranjeros = '06'
}
export enum TipoRelacionTercero {
    Cliente = 'C',
    DescripcionCliente = 'LBL_CUSTOMER',
    Proveedor = 'P',
    DescripcionProveedor = 'PROVIDER',
    Banco = 'B',
    DescripcionBanco = 'LBL_BANK',
    Vendedor = 'V',
    DescripcionVendedor = 'SELLER',
    Operador = 'O',
    DescripcionOperador = 'LBL_OPERATOR',
    Contratista = 'T',
    DescripcionContratista = 'LBL_CONTRACTOR',
    Empleado = 'E',
    DescripcionEmpleado = 'LBL_EMPLOYEE',
    Paciente = 'A',
    DescripcionPaciente = 'LBL_PATIENT',
    Profesional = 'F',
    DescripcionProfesional = 'LBL_PROFESSIONAL',
    Usuario = 'U',
    DescripcionUsuario = 'L_USER',
    Prospecto = 'X',
    DescripcionProspecto = 'MN_PROSPECT'
}
export enum SubtipoCotizante {
    Ninguno = 0,
    DescripcionNinguno = 'ENUM_SUB_QUOTE.NONE',
    Dependiente = 1,
    DescripcionDependiente = 'ENUM_SUB_QUOTE.ONE_DEPENDENT',
    Independiente = 2,
    DescripcionIndependiente = 'ENUM_SUB_QUOTE.TWO_INDEPENDENT',
    NoObligadoPorEdad = 3,
    DescripcionNoObligadoPorEdad = 'ENUM_SUB_QUOTE.THREE_QUOTE_NO_OBLIGATED',
    RequisitosCumplidos = 4,
    DescripcionRequisitosCumplidos = 'ENUM_SUB_QUOTE.FOUR_QUOTE_WITH_REQUERIMENTS',
    ReconocidaIndemnizacion = 5,
    DescripcionReconocidaIndemnizacion = 'ENUM_SUB_QUOTE.FIVE_QUOTE_RECOGNIZED_COMPENSATION',
    PertenecienteRegimen = 6,
    DescripcionPertenecienteRegimen = 'ENUM_SUB_QUOTE.SIX_QUOTE_BELONGING_A_REGIME'
}

export enum TipoEnvioNominaElectronica {
    Normal = 0,
    DescripcionNormal = "NORMAL",
    Remplazo = 1,
    DescripcionRemplazo = "LBL_REPLACE_PAYROLL",
    Eliminacion = 2,
    DescripcionEliminacion = "BUTTON_DELETE",
}

export enum TipoConceptoContable {
    ConceptoNomina = 'SELECCIONAR-CONCEPTO-NOMINA',
    DescripcionConceptoNomina = 'LBL_PAYROLL_CONCEPT',

    ARL = '#0>',
    DescripcionARL = 'SLD_ARL',

    EPS = '#1>',
    DescripcionEPS = 'LC_EPS',

    Pension = '#2>',
    DescripcionPension = 'PENSION',

    SENA = '#3>',
    DescripcionSENA = 'LBL_SENA',

    ICBF = '#4>',
    DescripcionICBF = 'ICBF',

    Cajas = '#5>',
    DescripcionCajas = 'BOXES',

    ESAP = '#6>',
    DescripcionESAP = 'PILA.PARAFISCAL_ESAP',

    MEN = '#7>',
    DescripcionMEN = 'PILA.PARAFISCAL_MEN'
}
export enum EstadoPasarelasDePago {
    Aprobada = 4,
    Declinada = 6,
    Error = 104,
    Expirada = 5,
    Pendiente = 7
}

export enum TiposCamposPersonalizados {
    Tab = 0,
    DescripcionTab = 'TAB',

    GroupPanel = 1,
    DescripcionGroupPanel = 'GROUP_PANEL',

    InputText = 2,
    DescripcionInputText = 'INPUT_TEXT',

    InputNumber = 3,
    DescripcionInputNumber = 'INPUT_NUMBER',

    InputFormula = 4,
    DescripcionInputFormula = 'INPUT_FORMULA',

    Dropdown = 5,
    DescripcionDropdown = 'INPUT_SELECT',

    InputDate = 6,
    DescripcionInputDate = 'INPUT_DATE',

    InputSearch = 7,
    DescripcionInputSearch = 'INPUT_SEARCH',

    InputToggle = 8,
    DescripcionInputToggle = 'INPUT_TOGGLE',

    InputFile = 9,
    DescripcionInputFile = 'INPUT_FILE',

    TextArea = 10,
    DescripcionTextArea = 'TEXTAREA',
}

export enum opcionesContabilizar {
    Nomina = 'N',
    DescripcionNomina = 'MN_NOMINE',

    Vacaciones = "V','W",
    DescripcionVacaciones = 'VACATIONS',

    LiquidacionContrato = 'Q',
    DescripcionLiquidacionContrato = 'CONTRACT_SETTLEMENT',

    Cesantias = 'C',
    DescripcionCesantias = 'LIQUIDATE_CONTRACT.CESANTIAS',

    Prestamo = 'P',
    DescripcionPrestamo = 'LOAN',

    Prima = 'E',
    DescripcionPrima = 'LBL_PREMIUM',

    ProvisionesDeNomina = 'I',
    DescripcionProvisionesDeNomina = "PAYROLL_PROVISIONS.PAYROLL_PROVISIONS"
}
export enum RestriccionFecha {
    Todos = 0,
    MayorIgualActual = 1,
    MenorIgualActual = 2,
    MayorActual = 3,
    MenorActual = 4
}

export enum EstadoEnvioNominaElectronica {
    Todas = 1,
    DescripcionTodas = 'LBL_LIST_ALL',
    PorTrasmitir = 2,
    DescripcionPorTrasmitir = 'SENDING_STATE_OF_ELECTRONIC_PAYROLL.LACK_OF_TRASMIT',
    Trasmitida = 3,
    DescripcionTrasmitida = 'SENDING_STATE_OF_ELECTRONIC_PAYROLL.TRANSMITTED',
    TransmitidaConError = 4,
    DescripcionTransmitidaConError = 'SENDING_STATE_OF_ELECTRONIC_PAYROLL.TRANSMITTED_WITH_ERROR'
}

export enum AperturaParqueadero {
    Parqueadero = 0,
    Visitante = 1
}

export enum TarifaPor {
    DescripcionTarifaHora = 'LBL_HOURS',
    Hora = 'hora',

    DescripcionTarifaMinuto = 'LBL_MINUTES',
    Minuto = 'minuto',

}

export enum TipoSuministro {
    Interno = 'I',
    DescripcionInterno = 'METHOD_INTERNAL',
    Externo = 'E',
    DescripcionExterno = 'METHOD_EXTERNAL',
    InternoPosterior = 'P',
    DescripcionInternoPosterior = 'INTERNAL_SUPPLY'
}

export enum TipoEnvioValorAdicional {
    NoEnviar = 0,
    DescripcionNoEnviar = 'SHIPMENT_TYPE_OF_ADITIONAL_VALUE_ITEMS.NOT_SENT',

    EnviarComoAnticipo = 1,
    DescripcionEnviarComoAnticipo = 'SHIPMENT_TYPE_OF_ADITIONAL_VALUE_ITEMS.SEND_LIKE_ADVANCE',

    EnviarComoDescuentoGlobal = 2,
    DescripcionEnviarComoDescuentoGlobal = 'SHIPMENT_TYPE_OF_ADITIONAL_VALUE_ITEMS.SEND_LIKE_DISCOUNT',

    EnviarComoRecargoGlobal = 3,
    DescripcionEnviarComoRecargoGlobal = 'SHIPMENT_TYPE_OF_ADITIONAL_VALUE_ITEMS.SEND_LIKE_SURCHARGE'
}

export enum ValorAdicional {
    ValorAdicional1,
    ValorAdicional2
}

export enum CalcularPrecio {
    PrecioUnitario,
    PrecioTotal
}

export enum CategoriasMenuPortal {

    SolicitudesPortalCliente = 0,
    DescripcionSolicitudesPortalCliente = 'LBL_REQUESTS_CUSTOMER_PORTAL',

    TareasPortalCliente = 1,
    DescripcionTareasPortalCliente = 'TASKS_CUSTOMER_PORTAL',

    SolicitudesPortalEmpleado = 2,
    DescripcionSolicitudesPortalEmpleado = 'LBL_REQUESTS_EMPLOYEE_PORTAL',

    TareasPotalEmpleado = 3,
    DescripcionTareasPotalEmpleado = 'TASKS_EMPLOYEE_PORTAL'
}

export enum ReasignarEjecutivoCuentas {
    OportunidadesAbiertas = 0,
    DescripcionOportunidadesAbiertas = 'LBL_OPEN_OPPORTUNITIES',

    OportunidadesCerradas = 1,
    DescripcionOportunidadesCerradas = 'LBL_CLOSED_OPPORTUNITIES',

    ClientesActivos = 2,
    DescripcionClientesActivos = 'CUSTOMERS_ASSETS',

    Sucursales = 3,
    DescripcionSucursales = 'LBL_BRANCH_OFFICES',

    OrdenPedidoPendientes = 4,
    DescripcionOrdenPedidoPendientes = 'BACK_ORDERS',

    FacturasPendientesPago = 5,
    DescripcionFacturasPendientesPago = 'OUTSTANDING_INVOICES',

    DocumentosVenta = 6,
    DescripcionDocumentosVenta = 'SALES_DOCUMENTS'
}

export enum TipoError {
    CajaSinTercero = -58,
    DescripcionCajaSinTercero = 'DESCRIPTION_ENUM_ERROR_TYPES.PETTY_CASH_WITHOUT_CLIENT',

    CajaSinCuenta = -57,
    DescripcionCajaSinCuenta = 'DESCRIPTION_ENUM_ERROR_TYPES.PETTY_CASH_WITHOUT_ACCOUNT',

    DocumentoSinCuentaPorCobrar = -56,
    DescripcionDocumentoSinCuentaPorCobrar = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_FOUND_DOCUMENT_FOR_ACCOUNT_RECEIVABLE',

    DocumentosNoCreados = -55,
    DescripcionDocumentosNoCreados = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_CREATE_DOCUMENT',

    ErroresEnProceso = -54,
    DescripcionErroresEnProceso = 'DESCRIPTION_ENUM_ERROR_TYPES.EXIST_ERRORS_ACTUALLY_PROCESS',

    UsuarioCaduco = -53,
    DescripcionUsuarioCaduco = 'DESCRIPTION_ENUM_ERROR_TYPES.PASSWORD_EXPIRED',

    UsuarioNoHabilitado = -52,
    DescripcionUsuarioNoHabilitado = 'DESCRIPTION_ENUM_ERROR_TYPES.THIS_USER_NOT_FOUND_ENABLED',

    RegistroNoEditable = -51,
    DescripcionRegistroNoEditable = 'DESCRIPTION_ENUM_ERROR_TYPES.THIS_RECORD_DOESNT_MODIFY',

    FalloOperacionConLicencia = -50,
    DescripcionFalloOperacionConLicencia = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_ACTUALLY_OPERATION_WITH_LICENSE',

    OperaionNoPermitidaSesionExpiro = -49,
    DescripcionOperaionNoPermitidaSesionExpiro = 'DESCRIPTION_ENUM_ERROR_TYPES.SESSION_EXPIRED_OERATION_DOESNT_ALLOWED',

    FalloEmpresaNoRegistradaEnSede = -48,
    DescripcionFalloEmpresaNoRegistradaEnSede = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_FOUND_RECORD_OF_COMPANY_ON_THE_PREMISE',

    FalloAutenticacionWebService = -47,
    DescripcionFalloAutenticacionWebService = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_AUTHENTICATION_ON_WEB_SERVICE',

    NoExisteUnaTransaccionActual = -46,
    DescripcionNoExisteUnaTransaccionActual = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_FOUND_TRANSACTION_STARTED',

    FalloCantidadPaquetesPenErrServicioEnvia = -45,
    DescripcionFalloCantidadPaquetesPenErrServicioEnvia = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_SEND_PACKAGES',

    FalloConexionServicioReplica = -44,
    DescripcionFalloConexionServicioReplica = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_COMMUNICATE_WITH_REPLY_SERVICE',

    FalloGuardarRegistroYaExistente = -43,
    DescripcionFalloGuardarRegistroYaExistente = 'DESCRIPTION_ENUM_ERROR_TYPES.CANT_ADD_BECOUSE_RECORD_ALREADY_EXISTS',

    FalloSuperoCantidadLimite = -42,
    DescripcionFalloSuperoCantidadLimite = 'DESCRIPTION_ENUM_ERROR_TYPES.EXCEED_LIMIR_QUANTITY_ALLOWED',

    NoCoincideLaConfirmacionDePws = -41,
    DescripcionNoCoincideLaConfirmacionDePws = 'DESCRIPTION_ENUM_ERROR_TYPES.PASSWORD_ISNT_SAME_PASSWORD_TYPED',

    PrefijoTransaccionInvalido = -40,
    DescripcionPrefijoTransaccionInvalido = 'DESCRIPTION_ENUM_ERROR_TYPES.INVALID_PREFIX_FOR_TRANSACTION',

    PrefijoSedeYaAsignado = -39,
    DescripcionPrefijoSedeYaAsignado = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_OPERATION_PREMISE_PREFIX_ASSIGNED',

    DatosEmpresaInvalidos = -38,
    DescripcionDatosEmpresaInvalidos = 'DESCRIPTION_ENUM_ERROR_TYPES.INVALID_DATA_COMPANY',

    PrefijoInvalidoReiniciarSede = -37,
    DescripcionPrefijoInvalidoReiniciarSede = 'DESCRIPTION_ENUM_ERROR_TYPES.INVALID_PREFIX_FOR_RESET_PREMISE_DATA',

    FalloEliminarProhibidaAccion = -36,
    DescripcionFalloEliminarProhibidaAccion = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_DELETING_NOT_ALLOW_RECORDS',

    FalloConfirmarSQLTransaccion = -35,
    DescripcionFalloConfirmarSQLTransaccion = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_CONFIRM_SQL_SENTENCES',

    FalloCrearSQLTransaccion = -34,
    DescripcionFalloCrearSQLTransaccion = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_ADD_TRANSACTION_SENTENCES',

    FalloCrearCabeceraTransaccion = -33,
    DescripcionFalloCrearCabeceraTransaccion = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_CREATE_TRANSACTION_HEADER_FOR_SYNCHRONIZATION',

    FalloCrearTransaccion = -32,
    DescripcionFalloCrearTransaccion = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_CREATE_DATA_SYNCHRONIZATION_TRANSACTION',

    NoActualizoNingunRegistro = -31,
    DescripcionNoActualizoNingunRegistro = 'DESCRIPTION_ENUM_ERROR_TYPES.SOMEOTHINGS_OPERATIONS_ABOUT_BD_DONT_GENERATE_NECESSARY_RESULTS',

    FalloCrearIdRegistro = -30,
    DescripcionFalloCrearIdRegistro = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_CREATE_RECORD_IDENTIFIER',

    FalloCargarParametrosSede = -29,
    DescripcionFalloCargarParametrosSede = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_CHARGE_CONFIGURATION_PARAMETERS_OF_PREMISE',

    FalloOperacionBd = -28,
    DescripcionFalloOperacionBd = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_ACTUALLY_OPERATION_ON_BD',

    FalloEjecutarConsultaBd = -27,
    DescripcionFalloEjecutarConsultaBd = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_EXECUTE_QUERY_ON_BD',

    NoHayRegistrosSeleccionados = -26,
    DescripcionNoHayRegistrosSeleccionados = 'DESCRIPTION_ENUM_ERROR_TYPES.HAVENT_SELECTED_RECORD_FOR_MAKE_OPERATION',

    NoExistenRegistros = -25,
    DescripcionNoExistenRegistros = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_FOUND_RECORD',

    FalloEliminarRegistrosAsociados = -24,
    DescripcionFalloEliminarRegistrosAsociados = 'DESCRIPTION_ENUM_ERROR_TYPES.ACTUALLY_RECORD_HAVE_OTHER_RECORDS_JOIN_IT',

    DatosUsuarioIncorrectos = -23,
    DescripcionDatosUsuarioIncorrectos = 'DESCRIPTION_ENUM_ERROR_TYPES.USER_DATA_TYPED_INVALID',

    FalloCargarXmlConfiguracion = -22,
    DescripcionFalloCargarXmlConfiguracion = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_CHARGE_CONFIGURATION_FILE',

    FalloEscribirXmlConfiguracion = -22,
    DescripcionFalloEscribirXmlConfiguracion = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_WRITE_CONFIGURATION_FILE',

    AccesoUsuarioRestringido = -21,
    DescripcionAccesoUsuarioRestringido = 'DESCRIPTION_ENUM_ERROR_TYPES.ACTUALLY_USER_DOESNT_ALLOW_MAKE_THE_OPERATION',

    FalloConexionConfiguracion = -20,
    DescripcionFalloConexionConfiguracion = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_TO_CONNECT_WITH_BD_APPLICATION_CONFIGURATION',

    ConexionBdPerdida = -19,
    DescripcionConexionBdPerdida = 'DESCRIPTION_ENUM_ERROR_TYPES.BD_CONNECTION_LOST_TRY_RESET',

    FalloCargarEstilos = -18,
    DescripcionFalloCargarEstilos = 'DESCRIPTION_ENUM_ERROR_TYPES.CANT_CHARGE_STYLES_FILE',

    FalloCargarXml = -17,
    DescripcionFalloCargarXml = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_CHARGE_XML_FILE',

    FalloEscribirXml = -16,
    DescripcionFalloEscribirXml = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_WRITE_XML_FILE',

    RegistroYaExistente = -15,
    DescripcionRegistroYaExistente = 'DESCRIPTION_ENUM_ERROR_TYPES.RECORD_ALREADY_EXIST_ON_BD',

    ClaveIncorrecta = -14,
    DescripcionClaveIncorrecta = 'DESCRIPTION_ENUM_ERROR_TYPES.PASSWORD_TYPED_IS_INVALID',

    UsuarioNoRegistrado = -13,
    DescripcionUsuarioNoRegistrado = 'DESCRIPTION_ENUM_ERROR_TYPES.USER_NOT_FOUND_ON_BD',

    MenusNoCargados = -12,
    DescripcionMenusNoCargados = 'DESCRIPTION_ENUM_ERROR_TYPES.CHARGE_MENUS_FAILED',

    RegistroNoEncontrado = -11,
    DescripcionRegistroNoEncontrado = 'DESCRIPTION_ENUM_ERROR_TYPES.NOT_FOUND_RECORD_ON_BD',

    FalloConfigurarCultura = -10,
    DescripcionFalloConfigurarCultura = 'DESCRIPTION_ENUM_ERROR_TYPES.CANT_DO_SYSTEM_CULTURE_CONFIGURATION',

    FalloNoIdentificado = -9,
    DescripcionFalloNoIdentificado = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_NOT_IDENTIFIER',

    idInvalido = -8,
    DescripcionidInvalido = 'DESCRIPTION_ENUM_ERROR_TYPES.IDENTIFIER_RECORD_INVALID',

    AccionNoPermitida = -7,
    DescripcionAccionNoPermitida = 'DESCRIPTION_ENUM_ERROR_TYPES.OPERATION_DIDN_ALLOWED',

    FalloCargarDatos = -6,
    DescripcionFalloCargarDatos = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_CHARGE_CURRENT_DATA',

    FalloConexionBd = -5,
    DescripcionFalloConexionBd = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_TO_CONNECT_WITH_BD',

    DatosIncompletos = -4,
    DescripcionDatosIncompletos = 'DESCRIPTION_ENUM_ERROR_TYPES.DATA_TYPED_ARENT_ENOUGH_TO_CONTINUE',

    FalloEliminar = -3,
    DescripcionFalloEliminar = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_DELETE_CURRENT_RECORD',

    FalloGuardar = -2,
    DescripcionFalloGuardar = 'DESCRIPTION_ENUM_ERROR_TYPES.ALERT_ERROR_TRYING_ADD_CURRENT_RECORD',

    FalloOperacion = -1,
    DescripcionFalloOperacion = 'DESCRIPTION_ENUM_ERROR_TYPES.FAIL_TRYING_CURRENT_OPERATION',

    Ninguno = 0,
    DescripcionNinguno = 'DESCRIPTION_ENUM_ERROR_TYPES.NONE'
}

export enum OrigenProcesoVerificacion {
    ControlDeAsistencia = 1,
    DescripcionControlDeAsistencia = 'MN_ASSIST_CONTROL',

    VerificacionEntregaDocumento = 2,
    DescripcionVerificacionEntregaDocumento = 'VERIFY_DOCUMENT_DELIVERY',

    VerificacionSolicitudes = 3,
    DescripcionVerificacionSolicitudes = 'REQUESTS'
}

export enum TiposConexionesInterfaces {
    Vtex = 1,
    DescripcionVtex = 'LBL_VTEX',

    Prestashop = 2,
    DescripcionPrestashop = 'VERSION_PRESTASHOP_801',

    Woocommerce = 3,
    DescripcionWoocommerce = 'WOOCOMMERCE_TRADS.NAME',

    PortalClientes = 4,
    DescripcionPortalClientes = 'LBL_CUSTOMER_PORTAL',

    Yeminus = 5,
    DescripcionYeminus = 'MN_GEMINUS',

    OpenPay = 6,
    DescripcionOpenPay = 'LBL_OPENPAY',

    Siras = 7,
    DescripcionSiras = 'SIRAS',

    Wompi = 8,
    DescripcionWompi = 'LBL_WOMPI',

    PayU = 9,
    DescripcionPayU = 'LBL_PAYU',

    RipsSispro = 10,
    DescripcionRipsSispro = 'RIPS_SISPRO'
}

export enum EntidadesLogs {
    Terceros_el = 0,
    DescripcionTerceros_el = 'EXTERNAL_CUSTOMERS',

    Login_el = 1,
    DescripcionLogin_el = 'EL_LOGIN',

    Productos_el = 4,
    DescripcionProductos_el = 'PRODUCTS',

    ControlAsistencia_el = 8,
    DescripcionControlAsistencia_el = 'MN_ASSIST_CONTROL',

    Nomina_el = 9,
    DescripcionNomina_el = 'MN_NOMINE',

    PlanDeCuentas_el = 10,
    DescripcionPlanDeCuentas_el = 'ACCOUNTS_PLAN',

    DocumentosLiquidados_el = 11,
    DescripcionDocumentosLiquidados_el = 'EL_SETTLED_DOCUMENTS',

    TiquetesBascula_el = 12,
    DescripcionTiquetesBascula_el = 'EL_SCALE_TICKETS',

    CentrosCosto_el = 13,
    DescripcionCentrosCosto_el = 'LC_CENTER_COSTS',

    Bodegas_el = 14,
    DescripcionBodegas_el = 'El_WAREHOUSES',

    Seguridad_el = 15,
    DescripcionSeguridad_el = 'LBL_SECURITY',

    ProductosControlados_el = 16,
    DescripcionProductosControlados_el = 'PRODUCTS_CONTROLLED',

    AdmClasificaciones_el = 17,
    DescripcionAdmClasificaciones_el = 'MANAGE_RANKINGS',

    Documentos_el = 18,
    DescripcionDocumentos_el = 'DOCUMENTS',

    OrdenesProduccion_el = 19,
    DescripcionOrdenesProduccion_el = 'MN_PRODUCTION_ORDERS',

    DocumentosContables_el = 20,
    DescripcionDocumentosContables_el = 'ACCOUNTING_DOCUMENT',

    niif_el = 21,
    Descripcionniif_el = 'LBL_STANDARD_NIIF',

    LimpiarDatos_el = 22,
    DescripcionLimpiarDatos_el = 'EL_CLEAR_DATA',

    Cita_el = 23,
    DescripcionCita_el = 'APPOINTMENTS'

}

export enum AccionesLogs {
    Eliminar_al = 0,
    DescripcionEliminar_al = 'BUTTON_DELETE',

    FalloAutenticacion_al = 1,
    DescripcionFalloAutenticacion_al = 'ACTIONS_LOG.FAIL_AUTHENTICATION',

    Anular_al = 2,
    DescripcionAnular_al = 'CANCEL',

    IngresoSistema_al = 3,
    DescripcionIngresoSistema_al = 'ACTIONS_LOG.INCOME_TO_THE_SYSTEM',

    Inactivar_al = 4,
    DescripcionInactivar_al = 'BUTTON_INACTIVATE',

    RetirarEmpleado_al = 5,
    DescripcionRetirarEmpleado_al = 'ACTIONS_LOG.REMOVE_EMPLOYEE',

    ModificarMarcacion_al = 6,
    DescripcionModificarMarcacion_al = 'ACTIONS_LOG.CHANGE_DIALING',

    ModificarLiquidacion_al = 7,
    DescripcionModificarLiquidacion_al = 'ACTIONS_LOG.CHANGE_LIQUIDATION',

    GenerarLiquidaciones_al = 8,
    DescripcionGenerarLiquidaciones_al = 'GENERATE_LIQUIDATION',

    ModificarParametrosLiquidacion_al = 9,
    DescripcionModificarParametrosLiquidacion_al = 'ACTIONS_LOG.MODIFY_SETTLEMENT_PARAMETERS',

    Recodificar_al = 10,
    DescripcionRecodificar_al = 'RECODE',

    AdicionarItemDocumento = 11,
    DescripcionAdicionarItemDocumento = 'ACTIONS_LOG.ADD_DOCUMENT_ITEM',

    EliminarItemDocumento = 12,
    DescripcionEliminarItemDocumento = 'ACTIONS_LOG.DELETE_DOCUMENT_ITEM',

    liquidar = 13,
    DescripcionLiquidar = 'LBL_SETTLEMENT',

    ReLiquidar = 14,
    DescripcionReLiquidar = 'ACTIONS_LOG.RE_LIQUIDATE',

    DescmarcarLiquidado = 15,
    DescripcionDescmarcarLiquidado = 'ACTIONS_LOG.UNCHECK_SETTLED',

    Imprimir = 16,
    DescripcionImprimir = 'ACTIONS_LOG.PRINT',

    Edicion_Perfiles = 17,
    DescripcionEdicion_Perfiles = 'ACTIONS_LOG.EDITING_PROFILES',

    Edicion_Usuarios = 18,
    DescripcionEdicion_Usuarios = 'ACTIONS_LOG.USER_EDITING',

    Edicion_Restricciones = 19,
    DescripcionEdicion_Restricciones = 'ACTIONS_LOG.EDITING_RESTRICTIONS',

    EdicionCabeceraCertControlados_al = 20,
    DescripcionEdicionCabeceraCertControlados_al = 'ACTIONS_LOG.HEADERS_EDITION_CONTROLLED_CERTIFICATES',

    EdicionDetalleCertControlados_al = 21,
    DescripcionEdicionDetalleCertControlados_al = 'ACTIONS_LOG.DETAILED_EDITION_OF_CONTROLLED_CERTIFICATES',

    EdicionClaseControlados_al = 22,
    DescripcionEdicionClaseControlados_al = 'ACTIONS_LOG.CONTROLLED_CLASS_EDITION',

    BloqueoClasificaciones_al = 23,
    DescripcionBloqueoClasificaciones_al = 'ACTIONS_LOG.BLOCKING_CLASSIFICATIONS',

    EliminarLiquidacionNomina_al = 24,
    DescripcionEliminarLiquidacionNomina_al = 'ACTIONS_LOG.DELETE_PAYROLL',

    Cancelar_al = 25,
    DescripcionCancelar_al = 'ACTIONS_LOG.CANCELLATION',

    EliminarDocContable_al = 26,
    DescripcionEliminarDocContable_al = 'ACTIONS_LOG.ELIMINATION_ACCOUNTING_DOCUMENTS',

    ModificaDocContable_al = 27,
    DescripcionModificaDocContable_al = 'ACTIONS_LOG.MODIFICATION_ACCOUNTING_DOCUMENTS',

    EliminaItemDocContable_al = 28,
    DescripcionEliminaItemDocContable_al = 'ACTIONS_LOG.ACCOUNTING_DOCUMENT_ITEM_DELETION',

    ModificaItemDocContable_al = 29,
    DescripcionModificaItemDocContable_al = 'ACTIONS_LOG.ACCOUNTING_DOCUMENT_ITEM_MODIFICATION',

    AnularDocContable_al = 30,
    DescripcionAnularDocContable_al = 'ACTIONS_LOG.CANCEL_ACCOUNTING_DOCUMENT',

    ModificarDocInventario_al = 31,
    DescripcionModificarDocInventario_al = 'ACTIONS_LOG.MODIFICATION_INVENTORY_DOCUMENT',

    ModificarNovedadNomina_al = 32,
    DescripcionModificarNovedadNomina_al = "ADD_NEWS_COMPONENT.CHANGE_PAYROLL_UPDATE",

    EliminarNovedadNomina_al = 33,
    DescripcionEliminarNovedadNomina_al = 'ACTIONS_LOG.DELETE_PAYROLL_UPDATE',

    ModificarItemDocumento_al = 9997,
    DescripcionModificarItemDocumento_al = 'ACTIONS_LOG.DOCUMENT_ITEM_MODIFICATION',

    OtrasAcciones = 9998,
    DescripcionOtrasAcciones = 'ACTIONS_LOG.OTHER_ACTIONS',

    BorradoDeAuditorias_al = 9999,
    DescripcionBorradoDeAuditorias_al = 'ACTIONS_LOG.DELETION_OF_AUDITS',

    CancelarCantidadPendiente_al = 10000,
    DescripcionCancelarCantidadPendiente_al = 'CANCEL_PENDING_AMOUNTS',

    contabilidad_al = 34,
    Descripcioncontabilidad_al = 'ACCOUNTING',

    Inventario_al = 35,
    DescripcioInventario_al = 'INVENTORY',

    ActivosFijos_al = 36,
    DescripcionActivosFijos_al = 'MN_FIXED_ASSETS',

    Limpiar_al = 37,
    DescripcionLimpiar_al = 'BUTTON_CLEAN',

    CambioDeTarifaIVA_al = 41,
    DescripcionCambioDeTarifaIVA_al = 'ACTIONS_LOG.CHANGE_RATES_IVA',

    CambioDeCongifuracionDeimpresion = 42,
    DescripcionCambioDeCongifuracionDeimpresion = 'ACTIONS_LOG.CHANGING_PRINT_SETTINGS',

    CerrarLiquidacionSinRecostear = 43,
    DescripcionCerrarLiquidacionSinRecostear = 'ACTIONS_LOG.CLOSE_SETTLEMENT_WITHOUT_REPOSITIONING',

    EliminacionMasivaCuotasPrestamos = 91,
    DescripcionEliminacionMasivaCuotasPrestamos = 'ACTIONS_LOG.MASSIVE_ELIMINATION_OF_LOAN_INSTALLMENTS',

    EliminarLiquidacionContrato_al = 92,
    DescripcionEliminarLiquidacionContrato_al = 'ACTIONS_LOG.ELIMINATE_CONTRACT_SETTLEMENT',

    ModificarProducto_al = 93,
    DescripcionModificarProducto_al = 'ACTIONS_LOG.MODIFY_PRODUCT'
}

export enum EstadoRadicacion {
    Todas = 0,
    DescripcionTodas = 'LBL_ALL',

    SinRadicar = 1,
    DescripcionSinRadicar = 'LBL_WITHOUT_FILING',

    Radicados = 2,
    DescripcionRadicados = 'LBL_SETTLED'
}
export enum OpcionesFE {
    NoAplica = 0,
    DescripcionNoAplica = 'LBL_DOES_NOT_APPLY',

    SinCufe = 1,
    DescripcionSinCufe = 'LBL_DOCUMENT_WITHOUT_CUFE',

    SinCufeConError = 2,
    DescripcionSinCufeConError = 'LBL_DOCUMENTS_WITHOUT_CUFE_WITH_ERROR',

    ConErrores = 3,
    DescripcionConErrores = 'LBL_DOCUMENTS_WITH_ERRORS',

    ConCufeSinGrafica = 4,
    DescripcionConCufeSinGrafica = 'LBL_DOCUMENTS_WITH_CUFE_AND_WITHOUT_REPRESENTATION_GRAPHIC',

    ConCufeSinEnviarCorreo = 5,
    DescripcionConCufeSinEnviarCorreo = 'LBL_DOCUMENTS_WITH_CUFE_AND_WITHOUT_SEND_EMAIL',

    CorreosNoVistosCliente = 6,
    DescripcionCorreosNoVistosCliente = 'LBL_MAIL_NOT_SEEN_BY_CUSTOMER',

    AprobadoCliente = 7,
    DescripcionAprobadoCliente = 'LBL_DOCUMENTS_APPROVED_BY_CUSTOMERS',

    RechazadoCliente = 8,
    DescripcionRechazadoCliente = 'LBL_DOCUMENTS_REJECTED_BY_CUSTOMERS',

}

export enum PresentacionesBalanceGeneral {
    Cuenta = 0,
    DescripcionCuenta = 'COUNT',
    CuentaTercero = 1,
    DescripcionCuentaTercero = 'BALANCE_SHEET.ACCOUNT_AND_THIRD_PERSON',
    TerceroCuenta = 2,
    DescripcionTerceroCuenta = 'BALANCE_SHEET.THIRD_PERSON_AND_ACCOUNT',
    CuentaCentroDeCosto = 3,
    DescripcionCuentaCentroDeCosto = 'BALANCE_SHEET.ACCOUNT_AND_COST_CENTER',
    CentroDeCostoCuenta = 4,
    DescripcionCentroDeCostoCuenta = 'BALANCE_SHEET.COST_CENTER_AND_ACCOUNT',
    CuentaTerceroCentroDeCosto = 5,
    DescripcionCuentaTerceroCentroDeCosto = 'BALANCE_SHEET.THIRD_PERSON_AND_COST_CENTER',
    CuentaCentroDeCostoTercero = 6,
    DescripcionCuentaCentroDeCostoTercero = 'BALANCE_SHEET.COST_CENTER_AND_THIRD_PERSON',
    PorMes = 7,
    DescripcionPorMes = 'METRIC_SALES.PER_MONTH',
    PorTrimestre = 8,
    DescripcionPorTrimestre = 'BALANCE_SHEET.PER_TRIMESTER',
    CuentaNit = 9,
    DescripcionCuentaNit = 'BALANCE_SHEET.LBL_ACCOUNT_AND_NIT',
    NitCuenta = 10,
    DescripcionNitCuenta = 'BALANCE_SHEET.LBL_NIT_AND_ACCOUNT',
    CuentaTercerosSinSaldo = 11,
    DescripcionCuentaTercerosSinSaldo = 'BALANCE_SHEET.THIRD_PARTY_ACCOUNT_WITH_NO_BALANCE',
    TerceroCuentaSinSaldo = 12,
    DescripcionTerceroCuentaSinSaldo = 'BALANCE_SHEET.THIRD_ACCOUNT_WITH_NO_BALANCE'
}

export enum NivelesPorCuentas {
    PrimerNivel = 1,
    DescripcionPrimerNivel = 'LBL_FIRST_LEVEL',
    SegundoNivel = 2,
    DescripcionSegundoNivel = 'LBL_SECOND_LEVEL',
    TercerNivel = 3,
    DescripcionTercerNivel = 'LBL_THIRD_LEVEL',
    CuartoNivel = 4,
    DescripcionCuartoNivel = "BALANCE_SHEET.FOURTH_LEVEL",
    TodosLosNiveles = 5,
    DescripcionTodosLosNiveles = 'LABEL_ALL_PLURAL',
    CuentasDeDetalle = 6,
    DescripcionCuentasDeDetalle = 'LBL_DETAIL_ACCOUNTS'

}

export enum OpcionesUbicacionMenu {
    Submenu = 1,
    DescripcionSubmenu = 'SUBMENU',

    MenuPrincipal = 2,
    DescripcionMenuPrincipal = 'LBL_MENU'
}

export enum AperturaDescargarDocAdjuntos {
    ConsultaDocumentos = 0,
    GestionDocumentosRadicados = 1
}

export enum TiposDeVisualizacionDeEstadosFinancieros {
    BalanceDePrueba = 1,
    DescripcionBalanceDePrueba = 'FINANCIAL_STATEMENTS.TRIAL_BALANCE',
    BalanceGeneral = 2,
    DescripcionBalanceGeneral = 'FINANCIAL_STATEMENTS.STATEMENT_OF_FINANCIAL_POSITION',
    EstadoDeResultados = 3,
    DescripcionEstadoDeResultados = 'FINANCIAL_STATEMENTS.INCOME_STATEMENT'
}

export enum OpcionesRealizacionTrasladoCuentas {
    CuentasPorCobrar = 1,
    CuentasPorPagar = 2,
    CambioFechasVencimiento = 3
}

export enum TipoAperturaHistorialDeHistoriasClinicas {
    FechaEgreso,
    Diagnostico,
    ValorFactura,
    Documento
}

export enum OpcionesDevolucionCxPCxC {
    AbononarOtrasFacturas = 1,
    AnticipoParcial = 2,
    AnticipoTotal = 3
}

export enum TiposDeRetencion {

    RetencionEnLaFuente = 1,
    DescripcionRetencionEnLaFuente = "WITHHOLDING_CERTIFICATES.WITHHOLDING_TAX_CERTIFICATE",

    RetencionDeIVA = 2,
    DescripcionRetencionDeIVA = "WITHHOLDING_CERTIFICATES.WITHHOLDING_CERTIFICATE_OF_IVA",

    RetencionDeICA = 3,
    DescripcionRetencionDeICA = "WITHHOLDING_CERTIFICATES.WITHHOLDING_CERTIFICATE_OF_ICA",

    RetencionDeCREE = 4,
    DescripcionRetencionDeCREE = "WITHHOLDING_CERTIFICATES.WITHHOLDING_CERTIFICATE_OF_CREE",

    RetencionDeTituloDeTimbre = 5,
    DescripcionRetencionDeTituloDeTimbre = "WITHHOLDING_CERTIFICATES.STAMP_WITHHOLDING_CERTIFICATE_OF_TITLE"
}

export enum TipoAperturaGestionAgenda {
    AperturaSalud,
    AperturaActividades
}

export enum TipoTarjetaPagoDocumento {
    Ninguna,
    DescripcionNinguna = "LBL_NEITHER",

    RecargaTarjeta = 1,
    DescripcionRecargaTarjeta = "LBL_PURCHASE_RELOAD_GIFT_CARD",

    AbonoSeparadoProductos = 2,
    DescripcionAbonoSeparadoProductos = "LBL_SEPARATE_FERTILIZER_PRODUCTS",

    RecargaTarjetaSeparadoProductos = 3,
    DescripcionRecargaTarjetaSeparadoProductos = "LBL_RELOAD_SEPARATE_GIFT_CARD_PRODUCTS",

    DocumentoSeparadoProductos = 4,
    DescripcionDocumentoSeparadoProductos = "LBL_PRODUCT_SEGREGATION_DOCUMENT",

    RetiroProductosTarjeta = 5,
    DescripcionRetiroProductosTarjeta = "LBL_WITHDRAWAL_PRODUCTS_GIFT_CARD",

    RetiroSeparadoProductos = 6,
    DescripcionRetiroSeparadoProductos = "LBL_SEPARATE_PRODUCT_RECALL",

    RetiroTarjetaSeparadoProductos = 7,
    DescripcionRetiroTarjetaSeparadoProductos = "LBL_SEPARATE_CARD_WITHDRAWAL_PRODUCTS",

    AplicarBonoDescuento = 8,
    DescripcionAplicarBonoDescuento = "LBL_DISCOUNT_VOUCHER_APPLICATION"
}

export enum TipoProvisionamientoNomina {
    Basica = 0,
    DescripcionBasica = "PAYROLL_PROVISIONS.BASIC_PROVISIONS",
    CompensacionFlexible = 1,
    DescripcionCompensacionFlexible = "PAYROLL_PROVISIONS.BASIC_PROVISIONS_AND_FLEXIBLE_COMPENSATION"
}

export enum MenuEstructurasTrabajo {
    MenuProyectos = 0,
    DescripcionMenuProyectos = "MN_WORK_MANAGEMENT",
    MenuProduccion = 1,
    DescripcionMenuProduccion = "MN_PRODUCTION",
    MenuFuncionesDeCargos = 2, // equivale a recurso humano
    DescripcionMenuFuncionesDeCargos = "MN_HUMAN_RESOURCE",
    MenuMantenimientoEquipos = 3,
    DescripcionMenuMantenimientoEquipos = "LBL_EQUIPMENT_MAINTENANCE",
    MenuMatrizDeRiesgos = 4,
    DescripcionMenuMatrizDeRiesgos = "RISK_MANAGEMENT"
}

export enum TiposFrecuencia {
    Diario = 1,
    DescriptionDiario = "DAILY",
    Semanal = 2,
    DescriptionSemanal = "LBL_WEEKLY",
    Quincenal = 3,
    DescriptionQuincenal = "LBL_EVERY_TWO_WEEKS",
    Mensual = 4,
    DescriptionMensual = "LBL_MONTHLY",
    Bimestral = 5,
    DescriptionBimestral = "BIMESTRAL",
    Trimestral = 6,
    DescriptionTrimestral = "TRIMESTRAL",
    Cuatrimestral = 7,
    DescriptionCuatrimestral = "QUARTERLY",
    Semestral = 8,
    DescriptionSemestral = "SEMIANNUAL",
    Anual = 9,
    DescriptionAnual = "ANNUAL"
}

export enum TipoConceptoNomina {
    ConceptoNomina = 1,
    DescripcionConceptoNomina = "LABEL_NO",
    ConceptoDeControl = 2,
    DescripcionConceptoDeControl = "LABEL_YES",
    ConceptoEnviableANe = 3,
    DescripcionConceptoEnviableANe = "ITEMS_THAT_ARE_SENT_TO_ELECTRONIC_PAYROLL",
    ConceptoNoEnviableANe = 4,
    DescripcionConceptoNoEnviableANe = "ITEMS_THAT_ARE_NOT_SENT_TO_ELECTRONIC_PAYROLL"
}

export enum TiposTareas {
    TareasEmpleado = 0,
    DescripcionTareasEmpleado = 'LBL_EMPLOYEE_TASK',

    TareasEquipos = 1,
    DescripcionTareasEquipos = 'LBL_EQUIPMENT_TASK',

    TareasProyectos = 2,
    DescripcionTareasProyectos = 'LBL_EQUIPMENT_TASK'
}

export enum RestriccionesSolicitarCufe {
    SinRestriccion = 0,
    DescripcionSinRestriccion = "WITHOUT_RESTRICTION",
    SoloContabilizados = 1,
    DescripcionSoloContabilizados = "ONLY_POSTED_DOCUMENTS_OR_PAYMENTS"
}

export enum PresentacionPrimaSemestral {
    PrimaServicios = 0,
    DescripcionPrimaServicios = "LIQUIDATE_PAYROLL_PROVISIONS.PREMIUM_SERVICES",
    PrimaCompensacionFlexible = 1,
    DescripcionPrimaCompensacionFlexible = "LIQUIDATE_PAYROLL_PROVISIONS.PREMIUM_FLEXIBLE_COMPENSATION"
}

export enum ExistenciasMostrar {
    Actual = 0,
    DescripcionActual = 'ENUM_STOCK_TO_SHOW.SHOW_EXISTING_STOCK_FROM_WAREHOUSE',

    Disponibilidad = 1,
    DescripcionDisponibilidad = 'ENUM_STOCK_TO_SHOW.SHOW_AVAILABLE_STOCK_OF_PRODUCT',

    DisponibilidadInmediata = 2,
    DescripcionDisponibilidadInmediata = 'ENUM_STOCK_TO_SHOW.SHOW_AVAILABLE_STOCK_IMMEDIATE',

    ExistenciaDisponibilidad = 3,
    DescripcionExistenciaDisponibilidad = 'ENUM_STOCK_TO_SHOW.SHOW_EXISTING_STOCK_AVAILABLE_STOCK',

    ExistenciaDisponibilidadInmediata = 4,
    DescripcionExistenciaDisponibilidadInmediata = 'ENUM_STOCK_TO_SHOW.SHOW_EXISTING_STOCK_AVAILABLE_STOCK_IMMEDIATE',

    DisponibilidadDisponibilidadInmediata = 5,
    DescripcionDisponibilidadDisponibilidadInmediata = 'ENUM_STOCK_TO_SHOW.SHOW_AVAILABLE_STOCK_AND_AVAILABLE_STOCK_IMMEDIATE',

    Todos = 6,
    DescripcionTodos = 'LABEL_ALL_PLURAL',

    NoMostrar = 10,
    DescripcionNoMostrar = 'ENUM_STOCK_TO_SHOW.DONT_SHOW'
}

export enum AperturaMatrizRiesgo {
    Clientes = 0,
    Proyectos = 1,
    Tareas = 2
}

export enum FormatoResultado {
    Moneda = 0,
    DescripcionMoneda = "RESULT_FORMAT.CURRENCY",
    porcentaje = 1,
    DescripcionPorcentaje = "RESULT_FORMAT.PERCENT",
    SinFormato = 2,
    DescripcionSinFormato = "RESULT_FORMAT.WITHOUT_FORMAT"
}

export enum AperturaEscalasEvaluacion {
    EvaluacionCompetencias = 0,
    Inventarios = 1,
    Produccion = 2,
    Proyectos = 3
}

export enum AperturaPuntuaciones {
    EvaluacionCompetencias = 0,
    Proyectos = 1
}

export enum TipoDato {
    String,
    Number,
    Date
}

export enum MetodosLiquidacionVacaciones {

    DescripcionLiquidacion1 = 'VACATIONS_HISTORIC.PAY_WHEN_YOU_GO_ON_HOLIDAY',
    Liquidacion1 = 1,

    DescripcionLiquidacion2 = 'VACATIONS_HISTORIC.SPTIL_YOU_RETURN_FROM_VACATION.IT_IS_USEFUL_WHEN_THE_PERSON_ENTERS_AND_LEAVES_VACATIONS_IN_THE_SAME_PAYROLL_PERIOD',
    Liquidacion2 = 2,

    DescripcionLiquidacion3 = 'VACATIONS_HISTORIC.PAY_UNSALARY_ON_THE_END_DATE_OF_THE_PERIOD_PUBLIC_SECTOR',
    Liquidacion3 = 3,

    DescripcionLiquidacion4 = 'VACATIONS_HISTORIC.PAY_LIT_VACATION_PAY_IN_THE_SETTLEMENT_PERIODS',
    Liquidacion4 = 4,

}

export enum TipoDeFechasEnflujoDeCaja {
    FechaVencimientoFactura = 0,
    DescripcionFechaVencimientoFactura = 'LBL_EXPIRATION_DATE',
    FechaCreacionFactura = 1,
    DescripcionFechaCreacionFactura = 'PI_CREATION_DATE',
    FechaProgramacionPago = 2,
    DescripcionFechaProgramacionPago = 'PROGRAMMING_PAY_DATES'
}

export enum ClasesTarea {
    TareasMaestras = 0,
    DescripcionTareasMaestras = "TASK_MASTER_TASKS",
    TareasLibres = 1,
    DescripcionTareasLibres = "TASK_FREE",
    Ambas = 2,
    DescripcionAmbas = "LBL_BOTH"
}

export enum PresentacionesFlujosDeCaja {
    Semanal = 0,
    DescripcionSemanal = "LBL_WEEKLY",
    SemanalPorConcepto = 1,
    DescripcionSemanalPorConcepto = "CASH_FLOW.WEEKLT_BY_CONCEPT",
    Mensual = 2,
    DescripcionMensual = "LBL_MONTHLY",
    MensualPorConcepto = 3,
    DescripcionMensualPorConcepto = "CASH_FLOW.MONTHLY_BY_CONCEPT"
}

export enum ProductosSinConteoFisico {
    ConExistencia = 0,
    DescripcionConExistencia = "PRODUCTS_IN_WAREHOUSE",
    ConAlmacenPorDefecto = 1,
    DescripcionConAlmacenPorDefecto = "PRODUCTS_ASSIGNED_DEFAULT_WAREHOUSE"
}

export enum MetodoFacturacion {
    FacturacionBasicaPorDocumentos = 0,
    DescripcionFacturacionBasicaPorDocumentos = 'BASIC_DOCUMENT_BASED_BILLING',
    FacturacionPorCargosOConsumos = 1,
    DescripcionFacturacionPorCargosOConsumos = 'BILLING_FOR_CHARGES_OR_CONSUMPTION'
}

export enum EventosNotificacionRecepcionFE {
    // se dejan con el valor segun la enumeracion de la DIAN
    AcuseDeRecibido = 30,
    DescripcionAcuseDeRecibido = "DIAN_RECEPTION_EVENT.ACKNOWLEDGEMENT",
    Reclamo = 31,
    DescripcionReclamo = "DIAN_RECEPTION_EVENT.CLAIM",
    ReciboDeBienesOServicios = 32,
    DescripcionReciboDeBienesOServicios = "DIAN_RECEPTION_EVENT.SERVICE_RECEIPT",
    AceptacionExpresa = 33,
    DescripcionAceptacionExpresa = "DIAN_RECEPTION_EVENT.EXPRESS_ACCEPTANCE",
    AceptacionTacita = 34,
    DescripcionAceptacionTacita = "DIAN_RECEPTION_EVENT.TACIT_ACCEPTANCE",

    // valores propios de yeminus para envio de eventos al tiempo
    AcuseReciboYAceptacionExpresa = 1,
    DescripcionAcuseReciboYAceptacionExpresa = "DIAN_RECEPTION_EVENT.ACKNOWLEDGEMENT_RECEIPT_ACCEPTANCE",
    AcuseYReciboDeBienes = 2,
    DescripcionAcuseYReciboDeBienes = "DIAN_RECEPTION_EVENT.ACKNOWLEDGEMENT_RECEIPT",
    ReciboYAceptacionExpresa = 3,
    DescripcionReciboYAceptacionExpresa = "DIAN_RECEPTION_EVENT.RECEIPT_ACCEPTANCE",

    // valor para identificar evento de aceptacion tacita no disponible por el web (ya generado)
    AceptacionTacitaYaGenerada = 4,

    AcuseReciboYReclamo = 5,
    DescripcionAcuseReciboYReclamo = "DIAN_RECEPTION_EVENT.ACKNOWLEDGEMENT_AND_COMPLAINT"
}

export enum AperturaCapturaRapidaDocumentos {
    OrdenDeMantenimiento = 0,
    RecepcionXMLCompras = 1
}

export enum OrigenRechazoCambioEstado {
    TerceroSinCupo,
    ProductosSinDisponibilidad
}

export enum TiposAlertaSistema {
    CambioEstado = 0,
    DescripcionCambioEstado = "TO_STATUS_CHANGE",

    EliminarDocumento = 1,
    DescripcionEliminarDocumento = "LBL_DELETE_DOCUMENT",

    EnviarDocumento = 2,
    DescripcionEnviarDocumento = "LBL_SEND_DOCUMENT",

    AutorizarUtilidadMinima = 3,
    DescripcionAutorizarUtilidadMinima = "LBL_AUTHORIZE_MINIMUM_UTILITY",

    AutorizarDescuentoMaximo = 4,
    DescripcionAutorizarDescuentoMaximo = "LBL_AUTHORIZE_MAXIMUM_DISCOUNT",

    SincronizarDocumento = 5,
    DescripcionSincronizarDocumento = "LBL_SYNCHRONIZE_DOCUMENT",

    VencimientoContratoEmpleado = 6,
    DescripcionVencimientoContratoEmpleado = "LBL_EXPIRATION_OF_EMPLOYEE_CONTRACT",

    AccionesSobreNuevoDocumento = 7,
    DescripcionAccionesSobreNuevoDocumento = "LBL_ACTIONS_ON_NEW_DOCUMENT",

    VencimientoVacacionesEmpleados = 8,
    DescripcionVencimientoVacacionesEmpleados = "LBL_EMPLOYEE_VACATION_EXPIRATION",

    CambioManualEstadoDocumento = 9,
    DescripcionCambioManualEstadoDocumento = "AUTOMATIC_STATUS_CHANGE_DOCUMENTS",

    VencimientoResolucionFacturacion = 10,
    DescripcionVencimientoResolucionFacturacion = "LBL_EXPIRATION_BILLING_RESOLUTION",

    VencimientoProductoPorSaldo = 11,
    DescripcionVencimientoProductoPorSaldo = "LBL_EXPIRATION_OF_PRODUCT_PER_BALANCE",

    BloqueoClasificacion = 12,
    DescripcionBloqueoClasificacion = "LBL_CLASSIFICATION_BLOCK",

    StockMinimoProducto = 13,
    DescripcionStockMinimoProducto = "LBL_MINIMUM_PRODUCT_STOCK",

    EventosProgramadosSinActividad = 14,
    DescripcionEventosProgramadosSinActividad = "LBL_PROGRAMMED_EVENTS_WITHOUT_ACTIVITY",

    DispensacionProductosPorDocumento = 15,
    DescripcionDispensacionProductosPorDocumento = "LBL_DISPENSING_OF_PRODUCTS_BY_DOCUMENT",

    CupoMaximoDeUnCliente = 16,
    DescripcionCupoMaximoDeUnCliente = "LBL_MAXIMUM_CLIENT_CREDIT",

    GlosasVencidas = 17,
    DescripcionGlosasVencidas = "LBL_OVERDUE_ACCOUNTS",

    VencimientoDePedidosProduccion = 18,
    DescripcionVencimientoDePedidosProduccion = "LBL_EXPIRATION_OF_PRODUCTION_ORDERS",

    VencimientoAccionesNoConformidad = 19,
    DescripcionVencimientoAccionesNoConformidad = "LBL_EXPIRATION_NON_CONFORMITY",

    PrecioMinimoProducto = 20,
    DescripcionPrecioMinimoProducto = "LBL_MINIMUM_PRODUCT_PRICE",

    DiasAtrasoCarteraWeb = 21,
    DescripcionDiasAtrasoCarteraWeb = "DAYS_OF_PORTFOLIO_DELAY",

    ActualizacionDatosEmpleadoWeb = 22,
    DescripcionActualizacionDatosEmpleadoWeb = "UPDATE_EMPLOYEE_DATA",

    VencimientoCursosHojasVida = 24,
    DescripcionVencimientoCursosHojasVida = "EXPIRATION_OF_RESUME_COURSES",

    CumpleañosEmpleados = 25,
    DescripcionCumpleañosEmpleados = "BIRTHDAY_EMPLOYEES",

    CambioEstadoAutomaticoOportunidades = 26,
    DescripcionCambioEstadoAutomaticoOportunidades = "AUTOMATIC_STATUS_CHANGE_OPORTUNITIES",

    CambioEstadoAutomaticoProyectos = 27,
    DescripcionCambioEstadoAutomaticoProyectos = "AUTOMATIC_STATUS_CHANGE_PROJECTS",

    CambioEstadoAutomaticoTareas = 28,
    DescripcionCambioEstadoAutomaticoTareas = "AUTOMATIC_STATUS_CHANGE_TASK",

    CambioEstadoAutomaticoSolicitudes = 29,
    DescripcionCambioEstadoAutomaticoSolicitudes = "AUTOMATIC_STATUS_CHANGE_REQUESTS",

    CambioEstadoAutomaticoAgenda = 30,
    DescripcionCambioEstadoAutomaticoAgenda = "AUTOMATIC_STATUS_CHANGE_SCHEDULER",

    CambioEstadoAutomaticoCampanas = 31,
    DescripcionCambioEstadoAutomaticoCampanas = "AUTOMATIC_STATUS_CHANGE_CAMPAIGNS",

    CambioEstadoAutomaticoActivosFijos = 32,
    DescripcionCambioEstadoAutomaticoActivosFijos = "AUTOMATIC_STATUS_CHANGE_FIXED_ASSETS",

    CambioEstadoAutomaticoTiposCarpetas = 33,
    DescripcionCambioEstadoAutomaticoTiposCarpetas = "AUTOMATIC_STATUS_CHANGE_FOLDER_TYPES",

    CambioEstadoAutomaticoContenidos = 34,
    DescripcionCambioEstadoAutomaticoContenidos = "AUTOMATIC_STATUS_CHANGE_CONTENTS",

    CambioEstadoAutomaticoVacantes = 35,
    DescripcionCambioEstadoAutomaticoVacantes = "AUTOMATIC_STATUS_CHANGE_VACANCIES",

    CambioEstadoAutomaticoHistoriaClinica = 36,
    DescripcionCambioEstadoAutomaticoHistoriaClinica = "AUTOMATIC_STATUS_CHANGE_CLINIC_HISTORY",

    CambioEstadoAutomaticoProductos = 37,
    DescripcionCambioEstadoAutomaticoProductos = "AUTOMATIC_STATUS_CHANGE_PRODUCTS",

    CambioEstadoAutomaticoGlosas = 38,
    DescripcionCambioEstadoAutomaticoGlosas = "AUTOMATIC_STATUS_CHANGE_GLOSSES",

    AlertasFechasVencimientoContenido = 39,
    DescripcionAlertasFechasVencimientoContenido = 'ALERTS_DATES_EXPIRATION_CONTENT',

    VencimientoTareas = 40,
    DescripcionVencimientoTareas = 'EXPIRATION_TASKS',

    NotificarConAnterioridadActividad = 41,
    DescripcionNotificarConAnterioridadActividad = 'NOTIFY_ACTIVITY_IN_ADVANCE',

    Ninguna = 99,
    DescripcionNinguna = "LBL_NEITHER"
}

export enum EstadoAprobacionAlerta {
    Enviada = 0,
    Aprobada = 1,
    Rechazada = 2
}
export enum InterfazEcommerce {
    Vtex = 0,
    Woocommerce = 1,
    Prestashop = 2
}

export enum SubCarpetaInterfaz {
    PedidosRecibidos = 0,
    DescripcionPedidosRecibidos = 'PRESTASHOP.LBL_FOLDER_ORDERS_RECEIVED',
    ActualizarInventario = 1,
    DescripcionActualizarInventario = 'MESSAGE_INTERFAZ_DOCUMENTO.LBL_UPDATE_INVENTORY'
}

export enum FormaGeneracionDocSoporte {
    PorOperacion = 1,
    DescripcionPorOperacion = 'LBL_PER_OPERATION',
    AcumuladoSemanal = 2,
    DescripcionAcumuladoSemanal = 'LBL_ACUM_WEEKLY'
}

export enum ModoAperturaMrpSolicitudCompra {
    SolicitudesCompra = 0,
    SolicitudesProduccion = 1
}
export enum TipoOperacionDian {
    FacturaVenta = '01',
    FacturaExportacion = '02',
    FacturaContingenciaFacturador = '03',
    FacturaContingenciaDian = '04',
    DocumentoSoporteElectronico = '05',
    NotaCredito = '91',
    NotaDebito = '92',
    NotaAjusteDocumentoSoporte = '95',
    NominaElectronica = '102',
    AjusteNominaElectronica = '103'
}

export enum TipoPeticionHttp {
    Get,
    Post
}

export enum AprobacionAlerta {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',
    Aprobado = 1,
    DescripcionAprobado = 'APPROVED',
    Rechazado = 2,
    DescripcionRechazado = 'REJECTED'

}

export enum SeccionPortalCliente {
    LandingPage = 0,
    Login = 1,
    Dashboard = 2
}

export enum MetodosDePago {
    PagoContraEntrega,
    PagoPayU
}

export enum CargarPaginacion {
    EjecucionContrato,
    DetalleForecast,
    HistorialPedidos
}

export enum TiposDeSitios {
    publicacionesClientes = 36,
    publicacionesProveedores = 37
}

export enum Paginacion {
    Siguiente,
    Anterior
}

export enum PasarelasPago {
    Pse = 0,
    PayU = 1,
    OpenPay = 2,
    Wompi = 3
}

export enum Cantidad {
    CantidadOrdenesCompra,
    CantidadPendiente
}

export enum OpcionesCantidad {
    Aumentar,
    Disminuir
}

export enum FormaDePagoDIAN {
    Contado = '1',
    Credito = '2',
}


export enum YeminusApis {
    ApiYeminus,
    ActivosFijos,
    Admin,
    CajasMenores,
    ComprasInventarios,
    ConsultasSql,
    CuentasPorCobrar,
    CuentasPorPagar,
    DocumentosElectronicos,
    Encuestas,
    EntregaMasivaDocumentos,
    FacturacionPeriodica,
    Financiero,
    GestionCapitalHumano,
    GestionContenidos,
    GestionTrabajo,
    Importaciones,
    informesComerciales,
    InformesFinancieros,
    Interfaces,
    Logistica,
    MantenimientoMaquinaria,
    PresupuestoPrivado,
    PresupuestoPublico,
    Produccion,
    Salud,
    Security,
    SolicitudesCompraMRP,
    TablasSistema,
    Ventas,
    WebComponents,
    Licenciamiento
}

export enum ServiciosApi {
    CrearAlertasActivosSinUso = 0,
    DescripcionCrearAlertasActivosSinUso = 'CREATE_UNUSED_ASSET_ALERTS',

    AlertasFechasVencimientoContenido = 1,
    DescripcionAlertasFechasVencimientoContenido = 'ALERTS_DATES_EXPIRATION_CONTENT',

    CambioEstadosAutomatico = 2,
    DescripcionCambioEstadosAutomatico = 'CHANGE_AUTOMATIC_STATES_ALERT',

    DespachadorCorreos = 3,
    DescripcionDespachadorCorreos = 'WEBMAIL_DISPATCHER',

    GenerarRepresentacionGraficaFE = 4,
    DescripcionGenerarRepresentacionGraficaFE = 'GENERATE_GRAPHIC_REPRESENTATION',

    FacturacionElectronica = 5,
    DescripcionFacturacionElectronica = 'ELECTRONIC_BILLING',

    ServicioTheFactory = 6,
    DescripcionServicioTheFactory = 'THE_FACTORY',

    ObtenerOrdenesPrestaShop = 7,
    DescripcionObtenerOrdenesPrestaShop = 'GET_PRESTASHOP_ORDERS',

    ObtenerOrdenesWooCommerce = 8,
    DescripcionObtenerOrdenesWooCommerce = 'GET_WOOCOMMERCE_ORDERS',

    ActualizarInventarioWoocommerce = 9,
    DescripcionActualizarInventarioWoocommerce = 'UPDATE_WOOCOMMERCE_INVENTORY',

    ActualizarInventarioPrestaShop = 10,
    DescripcionActualizarInventarioPrestaShop = 'UPDATE_PRESTASHOP_INVENTORY',

    ActualizarInventarioVtex = 11,
    DescripcionActualizarInventarioVtex = 'UPDATE_VTEX_INVENTORY',

    ObtenerOrdenesVtex = 12,
    DescripcionObtenerOrdenesVtex = 'GET_VTEX_ORDERS',

    ImportarTercerosDesdeArchivo = 13,
    DescripcionImportarTercerosDesdeArchivo = 'IMPORT_THIRD_PARTIES_FROM_FILE',

    ContabilizarDocumentos = 14,
    DescripcionContabilizarDocumentos = 'POST_DOCUMENTS',

    CrearDocumentoContableDesdeArchivo = 15,
    DescripcionCrearDocumentoContableDesdeArchivo = 'CREATE_ACCOUNTING_DOCUMENT_FROM_FILE',

    CrearDocumentosDesdeArchivoPlano = 16,
    DescripcionCrearDocumentosDesdeArchivoPlano = 'CREATE_DOCUMENTS_FROM_FLAT_FILE',

    EntregasProductos = 17,
    DescripcionEntregasProductos = 'DELIVERY_PRODUCTS',

    CrearReciboConsignaciones = 18,
    DescripcionCrearReciboConsignaciones = 'CREATE_CONSIGNMENT_RECEIPT',

    GenerarEntregaOrdenMantenimiento = 19,
    DescripcionGenerarEntregaOrdenMantenimiento = 'GENERATE_MAINTENANCE_ORDER_DELIVERY',

    DocumentosDesdeTablasBaseDeDatos = 20,
    DescripcionDocumentosDesdeTablasBaseDeDatos = 'DOCUMENTS_FROM_DATABASE_TABLES',

    DocumentoContableDesdeTablaBaseDeDatos = 21,
    DescripcionDocumentoContableDesdeTablaBaseDeDatos = 'ACCOUNTING_DOCUMENT_FROM_DATABASE_TABLE',

    AlertasFechasVencimientoTareas = 22,
    DescripcionAlertasFechasVencimientoTareas = 'ALERTS_DATES_EXPIRATION_TASKS',

    RecosteoDeInventariosYProduccion = 23,
    DescripcionRecosteoDeInventariosYProduccion = 'INVENTORY_AND_PRODUCTION_RECOSTS',

    NotificarConAnterioridadActividad = 24,
    DescripcionNotificarConAnterioridadActividad = 'NOTIFY_ACTIVITY_IN_ADVANCE',

    SincronizarDocumentosAlServidor = 25,
    DescripcionSincronizarDocumentosAlServidor = 'LBL_SYNCHRONIZE_DOCUMENTS'
}

export enum TipoTiempos {
    Activos = 0,
    DescripcionActivos = "ACTIVE_TIME",

    EnPausa = 1,
    DescripcionEnPausa = "TIME_IN_PAUSE",

    Todos = 2,
    DescripcionTodos = "LABEL_ALL_PLURAL"
}

export enum Rotacion {
    Producto = 1,
    DescripcionAprobado = 'Producto',
    Almacen = 2,
    DescripcionRechazado = 'Almacén',
    Marca = 3,
    DescripcionMarca = 'Marca',
    Fabricante = 4,
    DescripcionFabricante = 'Fabricante',
    Grupo = 5,
    DescripcionGrupo = 'Grupo',
    UnidadNegocio = 6,
    DescripcionUnidadNegocio = 'Unidad Negocio',
    AlmacenProducto = 7,
    DescripcionAlmacenProducto = 'Almacén / Producto',
    AlmacenGrupo = 8,
    DescripcionAlmacenGrupo = 'Almacén / Grupo',
    GrupoSubGrupo = 9,
    DescripcionGrupoSubGrupo = 'Grupo / Subgrupo'
}
export enum TiposDeDistribucion {
    Peso = 0,
    DescripcionPeso = "DOC_EXTERNAL_WEIGHT",
    Volumen = 1,
    DescripcionVolumen = "VOLUME",
    Costo = 2,
    DescripcionCosto = "LBL_COST",
    Cantidad = 3,
    DescripcionCantidad = "ORDER_PRO_QUANTITY",
    SegunDocLiquidador = 4,
    DescripcionSegunDocLiquidador = "ACCORDING_TO_SETTLEMENT_DOCUMENT",
    Producto = 5,
    DescripcionProducto = "LABEL_PRODUCT",
    SubPartidaarancelariaCosto = 6,
    DescripcionSubPartidaarancelariaCosto = "TARIFF_SUBHEADING_BY_COST",
    SubPartidaarancelariaCantidad = 7,
    DescripcionSubPartidaarancelariaCantidad = "TARIFF_SUBHEADING_BY_QUANTITY"
}

export enum FormatoImpresion {
    NoFormat = 0,
    CrystalReport = 1,
    RichText = 2,
    WordForWindows = 3,
    Excel = 4,
    PortableDocFormat = 5,
    HTML32 = 6,
    HTML40 = 7,
    ExcelRecord = 8,
    Text = 9,
    CharacterSeparatedValues = 10,
    TabSeperatedText = 11,
    EditableRTF = 12,
    Xml = 13,
    RPTR = 14,
    ExcelWorkbook = 15,
    XLSXPagebased = 16,
    XLSXRecord = 17
}
export enum VinculadoDocumento {
    Todos = 0,
    DescripcionTodos = 'LABEL_ALL_PLURAL',
    DocumentoVinculado = 1,
    DescripcionDocumentoVinculado = 'LBL_DOCUMENT_LINKED',
    DocumentoSinVincular = 2,
    DescripcionDocumentoSinVincular = 'LBL_DOCUMENT_UNLINKED'
}

export enum IdentidadDeGenero {
    Masculino = 1,
    DescripcionMasculino = "ORDER_GENER.LBL_MALE",
    Femenino = 2,
    DescripcionFemenino = "ORDER_GENER.LBL_FEMALE",
    Transgenero = 3,
    DescripcionTransgenero = "ORDER_GENER.LBL_TRANSGENDER",
    Neutro = 4,
    DescripcionNeutro = "ORDER_GENER.LBL_NEUTRAL",
    NoLoDeclara = 5,
    DescripcionNoLoDeclara = "ORDER_GENER.LBL_NON_BINARY"
}

export enum NivelEducativo {
    Preescolar = 1,
    DescripcionPreescolar = "EDUCATION_LEVEL.PRESCHOOL",
    BasicaPrimaria = 2,
    DescripcionBasicaPrimaria = "EDUCATION_LEVEL.BASIC_PRIMARY",
    BasicaSecundaria = 3,
    DescripcionBasicaSecundaria = "EDUCATION_LEVEL.BASIC_BACCALAUREATE",
    Clasica = 4,
    DescripcionClasica = "EDUCATION_LEVEL.MEDIUM_ACADEMIC_OR_CLASIC",
    MediaTecnica = 5,
    DescripcionMediaTecnica = "EDUCATION_LEVEL.MEDIUM_TECHNIQUE",
    Normalista = 6,
    DescripcionNormalista = "EDUCATION_LEVEL.NORMALIST",
    Especializacion = 10,
    DescripcionEspecializacion = "EDUCATION_LEVEL.SPECIALIZATION",
    Maestria = 11,
    DescripcionMaestria = "EDUCATION_LEVEL.MASTER_DEGREE",
    Doctorado = 12,
    DescripcionDoctorado = "EDUCATION_LEVEL.DOCTORATE",
    Ninguno = 13,
    DescripcionNinguno = "EDUCATION_LEVEL.NONE"



}

export enum Discapacidades {

    SinDiscapacidad = 0,
    DescripcionSinDiscapacidad = "DISABILITIES.WITHOUT_DISABILITY",
    Discapacidad_fisica = 1,
    DescripcionDiscapacidad_fisica = "DISABILITIES.PHYSICAL_DISABILITY",
    Discapacidad_visual = 2,
    DescripcionDiscapacidad_visual = "DISABILITIES.VISUAL_DISABILITY",
    Discapacidad_auditiva = 3,
    DescripcionDiscapacidad_auditiva = "DISABILITIES.HEARING_IMPAIRMENT",
    Discapacidad_intelectual = 4,
    DescripcionDiscapacidad_intelectual = "DISABILITIES.INTELLECTUAL_DISABILITY",
    Discapacidad_sicosocial = 5,
    DescripcionDiscapacidad_sicosocial = "DISABILITIES.PSYCHOSOCIAL_DISABILITY",
    Discapacidad_SordoCeguera = 6,
    DescripcionDiscapacidad_SordoCeguera = "DISABILITIES.DEAF_BLINDNESS_DISABILITY",
    Discapacidad_Multiple = 7,
    DescripcionDiscapacidad_Multiple = "DISABILITIES.MULTIPLY_DISABILITY",
}

export enum CausalesAnulaciónAtencionSiras {
    DatosBasicosPaciente = 1,
    DescripcionDatosBasicosPaciente = 'CORRECTION_BASIC_PATIENT_DATA',
    RemisionPaciente = 2,
    DescripcionRemisionPaciente = 'CORRECTION_PATIENT_REFERRAL',
    DatosAccidente = 3,
    DescripcionDatosAccidente = "CORRECTION_ACCIDENT_DATA",
    DatosVehiculoInvolucrado = 4,
    DescripcionDatosVehiculoInvolucrado = "CORRECTION_DATA_VEHICLE"

}

export enum TipoNotificacionUsuario {
    Notificacion = 'N',
    DescripcionNotificacion = 'SYSTEM_NOTIFICATION',
    NotificacionCorreo = 'S',
    DescripcionNotificacionCorreo = 'NOTIFICATION_AND_EMAIL',
}

export enum ModulosYeminus {
    Ninguno = 0,
    DescripcionNinguno = "NONE",
    ContabilidadGeneral = 1,
    DescripcionContabilidadGeneral = "MODULES.CONTABILITY",
    CuentasPorPagar = 2,
    DescripcionCuentasPorPagar = "MODULES.LBL_DEBTS_TO_PAY",
    CuentasPorCobrar = 3,
    DescripcionCuentasPorCobrar = "MODULES.ACCOUNTS_RECEIVABLE",
    ActivosFijos = 4,
    DescripcionActivosFijos = "MODULES.FIXED_ASSETS",
    PresupuestoContable = 5,
    DescripcionPresupuestoContable = "MODULES.ACCOUNTING_BUDGET",
    ConciliacionBancaria = 6,
    DescripcionConciliacionBancaria = "MODULES.BANCK_CONCILIATION",
    DiferidosYAmortizaciones = 7,
    DescripcionDiferidosYAmortizaciones = "MODULES.DEFERRED_AND_AMORTIZATIONS",
    CentrosDeCostos = 8,
    DescripcionCentrosDeCostos = "MODULES.CENTERS_COSTS",
    Inventarios = 9,
    DescripcionInventarios = "MODULES.INVENTORIES",
    Facturacion = 10,
    DescripcionFacturacion = "MODULES.BILLING",
    PuntoDeVenta = 11,
    DescripcionPuntoDeVenta = "MODULES.POINT_OF_SALE",
    ImpresionDeCodigosDeBarras = 12,
    DescripcionImpresionDeCodigosDeBarras = "MODULES.BARCODE_PRINTING",
    InformesDatacredito = 13,
    DescripcionInformesDatacredito = "MODULES.DATACREDIT_REPORTS",
    FacturacionPorListasDePrecio = 14,
    DescripcionFacturacionPorListasDePrecio = "MODULES.PRICE_LIST_BILLING",
    FacturacionServiciosDomicilarios = 15,
    DescripcionFacturacionServiciosDomicilarios = "MODULES.DOMICILIARY_SERVICES_BILLING",
    Nomina = 16,
    DescripcionNomina = "MODULES.PAY_SHEET",
    OrdenesDeProduccionYCostos = 17,
    DescripcionOrdenesDeProduccionYCostos = "MODULES.PRODUCTION_ORDERS_AND_COST",
    CosteoPorPedido = 18,
    DescripcionCosteoPorPedido = "MODULES.COSTING_PER_ORDER",
    SistemaDeCalidad = 19,
    DescripcionSistemaDeCalidad = "MODULES.QUALITY_SYSTEM",
    MantenimientoDeMaquinaria = 20,
    DescripcionMantenimientoDeMaquinaria = "MODULES.MACHINERY_MAINTENANCE",
    ControlDeVisitantes = 21,
    DescripcionControlDeVisitantes = "MODULES.VISITOR_CONTROL",
    ControlDeAsistenciaBasico = 22,
    DescripcionControlDeAsistenciaBasico = "MODULES.ASSIST_CONTROL",
    ManejoDeTurnos = 23,
    DescripcionManejoDeTurnos = "MODULES.SHIFT_MANAGEMENT",
    LiquidacionHorasExtras = 24,
    DescripcionLiquidacionHorasExtras = "MODULES.OVERTIME_SETTLEMENT",
    TablasProduccion = 25,
    DescripcionTablasProduccion = "MODULES.PRODUCTION_TABLES",
    TiemposProduccion = 26,
    DescripcionTiemposProduccion = "MODULES.PRODUCTION_TIMES",
    DocumentosDeProduccion = 27,
    DescripcionDocumentosDeProduccion = "MODULES.PRODUCTION_DOCUMENTS",
    DistribucionGastosDeAdministracionYVentas = 28,
    DescripcionDistribucionGastosDeAdministracionYVentas = "MODULES.DISTRIBUTION_OF_ADMINISTRATIVE_AND_SALES_EXPENSES",
    SPRBasico = 29,
    DescripcionSPRBasico = "MODULES.BASIC_SPR",
    PedidosProduccion = 30,
    DescripcionPedidosProduccion = "MODULES.PRODUCTION_ORDERDS",
    ControlPesajeVehiculos = 31,
    DescripcionControlPesajeVehiculos = "MODULES.VEHICLE_WEIGHIHG_CONTROL",
    DocumentosGenerales = 32,
    DescripcionDocumentosGenerales = "MODULES.GENERAL_DOCUMENTS",
    LiquidacionDeDocumentos = 33,
    DescripcionLiquidacionDeDocumentos = "MODULES.SETTLEMENT_OF_DOCUMENTS",
    InteligenciaDeNegocios = 34,
    DescripcionInteligenciaDeNegocios = "MODULES.BUSINESS_INTELLIGENCE",
    Analisis = 40,
    DescripcionAnalisis = "MODULES.ANALYSIS"

}

export enum CumplimientoOrdenamiento {
    SinCumplir = 0,
    DescripcionSinCumplir = 'UNFULFILLED',
    Cumplido = 1,
    DescripcionCumplido = 'CUMPLIMENT_INVOICE',
    Cancelado = 2,
    DescripcionCancelado = 'LBL_CANCELLED',
    CumplidoYNoFacturado = 3,
    DescripcionCumplidoYNoFacturado = 'CUMPLIMENT_UNBILLED'
}
export enum Profesiones {
    Ninguno = 0,
    DescripcionNinguno = "PROFESSIONS.NONE",
    MedicoEspecialista = 1,
    DescripcionMedicoEspecialista = "PROFESSIONS.MEDICAL_SPECIALIST",
    MedicoGeneral = 2,
    DescripcionMedicoGeneral = "PROFESSIONS.GENERAL_PRACTITIONER",
    enfermera = 3,
    Descripcionenfermera = "PROFESSIONS.NURSE",
    AuxiliarEnfermeria = 4,
    DescripcionAuxiliarEnfermeria = "PROFESSIONS.AUXILIARY_NURSE",
    Otro = 5,
    DescripcionOtro = "PROFESSIONS.OTHER",
}
export enum SolicitarTiposDeRetencion {

    RetencionEnLaFuenteVentas = 1,
    DescripcionRetencionEnLaFuenteVentas = "SOURCE_RETENCION_SALES",

    RetencionDeIVAVentas = 2,
    DescripcionRetencionDeIVAVentas = "IVA_RETENCION_SALES",

    RetencionDeICAVentas = 3,
    DescripcionRetencionDeICAVentas = "ICA_RETENCION_SALES",

    RetencionDeCREEVentas = 4,
    DescripcionRetencionDeCREEVentas = "CREE_RETENCION_SALES"
}

export enum TiposCorreosCertificadosRetencion {
    CorreoInstitucional = 0,
    DescripcionCorreoInstitucional = "LBL_EMAILS_INSTITUTIONAL_MAIL",

    CorreosFacturacionElectronica = 1,
    DescripcionCorreosFacturacionElectronica = "LBL_EMAILS_ELECTRONIC_BILLING",

    CorreosContactos = 2,
    DescripcionCorreosContactos = "LBL_EMAILS_CONTACT"
}

export enum ViaRealizacionActoQuirurgico {
    Unico = 1,
    DescripcionUnico = "VIA_SURGICAL_PROCEDURE.ONLY",
    MultipleBilateralMismaViaDiferenteEspecialidad = 2,
    DescripcionMultipleBilateralMismaViaDiferenteEspecialidad = "VIA_SURGICAL_PROCEDURE.MULTIPLE_DOUBLE_DIFFERENT_SPECIALTY",
    MultipleBilateralMismaViaIgualEspecialidad = 3,
    DescripcionMultipleBilateralMismaViaIgualEspecialidad = "VIA_SURGICAL_PROCEDURE.MULTIPLE_DOUBLE_SAME_SPECIALTY",
    MultipleBilateralDiferenteViaDiferenteEspecialidad = 4,
    DescripcionMultipleBilateralDiferenteViaDiferenteEspecialidad = "VIA_SURGICAL_PROCEDURE.MULTIPLE_DOUBLE_DIFFERENT_ROUTE_SPECIALTY",
    MultipleBilateralDiferenteViaIgualEspecialidad = 5,
    DescripcionMultipleBilateralDiferenteViaIgualEspecialidad = "VIA_SURGICAL_PROCEDURE.MULTIPLE_DOUBLE_SAME_ROUTE_SPECIALTY"
}


export enum EstadosMedidor {
    BuenEstado = '1',
    DescripcionBuenEstado = "GOOD_CONDITION",

    Daniado = '2',
    DescripcionDaniado = "LBL_HARM",

    SinMedidor = '3',
    DescripcionSinMedidor = "NOT_METERS"
}

export enum TipoTarifaAseo {
    DescripcionUrbano = 'SLD_URBANO',
    Urbano = "U",

    DescripcionRural = 'SLD_RURAL',
    Rural = "R",

    DescripcionDesocupadoUrbano = "URBAN_UNEMPLOYED",
    DesocupadoUrbano = "D",

    DescripcionDesocupadoRural = "RURAL_UNEMPLOYED",
    DesocupadoRural = "S"
}

export enum UsuoAseo {
    DescripcionResidencial = "RESIDENTIAL",
    Residencial = 1,

    DescripcionComercial = "LBL_COMMERCIAL",
    Comercial = 2,

    DescripcionIndustrial = "INDUSTRIAL",
    Industrial = 3,

    DescripcionOficial = "OFFICIAL",
    Oficial = 4,

    DecripcionEspecial = "SLD_ESPECIAL",
    Especial = 5
}

export enum TipoGeneracionRips {
    FacturacionIndividual = 0,
    DescripcionFacturacionIndividual = "COMPONENT_FILTER_RIPS.INDIVIDUAL_BILLING",
    FacturacionRemisionesRelacionadas = 1,
    DescripcionFacturacionRemisionesRelacionadas = "COMPONENT_FILTER_RIPS.BULLING_FOR_MULTIPLE_REFERRALS",
    FacturacionRemisionesVinculadas = 2,
    DescripcionFacturacionRemisionesVinculadas = "COMPONENT_FILTER_RIPS.BULLING_FOR_LINKED_REFERRALS"
}

export enum TercerosDocumentos {
    Tercero1 = 0,
    DescripcionTercero1 = 'LBL_CLIENT_1',
    Tercero2 = 1,
    DescripcionTercero2 = 'LBL_CLIENT_2',
    Tercero3 = 2,
    DescripcionTercero3 = 'LBL_CLIENT_3'
}

export enum TipoCuota {
    Fija = 0,
    DescripcionFija = 'FIXED',

    Variable = 1,
    DescripcionVariable = 'VARIABLE'
}
export enum TipoCantidadHistoricoDocumento {
    PorEntregar = 0,
    DescripcionPorEntregar = 'TO_BE_DELIVERED',
    Todos = 1,
    DescripcionTodos = 'LABEL_ALL_PLURAL'
}
export enum PresentacionNotificacionDocumento {
    PorDocumento = 0,
    DescripcionPorDocumento = 'BY_ORDER',
    PorProducto = 1,
    DescripcionPorProducto = 'PR_FOR_PRODUCT'
}
export enum ValoresNotificacionDocumento {
    Precios = 0,
    DescripcionPrecios = 'PRICES',
    Costo = 1,
    DescripcionCosto = 'LBL_COST',
    Ambos = 2,
    DescripcionAmbos = 'LBL_CONFIG_PROJ_PED',
    Ninguno = 3,
    DescripcionNinguno = 'NONE'

}

export enum TiposRecargas {
    PorDocumento = 0,
    DescripcionPorDocumento = "BY_ORDER",

    TotalPorCliente = 1,
    DescripcionTotalPorCliente = "TOTAL_BY_CUSTOMER"
}

export enum TiposGeneracionRedencionVentas {
    NuevasTarjetas = 0,
    DescripcionNuevasTarjetas = 'GENERATE_NEW_CARD',

    UsarExistentesDelCliente = 1,
    DescripcionUsarExistentesDelCliente = 'USE_EXISTING_CUSTOMER'
}

export enum EnumModoEdicionDocumentos {
    Creacion = 0,
    Edicion = 1,
    Elimnacion = 2,
    Duplicado = 3,
    Devolucion = 4
}


export enum FavoritosPorMenu {
    ConsultaDocumentos = '1505139237323',
    DescripcionConsultaDocumentos = 'QUERY_DOCUMENTS',

    Terceros = '1500061903067',
    DescripcionTercero = 'EXTERNAL_CUSTOMERS',

    LiquidacionNomina = '1590205015634',
    DescripcionLiquidacionNomina = 'SETTLED_PAYROLL',

    CapturaSeguimientoCartera = '1512423054390',
    DescripcionCapturaSeguimientoCartera = 'LBL_CAPTURE_MN_PORTAFOLIO_TRACKING',

    AuditoriasOperacionesDiarias = '1637341176179',
    DescripcionAuditoriasOperacionesDiarias = 'AUDITS_DAILY_OPERATIONS',

    SeguimientoCartera = '1512423054390',
    DescripcionSeguimientoCartera = 'MN_PORTAFOLIO_TRACKING',

    Glosas = '1624374496011',
    DescripcionGlosas = 'MANAGE_GLOSSES',

    Recibos = '1604442535265',
    DescripcionRecibos = 'LBL_RECEIPTS',

    Egresos = '1619146578117',
    DescripcionEgresos = 'D_PROCESS_EGRESS',

    ProgramacionPagos = '1610737430643',
    DescripcionProgramacionPagos = 'MN_PAYMENT_SCHEDULING',

    ChipPresupuestal = '1584633784747',
    DescripcionChipPresupuestal = 'CHIP_BUDGET',

    EjecucionPresupuestal = '1642800056066',
    DescripcionEjecucionPresupuestal = 'BUDGET_EXECUTION',

    MovimientoContable = '1588194720713',
    DescripcionMovimientoContable = 'ACCOUNTING_MOVEMENT',

    InventarioCanales = '1549989712883',
    DescripcionInventarioCanales = 'MN_ANIMAL_CHANNEL_INVENTORY',

    ConsultaDetallesDocumentosVentas = '1538424065934',
    DescripcionConsultaDetallesDocumentosVentas = 'QUERY_DOCUMENTS_DETAILS_SALES',

    ConsultaDetallesDocumentosCompras = '1538424065933',
    DescripcionConsultaDetallesDocumentosCompras = 'QUERY_DOCUMENTS_DETAILS_PURCHASES',

    ContactosClientes = '1538834681506',
    DescripcionContactosClientes = 'CONTACTS_EXTERNAL_CUSTOMERS',

    ExistenciasPorVariante = '1539787659453',
    DescripcionExistenciasPorVariante = 'MN_STOCKS_PER_CLASSIFICATION',

    LecturaDeAcueducto = '1639401588246',
    DescripcionLecturaDeAcueducto = 'COMPONENT_AQUEDUCT_READINGS.AQUEDUCT_READINGS',

    OrdenesDeServicio = '1581115097143',
    DescripcionOrdenDeServicio = 'ORDERS_OF_SERVICES_CONSULTATION',

    Equipos = '1646922015275',
    DescripcionEquipos = 'LBL_EQUIPMENT',

    TareasPendientes = '1646760402909',
    DescripcionTareasPendientes = 'LBL_PENDING_TASKS',

    Empleados = '1506518786949',
    DescripcionEmpleados = 'LBL_EMPLOYEES',

    ConsultaTiemposActividadesAgrupado = '1544107415546',
    DescripcionConsultaTiemposActividadesAgrupado = 'QUERY_TIMES_ACTIVITIES_GROUPED',

    ConsultaTiemposActividadesDetallado = '1544107415547',
    DescripcionConsultaTiemposActividadesDetallado = 'QUERY_TIMES_ACTIVITIES_DETAILED',

    ConsultaTiemposActividadesIndicador = '1544107415548',
    DescripcionConsultaTiemposActividadesIndicador = 'QUERY_TIMES_ACTIVITIES_INDICATORS',

    Gestionproyectos = '1517868098691',
    DescripcionGestionProyectos = 'PROJECTS',

    Gestiontareas = '1500046189469',
    DescripcionGestionTareas = 'MN_TASK_MANAGER',

    ProgramacionJornadas = '1588267203382',
    DescripcionProgramacionJornadas = 'DAY_PROGRAMMING',

    NovedadesNomina = '1602088122887',
    DescripcionNovedadesNomina = 'MENU_NOVELTYS_PAYROLL.LBL_NOVELTYS_PAYROLL',

    PlantillaNomina = '1637934851805',
    DescripcionPlantillaNomina = 'EXECUTE_PAYROLL_TEMPLATE.PAYROLL_DETAIL',

    HistoriaCLinica = '1574862473333',
    DescripcionHistoriaClinica = 'MN_CLINIC_HISTORY',

    CitasProgramadas = '1578752975525',
    DescripcioncitasProgramadas = 'MEDICAL_APPOINTMENTS',

    IngresoUrgencias = '1591191617107',
    DescripcionIngresoUrgencias = 'PATIENTS_ENTRANCE',

    HistoriaClinicaUrgencias = '1591191689267',
    DescripcionHistoriaClinicaUrgencias = 'CLINIC_HISTORY_EMERGENCY',

    ConsultaLaboratorio = '1573743701074',
    DescripcionConsultaLaboratorio = 'MN_LABORATORY_CONSULTATION',

    ConsultaGeneralOControl = '1595436311762',
    DescripcionConsultaGeneralOControl = 'GENERAL_CONSULTATION_OR_CONTROL',

    InterConsulta = '1595436328298',
    DescripcionInterConsulta = 'INTERCONSULTATION',

    MedicamentosYDispositivos = '1595436345874',
    DescripcionMedicamentosYDispositivos = 'MN_PRODUCTS_MEDICINES_DEVICES',

    FormulasMedicas = '1615382047317',
    DescripcionFormulasMedicas = 'MEDICAL_FORMULA',

    RayosX = '1595436356938',
    DescripcionRayosX = 'X_RAY',

    Cirugia = '1595436371334',
    DescripcionCirugia = 'SURGERY',

    Terapia = '1595436381788',
    DescripcionTerapia = 'THERAPIES',

    OtrosServicios = '1604584117661',
    DescripcionOtrosServicios = 'LBL_OTHER_SERVICES',

    Productos = '1511183471626',
    DescripcionProductos = 'LABEL_PRODUCT',

    LogisticaDespacho = '1501779778993',
    DescripcionLogisticaDespacho = 'MN_ASSIGN_RESPONSIBLE',

    Actividades = '1555095839307',
    DescripcionActividades = 'ACT_TITLE',

    Solicitudes = '1500050860537',
    DescripcionSolicitudes = 'REQUESTS',

    Oportunidades = '1501525837069',
    DescripcionOportunidades = 'MN_OPPORTUNITIES_MANAGEMENT'
}

export enum EnumLugarEdicionDocumento {
    Institucional = 0,
    PuntoVenta = 1,
    ImportacionDocumentos = 2, // Interfaces -> Yeminus -> Documentos inventarios
    ImportacionDetalle = 3, // Documentos -> Modificar documento -> Pegar items
    RecepcionXML = 4, // Compras e inventarios -> Compras electronicas -> Recepcion xml
    RecepcionCorreo = 5,// Compras e inventarios -> Compras electronicas -> Recepcion correos
    CitasMedicas = 6, // Salud -> Citas agendadas -> Agendamiento de citas
    HistoriaClinica = 7, // Salud -> Citas agendadas -> Historias clinicas
    InterfazVtex = 8, // Interfaces -> Vtex
    InterfazWoocommerce = 9, // Interfaces -> Woocommerce
    InterfazPrestashop = 10, // Interfaces -> Prestashop
    Mipres = 11, // Interfaces -> Mipress
    MrpSolicitudesCompra = 12, // Compras e inventarios -> Mrp solicitudes de compra o Mrp solicitudes de compra insumos
    ImportarEntregas = 13, // Logistica -> importar entregas -> Por documento
    AjusteConteoFisico = 14,// Compras e inventario -> Ajustar conteo físico
    MantenimientoEquipos = 15, // Mantenimiento de equipos -> Orden de mantenimiento,
    AdicionKits = 16, // Documentos -> Modificar documentos -> Mas acciones -> Adicionar kits
    Movil = 17
}

export enum Mascotas {
    Ninguno = 0,
    DescripcionNinguno = 'LABEL_NO',

    Perro = 1,
    DescripcionPerro = 'DOG',

    Gato = 2,
    DescripcionGato = 'CAT',

    PerroYGato = 3,
    DescripcionPerroYGato = 'DOG_AND_CAT',

    Otro = 4,
    DescripcionOtro = 'LBL_OTHER'
}

export enum Zonas {
    Urbano = 0,
    DescripcionUrbano = 'SLD_URBANO',

    Rural = 1,
    DescripcionRural = 'SLD_RURAL',

    SemiUrbana = 2,
    DescripcionSemiUrbana = 'SEMI_URBANO'
}

export enum MediosDeTransporteEmpleado {
    Carro = 0,
    DescripcionCarro = 'CAR',

    Motociclista = 1,
    DescripcionMotociclista = 'MOTORCYCLE',

    Patineta = 2,
    DescripcionPatineta = 'SKATEBOARD',

    Caminando = 3,
    DescripcionCaminando = 'WALKING',

    ServicioPublico = 4,
    DescripcionServicioPublico = 'PUBLIC_SERVICE',

    TransporteEmpresa = 5,
    DescripcionTransporteEmpresa = 'TRANSPORT_COMPANY',

    Bicicleta = 6,
    DescripcionBicicleta = 'BICYCLE'
}

export enum FrecuenciaDeportes {
    UnaODosVecesPorSemana = 0,
    DescripcionUnaODosVecesPorSemana = 'ONE_OR_TWO_TIMES_A_WEEK',

    TresACincoVecesPorSemana = 1,
    DescripcionTresACincoVecesPorSemana = 'THREE_OR_FIVE_TIMES_A_WEEK',

    SeisASieteVecesPorSemana = 2,
    DescripcionSeisASieteVecesPorSemana = 'SIX_OR_SEVEN_TIMES_A_WEEK',

    Ocacional = 3,
    DescripcionOcacional = 'OCCASIONAL'
}

export enum TiposPausaEnum {
    Tareas = 2,
    DescripcionTareas = "Tareas",
    Solicitudes = 3,
    DescripcionSolicitudes = "Solicitudes"
}


export enum CategoriasLicencias {
    Ninguna = -1,
    DescripcionNinguna = "Ninguna",
    A1 = 0,
    DescripcionA1 = "A1: Motos con cilindrada hasta de 125 c.c.",
    A2 = 1,
    DescripcionA2 = "A2: Motos, motociclos y mototriciclos con cilindrada mayor a 125 c.c.",
    B1 = 2,
    DescripcionB1 = "B1: Automóviles, motocarros, cuatrimotos, camperos, camionetas y microbuses",
    B2 = 3,
    DescripcionB2 = "B2: Camiones rígidos, busetas y buses",
    B3 = 4,
    DescripcionB3 = "B3: Vehículos articulados",
    C1 = 5,
    DescripcionC1 = "C1: Automóviles, motocarros, cuatrimotor, camperos, camionetas y microbuses de servicio público",
    C2 = 6,
    DescripcionC2 = "C2: Camiones rígidos, buses y busetas de servicio público",
    C3 = 7,
    DescripcionC3 = "C3: Vehículos articulados de servicio público"
}

export enum TipoVehiculo {
    Ninguno = -1,
    DescripcionNinguno = "Ninguno",
    Moto = 0,
    DescripcionMoto = "Moto",
    Carro = 1,
    DescripcionCarro = "Carro"
}

export enum ComposicionFamiliar {
    Nuclear = 0,
    DescripcionNuclear = "Nuclear: Hombre y mujer sin hijos",

    Extensa = 1,
    DescripcionExtensa = "Extensa: Biparental más otros parientes",

    Reconstruida = 2,
    DescripcionReconstruida = "Reconstruida: Hombre y mujer con o sin hijos que han convivido con otra pareja previamente",

    Monoparental = 3,
    DescripcionMonoparental = "Monoparental: Padre o madre con hijos",

    Biparental = 4,
    DescripcionBiparental = "Biparental: Padre y madre con hijos",

    Ampliada = 5,
    DescripcionAmpliada = "Ampliada: Incluye a padres, hijos, hermanos de los padres con sus propios hijos, abuelos, tíos abuelos, bisabuelos (generaciones ascendentes)",

    Antipica = 6,
    DescripcionAntipica = "Antipica",

    NoParental = 7,
    DescripcionNoParental = 'No parental : vínculos de parentesco que realizan funciones o roles de familia sin la presencia de los padres',

    Homoparental = 8,
    DescripcionHomoparental = 'Homoparental: Parejas del mismo género con o sin hijos',

    Unipersonal = 9,
    DescripcionUnipersonal = 'Unipersonal: Familia formada por una sola persona',

    MonoparentalExtensa = 10,
    DescripcionMonoparentalExtensa = "Monoparental: Padre o madre con hijos",
}

export enum Vivienda {
    Propia = 0,
    DescripcionPropia = "Propia",

    Arrendada = 1,
    DescripcionArrendada = "Arrendada",

    Compartida = 2,
    DescripcionCompartida = "Compartida",
}

export enum EstadoCivil {
    Soltero = 'S',
    DescripcionSoltero = "Soltero(a)",
    Casado = 'C',
    DescripcionCasado = "Casado(a)",
    UnionLibre = 'U',
    DescripcionUnionLibre = "Unión Libre",
    Viudo = 'V',
    DescripcionViudo = "Viudo(a)",
    Divorciado = 'P',
    DescripcionDivorciado = "Divorciado(a)",
    Religioso = 'R',
    DescripcionReligioso = "Religioso(a)",
    MadreSoltera = 'M',
    DescripcionMadreSoltera = "Madre Soltera",
}

export enum EstratosSocioEconomicos {
    BajoBajo = 1,
    DescripcionBajoBajo = "1: Bajo-bajo",

    Bajo = 2,
    DescripcionBajo = "2: Bajo",

    MedioBajo = 3,
    DescripcionMedioBajo = "3: Medio-bajo",

    Medio = 4,
    DescripcionMedio = "4: Medio",

    MedioAlto = 5,
    DescripcionMedioAlto = "5: Medio-alto",

    Alto = 6,
    DescripcionAlto = "6: Alto",
}

export enum MasaCorporal {
    Normal = 0,
    DescripcionNormal = "Normal",

    BajoPeso = 1,
    DescripcionBajoPeso = "Bajo peso",

    SobrePeso = 2,
    DescripcionSobrePeso = "Sobre peso",

    Obesidad = 3,
    DescripcionObesidad = "Obesidad"
}

export enum GruposSanguineos {
    A = 0,
    DescripcionA = "A",
    B = 1,
    DescripcionB = "B",
    O = 2,
    DescripcionO = "O",
    AB = 3,
    DescripcionAB = "AB"
}

export enum CondicionDiscapacidad {
    Ninguna = 0,
    DescripcionNinguna = "Ninguna",

    Mental = 1,
    DescripcionMental = "Mental",

    Motora = 2,
    DescripcionMotora = "Motora",

    Sensorial = 3,
    DescripcionSensorial = "Sensorial"
}

export enum ConsumeLicor {
    Semanalmente = 0,
    DescripcionSemanalmente = "Semanalmente",

    Quincenal = 1,
    DescripcionQuincenal = "Quincenal",

    Ocasional = 2,
    DescripcionOcasional = "Ocasional",

    Mensual = 3,
    DescripcionMensual = "Mensual"
}

export enum ConsumeDrogas {
    NoConsumidor = 0,
    DescripcionNoConsumidor = "No consumidor",

    Consumidor = 1,
    DescripcionConsumidor = "Consumidor",

    Exconsumidor = 2,
    DescripcionExconsumidor = "Exconsumidor"
}

export enum UsoDelTiempoLibre {
    Estudio = 0,
    DescripcionEstudio = "Estudio",

    LaboresDomesticas = 1,
    DescripcionLaboresDomesticas = "Labores domesticas",

    Recreacion = 2,
    DescripcionRecreacion = "Recreacion y deporte",

    Otro = 3,
    DescripcionOtro = "Otro trabajo"
}

export enum CategoriasAcuerdosNivelesServicios {
    DescripcionOportunidades = 'OPORTUNITIES',
    Oportunidades = 0,
    DescripcionProyectos = 'PROJECTS',
    Proyectos = 1,
    DescripcionSolicitudes = 'REQUESTS',
    Solicitudes = 3
}

export enum EnvioCorreoCRM {
    Nunca = 0,
    DescripcionNunca = "Nunca",
    EnvioPorDefectoNo = 1,
    DescripcionEnvioPorDefectoNo = "Envío por defecto 'No'",
    EnvioPorDefectoSi = 2,
    DescripcionEnvioPorDefectoSi = "Envío por defecto 'Sí'",
}

export enum CategoriaLicencia {
    Ninguna = -1,
    DescripcionNinguna = "Ninguna",
    A1 = 0,
    DescripcionA1 = "A1: Motos con cilindrada hasta de 125 c.c.",
    A2 = 1,
    DescripcionA2 = "A2: Motos, motociclos y mototriciclos con cilindrada mayor a 125 c.c.",
    B1 = 2,
    DescripcionB1 = "B1: Automóviles, motocarros, cuatrimotos, camperos, camionetas y microbuses",
    B2 = 3,
    DescripcionB2 = "B2: Camiones rígidos, busetas y buses",
    B3 = 4,
    DescripcionB3 = "B3: Vehículos articulados",
    C1 = 5,
    DescripcionC1 = "C1: Automóviles, motocarros, cuatrimotor, camperos, camionetas y microbuses de servicio público",
    C2 = 6,
    DescripcionC2 = "C2: Camiones rígidos, buses y busetas de servicio público",
    C3 = 7,
    Descripcion = "C3: Vehículos articulados de servicio público"
}

export enum EnumOrigenIncapacidad {
    Comun = 1,
    DescripcionComun = "COMMON_INCAPACITY",

    Laboral = 2,
    DescripcionLaboral = "WORK_INCAPACITY"
}


export enum ModalidadContratacionPago {
    PagoIndividual = 1,
    DescripcionPagoIndividual = "01-Pago individual por caso / Conjunto integral de atenciones / Paquete / Canasta",
    PagoGlobalProspectovo = 2,
    DescripcionPagoGlobalProspectovo = "02-Pago global prospectivo",
    PagoPorCapacitacion = 3,
    DescripcionPagoPorCapacitacion = "03-Pago por capitación",
    PagoPorEvento = 4,
    DescripcionPagoPorEvento = "04-Pago por evento",
    OtraModalidad = 5,
    DescripcionOtraModalidad = "05-Otra modalidad (específica)",

}

export enum CoberturaPlanBeneficios {
    UPC = 1,
    DescripcionUPC = "01-Plan de beneficios en salud financiado con UPC",
    PresupuestoMaximo = 2,
    DescripcionPresupuestoMaximo = "02-Presupuesto máximo",
    PrimaEPS = 3,
    DescripcionPrimaEPS = "03-Prima EPS / EOC, no asegurados SOAT EPS",
    CoberturaSOAT = 4,
    DescripcionCoberturaSOAT = "04-Cobertura póliza SOAT",
    CoberturaARL = 5,
    DescripcionCoberturaARL = "05-Cobertura ARL",
    CoberturaADRES = 6,
    DescripcionCoberturaADRES = "06-Cobertura ADRES",
    CoberturaSaludPublica = 7,
    DescripcionCoberturaSaludPublica = "07-Cobertura salud pública",
    CoberturaTerritorial = 8,
    DescripcionCoberturaTerritorial = "08-Cobertura entidad territorial, recursos de oferta",
    UrgenciasPoblacionMigrante = 9,
    DescripcionUrgenciasPoblacionMigrante = "09-Urgencias población migrante",
    PlanComplementario = 10,
    DescripcionPlanComplementario = "10-Plan complementario en salud",
    PlanMedicina = 11,
    DescripcionPlanMedicina = "11-Plan medicina prepagada",
    OtrasPolizas = 12,
    DescripcionOtrasPolizas = "12-Otras pólizas en salud",
    CoberturaRegimenEspecial = 13,
    DescripcionCoberturaRegimenEspecial = "13-Cobertura régimen especial o excepción",
    CoberturaFNS = 14,
    DescripcionCoberturaFNS = "14-Cobertura FNS de las personas privadas de la libertad",
    Particular = 15,
    DescripcionParticular = "15-Particular"
}

export enum CobrarEnPuntoDePago {
    Ninguno = 0,
    DescripcionNinguno = "Ninguno",
    Copago = 1,
    DescripcionCopago = "Copago",
    CuotaModeradora = 2,
    DescripcionCuotaModeradora = "Cuota moderadora",
    CuotaRecuperacion = 3,
    DescripcionCuotaRecuperacion = "Cuota de recuperación",
    PagoCompartido = 4,
    DescripcionPagoCompartido = "Pagos compartidos en planes voluntarios de salud",
    CopagoCuotaModeradora = 5,
    DescripcionCopagoCuotaModeradora = "Copago o cuota moderadora",
    Anticipos = 6,
    DescripcionAnticipos = 'LBL_ADVANCES_PAYMENTS'
}

export enum TiposFacturacion {
    Individual = 1,
    DescripcionIndividual = "Individual Factura Inmediata",
    Remision = 2,
    DescripcionRemision = "Remisión",
    RemisionCapitada = 3,
    DescripcionRemisionRemisionCapitada = "Remisión Capitada",
}

export enum TiposConvenio {
    Dispensacion = 0,
    DescripcionDispensacion = "Dispensación",
    ServiciosEnSalud = 1,
    DescripcionServiciosEnSaled = "Servicios en Salud",
}

export enum ModalidadPrestacionServicio {
    Intramural = '01',
    DescripcionIntramural = "Intramural",
    ExtramuralUnidadMovil = '02',
    DescripcionExtramuralUnidadMovil = "Extramural unidad móvil",
    ExtramuralUnidadDomiciliaria = '03',
    DescripcionExtramuralUnidadDomiciliaria = "Extramural domiciliaria",
    ExtramuralJornadaSalud = '04',
    DescripcionExtramuralJornadaSalud = "Extramural jornada de salud",
    TelemedicinaInteractiva = '06',
    DescripcionTelemedicinaInteractiva = "Telemedicina Interactiva",
    TelemedicinaNoInteractiva = '07',
    DescripcionTelemedicinaNoInteractiva = "Telemedicina no interactiva",
    TelemedicinaTelexperticia = '08',
    DescripcionTelemedicinaTelexperticia = "Telemedicina telexperticia",
    TelemedicinaTelemonitoreo = '09',
    DescripcionTelemedicinaTelemonitoreo = "Telemedicina telemonitoreo"
}

export enum CancelacionEntrega {
    MostrarTotalItems = 0,
    DescripcionMostrarTotalItems = 'SHOW_TOTAL_ITEMS',

    MostrarSoloItemsCancelados = 1,
    DescripcionMostrarSoloItemsCancelados = 'SHOW_ONLY_CANCELLED_ITEMS',

    MostrarSoloItemsNoCancelados = 2,
    DescripcionMostrarSoloItemsNoCancelados = 'SHOW_ONLY_UNCANCELLED_ITEMS'
}

export enum TipoEvaluacion {
    Ingreso = 0,
    DescripcionIngreso = "Ingreso",
    Periodica = 1,
    DescripcionPeriodica = "Periodica",
    Retiro = 2,
    DescripcionRetiro = "Retiro"
}

export enum ClaseEvaluacion {
    Evaluacion = 0,
    DescripcionEvaluacion = "Evaluación",
    Requisito = 1,
    DescripcionRequisito = "Requisito"
}

export enum TiposDeResolucion {
    Nacional = 1,
    DescripcionNacional = "Nacional",
    RegimenEspecial = 2,
    DescripcionRegimenEspecial = "Regimen Especial",
    ParticipacionRegional = 3,
    DescripcionParticipacionRegional = "Participacion Regional"
}

export enum DetallarCantidadMovimientoDetallado {
    SinDetalleAdicional = 0,
    DescripcionSinDetalleAdicional = 'NO_ADDITIONAL_DETAIL',

    TipoTercero = 1,
    DescripcionTipoTercero = "CU_LBL_CUSTOMER_TYPE",

    CiudadCliente = 2,
    DescripcionCiudadCliente = "LBL_CITY_CUSTOMER",

    RegionCliente = 3,
    DescripcionRegionCliente = "REGION_CUSTOMER",

    UnidadNegocioCliente = 4,
    DescripcionUnidadNegocioCliente = "LBL_UNITS_OF_BUSINESS_CUSTOMER",

    CategoriaCliente = 5,
    DescripcionCategoriaCliente = "CUSTOMER_CATEGORY",

    CicloFacturacionCliente = 6,
    DescripcionCicloFacturacionCliente = "CUSTOMER_CYCLE_BILLING",

    SectorCliente = 7,
    DescripcionSectorCliente = "CUSTOMER_SECTOR",

    PorVendedorCliente = 8,
    DescripcionPorVendedorCliente = "BY_CUSTOMER_SELLER",

    ClasificacionCliente = 9,
    DescripcionClasificacionCliente = "LBL_CLIENT_CLASSIFICATION"
}

export enum MostrarBusquedaProducto {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',

    TodosAlmacenes = 1,
    DescripcionTodosAlmacenes = 'ALL_WAREHOUSES',

    AlmacenesDocumento = 2,
    DescripcionAlmacenesDocumento = 'ALL_WAREHOUSES_OF_DOCUMENT',

    AlmacenesUsuario = 3,
    DescripcionAlmacenesUsuario = 'ALL_WAREHOUSES_OF_USER'

}

export enum TomarCostoMRP {
    CostoUltimaCompraDelProducto = 0,
    DescripcionCostoUltimaCompraDelProducto = 'PRODUCTS_LAST_PURCHASE_COST',

    ListaDeCostosDelProveedor = 1,
    DescripcionListaDeCostosDelProveedor = 'MENU_CONTENTS_PARAMETERS.COSTS_LIST_PROVIDER',

    CostoUltimaCompraDelProveedor = 2,
    DescripcionCostoUltimaCompraDelProveedor = 'SUPPLIER_LAST_PURCHASE_COST',
}

export enum NomenclaturaDian {
    AvenidaCalle = 'AC',
    DescripcionAvenidaCalle = 'Avenida Calle',

    Administracion = 'AD',
    DescripcionAdministracion = 'Administración',


    Adelante = 'ADL',
    DescripcionAdelante = 'Adelante',

    Aeropuerto = 'AER',
    DescripcionAeropuerto = 'Aeropuerto',

    Agencia = 'AG',
    DescripcionAgencia = 'Agencia',

    Agrupacion = 'AGP',
    DescripcionAgrupacion = 'Agrupación',

    AvenidaCarrera = 'AK',
    DescripcionAvenidaCarrera = 'Avenida carrera',

    Altillo = 'AL',
    DescripcionAltillo = 'Altillo',

    AlLado = 'ALD',
    DescripcionAlLado = 'Al lado',

    Almacen = 'ALM',
    DescripcionAlmacen = 'Almacén',

    Apartamento = 'AP',
    DescripcionApartamento = 'Apartamento',

    Apartado = 'APTDO',
    DescripcionApartado = 'Apartado',

    Atras = 'ATR',
    DescripcionAtras = 'Atrás',

    Autopista = 'AUT',
    DescripcionAutopista = 'Autopista',

    Avenida = 'AV',
    DescripcionAvenida = 'Avenida',

    AnilloVial = 'AVIAL',
    DescripcionAnilloVial = 'Anillo vial',

    Bodega = 'BG',
    DescripcionBodega = 'Bodega',

    Bloque = 'BL',
    DescripcionBloque = 'Bloque',

    Boulevard = 'BLV',
    DescripcionBoulevard = 'Boulevard',

    Barrio = 'BRR',
    DescripcionBarrio = 'Barrio',

    Corregimiento = 'C',
    DescripcionCorregimiento = 'Corregimiento',

    Casa = 'CA',
    DescripcionCasa = 'Casa',

    Caserio = 'CAS',
    DescripcionCaserío = 'Caserío',

    CentroComercial = 'CC',
    DescripcionCentroComercial = 'Centro comercial',

    Ciudadela = 'CD',
    DescripcionCiudadela = 'Ciudadela',

    Celula = 'CEL',
    DescripcionCelula = 'Célula',

    Centro = 'CEN',
    DescripcionCentro = 'Centro',

    Circular = 'CIR',
    DescripcionCircular = 'Circular',

    Calle = 'CL',
    DescripcionCalle = 'Calle',

    Callejon = 'CLJ',
    DescripcionCallejon = 'Callejón',

    Camino = 'CN',
    DescripcionCamino = 'Camino',

    ConjuntoResidencial = 'CON',
    DescripcionConjuntoResidencial = 'Conjunto residencial',

    Conjunto = 'CONJ',
    DescripcionConjunto = 'Conjunto',

    Carrera = 'CR',
    DescripcionCarrera = 'Carrera',

    Carretera = 'CRT',
    DescripcionCarretera = 'Carretera',

    Circunvalar = 'CRV',
    DescripcionCircunvalar = 'Circunvalar',

    Consultorio = 'CS',
    DescripcionConsultorio = 'Consultorio',

    Diagonal = 'DG',
    DescripcionDiagonal = 'Diagonal',

    Deposito = 'DP',
    DescripcionDeposito = 'Depósito',

    Departamento = 'DPTO',
    DescripcionDepartamento = 'Departamento',

    DepositoSotano = 'DS',
    DescripcionDepositoSotano = 'Depósito sótano',

    Edificio = 'ED',
    DescripcionEdificio = 'Edificio',

    Entrada = 'EN',
    DescripcionEntrada = 'Entrada',

    Escalera = 'ES',
    DescripcionEscalera = 'Escalera',

    Esquina = 'ESQ',
    DescripcionEsquina = 'Esquina',

    Este = 'ESTE',
    DescripcionEste = 'Este',

    Etapa = 'ET',
    DescripcionEtapa = 'Etapa',

    Exterior = 'EX',
    DescripcionExterior = 'Exterior',

    Finca = 'FCA',
    DescripcionFinca = 'Finca',

    Garaje = 'GJ',
    DescripcionGaraje = 'Garaje',

    GarajeSotano = 'GS',
    DescripcionGarajeSotano = 'Garaje sótano',

    Glorieta = 'GT',
    DescripcionGlorieta = 'Glorieta',

    Hacienda = 'HC',
    DescripcionHacienda = 'Hacienda',

    Hangar = 'HG',
    DescripcionHangar = 'Hangar',

    Interior = 'IN',
    DescripcionInterior = 'Interior',

    InspeccionDePolicia = 'IP',
    DescripcionInspeccionDePolicia = 'Inspección de Policía',

    InspeccionDepartamental = 'IPD',
    DescripcionInspeccionDepartamental = 'Inspección Departamental',

    InspeccionMunicipal = 'IPM',
    DescripcionInspeccionMunicipal = 'Inspección Municipal',

    Kilometro = 'KM',
    DescripcionKilometro = 'Kilómetro',

    Local = 'LC',
    DescripcionLocal = 'Local',

    LocalMezzanine = 'LM',
    DescripcionLocalMezzanine = 'Local mezzanine',

    Lote = 'LT',
    DescripcionLote = 'Lote',

    Modulo = 'MD',
    DescripcionModulo = 'Módulo',

    Mojon = 'MJ',
    DescripcionMojon = 'Mojón',

    Muelle = 'MLL',
    DescripcionMuelle = 'Muelle',

    Mezzanine = 'MN',
    DescripcionMezzanine = 'Mezzanine',

    Manzana = 'MZ',
    DescripcionManzana = 'Manzana',

    NombreVia = 'NOMBRE VIA',
    DescripcionNombreVia = 'Vías de nombre común',

    Norte = 'NORTE',
    DescripcionNorte = 'Norte',

    Oriente = 'O',
    DescripcionOriente = 'Oriente',

    Occidente = 'OCC',
    DescripcionOccidente = 'Occidente',

    Oeste = 'OESTE',
    DescripcionOeste = 'Oeste',

    Oficina = 'OF',
    DescripcionOficina = 'Oficina',

    Piso = 'P',
    DescripcionPiso = 'Piso',

    Parcela = 'PA',
    DescripcionParcela = 'Parcela',

    Parque = 'PAR',
    DescripcionParque = 'Parque',

    Predio = 'PD',
    DescripcionPredio = 'Predio',

    Penthouse = 'PH',
    DescripcionPenthouse = 'Penthouse',

    Pasaje = 'PJ',
    DescripcionPasaje = 'Pasaje',

    Planta = 'PL',
    DescripcionPlanta = 'Planta',

    Puente = 'PN',
    DescripcionPuente = 'Puente',

    Portería = 'POR',
    DescripcionPortería = 'Portería',

    Poste = 'POS',
    DescripcionPoste = 'Poste',

    Parqueadero = 'PQ',
    DescripcionParqueadero = 'Parqueadero',

    Paraje = 'PRJ',
    DescripcionParaje = 'Paraje',

    Paseo = 'PS',
    DescripcionPaseo = 'Paseo',

    Puesto = 'PT',
    DescripcionPuesto = 'Puesto',

    ParkWay = 'PW',
    DescripcionParkWay = 'Park Way',

    RoundPoint = 'RP',
    DescripcionRoundPoint = 'Round Point',

    Salon = 'SA',
    DescripcionSalon = 'Salón',

    SalonComunal = 'SC',
    DescripcionSalonComunal = 'Salón comunal',

    Salida = 'SD',
    DescripcionSalida = 'Salida',

    Sector = 'SEC',
    DescripcionSector = 'Sector',

    Solar = 'SL',
    DescripcionSolar = 'Solar',

    SúperManzana = 'SM',
    DescripcionSúperManzana = 'Súper manzana',

    Semisótano = 'SS',
    DescripcionSemisótano = 'Semisótano',

    Sótano = 'ST',
    DescripcionSotano = 'Sótano',

    Suite = 'SUITE',
    DescripcionSuite = 'Suite',

    Sur = 'SUR',
    DescripcionSur = 'Sur',

    Terminal = 'TER',
    DescripcionTerminal = 'Terminal',

    Terraplen = 'TERPLN',
    DescripcionTerraplen = 'Terraplén',

    Torre = 'TO',
    DescripcionTorre = 'Torre',

    Transversal = 'TV',
    DescripcionTransversal = 'Transversal',

    Terraza = 'TZ',
    DescripcionTerraza = 'Terraza',

    Unidad = 'UN',
    DescripcionUnidad = 'Unidad',

    UnidadResidencial = 'UR',
    DescripcionUnidadResidencial = 'Unidad residencial',

    Urbanizacion = 'URB',
    DescripcionUrbanizacion = 'Urbanización',

    Vereda = 'VRD',
    DescripcionVereda = 'Vereda',

    Variante = 'VTE',
    DescripcionVariante = 'Variante',

    ZonaFranca = 'ZF',
    DescripcionZonaFranca = 'Zona franca',

    Zona = 'ZN',
    DescripcionZona = 'Zona',
}

export enum EstadosCampanas {
    Ninguna = 0,
    DescripcionNinguna = "Ninguna",
    Abierta = 1,
    DescripcionAbierta = "Abierta",
    Lanzada = 2,
    DescripcionLanzada = "Lanzada",
    Cerrada = 3,
    DescripcionCerrada = "Cerrada"
}

export enum AgregarServicioHistoria {
    NoAgregarlo = 0,
    DescripcionNoAgregarlo = 'SERVICE_NOT_ADD',
    AgregarloSinCumplir = 1,
    DescripcionAgregarloSinCumplir = 'SERVICE_UNFULFILLED',
    AgregarloCumplidoFacturar = 2,
    DescripcionAgregarloCumplidoFacturar = 'SERVICE_CUMPLIMENT_INVOICE',
    AgregarloCumplidoNoFacturar = 3,
    DescripcionAgregarloCumplidoNoFacturar = 'SERVICE_CUMPLIMENT_UNBILLED',
    AgregarloSiministroExternoSinCumplir = 4,
    DescripcionAgregarloSiministroExternoSinCumplir = 'SERVICE_EXTERNAL_SUPPLY'
}

export enum TiposConsultaOportunidades {
    Detallado = 1,
    DescripcionDetallado = 'DETAILED',

    Indicadores = 2,
    DescripcionIndicadores = 'INDICATORS'
}
export enum TiposLibretaMilitar {
    SinLibretaMilitar = 0,
    DescripcionSinLibretaMilitar = 'NO_MILITARY_PASSBOOK',
    SegundaClase = 1,
    DescripcionSegundaClase = 'SECOND_CLASS',
    PrimeraClaseConTarjetaConducta = 2,
    DescripcionPrimeraClaseConTarjetaConducta = 'FIRST_CLASS_WITH_CARD',
    PrimeraClaseSinTarjetaConducta = 3,
    DescripcionPrimeraClaseSinTarjetaConducta = 'FIRST_CLASS_NOT_CARD'
}

export enum TiposUsuarios {
    Usuario = "U",
    DescripcionUsuario = "Usuario",

    Administrador = "A",
    DescripcionAdministrador = "Administrador",

    Invitado = "I",
    DescripcionInvitado = "Invitado"
}

export enum VisualizaPor {
    Producto = 1,
    DescripcionProducto = "Producto",
    Almacen = 2,
    DescripcionAlmacen = "Almacen",
    Marca = 3,
    DescripcionMarca = "Marca",
    Fabricante = 4,
    DescripcionFabricante = "Fabricante",
    Grupo = 5,
    DescripcionGrupo = "Grupo",
    UnidadNegocio = 6,
    DescripcionUnidadNegocio = "Unidad / Negocio",
    AlmacenProducto = 7,
    DescripcionAlmacenProducto = "Almacén / Producto",
    AlmacenGrupo = 8,
    DescripcionAlmacenGrupo = "Almacen / Grupo",
    GrupoSubGrupo = 9,
    DescripcionGrupoSubGrupo = "Grupo / SubGrupo"
}

export enum TipoDeclarante {
    Declarante = "S",
    DescripcionDeclarante = "LBL_DECLARANT",

    NoDeclarante = "N",
    DescripcionNoDeclarante = "LBL_NO_DECLARANT"
}

export enum ExportFormatType {
    NoFormat = 0,
    CrystalReport = 1,
    RichText = 2,
    WordForWindows = 3,
    Excel = 4,
    PortableDocFormat = 5,
    HTML32 = 6,
    HTML40 = 7,
    ExcelRecord = 8,
    Text = 9,
    CharacterSeparatedValues = 10,
    TabSeperatedText = 11,
    EditableRTF = 12,
    Xml = 13,
    RPTR = 14,
    ExcelWorkbook = 15,
    ImpresionRapida = 16
}

export enum TiposImpuestos {
    ImpuestoValorAgregado = 0,
    DescripcionImpuestoValorAgregado = 'CONSUMPTION_TAXES_DIAN.VALUE_ADDED_TAX',
    ImpuestoAlConsumoBolsaPlastica = 1,
    DescripcionImpuestoAlConsumoBolsaPlastica = 'CONSUMPTION_TAXES_DIAN.PLASTIC_BAG_CONSUMPTION_TAX',
    ImpuestoNacionalAlConsumo = 2,
    DescripcionImpuestoNacionalAlConsumo = 'CONSUMPTION_TAXES_DIAN.NATIONAL_CONSUMPTION_TAX',
    ImpuetoAlConsumo = 3,
    DescripcionImpuetoAlConsumo = 'CONSUMPTION_TAXES_DIAN.CONSUMPTION_TAX',
    ImpuestoAlConsumoDepartamental = 4,
    DescripcionImpuestoAlConsumoDepartamental = 'CONSUMPTION_TAXES_DIAN.DEPARTMENTAL_CONSUMPTION_TAX',
    ImpuestoNacionalCombustibles = 5,
    DescripcionImpuestoNacionalCombustibles = 'CONSUMPTION_TAXES_DIAN.NATIONAL_FUELS_TAX',
    ImpuestoAlConsumoDatos = 6,
    DescripcionImpuestoAlConsumoDatos = 'CONSUMPTION_TAXES_DIAN.DATA_EXCISE_TAX',
    ImpuestoAlConsumoLicores = 8,
    DescripcionImpuestoAlConsumoLicores = 'CONSUMPTION_TAXES_DIAN.EXCISE_TAX_ON_LIQUOR',
    ImpuestoNacionalProductosPlasticos = 9,
    DescripcionImpuestoNacionalProductosPlasticos = 'CONSUMPTION_TAXES_DIAN.NATIONAL_TAX_ON_PLASTIC_PRODUCTS',
    ImpuestoBebidasUltraprocesadas = 10,
    DescripcionImpuestoBebidasUltraprocesadas = 'CONSUMPTION_TAXES_DIAN.TAX_ON_ULTRA_PROCESSED_BEVERAGES',
    ImpuestoProductosComestiblesUltraprocesados = 11,
    DescripcionImpuestoProductosComestiblesUltraprocesados = 'CONSUMPTION_TAXES_DIAN.TAX_ON_ULTRA_PROCESSED_FOOD_PRODUCTS',
    OtrosImpuestos = 7,
    DescripcionOtrosImpuestos = 'CONSUMPTION_TAXES_DIAN.OTHER_TAX'
}

export enum ClasesImpuesto {
    Exento = 0,
    DescripcionExento = 'EXEMPT',
    Excluido = 1,
    DescripcionExcluido = 'EXCLUDED'
}


export enum AperturaConsultaDocumentos {
    CapturaRecibos = 1,
    CapturaEgresos = 2,
    CapturaDocumentos = 3
}
export enum TipoConsultaPivot {
    Detallado = 1,
    DescripcionDetallado = 'Detallado',

    Indicadores = 2,
    DescripcionIndicadores = 'Indicadores',

    IndicadoresAns = 3,
    DescripcionIndicadoresAns = 'Indicadores Ans',

}

export enum DimensionesPivot {
    TipoSolicitud = 1,
    DescripcionTipoSolicitud = 'Tipo Solicitud',

    Solicitud = 2,
    DescripcionSolicitud = 'Solicitud',

    Prioridad = 3,
    DescripcionPrioridad = 'Prioridad',

    Responsable = 4,
    DescripcionResponsable = 'Responsable',

    Area = 5,
    DescripcionArea = 'Area'
}

export enum MetricasPivot {
    Cantidad = 0,
    DescripcionCantidad = 'Cantidad',

    TiempoTrabajado = 1,
    DescripcionTiempoTrabajado = 'Tiempo Trabajado',

    TiempoParaFinalizar = 2,
    DescripcionTiempoParaFinalizar = 'Tiempo Para Finalizar'
}
export enum TipoCuentaCierre {
    CierreAnual = 0,
    DescripcionCierreAnual = 'Cierre anual',
    OtrosCierres = 1,
    DescripcionOtrosCierres = 'Otros cierres',
}

export enum ModoCuentaCierre {
    SaldoActualDelMes = 'S',
    DescripcionSaldoActualDelMes = 'Saldo actual del mes',
    DebitosCreditos = 'D',
    DescripcionDebitosCreditos = 'Debitos - Creditos',
    CreditosDebitos = 'C',
    DescripcionCreditosDebitos = 'Creditos - Debitos',
}
export enum CategoriasAlcanceGrupoSeguidores {
    Oportunidades = 1,
    DescripcionOportunidades = 'Oportunidades',

    Tareas = 2,
    DescripcionTareas = 'Tareas',

    Proyectos = 3,
    DescripcionProyectos = 'Proyectos',

    Solicitudes = 4,
    DescripcionSolicitudes = 'Solicitudes',

    Documentos = 5,
    DescripcionDocumentos = 'Documentos',

    Contenidos = 6,
    DescripcionContenidos = 'Contenidos'
}
export enum PresentacionesRecibos {
    DetallePagos = 0,
    DescripcionDetallePagos = 'PAYMENT_DETAILS',

    ResumenPorCliente = 1,
    DescripcionResumenPorCliente = 'SUMMARY_BY_CUSTOMER_BILLING',

    ResumenPorClienteDePago = 2,
    DescripcionResumenPorClienteDePago = 'SUMMARY_BY_CUSTOMER_OF_PAYMENT'
}
export enum OpcionesGeneracionResolucion256 {
    OportunidadCitas = 1,
    DescripcionOportunidadCitas = 'RESOLUTION_256_TYPE_2',
    ProgramacionQx = 2,
    DescripcionProgramacionQx = 'RESOLUTION_256_TYPE_4'
}

export enum TipoRegistroTransporte {
    ServicioAdicional = 0,
    DescripcionServicioAdicional = 'LBL_ADDITIONAL_SERVICE',
    RemesaTransporteRNDC = 1,
    DescripcionRemesaTransporteRNDC = 'LBL_RNDC_TRANSPORT_SHIPMENT'
}

export enum PresentacionOtrasTransaccionesItem {
    General,
    SectorSalud,
    SectorTransporte
}

export enum UnidadesMedidaTransporteCarga {
    kilogramos = 'KGM',
    Galones = 'GLL'
}

export enum ModoContabilizarActivosFijos {
    Detallado = 0,
    DescripcionDetallado = 'DEPRECIATION_OF_ASSETS_COMPONENT.LBL_DETAILED_BY_ASSET',
    CentroDeCosto = 1,
    DescripcionCentroCosto = 'DEPRECIATION_OF_ASSETS_COMPONENT.LBL_BY_COST_CENTER'
}

// Enumeracion la cual se toma como referencia en productos para la facturacion de historias clinicas de ISS
export enum TipoSalaComponenteISS {
    DescripcionComponenteSalaPartoISS = 'SURGICAL_COMPONENT_BIRTHS',
    ComponenteSalaPartoISS = 0,

    DescripcionComponenteSalaEspecialISS = 'SURGICAL_COMPONENT_SPECIAL_PROCEDURE',
    ComponenteSalaEspecialISS = 1,

    DescripcionComponenteSalaEndoscopiaISS = 'SURGICAL_COMPONENT_ENDOSCOPY',
    ComponenteSalaEndoscopiaISS = 2,

    DescripcionComponenteSalaISS = 'LBL_SURGICAL_COMPONENT_ROOM_ISS',
    ComponenteSalaISS = 3,

    DescripcionComponenteSalaCuracionesISS = 'SURGICAL_COMPONENT_CURES',
    ComponenteSalaCuracionesISS = 4,

    DescripcionComponenteSalaObservacionBajoNivelISS = 'SURGICAL_COMPONENT_OBSERVATION_LOW_LEVEL',
    ComponenteSalaObservacionBajoNivelISS = 5,

    DescripcionComponenteSalaObservacionMedioNivelISS = 'SURGICAL_COMPONENT_OBSERVATION_MEDIUM_LEVEL',
    ComponenteSalaObservacionMedioNivelISS = 6,

    DescripcionComponenteSalaObservacionAltoNivelISS = 'SURGICAL_COMPONENT_OBSERVATION_HIGH_LEVEL',
    ComponenteSalaObservacionAltoNivelISS = 7,

    DescripcionComponenteSalaRecuperacionBajoNivelISS = 'SURGICAL_COMPONENT_RECOVERY_LOW_LEVEL',
    ComponenteSalaRecuperacionBajoNivelISS = 8,

    DescripcionComponenteSalaRecuperacionMedioNivelISS = 'SURGICAL_COMPONENT_RECOVERY_MEDIUM_LEVEL',
    ComponenteSalaRecuperacionMedioNivelISS = 9,

    DescripcionComponenteSalaRecuperacionAltoNivelISS = 'SURGICAL_COMPONENT_RECOVERY_HIGH_LEVEL',
    ComponenteSalaRecuperacionAltoNivelISS = 10
}

export enum DestinoEjecucion {
    Pantalla = 0,
    DescripcionPantalla = "LBL_SCREEN",

    Csv = 1,
    DescripcionCsv = "EXPORT_FILE_CSV"
}

export enum FiltrarRotacionPor {
    Producto = 0,
    DescripcionProducto = "LBL_PRODUCT",

    ProductoSimilar = 1,
    DescripcionProductoSimilar = "LBL_SIMILAR_PRODUCT"
}

export enum TipoDocumentoRecepcionado {
    FacturaVenta = '01',
    DescripcionFacturaVenta = "INVOICE_SALES",

    FacturaExportacion = '02',
    DescripcionFacturaExportacion = "LBL_EXPORT_INVOICE",

    FacturaContingenciaFacturador = '03',
    DescripcionFacturaContingenciaFacturador = "LBL_CONTINGENCY_INVOICE_BILLER",

    FacturaContingenciaDian = '04',
    DescripcionFacturaContingenciaDian = "LBL_DIAN_CONTINGENCY_INVOICE",
}

export enum ResultadoEnvioNominaElectronica {
    ConCune = 1,
    DescripcionConCune = "RECORD_ELECTRONIC_PAYROLL.WITH_CUNE",

    SinCune = 2,
    DescripcionSinCune = "RECORD_ELECTRONIC_PAYROLL.WITHOUT_CUNEUS_AND_WITH_ERROR"
}

export enum TipoCaja {
    CajaMenor = 0,
    CajaGeneral = 1,
    RelacionDeGastos = 2
}

export enum OrigenSolcitudAlertaCupo {
    CambioEstado,
    Documentos
}

export enum PresentacionesSeguimientoCartera {
    DetalladoPorCliente = 0,
    DescripcionDetalladoPorCliente = "DETAILED_BY_CUSTOMER",
    ResumenPorCliente = 1,
    DescripcionResumenPorCliente = "SUMMARY_BY_CUSTOMER",
    DisponibilidadDeCupos = 2,
    DescripcionDisponibilidadDeCupos = "AVAILABLE_OF_QUOTAS",
    ResumenPorCiudadCliente = 3,
    DescripcionResumenPorCiudadCliente = "SUMMARY_BY_CITY_CLIENT",
    ResumenPorCiudadSucursal = 4,
    DescripcionResumenPorCiudadSucursal = "SUMMARY_BY_CITY_BRANCH",
    ResumenPorCentroDeCosto = 5,
    DescripcionResumenPorCentroDeCosto = "SUMMARY_BY_COST_CENTER",
    ResumenPorTipoCliente = 6,
    DescripcionResumenPorTipoCliente = "SUMMARY_BY_CUSTOMER_TYPE",
    ResumenPorClasificacionCliente = 7,
    DescripcionResumenPorClasificacionCliente = "SUMMARY_BY_CUSTOMER_CLASSIFICATION",
    ResumenPorRegion = 8,
    DescripcionResumenPorRegion = "SUMMARY_BY_REGION",
    ResumenPorCategoriaCliente = 9,
    DescripcionResumenPorCategoriaCliente = "SUMMARY_BY_CLIENT_CATEGORY",
    ResumenPorEstado = 10,
    DescripcionResumenPorEstado = "SUMMARY_BY_STATUS"
}
export enum SubCarpetaInterfazDocumento {
    SubirArchivo = 0,
    DescripcionSubirArchivo = 'MESSAGE_INTERFAZ_DOCUMENTO.LBL_FOLDER_UPLOAD_FILE',
    GenerarDocumentos = 1,
    DescripcionGenerarDocumentos = 'MESSAGE_INTERFAZ_DOCUMENTO.LBL_FOLDER_GENERATE_DOCUMENT'
}

export enum TriageHistoriaClinica {
    Triage1 = '01',
    DescripcionTriage1 = "01-Triage I",
    Triage2 = '02',
    DescripcionTriage2 = "02-Triage II",
    Triage3 = '03',
    DescripcionTriage3 = "03-Triage III",
    Triage4 = '04',
    DescripcionTriage4 = "04-Triage IV",
    Triage5 = '05',
    DescripcionTriage5 = "05-Triage V",
}

//#region Escala Glasgow
export enum EscalaValoracionAperturaOcular {
    Ninguna = 1,
    DescripcionNinguna = "GLASGOW.NONE",
    EstimuloDoloroso = 2,
    DescripcionEstimuloDoloroso = "GLASGOW.PAINFUL_STIMULUS",
    EstimuloVerbal = 3,
    DescripcionEstimuloVerbal = "GLASGOW.VERBAL_STIMULUS",
    Espontanea = 4,
    DescripcionEspontanea = "GLASGOW.SPONTANEA"
}

export enum EscalaValoracionRespuestaVerbal {
    Ninguna = 1,
    DescripcionNinguna = "GLASGOW.NONE",
    SonidosIncomprensibles = 2,
    DescripcionSonidosIncomprensibles = "GLASGOW.INCOMPREHENSIBLE_SOUNDS",
    PalabrasInadecuadas = 3,
    DescripcionPalabrasInadecuadas = "GLASGOW.INAPPROPRIATE_WORDS",
    Confusa = 4,
    DescripcionConfusa = "GLASGOW.CONFUSED",
    Orientada = 5,
    DescripcionOrientada = "GLASGOW.ORIENTED"
}
export enum EscalaValoracionRespuestaMotora {
    Ninguna = 1,
    DescripcionNinguna = "GLASGOW.NONE",
    ExtensionHiperbolica = 2,
    DescripcionExtensionHiperbolica = "GLASGOW.HYPERTONIC_EXTENSION",
    FlexionHipertonica = 3,
    DescripcionFlexionHipertonica = "GLASGOW.HYPERTONIC_BENDING",
    MovimientoRetirada = 4,
    DescripcionMovimientoRetirada = "GLASGOW.WITHDRAWAL_MOVEMENT",
    LocalizaDolor = 5,
    DescripcionLocalizaDolor = "GLASGOW.LOCATE_PAIN",
    ObedeceOrdenes = 6,
    DescripcionObedeceOrdenes = "GLASGOW.OBEYS_ORDERS"
}
//#endregion

export enum OpcionesContabilizarDocumentosIntereses {
    NoContabilizar = 0,
    DescripcionNoContabilizar = 'LBL_NOT_ASSESS',
    ProgramarContabilizacion = 1,
    DescripcionProgramarContabilizacion = 'QUERY_DOCUMENTS_ALERTS.PROGRAM_ACCOUNTING',
    Contabilizar = 2,
    DescripcionContabilizar = 'LBL_IMMEDIATELY_ACCOUNT'
}

export enum TipoConsultorio {
    DescripcionConsultorio = "Consultorio",
    Consultorio = 0,

    DescripcionCamilla = "Camilla",
    Camilla = 1,

    DescripcionCama = "Cama",
    Cama = 2
}

export enum TipoApertutaFurips {
    Furips,
    HistoriasClinicas
}

export enum OrigenAdjuntarReporteGenerado {
    HistoriaClinica,
    CitaMedica,
    IngresoPaciente
}


export enum UnidadDeMedidaIndicadoresTiposServicios {
    DiasCalendario = 0,
    DescripcionDiasCalendario = 'LBL_DAYS_CALENDAR',

    Porcentaje = 1,
    DescripcionPorcentaje = "PERCENTAGE",

    Minutos = 2,
    DescripcionMinutos = "LBL_MINUTES",

    TasaPorMil = 3,
    DescripcionTasaPorMil = "LBL_RATE_X_THOUSAND",

    TasaPorCien = 4,
    DescripcionTasaPorCien = "LBL_RATE_X_ONEHUNDRED"
}

export enum EstadoDiferidos {
    AmortizacionPendiente = 'AP',
    DescripcionAmortizacionPendiente = 'PENDING_AMORTIZATION',

    Finalizados = 'F',
    DescripcionFinalizados = "FINALIZED",

    Todos = 'T',
    DescripcionTodos = "LABEL_ALL_PLURAL",
}

export enum MesesEnum {
    Enero = 1,
    DescripcionEnero = 'MONTH_1',
    Febrero = 2,
    DescripcionFebrero = 'MONTH_2',
    Marzo = 3,
    DescripcionMarzo = 'MONTH_3',
    Abril = 4,
    DescripcionAbril = 'MONTH_4',
    Mayo = 5,
    DescripcionMayo = 'MONTH_5',
    Junio = 6,
    DescripcionJunio = 'MONTH_6',
    Julio = 7,
    DescripcionJulio = 'MONTH_7',
    Agosto = 8,
    DescripcionAgosto = 'MONTH_8',
    Septiembre = 9,
    DescripcionSeptiembre = 'MONTH_9',
    Octubre = 10,
    DescripcionOctubre = 'MONTH_10',
    Noviembre = 11,
    DescripcionNoviembre = 'MONTH_11',
    Diciembre = 12,
    DescripcionDiciembre = 'MONTH_12',
}

export enum TipoAtencionIngresoPaciente {
    PrimeraVez = '0',
    DescripcionPrimeraVez = 'FIRST_TIME',

    ReIngreso = '1',
    DescripcionReIngreso = 'RE_ENTRY',

    Remitido = '2',
    DescripcionRemitido = 'REFERRAL',

    OrdenDeServicio = '3',
    DescripcionOrdenDeServicio = 'SERVICE_ORDER',

    Tiempo = 'T',
    DescripcionTiempo = 'LBL_TIME'
}

//Enumeracion la cual se utiliza para establecer
//Enumeracion la cual se utiliza para establecer
//la forma de atencion de los ordenamientos de la historia clinica
export enum TipoPrestacionServicioHistoria {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',
    Intrahospitalario = 1,
    DescripcionIntrahospitalario = 'INPATIENT',
    Ambulatorio = 2,
    DescripcionAmbulatorio = 'AMBULATORY',
    Ambos = 3,
    DescripcionAmbos = 'LBL_CONFIG_PROJ_PED'
}


export enum ClasesCodigoGlosa {
    Glosa = 0,
    DescripcionGlosa = 'LBL_GLOSS',

    Devolucion = 1,
    DescripcionDevolucion = 'RETURN',

    Respuesta = 2,
    DescripcionRespuesta = 'LBL_RESPONSE'
}


export enum ClaseReferencia {
    Referencia = 0,
    DescripcionReferencia = 'LBL_REFERRAL',
    ContraReferencia = 1,
    DescripcionContraReferencia = 'COUNTERREFERRAL',
    OrdenDeServicio = 2,
    DescripcionOrdenDeServicio = 'SERVICE_ORDER'
}

export enum PrioridadSalud {
    Prioritaria = 1,
    DescripcionPrioritaria = 'PRIORITY',
    NoPrioritaria = 2,
    DescripcionNoPrioritaria = 'NOT_PRIORITY'
}

export enum TipoAtencionsolicitada {
    PostUrgencia = 1,
    DescripcionPostUrgencia = 'TECH_SERVICES_POST_EMERGENCY',
    AtenPrioritaria = 2,
    DescripcionAtenPrioritaria = 'TECH_SERVICES_PRIORITY_ATTENTION',
    ElecOProgramNoPrioritaria = 3,
    DescripcionElecOProgramNoPrioritaria = 'TECH_SERVICES_ELECTIVES_NOT_PRIORITY'
}

export enum ModalidadTecnologiaSalud {
    Intramural = 1,
    DescripcionIntramural = 'LBL_INTRAMURAL',
    ExtramuralUnidMovil = 2,
    DescripcionExtramuralUnidMovil = 'LBL_EXTRATRAMURAL_UNIT_MOBILE',
    ExtramuralDomic = 3,
    DescripcionExtramuralDomic = 'LBL_EXTRAMURAL_DOMICILIARY',
    ExtramuralSalud = 4,
    DescripcionExtramuralSalud = 'LBL_EXTRAMURAL_HEALTH_DAY',
    TelemedicinaInterac = 6,
    DescripcionTelemedicinaInterac = 'TELEMEDICINE_INTERACTIVE',
    TelemedicinaNoInterac = 7,
    DescripcionTelemedicinaNoInterac = 'TELEMEDICINE_NOT_INTERACTIVE',
    TelemedicinaTelex = 8,
    DescripcionTelemedicinaTelex = 'TELEMEDICINE_TELEEXPERTISE',
    TelemedicinaTelemon = 9,
    DescripcionTelemedicinaTelemon = 'TELEMEDICINE_TELEMONITORING'
}

export enum GrupoServicios {
    ConsultaExterna = 1,
    DescripcionConsultaExterna = 'SLD_EXTERNAL_CONSULTATION',
    DiagnosticoComplement = 2,
    DescripcionDiagnosticoComplement = 'SUPPORT_DIAGNOSIS_AND_THERAPEUTIC',
    Internacion = 3,
    DescripcionInternacion = 'INTERACTION',
    Quirurgico = 4,
    DescripcionQuirurgico = 'SURGICAL',
    AtencionInmediata = 5,
    DescripcionAtencionInmediata = 'IMMEDIATE_ATTENTION',
}
export enum Ordenamientos {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',

    ConsultaDeControl = 1,
    DescripcionConsultaDeControl = 'GENERAL_CONSULTATION_OR_CONTROL',

    Laboratorio = 2,
    DescripcionLaboratorio = 'LABORATORY',

    InterConsulta = 3,
    DescripcionInterConsulta = 'INTERCONSULTATION',

    ExamenesDiagnosticas = 4,
    DescripcionExamenesDiagnosticas = 'X_RAY',

    ProcedimientosQuirurgicos = 5,
    DescripcionProcedimientosQuirurgicos = 'SURGERY',

    Terapias = 6,
    DescripcionTerapias = 'THERAPIES',

    OtrosServicios = 7,
    DescripcionOtrosServicios = 'LBL_OTHER_SERVICES'
}
//#region CodservicioRips segun la tabla de referencia: https://web.sispro.gov.co/WebPublico/Consultas/ConsultarDetalleReferenciaBasica.aspx?Code=Servicios
export enum ServicioConsultaExterna {
    Anestesia = 301,
    DescripcionAnestesia = 'CA_ANESTHESIA',
    Cardiologia = 302,
    DescripcionCardiologia = 'CA_CARDIOLOGY',
    CirugiaCardiovascular = 303,
    DescripcionCirugiaCardiovascular = 'CA_CARDIOVASCULAR_SURGERY',
    CirugiaGeneral = 304,
    DescripcionCirugiaGeneral = 'CA_GENERAL_SURGERY',
    CirugiaPediatrica = 306,
    DescripcionCirugiaPediatrica = 'CA_PEDIATRIC_SURGERY',
    Dermatologia = 308,
    DescripcionDermatologia = 'CA_DERMATOLOGY',
    DolorYCuidadosPaliativos = 309,
    DescripcionDolorYCuidadosPaliativos = 'CA_PAIN_AND_PALLIATIVE_CARE',
    Endocrinologia = 310,
    DescripcionEndocrinologia = 'CA_ENDOCRINOLOGY',
    Endodoncia = 311,
    DescripcionEndodoncia = 'CA_ENDODONTICS',
    Enfermeria = 312,
    DescripcionEnfermeria = 'CA_NURSING',
    Estomatologia = 313,
    DescripcionEstomatologia = 'CA_STOMATOLOGY',
    Gastroenterologia = 316,
    DescripcionGastroenterologia = 'CA_GASTROENTEROLOGY',
    Genetica = 317,
    DescripcionGenetica = 'CA_GENETICS',
    Geriatria = 318,
    DescripcionGeriatria = 'CA_GERIATRICS',
    Ginecobstetricia = 320,
    DescripcionGinecobstetricia = 'CA_OBSTETRICS_AND_GYNECOLOGY',
    Hematologia = 321,
    DescripcionHematologia = 'CA_HEMATOLOGY',
    Infectologia = 323,
    DescripcionInfectologia = 'CA_INFECTOLOGY',
    Inmunologia = 324,
    DescripcionInmunologia = 'CA_IMMUNOLOGY',
    MedicinaFamiliar = 325,
    DescripcionMedicinaFamiliar = 'CA_FAMILY_MEDICINE',
    MedicinaFisicaYDelDeporte = 326,
    DescripcionMedicinaFisicaYDelDeporte = 'CA_PHYSICAL_AND_SPORTS_MEDICINE',
    MedicinaFisicaYRehabilitacion = 327,
    DescripcionMedicinaFisicaYRehabilitacion = 'CA_PHYSICAL_AND_REHABILITATION_MEDICINE',
    MedicinaGeneral = 328,
    DescripcionMedicinaGeneral = 'CA_GENERAL_MEDICINE',
    MedicinaInterna = 329,
    DescripcionMedicinaInterna = 'CA_INTERNAL_MEDICINE',
    Nefrologia = 330,
    DescripcionNefrologia = 'CA_NEPHROLOGY',
    Neumologia = 331,
    DescripcionNeumologia = 'CA_PNEUMOLOGY',
    Neurologia = 332,
    DescripcionNeurologia = 'CA_NEUROLOGY',
    NutricionYDietetica = 333,
    DescripcionNutricionYDietetica = 'CA_NUTRITION_AND_DIETETICS',
    OdontologiaGeneral = 334,
    DescripcionOdontologiaGeneral = 'CA_GENERAL_DENTISTRY',
    Oftalmologia = 335,
    DescripcionOftalmologia = 'CA_OPHTHALMOLOGY',
    OncologiaClinica = 336,
    DescripcionOncologiaClinica = 'CA_CLINICAL_ONCOLOGY',
    Optometria = 337,
    DescripcionOptometria = 'CA_OPTOMETRY',
    Ortodoncia = 338,
    DescripcionOrtodoncia = 'CA_ORTHODONTICS',
    OrtopediaOTraumatologia = 339,
    DescripcionOrtopediaOTraumatologia = 'CA_ORTHOPEDICS_AND_TRAUMATOLOGY',
    Otorrinolaringologia = 340,
    DescripcionOtorrinolaringologia = 'CA_OTORHINOLARYNGOLOGY',
    Pediatria = 342,
    DescripcionPediatria = 'CA_PEDIATRICS',
    Periodoncia = 343,
    DescripcionPeriodoncia = 'CA_PERIODONTICS',
    Psicologia = 344,
    DescripcionPsicologia = 'CA_PSYCHOLOGY',
    Psiquiatria = 345,
    DescripcionPsiquiatria = 'CA_PSYCHIATRY',
    RehabilitacionOncologica = 346,
    DescripcionRehabilitacionOncologica = 'CA_ONCOLOGICAL_REHABILITATION',
    RehabilitacionOral = 347,
    DescripcionRehabilitacionOral = 'CA_ORAL_REHABILITATION',
    Reumatologia = 348,
    DescripcionReumatologia = 'CA_RHEUMATOLOGY',
    Toxicologia = 354,
    DescripcionToxicologia = 'CA_TOXICOLOGY',
    Urologia = 355,
    DescripcionUrologia = 'CA_UROLOGY',
    OtrasConsultasDeEspecialidad = 356,
    DescripcionOtrasConsultasDeEspecialidad = 'CA_OTHER_SPECIALTY_CONSULTATIONS',
    CardiologiaPediatrica = 361,
    DescripcionCardiologiaPediatrica = 'CA_PEDIATRIC_CARDIOLOGY',
    CirugiaDeCabezaYCuello = 362,
    DescripcionCirugiaDeCabezaYCuello = 'CA_HEAD_AND_NECK_SURGERY',
    CirugiaDeMano = 363,
    DescripcionCirugiaDeMano = 'CA_HAND_SURGERY',
    CirugiaDeMamaYTumoresTejidosBlandos = 364,
    DescripcionCirugiaDeMamaYTumoresTejidosBlandos = 'CA_BREAST_AND_SOFT_TISSUE_TUMORS_SURGERY',
    CirugiaDermatologica = 365,
    DescripcionCirugiaDermatologica = 'CA_DERMATOLOGICAL_SURGERY',
    CirugiaDeTorax = 366,
    DescripcionCirugiaDeTorax = 'CA_THORACIC_SURGERY',
    CirugiaGastrointestinal = 367,
    DescripcionCirugiaGastrointestinal = 'CA_GASTROINTESTINAL_SURGERY',
    CirugiaGinecologicaLaparoscopica = 368,
    DescripcionCirugiaGinecologicaLaparoscopica = 'CA_GYNECOLOGICAL_LAPAROSCOPIC_SURGERY',
    CirugiaPlasticaYEstetica = 369,
    DescripcionCirugiaPlasticaYEstetica = 'CA_PLASTIC_AND_AESTHETIC_SURGERY',
    CirugiaPlasticaOncologica = 370,
    DescripcionCirugiaPlasticaOncologica = 'CA_ONCOLOGICAL_PLASTIC_SURGERY',
    OtrasConsultasGenerales = 371,
    DescripcionOtrasConsultasGenerales = 'CA_OTHER_GENERAL_CONSULTATIONS',
    CirugiaVascular = 372,
    DescripcionCirugiaVascular = 'CA_VASCULAR_SURGERY',
    CirugiaOncologica = 373,
    DescripcionCirugiaOncologica = 'CA_ONCOLOGICAL_SURGERY',
    CirugiaOncologicaPediatrica = 374,
    DescripcionCirugiaOncologicaPediatrica = 'CA_PEDIATRIC_ONCOLOGICAL_SURGERY',
    DermatologiaOncologica = 375,
    DescripcionDermatologiaOncologica = 'CA_ONCOLOGICAL_DERMATOLOGY',
    Coloproctologia = 377,
    DescripcionColoproctologia = 'CA_COLOPROCTOLOGY',
    GinecologiaOncologica = 379,
    DescripcionGinecologiaOncologica = 'CA_ONCOLOGICAL_GYNECOLOGY',
    MedicinaNuclear = 383,
    DescripcionMedicinaNuclear = 'CA_NUCLEAR_MEDICINE',
    NefrologiaPediatrica = 384,
    DescripcionNefrologiaPediatrica = 'CA_PEDIATRIC_NEPHROLOGY',
    Neonatologia = 385,
    DescripcionNeonatologia = 'CA_NEONATOLOGY',
    NeumologiaPediatrica = 386,
    DescripcionNeumologiaPediatrica = 'CA_PEDIATRIC_PNEUMOLOGY',
    Neurocirugia = 387,
    DescripcionNeurocirugia = 'CA_NEUROSURGERY',
    Neuropediatria = 388,
    DescripcionNeuropediatria = 'CA_NEUROPEDIATRY',
    OftalmologiaOncologica = 390,
    DescripcionOftalmologiaOncologica = 'CA_OPHTHALMOLOGY_ONCOLOGY',
    OncologiaYHematologiaPediatrica = 391,
    DescripcionOncologiaYHematologiaPediatrica = 'CA_PEDIATRIC_ONCOLOGY_AND_HEMATOLOGY',
    OrtopediaOncologica = 393,
    DescripcionOrtopediaOncologica = 'CA_ONCOLOGICAL_ORTHOPEDICS',
    UrologiaOncologica = 395,
    DescripcionUrologiaOncologica = 'CA_ONCOLOGICAL_UROLOGY',
    Odontopediatria = 396,
    DescripcionOdontopediatria = 'CA_PEDIATRIC_DENTISTRY',
    MedicinaEstetica = 397,
    DescripcionMedicinaEstetica = 'CA_AESTHETIC_MEDICINE',
    HematologiaOncologica = 406,
    DescripcionHematologiaOncologica = 'CA_ONCOLOGICAL_HEMATOLOGY',
    MedicinaDelTrabajoYMedicinaLaboral = 407,
    DescripcionMedicinaDelTrabajoYMedicinaLaboral = 'CA_WORK_AND_OCCUPATIONAL_MEDICINE',
    Radioterapia = 408,
    DescripcionRadioterapia = 'CA_RADIOTHERAPY',
    OrtopediaPediatrica = 409,
    DescripcionOrtopediaPediatrica = 'CA_PEDIATRIC_ORTHOpedics',
    CirugiaOral = 410,
    DescripcionCirugiaOral = 'CA_ORAL_SURGERY',
    CirugiaMaxilofacial = 411,
    DescripcionCirugiaMaxilofacial = 'CA_MAXILLOFACIAL_SURGERY',
    MedicinaAlternativaYComplementariaHomeopatica = 412,
    DescripcionMedicinaAlternativaYComplementariaHomeopatica = 'CA_HOMEOPATHIC_COMPLEMENTARY_MEDICINE',
    MedicinaAlternativaYComplementariaAyurvedica = 413,
    DescripcionMedicinaAlternativaYComplementariaAyurvedica = 'CA_AYURVEDIC_COMPLEMENTARY_MEDICINE',
    MedicinaAlternativaYComplementariaTradicionalChina = 414,
    DescripcionMedicinaAlternativaYComplementariaTradicionalChina = 'CA_TRADITIONAL_CHINESE_COMPLEMENTARY_MEDICINE',
    MedicinaAlternativaYComplementariaNaturopatica = 415,
    DescripcionMedicinaAlternativaYComplementariaNaturopatica = 'CA_NATUROPATHIC_COMPLEMENTARY_MEDICINE',
    MedicinaAlternativaYComplementariaNeuralterapeutica = 416,
    DescripcionMedicinaAlternativaYComplementariaNeuralterapeutica = 'CA_NEURAL_THERAPEUTIC_COMPLEMENTARY_MEDICINE',
    TerapiasAlternativasYComplementariasBioenergetica = 417,
    DescripcionTerapiasAlternativasYComplementariasBioenergetica = 'CA_BIOENERGETICS_COMPLEMENTARY_THERAPIES',
    TerapiasAlternativasYComplementariasTerapiaConFiltros = 418,
    DescripcionTerapiasAlternativasYComplementariasTerapiaConFiltros = 'CA_FILTER_THERAPY_COMPLEMENTARY_THERAPIES',
    TerapiasAlternativasYComplementariasTerapiasManuales = 419,
    DescripcionTerapiasAlternativasYComplementariasTerapiasManuales = 'CA_MANUAL_THERAPIES_COMPLEMENTARY_THERAPIES',
    Vacunacion = 420,
    DescripcionVacunacion = 'CA_VACCINATION',
    Patologia = 421,
    DescripcionPatologia = 'CA_PATHOLOGY',
    MedicinaAlternativaYComplementariaOsteopatica = 422,
    DescripcionMedicinaAlternativaYComplementariaOsteopatica = 'CA_OSTEOPATHIC_COMPLEMENTARY_MEDICINE',
    SeguridadYSaludEnElTrabajo = 423,
    DescripcionSeguridadYSaludEnElTrabajo = 'CA_WORKPLACE_HEALTH_AND_SAFETY',
}

export enum ServicioDiagnostico {
    LaboratorioClinico = 706,
    DescripcionLaboratorioClinico = 'AD_CLINICAL_LABORATORY',
    Quimioterapia = 709,
    DescripcionQuimioterapia = 'AD_CHEMOTHERAPY',
    Radioterapia = 711,
    DescripcionRadioterapia = 'AD_RADIOTHERAPY',
    TomaDeMuestrasDeLaboratorioClinico = 712,
    DescripcionTomaDeMuestrasDeLaboratorioClinico = 'AD_CLINICAL_LABORATORY_SAMPLE_COLLECTION',
    ServicioFarmaceutico = 714,
    DescripcionServicioFarmaceutico = 'AD_PHARMACEUTICAL_SERVICE',
    MedicinaNuclear = 715,
    DescripcionMedicinaNuclear = 'AD_NUCLEAR_MEDICINE',
    LaboratorioCitologiasCervicoUterinas = 717,
    DescripcionLaboratorioCitologiasCervicoUterinas = 'AD_CYTOLOGY_CERVICO-UTERINE_LABORATORY',
    TerapiaOcupacional = 728,
    DescripcionTerapiaOcupacional = 'AD_OCCUPATIONAL_THERAPY',
    TerapiaRespiratoria = 729,
    DescripcionTerapiaRespiratoria = 'AD_RESPIRATORY_THERAPY',
    LaboratorioDeHistotecnologia = 731,
    DescripcionLaboratorioDeHistotecnologia = 'AD_HISTOTECHNOLOGY_LABORATORY',
    Hemodialisis = 733,
    DescripcionHemodialisis = 'AD_HEMODIALYSIS',
    DialisisPeritoneal = 734,
    DescripcionDialisisPeritoneal = 'AD_PERITONEAL_DIALYSIS',
    Fisioterapia = 739,
    DescripcionFisioterapia = 'AD_PHYSIOTHERAPY',
    FonoaudiologiaOTerapiaDelLenguaje = 740,
    DescripcionFonoaudiologiaOTerapiaDelLenguaje = 'AD_SPEECH_THERAPY',
    DiagnosticoVascular = 742,
    DescripcionDiagnosticoVascular = 'AD_VASCULAR_DIAGNOSIS',
    HemodinamiaEIntervencionismo = 743,
    DescripcionHemodinamiaEIntervencionismo = 'AD_HEMODYNAMICS_AND_INTERVENTIONAL',
    ImagenesDiagnosticasIonizantes = 744,
    DescripcionImagenesDiagnosticasIonizantes = 'AD_DIAGNOSTIC_IMAGING_IONIZING',
    ImagenesDiagnosticasNoIonizantes = 745,
    DescripcionImagenesDiagnosticasNoIonizantes = 'AD_DIAGNOSTIC_IMAGING_NON_IONIZING',
    GestionPreTransfusional = 746,
    DescripcionGestionPreTransfusional = 'AD_PRE-TRANSFUSION_MANAGEMENT',
    Patologia = 747,
    DescripcionPatologia = 'AD_PATHOLOGY',
    RadiologiaOdontologica = 748,
    DescripcionRadiologiaOdontologica = 'AD_DENTAL_RADIOLOGY',
    TomaDeMuestrasDeCuelloUterinoYGinecologicas = 749,
    DescripcionTomaDeMuestrasDeCuelloUterinoYGinecologicas = 'AD_CERVICAL_AND_GYNECOLOGICAL_SAMPLE_COLLECTION',

}

export enum ServicioInternacion {
    CuidadoIntermedioNeonatal = 105,
    DescripcionCuidadoIntermedioNeonatal = 'I_INTERMEDIATE_CARE_NEONATAL',
    CuidadoIntermedioPediatrico = 106,
    DescripcionCuidadoIntermedioPediatrico = 'I_INTERMEDIATE_CARE_PEDIATRIC',
    CuidadoIntermedioAdultos = 107,
    DescripcionCuidadoIntermedioAdultos = 'I_INTERMEDIATE_CARE_ADULTS',
    CuidadoIntensivoNeonatal = 108,
    DescripcionCuidadoIntensivoNeonatal = 'I_INTENSIVE_CARE_NEONATAL',
    CuidadoIntensivoPediatrico = 109,
    DescripcionCuidadoIntensivoPediatrico = 'I_INTENSIVE_CARE_PEDIATRIC',
    CuidadoIntensivoAdultos = 110,
    DescripcionCuidadoIntensivoAdultos = 'I_INTENSIVE_CARE_ADULTS',
    CuidadoBasicoNeonatal = 120,
    DescripcionCuidadoBasicoNeonatal = 'I_BASIC_NEONATAL_CARE',
    HospitalizacionAdultos = 129,
    DescripcionHospitalizacionAdultos = 'I_HOSPITALIZATION_ADULTS',
    HospitalizacionPediatrica = 130,
    DescripcionHospitalizacionPediatrica = 'I_HOSPITALIZATION_PEDIATRIC',
    HospitalizacionEnSaludMental = 131,
    DescripcionHospitalizacionEnSaludMental = 'I_HOSPITALIZATION_MENTAL_HEALTH',
    HospitalizacionParcial = 132,
    DescripcionHospitalizacionParcial = 'I_PARTIAL_HOSPITALIZATION',
    HospitalizacionPacienteCronicoConVentilador = 133,
    DescripcionHospitalizacionPacienteCronicoConVentilador = 'I_HOSPITALIZATION_PATIENT_WITH_VENTILATOR',
    HospitalizacionPacienteCronicoSinVentilador = 134,
    DescripcionHospitalizacionPacienteCronicoSinVentilador = 'I_HOSPITALIZATION_PATIENT_WITHOUT_VENTILATOR',
    HospitalizacionEnConsumoDeSustanciasPsicoactivas = 135,
    DescripcionHospitalizacionEnConsumoDeSustanciasPsicoactivas = 'I_HOSPITALIZATION_SUBSTANCE_ABUSE',
    CuidadoBasicoDelConsumoDeSustanciasPsicoactivas = 138,
    DescripcionCuidadoBasicoDelConsumoDeSustanciasPsicoactivas = 'I_BASIC_SUBSTANCE_ABUSE_CARE'

}

export enum ServicioQuirurgico {
    CirugiaDeCabezaYCuello = 201,
    DescripcionCirugiaDeCabezaYCuello = 'Q_HEAD_AND_NECK_SURGERY',
    CirugiaCardiovascular = 202,
    DescripcionCirugiaCardiovascular = 'Q_CARDIOVASCULAR_SURGERY',
    CirugiaGeneral = 203,
    DescripcionCirugiaGeneral = 'Q_GENERAL_SURGERY',
    CirugiaGinecologica = 204,
    DescripcionCirugiaGinecologica = 'Q_GYNECOLOGICAL_SURGERY',
    CirugiaMaxilofacial = 205,
    DescripcionCirugiaMaxilofacial = 'Q_MAXILLOFACIAL_SURGERY',
    CirugiaOrtopedica = 207,
    DescripcionCirugiaOrtopedica = 'Q_ORTHOPEDIC_SURGERY',
    CirugiaOftalmologica = 208,
    DescripcionCirugiaOftalmologica = 'Q_OPHTHALMOLOGICAL_SURGERY',
    CirugiaOtorrinolaringologia = 209,
    DescripcionCirugiaOtorrinolaringologia = 'Q_OTORHINOLARYNGOLOGICAL_SURGERY',
    CirugiaOncologica = 210,
    DescripcionCirugiaOncologica = 'Q_ONCOLOGICAL_SURGERY',
    CirugiaOral = 211,
    DescripcionCirugiaOral = 'Q_ORAL_SURGERY',
    CirugiaPediatrica = 212,
    DescripcionCirugiaPediatrica = 'Q_PEDIATRIC_SURGERY',
    CirugiaPlasticaYEstetica = 213,
    DescripcionCirugiaPlasticaYEstetica = 'Q_PLASTIC_AND_AESTHETIC_SURGERY',
    CirugiaVascularYAngiologica = 214,
    DescripcionCirugiaVascularYAngiologica = 'Q_VASCULAR_AND_ANGIOLOGICAL_SURGERY',
    CirugiaUrologica = 215,
    DescripcionCirugiaUrologica = 'Q_UROLOGICAL_SURGERY',
    OtrasCirugias = 217,
    DescripcionOtrasCirugias = 'Q_OTHER_SURGERIES',
    CirugiaEndovascularNeurologica = 218,
    DescripcionCirugiaEndovascularNeurologica = 'Q_NEUROLOGICAL_ENDOVASCULAR_SURGERY',
    CirugiaOncologicaPediatrica = 227,
    DescripcionCirugiaOncologicaPediatrica = 'Q_PEDIATRIC_ONCOLOGICAL_SURGERY',
    CirugiaDeLaMano = 231,
    DescripcionCirugiaDeLaMano = 'Q_HAND_SURGERY',
    CirugiaDeMamaYTumoresTejidosBlandos = 232,
    DescripcionCirugiaDeMamaYTumoresTejidosBlandos = 'Q_BREAST_AND_SOFT_TISSUE_TUMORS_SURGERY',
    CirugiaDermatologica = 233,
    DescripcionCirugiaDermatologica = 'Q_DERMATOLOGICAL_SURGERY',
    CirugiaDeTorax = 234,
    DescripcionCirugiaDeTorax = 'Q_THORACIC_SURGERY',
    CirugiaGastrointestinal = 235,
    DescripcionCirugiaGastrointestinal = 'Q_GASTROINTESTINAL_SURGERY',
    CirugiaPlasticaOncologica = 237,
    DescripcionCirugiaPlasticaOncologica = 'Q_ONCOLOGICAL_PLASTIC_SURGERY',
    Neurocirugia = 245,
    DescripcionNeurocirugia = 'Q_NEUROSURGERY',
}

export enum ServicioAtencionInmediata {
    AtencionDelParto = 1101,
    DescripcionAtencionDelParto = 'AI_LABOR_DELIVERY_ATTENTION',
    Urgencias = 1102,
    DescripcionUrgencias = 'AI_URGENCY',
    TransporteAsistencialBasico = 1103,
    DescripcionTransporteAsistencialBasico = 'AI_BASIC_ASSISTANCE_TRANSPORT',
    TransporteAsistencialMedicalizado = 1104,
    DescripcionTransporteAsistencialMedicalizado = 'AI_MEDICALIZED_ASSISTANCE_TRANSPORT',
    AtencionPrehospitalaria = 1105,
    DescripcionAtencionPrehospitalaria = 'AI_PREHOSPITAL_CARE',

}
//#endregion

export enum PrefijoPaises {
    Afganistan = 'AFG',
    DescripcionAfganistan = 'AFGANISTAN',
    Albania = 'ALB',
    DescripcionAlbania = 'ALBANIA',
    Antartida = 'ATA',
    DescripcionAntartida = 'ANTARTIDA',
    Argelia = 'DZA',
    DescripcionArgelia = 'ARGELIA',
    SamoaAmericana = 'ASM',
    DescripcionSamoaAmericana = 'SAMOA_AMERICANA',
    Andorra = 'AND',
    DescripcionAndorra = 'ANDORRA',
    Angola = 'AGO',
    DescripcionAngola = 'ANGOLA',
    AntiguaYBarbuda = 'ATG',
    DescripcionAntiguaYBarbuda = 'ANTIGUA_Y_BARBUDA',
    Azerbaiyan = 'AZE',
    DescripcionAzerbaiyan = 'AZERBAIYAN',
    Argentina = 'ARG',
    DescripcionArgentina = 'ARGENTINA',
    Australia = 'AUS',
    DescripcionAustralia = 'AUSTRALIA',
    Austria = 'AUT',
    DescripcionAustria = 'AUSTRIA',
    Bahamas = 'BHS',
    DescripcionBahamas = 'BAHAMAS',
    Barein = 'BHR',
    DescripcionBarein = 'BAREIN',
    Banglades = 'BGD',
    DescripcionBanglades = 'BANGLADES',
    Armenia = 'ARM',
    DescripcionArmenia = 'ARMENIA',
    Barbados = 'BRB',
    DescripcionBarbados = 'BARBADOS',
    Belgica = 'BEL',
    DescripcionBelgica = 'BELGICA',
    Bermuda = 'BMU',
    DescripcionBermuda = 'BERMUDA',
    Butan = 'BTN',
    DescripcionButan = 'BUTAN',
    Bolivia = 'BOL',
    DescripcionBolivia = 'BOLIVIA',
    BosniaHerzegovina = 'BIH',
    DescripcionBosniaHerzegovina = 'BOSNIA-HERZEGOVINA',
    Botsuana = 'BWA',
    DescripcionBotsuana = 'BOTSUANA',
    IslaBouvet = 'BVT',
    DescripcionIslaBouvet = 'ISLA_BOUVET',
    Brazil = 'BRA',
    DescripcionBrazil = 'BRAZIL',
    Belice = 'BLZ',
    DescripcionBelice = 'BELICE',
    TerritorioBritanicoDelOceanoIndico = 'IOT',
    DescripcionTerritorioBritanicoDelOceanoIndico = 'TERRITORIO_BRITANICO_DEL_OCEANO_INDICO',
    IslasSolomon = 'SLB',
    DescripcionIslasSolomon = 'ISLAS_SOLOMON',
    IslasVirgenesBritanicas = 'VGB',
    DescripcionIslasVirgenesBritanicas = 'ISLAS_VIRGENES_BRITANICAS',
    Brunei = 'BRN',
    DescripcionBrunei = 'BRUNEI',
    Bulgaria = 'BGR',
    DescripcionBulgaria = 'BULGARIA',
    MyanmarFormerBurma = 'MMR',
    DescripcionMyanmarFormerBurma = 'MYANMAR_FORMER_BURMA',
    Burundi = 'BDI',
    DescripcionBurundi = 'BURUNDI',
    Bielorrusia = 'BLR',
    DescripcionBielorrusia = 'BIELORRUSIA',
    Camboya = 'KHM',
    DescripcionCamboya = 'CAMBOYA',
    Camerun = 'CMR',
    DescripcionCamerun = 'CAMERUN',
    Canada = 'CAN',
    DescripcionCanada = 'CANADA',
    CaboVerde = 'CPV',
    DescripcionCaboVerde = 'CABO_VERDE',
    IslasCaiman = 'CYM',
    DescripcionIslasCaiman = 'ISLAS_CAIMAN',
    RepublicaCentroafricana = 'CAF',
    DescripcionRepublicaCentroafricana = 'REPUBLICA_CENTROAFRICANA',
    SriLanka = 'LKA',
    DescripcionSriLanka = 'SRI_LANKA',
    Chad = 'TCD',
    DescripcionChad = 'CHAD',
    Chile = 'CHL',
    DescripcionChile = 'CHILE',
    China = 'CHN',
    DescripcionChina = 'CHINA',
    Taiwan = 'TWN',
    DescripcionTaiwan = 'TAIWAN',
    IslaDeNavidad = 'CXR',
    DescripcionIslaDeNavidad = 'ISLA_DE_NAVIDAD',
    IslasCocos = 'CCK',
    DescripcionIslasCocos = 'ISLAS_COCOS',
    Colombia = 'COL',
    DescripcionColombia = 'COLOMBIA',
    Comoras = 'COM',
    DescripcionComoras = 'COMORAS',
    Mayotte = 'MYT',
    DescripcionMayotte = 'MAYOTTE',
    Congo = 'COG',
    DescripcionCongo = 'CONGO',
    RepublicaDemocraticaDelCongo = 'COD',
    DescripcionRepublicaDemocraticaDelCongo = 'REPUBLICA_DEMOCRATICA_DEL_CONGO',
    IslasCook = 'COK',
    DescripcionIslasCook = 'ISLAS_COOK',
    CostaRica = 'CRI',
    DescripcionCostaRica = 'COSTA_RICA',
    Croacia = 'HRV',
    DescripcionCroacia = 'CROACIA',
    Cuba = 'CUB',
    DescripcionCuba = 'CUBA',
    Chipre = 'CYP',
    DescripcionChipre = 'CHIPRE',
    RepublicaCheca = 'CZE',
    DescripcionRepublicaCheca = 'REPUBLICA_CHECA',
    Benin = 'BEN',
    DescripcionBenin = 'BENIN',
    Dinamarca = 'DNK',
    DescripcionDinamarca = 'DINAMARCA',
    Dominica = 'DMA',
    DescripcionDominica = 'DOMINICA',
    RepublicaDominicana = 'DOM',
    DescripcionRepublicaDominicana = 'REPUBLICA_DOMINICANA',
    Ecuador = 'ECU',
    DescripcionEcuador = 'ECUADOR',
    ElSalvador = 'SLV',
    DescripcionElSalvador = 'EL_SALVADOR',
    GuineaEcuatorial = 'GNQ',
    DescripcionGuineaEcuatorial = 'GUINEA_ECUATORIAL',
    Etiopia = 'ETH',
    DescripcionEtiopia = 'ETIOPIA',
    Eritrea = 'ERI',
    DescripcionEritrea = 'ERITREA',
    Estonia = 'EST',
    DescripcionEstonia = 'ESTONIA',
    IslasFeroe = 'FRO',
    DescripcionIslasFeroe = 'ISLAS_FEROE',
    IslasMalvinas = 'FLK',
    DescripcionIslasMalvinas = 'ISLAS_MALVINAS',
    IslasGeorgiasDelSurYSandwichDelSur = 'SGS',
    DescripcionIslasGeorgiasDelSurYSandwichDelSur = 'ISLAS_GEORGIAS_DEL_SUR_Y_SANDWICH_DEL_SUR',
    Fiyi = 'FJI',
    DescripcionFiyi = 'FIYI',
    Finlandia = 'FIN',
    DescripcionFinlandia = 'FINLANDIA',
    Aland = 'ALA',
    DescripcionAland = 'ALAND',
    Francia = 'FRA',
    DescripcionFrancia = 'FRANCIA',
    GuayanaFrancesa = 'GUF',
    DescripcionGuayanaFrancesa = 'GUAYANA_FRANCESA',
    PolinesiaFrancesa = 'PYF',
    DescripcionPolinesiaFrancesa = 'POLINESIA_FRANCESA',
    TierrasAustralesYAntarticasFrancesas = 'ATF',
    DescripcionTierrasAustralesYAntarticasFrancesas = 'TIERRAS_AUSTRALES_Y_ANTARTICAS_FRANCESAS',
    Yibuti = 'DJI',
    DescripcionYibuti = 'YIBUTI',
    Gabon = 'GAB',
    DescripcionGabon = 'GABON',
    Georgia = 'GEO',
    DescripcionGeorgia = 'GEORGIA',
    Gambia = 'GMB',
    DescripcionGambia = 'GAMBIA',
    Palestina = 'PSE',
    DescripcionPalestina = 'PALESTINA',
    Alemania = 'DEU',
    DescripcionAlemania = 'ALEMANIA',
    Ghana = 'GHA',
    DescripcionGhana = 'GHANA',
    Gibraltar = 'GIB',
    DescripcionGibraltar = 'GIBRALTAR',
    Kiribati = 'KIR',
    DescripcionKiribati = 'KIRIBATI',
    Grecia = 'GRC',
    DescripcionGrecia = 'GRECIA',
    Groenlandia = 'GRL',
    DescripcionGroenlandia = 'GROENLANDIA',
    Granada = 'GRD',
    DescripcionGranada = 'GRANADA',
    Guadaluoe = 'GLP',
    DescripcionGuadaluoe = 'GUADALUOE',
    Guam = 'GUM',
    DescripcionGuam = 'GUAM',
    Guatemala = 'GTM',
    DescripcionGuatemala = 'GUATEMALA',
    Guinea = 'GIN',
    DescripcionGuinea = 'GUINEA',
    Guyana = 'GUY',
    DescripcionGuyana = 'GUYANA',
    Haiti = 'HTI',
    DescripcionHaiti = 'HAITI',
    IslaHeardYMcdonald = 'HMD',
    DescripcionIslaHeardYMcdonald = 'ISLA_HEARD_Y_MCDONALD',
    SantaSede = 'VAT',
    DescripcionSantaSede = 'SANTA_SEDE',
    Honduras = 'HND',
    DescripcionHonduras = 'HONDURAS',
    HongKong = 'HKG',
    DescripcionHongKong = 'HONG_KONG',
    Hungria = 'HUN',
    DescripcionHungria = 'HUNGRIA',
    Islandia = 'ISL',
    DescripcionIslandia = 'ISLANDIA',
    India = 'IND',
    DescripcionIndia = 'INDIA',
    Indonesia = 'IDN',
    DescripcionIndonesia = 'INDONESIA',
    Iran = 'IRN',
    DescripcionIran = 'IRAN',
    Iraq = 'IRQ',
    DescripcionIraq = 'IRAQ',
    Irlanda = 'IRL',
    DescripcionIrlanda = 'IRLANDA',
    Israel = 'ISR',
    DescripcionIsrael = 'ISRAEL',
    Italia = 'ITA',
    DescripcionItalia = 'ITALIA',
    CostaDeMarfil = 'CIV',
    DescripcionCostaDeMarfil = 'COSTA_DE_MARFIL',
    Jamaica = 'JAM',
    DescripcionJamaica = 'JAMAICA',
    Japon = 'JPN',
    DescripcionJapon = 'JAPON',
    Kazajistan = 'KAZ',
    DescripcionKazajistan = 'KAZAJISTAN',
    Jordania = 'JOR',
    DescripcionJordania = 'JORDANIA',
    Kenya = 'KEN',
    DescripcionKenya = 'KENYA',
    CoreaDelNorte = 'PRK',
    DescripcionCoreaDelNorte = 'COREA_DEL_NORTE',
    CoreaDelSur = 'KOR',
    DescripcionCoreaDelSur = 'COREA_DEL_SUR',
    Kuwait = 'KWT',
    DescripcionKuwait = 'KUWAIT',
    Kirguistan = 'KGZ',
    DescripcionKirguistan = 'KIRGUISTAN',
    Laos = 'LAO',
    DescripcionLaos = 'LAOS',
    Libano = 'LBN',
    DescripcionLibano = 'LIBANO',
    Lesoto = 'LSO',
    DescripcionLesoto = 'LESOTO',
    Letonia = 'LVA',
    DescripcionLetonia = 'LETONIA',
    Liberia = 'LBR',
    DescripcionLiberia = 'LIBERIA',
    Libia = 'LBY',
    DescripcionLibia = 'LIBIA',
    Liechtenstein = 'LIE',
    DescripcionLiechtenstein = 'LIECHTENSTEIN',
    Lituania = 'LTU',
    DescripcionLituania = 'LITUANIA',
    Luxemburgo = 'LUX',
    DescripcionLuxemburgo = 'LUXEMBURGO',
    Macao = 'MAC',
    DescripcionMacao = 'MACAO',
    Madagascar = 'MDG',
    DescripcionMadagascar = 'MADAGASCAR',
    Malaui = 'MWI',
    DescripcionMalaui = 'MALAUI',
    Malasia = 'MYS',
    DescripcionMalasia = 'MALASIA',
    Maldivas = 'MDV',
    DescripcionMaldivas = 'MALDIVAS',
    Mali = 'MLI',
    DescripcionMali = 'MALI',
    Malta = 'MLT',
    DescripcionMalta = 'MALTA',
    Martinica = 'MTQ',
    DescripcionMartinica = 'MARTINICA',
    Mauritania = 'MRT',
    DescripcionMauritania = 'MAURITANIA',
    Mauricio = 'MUS',
    DescripcionMauricio = 'MAURICIO',
    Mexico = 'MEX',
    DescripcionMexico = 'MEXICO',
    Monaco = 'MCO',
    DescripcionMonaco = 'MONACO',
    Mongolia = 'MNG',
    DescripcionMongolia = 'MONGOLIA',
    Moldavia = 'MDA',
    DescripcionMoldavia = 'MOLDAVIA',
    Montenegro = 'MNE',
    DescripcionMontenegro = 'MONTENEGRO',
    Montserrat = 'MSR',
    DescripcionMontserrat = 'MONTSERRAT',
    Marruecos = 'MAR',
    DescripcionMarruecos = 'MARRUECOS',
    Mozambique = 'MOZ',
    DescripcionMozambique = 'MOZAMBIQUE',
    Oman = 'OMN',
    DescripcionOman = 'OMAN',
    Namibia = 'NAM',
    DescripcionNamibia = 'NAMIBIA',
    Nauru = 'NRU',
    DescripcionNauru = 'NAURU',
    Nepal = 'NPL',
    DescripcionNepal = 'NEPAL',
    PaisesBajos = 'NLD',
    DescripcionPaisesBajos = 'PAISES_BAJOS',
    Curazao = 'CUW',
    DescripcionCurazao = 'CURAZAO',
    Aruba = 'ABW',
    DescripcionAruba = 'ARUBA',
    SanMartinParteHolandesa = 'SXM',
    DescripcionSanMartinParteHolandesa = 'SAN_MARTIN_PARTE_HOLANDESA',
    BonaireSanEustaquioYSaba = 'BES',
    DescripcionBonaireSanEustaquioYSaba = 'BONAIRE,_SAN_EUSTAQUIO_Y_SABA',
    NuevaCaledonia = 'NCL',
    DescripcionNuevaCaledonia = 'NUEVA_CALEDONIA',
    Vanuatu = 'VUT',
    DescripcionVanuatu = 'VANUATU',
    NuevaZelanda = 'NZL',
    DescripcionNuevaZelanda = 'NUEVA_ZELANDA',
    Nicaragua = 'NIC',
    DescripcionNicaragua = 'NICARAGUA',
    Niger = 'NER',
    DescripcionNiger = 'NIGER',
    Nigeria = 'NGA',
    DescripcionNigeria = 'NIGERIA',
    Niue = 'NIU',
    DescripcionNiue = 'NIUE',
    IslaNorfolk = 'NFK',
    DescripcionIslaNorfolk = 'ISLA_NORFOLK',
    Noruega = 'NOR',
    DescripcionNoruega = 'NORUEGA',
    IslasMarianasDelNorte = 'MNP',
    DescripcionIslasMarianasDelNorte = 'ISLAS_MARIANAS_DEL_NORTE',
    IslasUltramarinasMenoresDeEstadosUnidos = 'UMI',
    DescripcionIslasUltramarinasMenoresDeEstadosUnidos = 'ISLAS_ULTRAMARINAS_MENORES_DE_ESTADOS_UNIDOS',
    Micronesia = 'FSM',
    DescripcionMicronesia = 'MICRONESIA',
    IslasMarshall = 'MHL',
    DescripcionIslasMarshall = 'ISLAS_MARSHALL',
    Palaos = 'PLW',
    DescripcionPalaos = 'PALAOS',
    Paquistan = 'PAK',
    DescripcionPaquistan = 'PAQUISTAN',
    Panama = 'PAN',
    DescripcionPanama = 'PANAMA',
    PapuaNuevaGuinea = 'PNG',
    DescripcionPapuaNuevaGuinea = 'PAPUA_NUEVA_GUINEA',
    Paraguay = 'PRY',
    DescripcionParaguay = 'PARAGUAY',
    Peru = 'PER',
    DescripcionPeru = 'PERU',
    Filipinas = 'PHL',
    DescripcionFilipinas = 'FILIPINAS',
    Pitcairn = 'PCN',
    DescripcionPitcairn = 'PITCAIRN',
    Polonia = 'POL',
    DescripcionPolonia = 'POLONIA',
    Portugal = 'PRT',
    DescripcionPortugal = 'PORTUGAL',
    GuineaBisau = 'GNB',
    DescripcionGuineaBisau = 'GUINEA-BISAU',
    TimorOriental = 'TLS',
    DescripcionTimorOriental = 'TIMOR_ORIENTAL',
    PuertoRico = 'PRI',
    DescripcionPuertoRico = 'PUERTO_RICO',
    Catar = 'QAT',
    DescripcionCatar = 'CATAR',
    Reunion = 'REU',
    DescripcionReunion = 'REUNION',
    Rumania = 'ROU',
    DescripcionRumania = 'RUMANIA',
    Rusia = 'RUS',
    DescripcionRusia = 'RUSIA',
    Ruanda = 'RWA',
    DescripcionRuanda = 'RUANDA',
    SanBartolome = 'BLM',
    DescripcionSanBartolome = 'SAN_BARTOLOME',
    SantaHelenaAscensionYTristanDeAcuna = 'SHN',
    DescripcionSantaHelenaAscensionYTristanDeAcuna = 'SANTA_HELENA_ASCENSION_Y_TRISTAN_DE_ACUNA',
    SanCristobalYNieves = 'KNA',
    DescripcionSanCristobalYNieves = 'SAN_CRISTOBAL_Y_NIEVES',
    Anguila = 'AIA',
    DescripcionAnguila = 'ANGUILA',
    SantaLucia = 'LCA',
    DescripcionSantaLucia = 'SANTA_LUCIA',
    SanMartinParteFrancesa = 'MAF',
    DescripcionSanMartinParteFrancesa = 'SAN_MARTIN_PARTE_FRANCESA',
    SanPedroYMiquelon = 'SPM',
    DescripcionSanPedroYMiquelon = 'SAN_PEDRO_Y_MIQUELON',
    SanVicenteYLasGranadinas = 'VCT',
    DescripcionSanVicenteYLasGranadinas = 'SAN_VICENTE_Y_LAS_GRANADINAS',
    SanMarino = 'SMR',
    DescripcionSanMarino = 'SAN_MARINO',
    SantoTomeYPrincipe = 'STP',
    DescripcionSantoTomeYPrincipe = 'SANTO_TOME_Y_PRINCIPE',
    ArabiaSaudita = 'SAU',
    DescripcionArabiaSaudita = 'ARABIA_SAUDITA',
    Senegal = 'SEN',
    DescripcionSenegal = 'SENEGAL',
    Serbia = 'SRB',
    DescripcionSerbia = 'SERBIA',
    Seychelles = 'SYC',
    DescripcionSeychelles = 'SEYCHELLES',
    SierraLeona = 'SLE',
    DescripcionSierraLeona = 'SIERRA_LEONA',
    Singapur = 'SGP',
    DescripcionSingapur = 'SINGAPUR',
    Eslovaquia = 'SVK',
    DescripcionEslovaquia = 'ESLOVAQUIA',
    Vietnam = 'VNM',
    DescripcionVietnam = 'VIETNAM',
    Eslovenia = 'SVN',
    DescripcionEslovenia = 'ESLOVENIA',
    Somalia = 'SOM',
    DescripcionSomalia = 'SOMALIA',
    Sudafrica = 'ZAF',
    DescripcionSudafrica = 'SUDAFRICA',
    Zimbabue = 'ZWE',
    DescripcionZimbabue = 'ZIMBABUE',
    Espana = 'ESP',
    DescripcionEspana = 'ESPANA',
    SudanDelSur = 'SSD',
    DescripcionSudanDelSur = 'SUDAN_DEL_SUR',
    Sudan = 'SDN',
    DescripcionSudan = 'SUDAN',
    SaharaOccidental = 'ESH',
    DescripcionSaharaOccidental = 'SAHARA_OCCIDENTAL',
    Surinam = 'SUR',
    DescripcionSurinam = 'SURINAM',
    SvalbardYJanMayen = 'SJM',
    DescripcionSvalbardYJanMayen = 'SVALBARD_Y_JAN_MAYEN',
    Suazilandia = 'SWZ',
    DescripcionSuazilandia = 'SUAZILANDIA',
    Suecia = 'SWE',
    DescripcionSuecia = 'SUECIA',
    Suiza = 'CHE',
    DescripcionSuiza = 'SUIZA',
    Siria = 'SYR',
    DescripcionSiria = 'SIRIA',
    Tayikistan = 'TJK',
    DescripcionTayikistan = 'TAYIKISTAN',
    Tailandia = 'THA',
    DescripcionTailandia = 'TAILANDIA',
    Togo = 'TGO',
    DescripcionTogo = 'TOGO',
    Tokelau = 'TKL',
    DescripcionTokelau = 'TOKELAU',
    Tonga = 'TON',
    DescripcionTonga = 'TONGA',
    TrinidadYTobago = 'TTO',
    DescripcionTrinidadYTobago = 'TRINIDAD_Y_TOBAGO',
    EmiratosArabesUnidos = 'ARE',
    DescripcionEmiratosArabesUnidos = 'EMIRATOS_ARABES_UNIDOS',
    Tunez = 'TUN',
    DescripcionTunez = 'TUNEZ',
    Turquia = 'TUR',
    DescripcionTurquia = 'TURQUIA',
    Turkmenistan = 'TKM',
    DescripcionTurkmenistan = 'TURKMENISTAN',
    IslasTurcasYCaicos = 'TCA',
    DescripcionIslasTurcasYCaicos = 'ISLAS_TURCAS_Y_CAICOS',
    Tuvalu = 'TUV',
    DescripcionTuvalu = 'TUVALU',
    Uganda = 'UGA',
    DescripcionUganda = 'UGANDA',
    Ucrania = 'UKR',
    DescripcionUcrania = 'UCRANIA',
    Macedonia = 'MKD',
    DescripcionMacedonia = 'MACEDONIA',
    Egipto = 'EGY',
    DescripcionEgipto = 'EGIPTO',
    ReinoUnido = 'GBR',
    DescripcionReinoUnido = 'REINO_UNIDO',
    Guernsey = 'GGY',
    DescripcionGuernsey = 'GUERNSEY',
    Jersey = 'JEY',
    DescripcionJersey = 'JERSEY',
    IslaDeMan = 'IMN',
    DescripcionIslaDeMan = 'ISLA_DE_MAN',
    Tanzania = 'TZA',
    DescripcionTanzania = 'TANZANIA',
    EstadosUnidos = 'USA',
    DescripcionEstadosUnidos = 'ESTADOS_UNIDOS',
    IslasVirgenesDeLosEstadosUnidos = 'VIR',
    DescripcionIslasVirgenesDeLosEstadosUnidos = 'ISLAS_VIRGENES_DE_LOS_ESTADOS_UNIDOS',
    BurkinaFaso = 'BFA',
    DescripcionBurkinaFaso = 'BURKINA_FASO',
    Uruguay = 'URY',
    DescripcionUruguay = 'URUGUAY',
    Uzbekistan = 'UZB',
    DescripcionUzbekistan = 'UZBEKISTAN',
    Venezuela = 'VEN',
    DescripcionVenezuela = 'VENEZUELA',
    WallisYFutuna = 'WLF',
    DescripcionWallisYFutuna = 'WALLIS_Y_FUTUNA',
    Samoa = 'WSM',
    DescripcionSamoa = 'SAMOA',
    Yemen = 'YEM',
    DescripcionYemen = 'YEMEN',
    Zambia = 'ZMB',
    DescripcionZambia = 'ZAMBIA',
}

export enum ComunidadEtnica {
    Polindara = 94,
    DescripcionPolindara = 'POLINDARA',
    Achagua = 1,
    DescripcionAchagua = 'ACHAGUA',
    Amorua = 2,
    DescripcionAmorua = 'AMORUA',
    Andoque = 3,
    DescripcionAndoque = 'ANDOQUE',
    Arhuaco = 4,
    DescripcionArhuaco = 'ARHUACO',
    Awa = 5,
    DescripcionAwa = 'AWA',
    Bara = 6,
    DescripcionBara = 'BARA',
    Barasana = 7,
    DescripcionBarasana = 'BARASANA',
    Bari = 8,
    DescripcionBari = 'BARI',
    Betoye = 9,
    DescripcionBetoye = 'BETOYE',
    Bora = 10,
    DescripcionBora = 'BORA',
    Cabiyari = 11,
    DescripcionCabiyari = 'CABIYARI',
    Carapana = 12,
    DescripcionCarapana = 'CARAPANA',
    Carijona = 13,
    DescripcionCarijona = 'CARIJONA',
    Chimila = 14,
    DescripcionChimila = 'CHIMILA',
    Chiricoa = 15,
    DescripcionChiricoa = 'CHIRICOA',
    Cocama = 16,
    DescripcionCocama = 'COCAMA',
    Coconuco = 17,
    DescripcionCoconuco = 'COCONUCO',
    Cofan = 18,
    DescripcionCofan = 'COFAN',
    CoyaimaNatagaima = 19,
    DescripcionCoyaimaNatagaima = 'COYAIMA_NATAGAIMA',
    Cubeo = 20,
    DescripcionCubeo = 'CUBEO',
    Cuiba = 21,
    DescripcionCuiba = 'CUIBA',
    Curripaco = 22,
    DescripcionCurripaco = 'CURRIPACO',
    Desano = 23,
    DescripcionDesano = 'DESANO',
    Dujos = 24,
    DescripcionDujos = 'DUJOS',
    Embera = 25,
    DescripcionEmbera = 'EMBERA',
    EmberaCatio = 26,
    DescripcionEmberaCatio = 'EMBERA_CATIO',
    EmberaChami = 27,
    DescripcionEmberaChami = 'EMBERA_CHAMI',
    EmberaSiapidara = 28,
    DescripcionEmberaSiapidara = 'EMBERA_SIAPIDARA',
    Guambiano = 29,
    DescripcionGuambiano = 'GUAMBIANO',
    Guanaca = 30,
    DescripcionGuanaca = 'GUANACA',
    Guayabero = 31,
    DescripcionGuayabero = 'GUAYABERO',
    Guayuu = 32,
    DescripcionGuayuu = 'GUAYUU',
    Hitnu = 33,
    DescripcionHitnu = 'HITNU',
    Inga = 34,
    DescripcionInga = 'INGA',
    Kamsa = 35,
    DescripcionKamsa = 'KAMSA',
    Kogui = 36,
    DescripcionKogui = 'KOGUI',
    Koreguaje = 37,
    DescripcionKoreguaje = 'KOREGUAJE',
    Letuama = 38,
    DescripcionLetuama = 'LETUAMA',
    Macaguaje = 39,
    DescripcionMacaguaje = 'MACAGUAJE',
    Macu = 40,
    DescripcionMacu = 'MACU',
    Macuna = 41,
    DescripcionMacuna = 'MACUNA',
    Masiguare = 42,
    DescripcionMasiguare = 'MASIGUARE',
    Matapi = 43,
    DescripcionMatapi = 'MATAPI',
    Mirana = 44,
    DescripcionMirana = 'MIRANA',
    Muinane = 45,
    DescripcionMuinane = 'MUINANE',
    Muisca = 46,
    DescripcionMuisca = 'MUISCA',
    Nonuya = 47,
    DescripcionNonuya = 'NONUYA',
    Ocaina = 48,
    DescripcionOcaina = 'OCAINA',
    Paez = 49,
    DescripcionPaez = 'PAEZ',
    Pastos = 50,
    DescripcionPastos = 'PASTOS',
    Piapoco = 51,
    DescripcionPiapoco = 'PIAPOCO',
    Piaroa = 52,
    DescripcionPiaroa = 'PIAROA',
    Piratapuyo = 53,
    DescripcionPiratapuyo = 'PIRATAPUYO',
    Pisamira = 54,
    DescripcionPisamira = 'PISAMIRA',
    Puinave = 55,
    DescripcionPuinave = 'PUINAVE',
    Saliba = 56,
    DescripcionSaliba = 'SALIBA',
    Sikuani = 57,
    DescripcionSikuani = 'SIKUANI',
    Siona = 58,
    DescripcionSiona = 'SIONA',
    Siriano = 59,
    DescripcionSiriano = 'SIRIANO',
    Siripu = 60,
    DescripcionSiripu = 'SIRIPU',
    Taiwano = 61,
    DescripcionTaiwano = 'TAIWANO',
    Tanimuka = 62,
    DescripcionTanimuka = 'TANIMUKA',
    Tariano = 63,
    DescripcionTariano = 'TARIANO',
    Tatuyo = 64,
    DescripcionTatuyo = 'TATUYO',
    Tikunas = 65,
    DescripcionTikunas = 'TIKUNAS',
    Totoro = 66,
    DescripcionTotoro = 'TOTORO',
    Tucano = 67,
    DescripcionTucano = 'TUCANO',
    Tule = 68,
    DescripcionTule = 'TULE',
    Tuyuca = 69,
    DescripcionTuyuca = 'TUYUCA',
    Uwa = 70,
    DescripcionUwa = 'UWA',
    Wanano = 71,
    DescripcionWanano = 'WANANO',
    Wayuu = 72,
    DescripcionWayuu = 'WAYUU',
    Witoto = 73,
    DescripcionWitoto = 'WITOTO',
    Wiwua = 74,
    DescripcionWiwua = 'WIWUA',
    Wounaan = 75,
    DescripcionWounaan = 'WOUNAAN',
    Yagua = 76,
    DescripcionYagua = 'YAGUA',
    Yanacona = 77,
    DescripcionYanacona = 'YANACONA',
    Yauna = 78,
    DescripcionYauna = 'YAUNA',
    Yucuna = 79,
    DescripcionYucuna = 'YUCUNA',
    Yuko = 80,
    DescripcionYuko = 'YUKO',
    Yuri = 81,
    DescripcionYuri = 'YURI',
    Yuruti = 82,
    DescripcionYuruti = 'YURUTI',
    Zenu = 83,
    DescripcionZenu = 'ZENU',
    InResidentesBogota = 100,
    DescripcionInResidentesBogota = 'IN_RESIDENTES_BOGOTA',
    Negritudes = 200,
    DescripcionNegritudes = 'NEGRITUDES',
    Rom = 400,
    DescripcionRom = 'ROM',
    OtrasEtnias = 999,
    DescripcionOtrasEtnias = 'OTHER_ETNIAS',
    NoAplica = 0,
    DescripcionNoAplica = 'NOT_APPLY',
    Quiyasingas = 93,
    DescripcionQuiyasingas = 'QUIYASINGAS',
    Tama = 92,
    DescripcionTama = 'TAMA',
    Payoarini = 91,
    DescripcionPayoarini = 'PAYOARINI',
    Mura = 90,
    DescripcionMura = 'MURA',
    Garu = 89,
    DescripcionGaru = 'GARU',
    Datuana = 88,
    DescripcionDatuana = 'DATUANA',
    Corocoro = 87,
    DescripcionCorocoro = 'COROCORO',
    Chami = 86,
    DescripcionChami = 'CHAMI',
    Katio = 85,
    DescripcionKatio = 'KATIO',
    Caramanta = 84,
    DescripcionCaramanta = 'CARAMANTA',
}

export enum EstadoCertificado {
    Todos = 'TO',
    DescripcionTodos = 'LABEL_ALL_PLURAL',
    Vigentes = 'VI',
    DescripcionVigentes = 'LBL_PREVAILING',
    Vencidas = 'VE',
    DescripcionCaramanta = 'LBL_EXPIRED',
}

export enum TipoControl {
    Nacional = 0,
    DescripcionNacional = 'LBL_NATIONAL',
    Especial = 1,
    DescripcionEspecial = 'SLD_ESPECIAL'
}

export enum TiposDeUso {
    AcetatoDeCelulosaPlasticosYFibrasTextiles = 1,
    DescripcionAcetatoDeCelulosaPlasticosYFibrasTextiles = 'ACETATE_OF_CELLULOSE_PLASTICS_AND_TEXTILE_FIBERS',
    AcetilacionDeAlcoholesYAminas = 2,
    DescripcionAcetilacionDeAlcoholesYAminas = 'ACETYLATION_OF_ALCOHOLS_AND_AMINES',
    AgenteDeshidratante = 3,
    DescripcionAgenteDeshidratante = 'DEHYDRATING_AGENT',
    AgenteOxidante = 4,
    DescripcionAgenteOxidante = 'OXIDIZING_AGENT',
    Ambientadores = 5,
    DescripcionAmbientadores = 'AIR_FRESHENERS',
    Anestesico = 6,
    DescripcionAnestesico = 'ANESTHETIC',
    AnticongelanteDeVehiculos = 7,
    DescripcionAnticongelanteDeVehiculos = 'VEHICLE_ANTIFREEZE',
    Bactericida = 8,
    DescripcionBactericida = 'BACTERICIDE',
    Barnices = 9,
    DescripcionBarnices = 'VARNISHES',
    Caucho = 10,
    DescripcionCaucho = 'RUBBER',
    CombustibleParaHornos = 11,
    DescripcionCombustibleParaHornos = 'FUEL_FOR_OVENS',
    Curtiembres = 12,
    DescripcionCurtiembres = 'TANNERY',
    Decapante = 13,
    DescripcionDecapante = 'STRIPPING_AGENT',
    Deshidratante = 14,
    DescripcionDeshidratante = 'DEHYDRANT',
    Desinfectante = 15,
    DescripcionDesinfectante = 'DISINFECTANT',
    Desodorizante = 16,
    DescripcionDesodorizante = 'DEODORIZER',
    Desosidante = 17,
    DescripcionDesosidante = 'DEFOAMER',
    Detergentes = 18,
    DescripcionDetergentes = 'DETERGENTS',
    Diluyente = 19,
    DescripcionDiluyente = 'DILUENT',
    DisolventeDeGomasNaturalesYResinasSinteticas = 20,
    DescripcionDisolventeDeGomasNaturalesYResinasSinteticas = 'SOLVENT_FOR_NATURAL_RUBBERS_AND_SYNTHETIC_RESINS',
    DisolventeDeTintasTintesResinasYAdhesivos = 21,
    DescripcionDisolventeDeTintasTintesResinasYAdhesivos = 'SOLVENT_FOR_INKS_DYES_RESINS_AND_ADHESIVES',
    DisolventeProduccionDeLacasEsmaltesLacados = 22,
    DescripcionDisolventeProduccionDeLacasEsmaltesLacados = 'SOLVENT_PRODUCTION_OF_LACQUERS_LACQUERED_ENAMELS',
    ElaboracionPvc = 23,
    DescripcionElaboracionPvc = 'PVC_MANUFACTURING',
    Embalsamar = 24,
    DescripcionEmbalsamar = 'EMBALMING',
    Explosivos = 25,
    DescripcionExplosivos = 'EXPLOSIVES',
    ExtractosAromatizados = 26,
    DescripcionExtractosAromatizados = 'FLAVORED_EXTRACTS',
    ExtraccionDeAceites = 27,
    DescripcionExtraccionDeAceites = 'OIL_EXTRACTION',
    Extrusion = 28,
    DescripcionExtrusion = 'EXTRUSION',
    FabricacionDeAdhesivos = 29,
    DescripcionFabricacionDeAdhesivos = 'ADHESIVE_MANUFACTURING',
    FabricacionDePerfumes = 30,
    DescripcionFabricacionDePerfumes = 'PERFUME_MANUFACTURING',
    FabricacionDeResinas = 31,
    DescripcionFabricacionDeResinas = 'RESIN_MANUFACTURING',
    FabricacionDeTintas = 32,
    DescripcionFabricacionDeTintas = 'INK_MANUFACTURING',
    FormulacionDeThinner = 33,
    DescripcionFormulacionDeThinner = 'THINNER_FORMULATION',
    Galvanizado = 202,
    DescripcionGalvanizado = 'GALVANIZING',
    GomasYGelatinas = 203,
    DescripcionGomasYGelatinas = 'GUMS_AND_GELATINS',
    IndustriaTextil = 204,
    DescripcionIndustriaTextil = 'TEXTILE_INDUSTRY',
    IngeniosAzucareros = 205,
    DescripcionIngeniosAzucareros = 'SUGAR_MILLS',
    InhibidorDeLaCorrosion = 206,
    DescripcionInhibidorDeLaCorrosion = 'CORROSION_INHIBITOR',
    Lacas = 207,
    DescripcionLacas = 'LACQUERS',
    LimpiadoresConDetergentes = 208,
    DescripcionLimpiadoresConDetergentes = 'DETERGENT_CLEANERS',
    LimpiadoresDeTelas = 209,
    DescripcionLimpiadoresDeTelas = 'FABRIC_CLEANERS',
    Metales = 210,
    DescripcionMetales = 'METALS',
    Metalurgica = 211,
    DescripcionMetalurgica = 'METALLURGY',
    Pegamentos = 212,
    DescripcionPegamentos = 'GLUES',
    Pinturas = 213,
    DescripcionPinturas = 'PAINTS',
    Plaguicidas = 214,
    DescripcionPlaguicidas = 'PESTICIDES',
    Plasticos = 215,
    DescripcionPlasticos = 'PLASTICS',
    Preservante = 216,
    DescripcionPreservante = 'PRESERVATIVE',
    ProductosDeLimpieza = 217,
    DescripcionProductosDeLimpieza = 'CLEANING_PRODUCTS',
    PulpasYPapeles = 218,
    DescripcionPulpasYPapeles = 'PULPS_AND_PAPERS',
    PurificacionDeAguasNegras = 219,
    DescripcionPurificacionDeAguasNegras = 'PURIFICATION_OF_SEWAGE_WATERS',
    PurificarOloresCausadosPorMateriasOrganicas = 220,
    DescripcionPurificarOloresCausadosPorMateriasOrganicas = 'PURIFICATION_OF_ODORS_CAUSED_BY_ORGANIC_MATTER',
    Refinerias = 221,
    DescripcionRefinerias = 'REFINERIES',
    Refrigerante = 222,
    DescripcionRefrigerante = 'REFRIGERANT',
    SaborizanteSintetico = 223,
    DescripcionSaborizanteSintetico = 'SYNTHETIC_FLAVORING',
    SaponificacionDeLosacidosGrasos = 224,
    DescripcionSaponificacionDeLosacidosGrasos = 'SAPONIFICATION_OF_FATTY_ACIDS',
    SedaArtificial = 225,
    DescripcionSedaArtificial = 'ARTIFICIAL_SILK',
    Sedante = 226,
    DescripcionSedante = 'SEDATIVE',
    SolucionesDePiroxilina = 227,
    DescripcionSolucionesDePiroxilina = 'PYROXYLIN_SOLUTIONS',
    Vidrio = 228,
    DescripcionVidrio = 'GLASS',
    Otros = 229,
    DescripcionOtros = 'OTHERS'
}

export enum TipoCertificado {
    Certificado = 0,
    DescripcionCertificado = 'LBL_CERTIFICATE',
    Radicado = 1,
    DescripcionRadicado = 'LBL_RECORDED',
    Indumil = 2,
    DescripcionIndumil = 'INDUMIL',
    Extraordinario = 3,
    DescripcionExtraordinario = 'EXTRAORDINARY',
}

export enum AperturaCapturaRecuperarDocumentos {
    RecuperarFacturaDian = 0,
    Documentos = 1
}

export enum TipoNovedadFactPeriodica {
    Novedad = 0,
    DescripcionNovedad = 'LBL_NEW',
    Cortesia = 1,
    DescripcionCortesia = 'LBL_COURTESIES'
}

export enum EstadisticasDeUso {
    DisponibilidadDeEspacio = 1,
    DescripcionDisponibilidadDeEspacio = 'SPACE_AVAILABILITY',
    TamanioDeTablas = 2,
    DescripcionTamanioDeTablas = 'SIZE_TABLES',
    NumeroDeSesionesPorUsuario = 3,
    DescripcionNumeroDeSesionesPorUsuario = 'NUMBER_USER_LOGIN',
    NumeroDeSesionesPorAplicacion = 4,
    DescripcionNumeroDeSesionesPorAplicacion = 'NUMBER_USER_APP',
    ParametrosBaseDeDatos = 5,
    DescripcionParametrosBaseDeDatos = 'DATABASE_PARAMETERS',
    TransaccionesPendientes = 6,
    DescripcionTransaccionesPendientes = 'PENDING_TRANSACTION',
}

export enum AlUnirPdfOrdenarPor {
    NumeroDocumento = 0,
    DescripcionNumeroDocumento = 'NUMBER_DOCUMENT',
    RutaSubRuta = 1,
    DescripcionRutaSubRuta = 'ROUTE_AND_SUB_ROUTE_ORDER'
}


export enum AccionesAutomaticasPrefijo {
    Manual = 0,
    DescripcionManual = 'LBL_MANUAL',
    ContabilizarProgramarEnvioDocumentoElectronico = 1,
    DescripcionContabilizarProgramarEnvioDocumentoElectronico = 'WHEN_POSTING_THE_PROGRAM_SEND_ELECTRONIC_DOCUMENT',
    PagarDocProgramarContabilizacionEnvioDocElectronico = 2,
    DescripcionPagarDocProgramarContabilizacionEnvioDocElectronico = 'PAY_DOCUMENT_SCHEDULING_POSTING_AND_ELECTRONIC_MAILING',
    PagarDocProgramarContabilizacionSolicitarCufeListar = 3,
    DescripcionPagarDocProgramarContabilizacionSolicitarCufeListar = 'PAY_SCHEDULING_DOCUMENT_POSTING_REQUEST_FOR_CUFE'
}

export enum ResultadoPagarDocumento {
    ErrorAlRealizarPago,
    DocumentoPagadoProgramadoContabilizacion,
    DocumentoPagadoProgramadoContabilizacionYEnvioElectronico,
    DocumentoPagadoNoTransmitidoDIAN,
    DocumentoPagadoTransmitidoDIAN
}

// Enumeración para las opciones de Activo y Inactivo
export enum ActivoInactivoDocumento {
    Activo = 'A',
    DescripcionActivo = 'ACTIVE',
    Inactivo = 'I',
    DescripcionInactivo = 'LBL_INACTIVE',
    InactivoOculto = 'O',
    DescripcionInactivoOculto = 'INACTIVE_HIDING'
}


export enum ModeloCupoCredito {
    DigitarDocumentos = 0,
    DescripcionDigitarDocumentos = 'OPTION_1_WHEN_ENTERING_THE_PRODUCTS',
    CambiarEstado = 1,
    DescripcionCambiarEstado = 'OPTION_2_THROUGH_THE_CHANGE_OF_STATES'
}

export enum EstadoPlanesTratamiento {
    Pendientes = 'P',
    DescripcionPendientes = 'PENDING',
    Finalizados = 'F',
    DescripcionFinalizados = 'FINALIZED'
}

export enum FrecuenciaPlanesTratamiento {
    Diario = 1,
    DescriptionDiario = "DAILY",
    Semanal = 2,
    DescriptionSemanal = "LBL_WEEKLY",
    Quincenal = 3,
    DescriptionQuincenal = "LBL_EVERY_TWO_WEEKS",
    Mensual = 4,
    DescriptionMensual = "LBL_MONTHLY"
}


export enum TipoPagoListaPrecioSalud {
    Todos = 0,
    DescripcionTodos = 'LABEL_ALL_PLURAL',
    PorEvento = 1,
    DescripcionPorEvento = 'LBL_BY_EVENT',
    PorCapitacion = 2,
    DescripcionPorCapitacion = 'LBL_BY_CAPITATION'
}

export enum ProductoControlado {
    Ninguno = 0,
    DescripcionNinguno = 'NONE',
    AnticonceptivosEImplantes = 1,
    DescripcionAnticonceptivosEImplantes = 'CONTRACEPTIVES_IMPLANTS',
    DispositivosDeMonopolio = 2,
    DescripcionDispositivosDeMonopolio = 'MONOPOLY_DEVICES',
    MedicamentosDePsiquiatria = 3,
    DescripcionMedicamentosDePsiquiatria = 'PSYCHIATRY_DRUGS'
}

export enum SugerirCamposPersonalizadosHistoriasClinicas {
    Pacientes = 0,
    DescripcionPacientes = 'LBL_PATIENT',

    HistoriaCLinicaAnterior = 1,
    DescripcionHistoriaCLinicaAnterior = 'PREVIOUS_MEDICAL_HISTORY'
}

export enum IncapacidadRetroactiva {
    UrgenciaInternacion = 1,
    DescripcionUrgenciaInternacion = 'EMERGENCY_OR_INTERNMENT_PATIENT',
    TrastornosConfusiones = 2,
    DescripcionTrastornosConfusiones = 'MEMORY_IMPAIRMENT_MENTAL_CONFUSION_DISORIENTATION_TO_TIME_AND_PLACE',
    EventoTerrorista = 3,
    DescripcionEventoTerrorista = 'CATASTROPHIC_EVEN_AND_TERRORIST'
}

export enum TipoUsoSPD {
    Residencial = "01",
    DescripcionResidencial = 'LBL_RESIDENTIAL_USE',

    Industrial = "02",
    DescripcionIndustrial = 'LBL_INDUSTRIAL_USE',

    Comercial = "03",
    DescripcionComercial = 'LBL_COMMERCIAL_USE',

    Oficial = "04",
    DescripcionOficial = 'LBL_OFFICIAL_USE'
}

export enum EstratosSPD {
    Residencial_1 = 1,
    DescripcionResidencial_1 = 'RESIDENTIAL_STRATUM_ONE',

    Residencial_2 = 2,
    DescripcionResidencial_2 = 'RESIDENTIAL_STRATUM_TWO',

    Residencial_3 = 3,
    DescripcionResidencial_3 = 'RESIDENTIAL_STRATUM_THREE',

    Residencial_4 = 4,
    DescripcionResidencial_4 = 'RESIDENTIAL_STRATUM_FOUR',

    Residencial_5 = 5,
    DescripcionResidencial_5 = 'RESIDENTIAL_STRATUM_FIVE',

    Residencial_6 = 6,
    DescripcionResidencial_6 = 'RESIDENTIAL_STRATUM_SIX',

    NoAplica = 7,
    DescripcionNoAplica = 'STRATUM_DOES_NOT_APPLY'
}

export enum PresentacionExistenciaPorPeriodo {
    Detallado = 0,
    DescripcionDetallado = 'DETAILED',
    CompExistenciaPorAlmacen = 1,
    DescripcionCompExistenciaPorAlmacen = 'COMPARATIVE_STOCK_WAREHOUSE',
    CompDisponibilidadPorAlmacen = 2,
    DescripcionCompDisponibilidadPorAlmacen = 'COMPARATIVE_AVALIBLE_WAREHOUSE',
    ResumidoPorProductoSimilar = 3,
    DescripcionResumidoPorProductoSimilar = 'SUMMARIZED_SIMILAR_PRODUCT',
    ResumidoPorBodega = 4,
    DescripcionResumidoPorBodega = 'SUMMARIZED_WAREHOUSE',
    ResumidoPorBodegaGrupo = 5,
    DescripcionResumidoPorBodegaGrupo = 'SUMMARIZED_WAREHOUSE_GROUP',
    ResumidoPorGrupo = 6,
    DescripcionResumidoPorGrupo = 'SUMMARIZED_GROUP',
    ResumidoPorGrupoYSubgrupo = 7,
    DescripcionResumidoPorGrupoYSubgrupo = 'SUMMARIZED_GROUP_SUBGROUP',
    ResumidoPorMarca = 8,
    DescripcionResumidoPorMarca = 'SUMMARIZED_BRAND',
    ResumidoPorDiseño = 9,
    DescripcionResumidoPorDiseño = 'SUMMARIZED_DESIGN',
    ResumidoPorUnidadDeNegocio = 10,
    DescripcionResumidoPorUnidadDeNegocio = 'SUMMARIZED_BUSINESS_UNIT',
    ResumidoPorCategoría = 11,
    DescripcionResumidoPorCategoría = 'SUMMARIZED_CATEGORY',
    ResumidoPorCategoríaSubcategoría = 12,
    DescripcionResumidoPorCategoríaSubcategoría = 'SUMMARIZED_CATEGORY_SUBCATEGORY',
    ResumidoPorFabricanteProveedor = 13,
    DescripcionResumidoPorFabricanteProveedor = 'SUMMARIZED_PRODUCER_PROVIDER'
}

export enum TiposMedicionPosterior {
    PrecioTransaccion = 1,
    DescripcionPrecioTransaccion = "Precio de la transacción / Valor nominal / Costo",

    CostoAmortizado = 2,
    DescripcionCostoAmortizado = "Costo amortizado",

    ValorRazonable = 3,
    DescripcionValorRazonable = "Valor razonable",

    ValorRazonableCambiosOri = 4,
    DescripcionValorRazonableCambiosOri = "Valor razonable con cambios en el ORI",

    ValorPresentePagosFuturos = 5,
    DescripcionValorPresentePagosFuturos = "Valor presente pagos futuros",

    NoAplica = 6,
    DescripcionNoAplica = "No aplica",
}

export enum ArchivosSuperSalud {
    FT001 = 1,
    DescripcionFT001 = "FT001 - Cátalogo información financiera",

    FT003 = 3,
    DescripcionFT003 = "FT003 - Cuentas por cobrar - Deudores",

    FT004 = 4,
    DescripcionFT004 = "FT004 - Cuentas por pagar - Acreedores",

    FT010 = 10,
    DescripcionFT010 = "FT010 - Activos no monetarios",
}

export enum PresentacionesProgramacionPagos {
    DetalladoPorEstado = 0,
    DescripcionDetalladoPorEstado = "DETAILED_BY_STATUS",
    DetalladoPorProveedor = 1,
    DescripcionDetalladoPorProveedor = "DETAILED_BY_PROVIDER",
    ResumenPorProveedor = 2,
    DescripcionResumenPorProveedor = "SUMMARY_BY_PROVIDER",
    ResumenPorCuenta = 3,
    DescripcionResumenPorCuenta = "SUMMARY_BY_ACCOUNT",
    ResumenPorCentroDeCosto = 4,
    DescripcionResumenPorCentroDeCosto = "SUMMARY_BY_COST_CENTER"
}

export enum PresentacionInventarioActvos {
    Detallado = 0,
    DescripcionDetallado = "Detallado",
    ResumidoPorTipoDeActivo = 1,
    DescripcionResumidoPorTipoDeActivo = "Resumido por tipo de activo",
    ResumidoPorTipoDeActivoYSubtipoDeActivo = 2,
    DescripcionResumidoPorTipoDeActivoYSubtipoDeActivo = "Resumido por tipo de activo y subtipo de activo",
    ResumidoPorCentroDeCosto = 3,
    DescripcionResumidoPorCentroDeCosto = "Resumido por centro de costo",
    ResumidoPorTipoDeActivoYCentroDeCosto = 4,
    DescripcionResumidoPorTipoDeActivoYCentroDeCosto = "Resumido por tipo de activo y centro de costo"
}

export enum SubCarpetaRecursos {
    ConsultasVentas = "consultasventas",
    DescripcionConsultasVentas = "SALES_QUERIES",
    Traslados = "traslados",
    DescripcionTraslados = "TRANSFERS",
    ConsultasActivosFijos = "consultasactivosfijos",
    DescripcionConsultasActivosFijos = "CAPITAL_ASSETS_QUERIES",
    ConsultasTerceros = "consultasterceros",
    DescripcionConsultasTerceros = "THIRD_PARTIES_QUERIES",
    ConsultasProductos = "consultasproductos",
    DescripcionConsultasProductos = "PRODUCTS_QUERIES",
    ConsultasDocumentos = "consultasdocumentos",
    DescripcionConsultasDocumentos = "DOCUMENTS_QUERIES",
    ConsultasResumenDocumentos = "consultasresumendocumentos",
    DescripcionConsultasResumenDocumentos = "DOCUMENTS_OVERVIEW_QUERIES",
    ConsultasLiquidaciones = "consultasliquidaciones",
    DescripcionConsultasLiquidaciones = "SETTLEMENTS_QUERIES",
    ConsultasArrendamientos = "consultasarrendamientos",
    DescripcionConsultaArrendamientos = "LEASES_QUERIES",
    ConsultasActividades = "consultasactividades",
    DescripcionConsultasActividades = "ACTIVITIES_QUERIES",
    ConsultasTareasProyectos = "consultastareasproyectos",
    DescripcionConsultasTareasProyectos = "PROJECTS_TASK_QUERIES",
    ConsultasSolicitudes = "consultassolicitudes",
    DescripcionConsultasSolicitudes = "REQUESTS_QUERIES",
    ConsultasEmpleados = "consultasempleados",
    DescripcionConsultasEmpleados = "EMPLOYEES_QUERIES"
}

export enum PresentacionesFiltroNomina {
    Detallado = 0,
    DescripcionDetallado = "Detallado",
    SalariosPromedioPrimas = 1,
    DescripcionSalariosPromedioPrimas = "Salarios Promedio Primas",
    SalariosPromedioCesantias = 2,
    DescripcionSalariosPromedioCesantias = "Salarios Promedio Cesantias",
    SalariosPromedioVacaciones = 3,
    DescripcionSalariosPromedioVacaciones = "Salarios Promedio Vacaciones",
    ResumidoPorEmpleadoConcepto = 4,
    DescripcionResumidoPorEmpleadoConcepto = "Resumido Por Empleado - Concepto",
    ResumidoPorConceptoEmpleado = 5,
    DescripcionResumidoPorConceptoEmpleado = "Resumido Por Concepto - Empleado",
    ResumidoPorEmpleado = 6,
    DescripcionResumidoPorEmpleado = "Resumido Por Empleado",
    ResumidoPorCentroDeCostoConcepto = 7,
    DescripcionResumidoPorCentroDeCostoConcepto = "Resumido Por Centro De Costo - Concepto",
    ResumidoPorConceptoCentroDeCosto = 8,
    DescripcionResumidoPorConceptoCentroDeCosto = "Resumido Por Concepto - Centro De Costo",
    ResumidoPorConcepto = 9,
    DescripcionResumidoPorConcepto = "Resumido Por Concepto",
    ResumidoPorConceptoMesAMes = 10,
    DescripcionResumidoPorConceptoMesAMes = "Resumido Por Concepto Mes a Mes",
    ResumidoPorEmpleadoMesAMes = 11,
    DescripcionResumidoPorEmpleadoMesAMes = "Resumido Por Empleado Mes a Mes",
    ResumidoPorEmpleadoConceptoMesAMes = 12,
    DescripcionResumidoPorEmpleadoConceptoMesAMes = "Resumido Por Empleado - Concepto Mes a Mes"
}

export enum TipoPerfilPortales {
    Cliente = 0,
    DescripcionCliente = "LBL_CUSTOMER",
    Empleados = 1,
    DescripcionEmpleados = "LBL_EMPLOYEES",
    Proveedores = 2,
    DescripcionProveedores = "MN_SUPPLIERS"
}

export enum MetodoDescuentoDocumentos {
    NoAsumeIvaDescuento = 0,
    DescripcionNoAsumeIvaDescuento = 'NO_ASSUME_IVA_DISCOUNT',
    IvaDescuentoAsumeCliente = 1,
    DescripcionIvaDescuentoAsumeCliente = 'CUSTOMER_ASSUME_IVA_DISCOUNT',
    IvaDescuentoAsumeEmpresa = 2,
    DescripcionIvaDescuentoAsumeEmpresa = 'COMPANY_ASSUME_IVA_DISCOUNT'
}